webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(537);
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueAnalytics = __webpack_require__(569);
	
	var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);
	
	var _vueGtm = __webpack_require__(570);
	
	var _vueGtm2 = _interopRequireDefault(_vueGtm);
	
	var _saasPagesKlickpagesHeader = __webpack_require__(157);
	
	var _saasPagesKlickpagesHeader2 = _interopRequireDefault(_saasPagesKlickpagesHeader);
	
	var _klickpagesSupportChat = __webpack_require__(156);
	
	var _klickpagesSupportChat2 = _interopRequireDefault(_klickpagesSupportChat);
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _config = __webpack_require__(176);
	
	var _App = __webpack_require__(573);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VueApp = new _vue2.default({
	  store: _config.store,
	  i18n: _i18n2.default,
	  router: _config.router,
	  rebrandConfigs: _rebrand2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});
	
	_vue2.default.use(_saasPagesKlickpagesHeader2.default, { store: _config.store });
	_vue2.default.use(_klickpagesSupportChat2.default, { store: _config.store });
	
	_vue2.default.use(_vueAnalytics2.default, {
	  id: ("UA-115650804-1,UA-166451857-1").split(','),
	  router: _config.router,
	  autoTracking: {
	    page: ("production") === 'production' || ("production") === 'staging'
	  }
	});
	
	_vue2.default.use(_vueGtm2.default, {
	  id: ("GTM-M7Z594X,GTM-NZB9QBR").split(','),
	  defer: false,
	  enabled: true,
	  loadScript: true,
	  vueRouter: _config.router
	});
	
	_vueAnalytics2.default.onScriptLoaded().then(function () {
	  VueApp.$mount('#app');
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(572);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _messages = __webpack_require__(223);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _cookie = __webpack_require__(222);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _config = __webpack_require__(105);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _url = __webpack_require__(104);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	
	var getLocale = function getLocale() {
	  var urlLocale = _url2.default.getLocale(window.location.pathname);
	
	  return urlLocale || (0, _cookie2.default)() || _config2.default.DEFAULT_LOCALE;
	};
	
	var i18n = new _vueI18n2.default({
	  locale: getLocale(),
	  messages: _messages2.default
	});
	
	exports.default = i18n;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isDomainRebrand = window.location.hostname === ("box.pages.hotmart.com");
	
	exports.default = {
	  urls: {
	    API_ENDPOINT: isDomainRebrand ? ("https://box-api.pages.hotmart.com") : ("https://box-api.eks.klickpages.com.br"),
	    KLICKART_URL: isDomainRebrand ? ("https://art.pages.hotmart.com") : ("https://art.klickpages.com.br"),
	    KLICKART_AUTH_URI: isDomainRebrand ? ("https://art.pages.hotmart.com/crossapp/klickbox") : ("https://art.klickpages.com.br/crossapp/klickbox"),
	    KLICKBOX_MANAGER_SCRIPT: isDomainRebrand ? ("https://box-delivery.pages.hotmart.com/prod/v1") : ("https://box-delivery.klickpages.com.br/prod/v1"),
	    THEME_CDN_URI: isDomainRebrand ? ("https://box-themes.pages.hotmart.com") : ("https://box-themes.klickpages.com.br")
	  }
	};

/***/ },
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getCanvas = function getCanvas(html) {
	  var canvas = document.createElement('div');
	  canvas.innerHTML = html;
	
	  return canvas;
	};
	
	exports.default = getCanvas;

/***/ },
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(439)
	
	/* template */
	var __vue_template__ = __webpack_require__(844)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(914)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _instance = __webpack_require__(101);
	
	var _instance2 = _interopRequireDefault(_instance);
	
	var _auth = __webpack_require__(91);
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API = function () {
	  function API() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, API);
	
	    this.path = config.path;
	
	    this.axios = (0, _instance2.default)();
	  }
	
	  (0, _createClass3.default)(API, [{
	    key: 'get',
	    value: function get() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.axios.get(this.path + '/' + resource, (0, _assign2.default)({}, this.config, config));
	    }
	  }, {
	    key: 'put',
	    value: function put() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var data = arguments[1];
	      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this.axios.put(this.path + '/' + resource, data, (0, _assign2.default)({}, this.config, config));
	    }
	  }, {
	    key: 'post',
	    value: function post(data) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var resource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	      var path = this.path + '/' + resource;
	
	      return this.axios.post(path, data, (0, _assign2.default)({}, this.config, config));
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.axios.delete(this.path + '/' + resource, (0, _assign2.default)({}, this.config, config));
	    }
	  }, {
	    key: 'config',
	    get: function get() {
	      return {
	        headers: {
	          Authorization: 'token=' + _auth.token.get(),
	          'Content-Language': _i18n2.default.locale
	        }
	      };
	    }
	  }]);
	  return API;
	}();
	
	exports.default = API;

/***/ },
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(441)
	
	/* template */
	var __vue_template__ = __webpack_require__(851)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 35 */,
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STEP_CLASSES_DEFINITIONS = exports.STEP_CLASSES = exports.STEP_JUMP_OTHER_LABEL = exports.STEP_THANKS_CLASS = exports.STEP_JUMP_CLASS = exports.STEP_OPTION_CLASS = exports.STEP_REDIRECT_CLASS = exports.STEP_TEXT_CLASS = exports.STEP_FORM_EMAIL_CLASS = exports.STEP_YES_NO_CLASS = exports.STEP_MULTIPLE_CHOICE_CLASS = exports.STEP_WELCOME_CLASS = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _STEP_CLASSES_DEFINIT;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STEP_WELCOME_CLASS = exports.STEP_WELCOME_CLASS = 'klickbox-fluxogram-step-welcome';
	var STEP_MULTIPLE_CHOICE_CLASS = exports.STEP_MULTIPLE_CHOICE_CLASS = 'klickbox-fluxogram-step-multiple-choice';
	var STEP_YES_NO_CLASS = exports.STEP_YES_NO_CLASS = 'klickbox-fluxogram-step-yes-no';
	var STEP_FORM_EMAIL_CLASS = exports.STEP_FORM_EMAIL_CLASS = 'klickbox-fluxogram-step-form-email';
	var STEP_TEXT_CLASS = exports.STEP_TEXT_CLASS = 'klickbox-fluxogram-step-text';
	var STEP_REDIRECT_CLASS = exports.STEP_REDIRECT_CLASS = 'klickbox-fluxogram-step-redirect';
	var STEP_OPTION_CLASS = exports.STEP_OPTION_CLASS = 'klickbox-fluxogram-step-option';
	var STEP_JUMP_CLASS = exports.STEP_JUMP_CLASS = 'klickbox-fluxogram-step-jump';
	var STEP_THANKS_CLASS = exports.STEP_THANKS_CLASS = 'klickbox-fluxogram-step-thanks';
	
	var STEP_JUMP_OTHER_LABEL = exports.STEP_JUMP_OTHER_LABEL = '<label>Em todos outros casos</label>';
	
	var STEP_CLASSES = exports.STEP_CLASSES = {
	  welcome: STEP_WELCOME_CLASS,
	  'multiple-choice': STEP_MULTIPLE_CHOICE_CLASS,
	  'yes-no': STEP_YES_NO_CLASS,
	  text: STEP_TEXT_CLASS,
	  email: STEP_FORM_EMAIL_CLASS,
	  redirect: STEP_REDIRECT_CLASS,
	  thanks: STEP_THANKS_CLASS
	};
	
	var STEP_CLASSES_DEFINITIONS = exports.STEP_CLASSES_DEFINITIONS = (_STEP_CLASSES_DEFINIT = {}, (0, _defineProperty3.default)(_STEP_CLASSES_DEFINIT, STEP_WELCOME_CLASS, 'fill:#dc9f99;'), (0, _defineProperty3.default)(_STEP_CLASSES_DEFINIT, STEP_MULTIPLE_CHOICE_CLASS, 'fill:#7AA2E4;'), (0, _defineProperty3.default)(_STEP_CLASSES_DEFINIT, STEP_TEXT_CLASS, 'fill:#abd684;'), (0, _defineProperty3.default)(_STEP_CLASSES_DEFINIT, STEP_YES_NO_CLASS, 'fill:#CF9AF1;'), (0, _defineProperty3.default)(_STEP_CLASSES_DEFINIT, STEP_FORM_EMAIL_CLASS, 'fill:#54CF9F;'), (0, _defineProperty3.default)(_STEP_CLASSES_DEFINIT, STEP_REDIRECT_CLASS, 'fill:#F4B786;'), (0, _defineProperty3.default)(_STEP_CLASSES_DEFINIT, STEP_OPTION_CLASS, 'fill:#FFF,stroke-width:1px;'), (0, _defineProperty3.default)(_STEP_CLASSES_DEFINIT, STEP_JUMP_CLASS, 'fill:#FFF,stroke-width:1px;'), (0, _defineProperty3.default)(_STEP_CLASSES_DEFINIT, STEP_THANKS_CLASS, 'fill:#DC9F99;'), _STEP_CLASSES_DEFINIT);

/***/ },
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(313)
	
	/* template */
	var __vue_template__ = __webpack_require__(763)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(315)
	
	/* template */
	var __vue_template__ = __webpack_require__(745)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(424)
	
	/* template */
	var __vue_template__ = __webpack_require__(805)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(435)
	
	/* template */
	var __vue_template__ = __webpack_require__(917)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var text = exports.text = function text(htmlString) {
	  var wrapper = document.createElement('div');
	
	  wrapper.innerHTML = htmlString;
	
	  return wrapper.textContent;
	};
	
	var stepList = exports.stepList = function stepList(steps) {
	  if (!Array.isArray(steps)) {
	    return [];
	  }
	
	  return steps.map(function (step) {
	    step.sanitized_title = text(step.title);
	    return step;
	  });
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(26);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(28);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(27);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(25);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Box = function (_API) {
	  (0, _inherits3.default)(Box, _API);
	
	  function Box() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Box);
	
	    config.path = 'boxes';
	
	    return (0, _possibleConstructorReturn3.default)(this, (Box.__proto__ || (0, _getPrototypeOf2.default)(Box)).call(this, config));
	  }
	
	  (0, _createClass3.default)(Box, [{
	    key: 'metrics',
	    value: function metrics() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.get(resource + '/metrics', params);
	    }
	  }, {
	    key: 'resume',
	    value: function resume() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.get(resource + '/summary', params);
	    }
	  }, {
	    key: 'resumeEmails',
	    value: function resumeEmails() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.get(resource + '/summary/emails', params);
	    }
	  }]);
	  return Box;
	}(_api2.default);
	
	exports.default = Box;

/***/ },
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(301)
	
	/* template */
	var __vue_template__ = __webpack_require__(766)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(312)
	
	/* template */
	var __vue_template__ = __webpack_require__(846)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(365)
	
	/* template */
	var __vue_template__ = __webpack_require__(797)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 57 */,
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getElement = exports.getHtmlTag = undefined;
	
	var _keys = __webpack_require__(37);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var camelCaseToLispCase = function camelCaseToLispCase(text) {
	  return text.replace(/([A-Z])/g, function ($1) {
	    return '-' + $1.toLowerCase();
	  });
	};
	
	var getItems = function getItems() {
	  var items = document.querySelectorAll('[klickbox-internal-style]');
	  return (0, _from2.default)(items);
	};
	
	var jsonToCSS = function jsonToCSS(style) {
	  var keys = (0, _keys2.default)(style);
	
	  return keys.map(function (key) {
	    return camelCaseToLispCase(key) + ': ' + style[key] + ' !important;';
	  }).join('');
	};
	
	var getHtmlTag = exports.getHtmlTag = function getHtmlTag(styles) {
	  var items = getItems();
	
	  if (!items.length) {
	    return '';
	  }
	
	  var tagStyle = '<style>';
	
	  items.forEach(function (item) {
	    var itemEdit = item.getAttribute('klickbox-edit-item');
	    var itemClass = item.getAttribute('klickbox-internal-style');
	
	    var rules = styles[itemEdit].rules;
	
	    tagStyle = tagStyle + '.' + itemClass + ' { ' + jsonToCSS(rules) + ' }';
	  });
	
	  tagStyle = tagStyle + '</style>';
	
	  return tagStyle;
	};
	
	var getElement = exports.getElement = function getElement(item) {
	  var selector = '[klickbox-edit-item="' + item + '"][klickbox-internal-style]';
	  return document.querySelector(selector);
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueRouter = __webpack_require__(155);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(227);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _url = __webpack_require__(104);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: _routes2.default
	});
	
	router.beforeEach(function (to, from, next) {
	  if (!_url2.default.hasLocale(to.fullPath)) {
	    return next('' + _i18n2.default.locale + to.fullPath);
	  }
	
	  return next();
	});
	
	exports.default = router;

/***/ },
/* 60 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STEPS_SET = exports.STEPS_SET = 'STEPS_SET';
	var STEP_ADD = exports.STEP_ADD = 'STEP_ADD';
	var STEP_UPDATE_FORM_HTML = exports.STEP_UPDATE_FORM_HTML = 'STEP_UPDATE_FORM_HTML';
	var STEP_UPDATE_ORIGINAL_FORM_HTML = exports.STEP_UPDATE_ORIGINAL_FORM_HTML = 'STEP_UPDATE_ORIGINAL_FORM_HTML';
	var STEP_UPDATE_FORM_CUSTOMIZED = exports.STEP_UPDATE_FORM_CUSTOMIZED = 'STEP_UPDATE_FORM_CUSTOMIZED';
	var STEP_UPDATE_REDIRECT_AUTOMATIC = exports.STEP_UPDATE_REDIRECT_AUTOMATIC = 'STEP_UPDATE_REDIRECT_AUTOMATIC';
	var STEP_UPDATE_REDIRECT_URL = exports.STEP_UPDATE_REDIRECT_URL = 'STEP_UPDATE_REDIRECT_URL';
	var STEP_UPDATE_REDIRECT_BUTTON_TEXT = exports.STEP_UPDATE_REDIRECT_BUTTON_TEXT = 'STEP_UPDATE_REDIRECT_BUTTON_TEXT';
	var STEP_UPDATE_MULTIPLE_ANSWER = exports.STEP_UPDATE_MULTIPLE_ANSWER = 'STEP_UPDATE_MULTIPLE_ANSWER';
	var STEP_SET_ACTIVE = exports.STEP_SET_ACTIVE = 'STEP_SET_ACTIVE';
	var STEP_UPDATE_TITLE = exports.STEP_UPDATE_TITLE = 'STEP_UPDATE_TITLE';
	var STEP_REMOVE = exports.STEP_REMOVE = 'STEP_REMOVE';
	var STEP_UPDATE_QUIZ_ID = exports.STEP_UPDATE_QUIZ_ID = 'STEP_UPDATE_QUIZ_ID';
	var STEP_UPDATE_REDIRECT_EMAIL_SERVICE = exports.STEP_UPDATE_REDIRECT_EMAIL_SERVICE = 'STEP_UPDATE_REDIRECT_EMAIL_SERVICE';
	var STEP_UPDATE_DESCRIPTION_VISIBILITY = exports.STEP_UPDATE_DESCRIPTION_VISIBILITY = 'STEP_UPDATE_DESCRIPTION_VISIBILITY';
	var STEP_UPDATE_DESCRIPTION = exports.STEP_UPDATE_DESCRIPTION = 'STEP_UPDATE_DESCRIPTION';
	var STEP_UPDATE_WELCOME_ACTIVE = exports.STEP_UPDATE_WELCOME_ACTIVE = 'STEP_UPDATE_WELCOME_ACTIVE';
	var STEP_UPDATE_WELCOME_OPTION = exports.STEP_UPDATE_WELCOME_OPTION = 'STEP_UPDATE_WELCOME_OPTION';
	var STEP_UPDATE_TEXT_REQUIRED = exports.STEP_UPDATE_TEXT_REQUIRED = 'STEP_UPDATE_TEXT_REQUIRED';
	var STEP_UPDATE_TEXT_SIZE = exports.STEP_UPDATE_TEXT_SIZE = 'STEP_UPDATE_TEXT_SIZE';
	var STEP_UPDATE_TEXT_PLACEHOLDER = exports.STEP_UPDATE_TEXT_PLACEHOLDER = 'STEP_UPDATE_TEXT_PLACEHOLDER';
	var STEP_UPDATE_NEXT_BUTTON_TEXT = exports.STEP_UPDATE_NEXT_BUTTON_TEXT = 'STEP_UPDATE_NEXT_BUTTON_TEXT';
	var STEP_UPDATE_POSITIONS = exports.STEP_UPDATE_POSITIONS = 'STEP_UPDATE_POSITIONS';
	var STEP_RESET_STATE = exports.STEP_RESET_STATE = 'STEP_RESET_STATE';
	var STEP_PUSH = exports.STEP_PUSH = 'STEP_PUSH';
	var STEP_SET_STYLES = exports.STEP_SET_STYLES = 'STEP_SET_STYLES';
	var STEP_UPDATE_STYLE = exports.STEP_UPDATE_STYLE = 'STEP_UPDATE_STYLE';
	var STEP_SET_PREVIEW = exports.STEP_SET_PREVIEW = 'STEP_SET_PREVIEW';

/***/ },
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(358)
	
	/* template */
	var __vue_template__ = __webpack_require__(746)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(454)
	
	/* template */
	var __vue_template__ = __webpack_require__(799)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.token = undefined;
	
	var _token = __webpack_require__(92);
	
	var token = _interopRequireWildcard(_token);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.token = token;

/***/ },
/* 92 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var KEY = 'klickbox-auth-token';
	
	var set = exports.set = function set(token) {
	  window.sessionStorage.setItem(KEY, token);
	};
	
	var get = exports.get = function get() {
	  return window.sessionStorage.getItem(KEY);
	};

/***/ },
/* 93 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SCRIPT = exports.SCRIPT = '<script src="{{MANAGER_SCRIPT}}/{{BOX_ID}}/script"></script>';
	var TRIGGER_BUTTON_ATTR = exports.TRIGGER_BUTTON_ATTR = 'data-kbx-trigger-button';

/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FLUXOGRAM_NODE_CLASS = exports.FLUXOGRAM_NODE_CLASS = 'klickbox-fluxogram';

/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  EMAIL_FIELD: /(name="(\w+email|email\w+|email|cmp1|kmbSubscribe\[email\]|mauticform\[email\])")/ig
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.textNodeToPlaceholder = exports.normalizeHiddenFields = exports.linkSubmitToButton = exports.labelToSelectOption = exports.labelToPlaceholder = exports.inputImageToButton = exports.clearForm = exports.applyAttributes = exports.addForToLabel = exports.addAttributeToEmailField = undefined;
	
	var _addAttributeToEmailField = __webpack_require__(190);
	
	var _addAttributeToEmailField2 = _interopRequireDefault(_addAttributeToEmailField);
	
	var _addForToLabel = __webpack_require__(191);
	
	var _addForToLabel2 = _interopRequireDefault(_addForToLabel);
	
	var _applyAttributes = __webpack_require__(192);
	
	var _applyAttributes2 = _interopRequireDefault(_applyAttributes);
	
	var _clearForm = __webpack_require__(193);
	
	var _clearForm2 = _interopRequireDefault(_clearForm);
	
	var _inputImageToButton = __webpack_require__(194);
	
	var _inputImageToButton2 = _interopRequireDefault(_inputImageToButton);
	
	var _labelToPlaceholder = __webpack_require__(195);
	
	var _labelToPlaceholder2 = _interopRequireDefault(_labelToPlaceholder);
	
	var _labelToSelectOption = __webpack_require__(196);
	
	var _labelToSelectOption2 = _interopRequireDefault(_labelToSelectOption);
	
	var _linkSubmitToButton = __webpack_require__(197);
	
	var _linkSubmitToButton2 = _interopRequireDefault(_linkSubmitToButton);
	
	var _normalizeHiddenFields = __webpack_require__(198);
	
	var _normalizeHiddenFields2 = _interopRequireDefault(_normalizeHiddenFields);
	
	var _textNodeToPlaceholder = __webpack_require__(199);
	
	var _textNodeToPlaceholder2 = _interopRequireDefault(_textNodeToPlaceholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.addAttributeToEmailField = _addAttributeToEmailField2.default;
	exports.addForToLabel = _addForToLabel2.default;
	exports.applyAttributes = _applyAttributes2.default;
	exports.clearForm = _clearForm2.default;
	exports.inputImageToButton = _inputImageToButton2.default;
	exports.labelToPlaceholder = _labelToPlaceholder2.default;
	exports.labelToSelectOption = _labelToSelectOption2.default;
	exports.linkSubmitToButton = _linkSubmitToButton2.default;
	exports.normalizeHiddenFields = _normalizeHiddenFields2.default;
	exports.textNodeToPlaceholder = _textNodeToPlaceholder2.default;

/***/ },
/* 97 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var applyFilters = function applyFilters(filters, html) {
	  var filteredHtml = html;
	
	  filters.forEach(function (filter) {
	    filteredHtml = filter(filteredHtml);
	  });
	
	  return filteredHtml;
	};
	
	exports.default = applyFilters;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apply = __webpack_require__(97);
	
	var _apply2 = _interopRequireDefault(_apply);
	
	var _validator = __webpack_require__(201);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _validations = __webpack_require__(204);
	
	var _klicknotify = __webpack_require__(80);
	
	var _klicknotify2 = _interopRequireDefault(_klicknotify);
	
	var _factories = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filters = [_factories.addAttributeToEmailField, _factories.linkSubmitToButton];
	
	var validations = [_validations.emailField];
	
	var standard = function standard(html) {
	  var tests = (0, _validator2.default)(validations, html);
	  if (!tests) {
	    _klicknotify2.default.error({
	      message: 'Esse não é um formulário de email válido!',
	      autoHide: true
	    });
	    return '';
	  }
	
	  return (0, _apply2.default)(filters, html);
	};
	
	exports.default = standard;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(33);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selector = '[klickbox-edit-item]:not([klickbox-edit-not-highlight])';
	
	var sidebarChangePanel = null;
	var sidebarSetElement = null;
	var canvasEnableHighlight = null;
	var sidebarChangeActiveButton = null;
	
	var bindClicks = function bindClicks(items) {
	  items.forEach(function (item) {
	    item.addEventListener('click', function (event) {
	      event.stopPropagation();
	      sidebarChangePanel('modifiers');
	      sidebarChangeActiveButton('style');
	      sidebarSetElement(item);
	    });
	  });
	};
	
	var bindHover = function bindHover(items) {
	  var updateHightlight = function updateHightlight(event, element) {
	    if (element.classList.contains('kbx-modal')) {
	      return false;
	    }
	
	    if (!items.includes(element)) {
	      return updateHightlight(event, element.parentElement);
	    }
	
	    canvasEnableHighlight({ event: { target: element } });
	
	    event.stopPropagation();
	
	    return true;
	  };
	
	  (0, _jquery2.default)('.kbx-modal').on('mouseover', selector, function (event) {
	    var element = event.target;
	
	    updateHightlight(event, element);
	  });
	};
	
	var Highlight = function () {
	  function Highlight() {
	    (0, _classCallCheck3.default)(this, Highlight);
	  }
	
	  (0, _createClass3.default)(Highlight, [{
	    key: 'bind',
	    value: function bind(actions) {
	      var queryItems = document.querySelectorAll(selector);
	      var editItems = (0, _from2.default)(queryItems);
	
	      sidebarChangePanel = actions.sidebarChangePanel;
	      sidebarSetElement = actions.sidebarSetElement;
	      canvasEnableHighlight = actions.canvasEnableHighlight;
	      sidebarChangeActiveButton = actions.sidebarChangeActiveButton;
	
	      bindClicks(editItems);
	      bindHover(editItems);
	    }
	  }]);
	  return Highlight;
	}();
	
	exports.default = Highlight;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deep = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(37);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(62);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isObject = function isObject(item) {
	  return item && (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' && !Array.isArray(item);
	};
	
	var deep = exports.deep = function deep(target) {
	  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    sources[_key - 1] = arguments[_key];
	  }
	
	  if (!sources.length) {
	    return target;
	  }
	
	  var source = sources.shift();
	
	  if (isObject(target) && isObject(source)) {
	    (0, _keys2.default)(source).forEach(function (key) {
	      if (!isObject(source[key])) {
	        return (0, _assign2.default)(target, (0, _defineProperty3.default)({}, key, source[key]));
	      }
	
	      if (!target[key]) {
	        (0, _assign2.default)(target, (0, _defineProperty3.default)({}, key, {}));
	      }
	
	      return deep(target[key], source[key]);
	    });
	  }
	
	  return deep.apply(undefined, [target].concat(sources));
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _interceptors = __webpack_require__(208);
	
	var Interceptors = _interopRequireWildcard(_interceptors);
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_ENDPOINT = _rebrand2.default.urls.API_ENDPOINT;
	
	var instance = void 0;
	
	exports.default = function () {
	  if (instance) {
	    return instance;
	  }
	
	  var LoaderResponse = Interceptors.loader.response;
	
	  instance = _axios2.default.create({ baseURL: API_ENDPOINT });
	
	  instance.interceptors.request.use(Interceptors.loader.request);
	
	  instance.interceptors.response.use(function (response) {
	    return response;
	  }, Interceptors.token(instance));
	  instance.interceptors.response.use(LoaderResponse.success, LoaderResponse.error);
	
	  return instance;
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(26);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(28);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(27);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(25);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quiz = function (_API) {
	  (0, _inherits3.default)(Quiz, _API);
	
	  function Quiz() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Quiz);
	
	    config.path = 'quizzes';
	
	    return (0, _possibleConstructorReturn3.default)(this, (Quiz.__proto__ || (0, _getPrototypeOf2.default)(Quiz)).call(this, config));
	  }
	
	  (0, _createClass3.default)(Quiz, [{
	    key: 'answers',
	    value: function answers() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.get(resource + '/answers', params);
	    }
	  }, {
	    key: 'export',
	    value: function _export() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this.post(data, config, resource + '/export');
	    }
	  }]);
	  return Quiz;
	}(_api2.default);
	
	exports.default = Quiz;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoUpdate = exports.get = undefined;
	
	var _config = __webpack_require__(206);
	
	var config = _interopRequireWildcard(_config);
	
	var _auth = __webpack_require__(91);
	
	var _klickart = __webpack_require__(212);
	
	var _klickart2 = _interopRequireDefault(_klickart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _config$token = config.token,
	    REQUEST_BODY = _config$token.REQUEST_BODY,
	    MINUTES_TO_UPDATE = _config$token.MINUTES_TO_UPDATE,
	    PATH = _config$token.PATH;
	
	var klickart = new _klickart2.default();
	
	var get = exports.get = function get() {
	  return klickart.post(REQUEST_BODY, {}, PATH).then(function (response) {
	    _auth.token.set(response.data.token);
	
	    return response.data.token;
	  });
	};
	
	var autoUpdate = exports.autoUpdate = function autoUpdate() {
	  setInterval(function () {
	    get();
	  }, 1000 * 60 * MINUTES_TO_UPDATE);
	};

/***/ },
/* 104 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var url = {};
	
	var validLocales = ['en', 'es', 'pt-BR'];
	
	var isLocaleValid = function isLocaleValid(locale) {
	  return validLocales.includes(locale);
	};
	
	var getFirstPath = function getFirstPath(path) {
	  var paths = path.split('/');
	  var i = 0;
	
	  while (!paths[i] && i < paths.length) {
	    i += 1;
	  }return paths[i];
	};
	
	url.getLocale = function (path) {
	  var locale = getFirstPath(path);
	
	  if (isLocaleValid(locale)) {
	    return locale;
	  }
	
	  return null;
	};
	
	url.hasLocale = function (path) {
	  return !!url.getLocale(path);
	};
	
	exports.default = url;

/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  LOCALE_KEY: 'klickpages_locale',
	  DEFAULT_LOCALE: 'pt-BR'
	};

/***/ },
/* 106 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BOX_GET = exports.BOX_GET = 'BOX_GET';
	var BOX_ACTIVE_SET = exports.BOX_ACTIVE_SET = 'BOX_ACTIVE_SET';
	var BOX_ACTIVE_UPDATE_KIND = exports.BOX_ACTIVE_UPDATE_KIND = 'BOX_ACTIVE_UPDATE_KIND';
	var BOX_ACTIVE_UPDATE_FORMAT = exports.BOX_ACTIVE_UPDATE_FORMAT = 'BOX_ACTIVE_UPDATE_FORMAT';
	var BOX_ACTIVE_UPDATE_THEME_SLUG = exports.BOX_ACTIVE_UPDATE_THEME_SLUG = 'BOX_ACTIVE_UPDATE_THEME_SLUG';
	var BOX_ACTIVE_UPDATE_THEME_FONTS = exports.BOX_ACTIVE_UPDATE_THEME_FONTS = 'BOX_ACTIVE_UPDATE_THEME_FONTS';
	var BOX_ACTIVE_UPDATE_NAME = exports.BOX_ACTIVE_UPDATE_NAME = 'BOX_ACTIVE_UPDATE_NAME';
	var BOX_LIST_SET = exports.BOX_LIST_SET = 'BOX_LIST_SET';
	var BOX_LIST_REMOVE = exports.BOX_LIST_REMOVE = 'BOX_LIST_REMOVE';
	var BOX_LIST_UPDATE_NAME = exports.BOX_LIST_UPDATE_NAME = 'BOX_LIST_UPDATE_NAME';
	var BOX_ACTIVE_RESET = exports.BOX_ACTIVE_RESET = 'BOX_ACTIVE_RESET';
	var BOX_SET_CONFIG = exports.BOX_SET_CONFIG = 'BOX_SET_CONFIG';
	var BOX_UPDATE_CONFIG = exports.BOX_UPDATE_CONFIG = 'BOX_UPDATE_CONFIG';
	var BOX_UPDATE_CONFIG_STYLE = exports.BOX_UPDATE_CONFIG_STYLE = 'BOX_UPDATE_CONFIG_STYLE';
	var BOX_UPDATE_CONTENT_BODY = exports.BOX_UPDATE_CONTENT_BODY = 'BOX_UPDATE_CONTENT_BODY';
	var KLICKPAGES_HEADER_ACTIVE = exports.KLICKPAGES_HEADER_ACTIVE = 'KLICKPAGES_HEADER_ACTIVE';

/***/ },
/* 107 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CANVAS_CHANGE_VIEW = exports.CANVAS_CHANGE_VIEW = 'CANVAS_CHANGE_VIEW';
	var CANVAS_CHANGE_PREVIEW_DEVICE = exports.CANVAS_CHANGE_PREVIEW_DEVICE = 'CANVAS_CHANGE_PREVIEW_DEVICE';
	var CANVAS_ENABLE_HIGHLIGHT = exports.CANVAS_ENABLE_HIGHLIGHT = 'CANVAS_ENABLE_HIGHLIGHT';
	var CANVAS_DISABLE_HIGHLIGHT = exports.CANVAS_DISABLE_HIGHLIGHT = 'CANVAS_DISABLE_HIGHLIGHT';
	var CANVAS_RESET_STATE = exports.CANVAS_RESET_STATE = 'CANVAS_RESET_STATE';

/***/ },
/* 108 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CODE_SET_BOX = exports.CODE_SET_BOX = 'CODE_SET_BOX';

/***/ },
/* 109 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var JUMP_ADD = exports.JUMP_ADD = 'JUMP_ADD';
	var JUMP_REMOVE = exports.JUMP_REMOVE = 'JUMP_REMOVE';
	var JUMP_ADD_OPTION = exports.JUMP_ADD_OPTION = 'JUMP_ADD_OPTION';
	var JUMP_REMOVE_OPTION = exports.JUMP_REMOVE_OPTION = 'JUMP_REMOVE_OPTION';
	var JUMP_SET_ACTIVE = exports.JUMP_SET_ACTIVE = 'JUMP_SET_ACTIVE';
	var JUMP_CLEAR = exports.JUMP_CLEAR = 'JUMP_CLEAR';
	var JUMP_UPDATE_OPTION_ID = exports.JUMP_UPDATE_OPTION_ID = 'JUMP_UPDATE_OPTION_ID';
	var JUMP_UPDATE_DESTINATION_STEP_ID = exports.JUMP_UPDATE_DESTINATION_STEP_ID = 'JUMP_UPDATE_DESTINATION_STEP_ID';
	var JUMP_RESET_ACTIVE = exports.JUMP_RESET_ACTIVE = 'JUMP_RESET_ACTIVE';

/***/ },
/* 110 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MODAL_OPEN = exports.MODAL_OPEN = 'MODAL_OPEN';
	var MODAL_CLOSE = exports.MODAL_CLOSE = 'MODAL_CLOSE';

/***/ },
/* 111 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var OPTION_ADD = exports.OPTION_ADD = 'OPTION_ADD';
	var OPTION_REMOVE = exports.OPTION_REMOVE = 'OPTION_REMOVE';
	var OPTION_UPDATE_LABEL = exports.OPTION_UPDATE_LABEL = 'OPTION_UPDATE_LABEL';
	var OPTION_UPDATE_OTHER_ANSWER = exports.OPTION_UPDATE_OTHER_ANSWER = 'OPTION_UPDATE_OTHER_ANSWER';
	var OPTION_SET_ACTIVE = exports.OPTION_SET_ACTIVE = 'OPTION_SET_ACTIVE';
	var OPTION_RESET_ACTIVE = exports.OPTION_RESET_ACTIVE = 'OPTION_RESET_ACTIVE';

/***/ },
/* 112 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var QUIZ_SET_ID = exports.QUIZ_SET_ID = 'QUIZ_SET_ID';
	var QUIZ_SET_STYLES = exports.QUIZ_SET_STYLES = 'QUIZ_SET_STYLES';
	var QUIZ_UPDATE_STYLE = exports.QUIZ_UPDATE_STYLE = 'QUIZ_UPDATE_STYLE';
	var QUIZ_RESET_STATE = exports.QUIZ_RESET_STATE = 'QUIZ_RESET_STATE';

/***/ },
/* 113 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var METRICS_RESET_STATE = exports.METRICS_RESET_STATE = 'METRICS_RESET_STATE';
	var METRICS_SET_DATA = exports.METRICS_SET_DATA = 'METRICS_SET_DATA';

/***/ },
/* 114 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RESUME_EMAILS_SET_DATA = exports.RESUME_EMAILS_SET_DATA = 'RESUME_EMAILS_SET_DATA';

/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RESUME_SET_DATA = exports.RESUME_SET_DATA = 'RESUME_SET_DATA';
	var RESUME_RESET_STATE = exports.RESUME_RESET_STATE = 'RESUME_RESET_STATE';
	var RESUME_SET_DATE_FROM = exports.RESUME_SET_DATE_FROM = 'RESUME_SET_DATE_FROM';
	var RESUME_SET_DATE_TO = exports.RESUME_SET_DATE_TO = 'RESUME_SET_DATE_TO';

/***/ },
/* 116 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REPORT_SET_ANSWERS = exports.REPORT_SET_ANSWERS = 'REPORT_SET_ANSWERS';
	var REPORT_SET_QUIZ_ID = exports.REPORT_SET_QUIZ_ID = 'REPORT_SET_QUIZ_ID';
	var REPORT_SET_PAGE = exports.REPORT_SET_PAGE = 'REPORT_SET_PAGE';
	var REPORT_SET_DATE_FROM = exports.REPORT_SET_DATE_FROM = 'REPORT_SET_DATE_FROM';
	var REPORT_SET_DATE_TO = exports.REPORT_SET_DATE_TO = 'REPORT_SET_DATE_TO';
	var REPORT_RESET_STATE = exports.REPORT_RESET_STATE = 'REPORT_RESET_STATE';
	var REPORT_SET_EXPORT_EMAIL = exports.REPORT_SET_EXPORT_EMAIL = 'REPORT_SET_EXPORT_EMAIL';

/***/ },
/* 117 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SIDEBAR_UPDATE_VISIBILITY = exports.SIDEBAR_UPDATE_VISIBILITY = 'SIDEBAR_UPDATE_VISIBILITY';
	var SIDEBAR_UPDATE_ACTIVE_BUTTON = exports.SIDEBAR_UPDATE_ACTIVE_BUTTON = 'SIDEBAR_UPDATE_ACTIVE_BUTTON';
	var SIDEBAR_SET_ELEMENT = exports.SIDEBAR_SET_ELEMENT = 'SIDEBAR_SET_ELEMENT';
	var SIDEBAR_RESET_STATE = exports.SIDEBAR_RESET_STATE = 'SIDEBAR_RESET_STATE';

/***/ },
/* 118 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var THEME_SET_LIST = exports.THEME_SET_LIST = 'THEME_SET_LIST';
	var THEME_SET_ACTIVE = exports.THEME_SET_ACTIVE = 'THEME_SET_ACTIVE';
	var THEME_RESET_STATE = exports.THEME_RESET_STATE = 'THEME_RESET_STATE';

/***/ },
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(311)
	
	/* template */
	var __vue_template__ = __webpack_require__(906)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(387)
	
	/* template */
	var __vue_template__ = __webpack_require__(850)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(397)
	
	/* template */
	var __vue_template__ = __webpack_require__(843)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(437)
	
	/* template */
	var __vue_template__ = __webpack_require__(858)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(438)
	
	/* template */
	var __vue_template__ = __webpack_require__(785)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(440)
	
	/* template */
	var __vue_template__ = __webpack_require__(831)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = exports.store = undefined;
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(155);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vuexRouterSync = __webpack_require__(933);
	
	var _klicknotify = __webpack_require__(80);
	
	var _klicknotify2 = _interopRequireDefault(_klicknotify);
	
	var _store = __webpack_require__(229);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(59);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _watcher = __webpack_require__(228);
	
	var RouterWatcher = _interopRequireWildcard(_watcher);
	
	var _token = __webpack_require__(103);
	
	var TokenRequest = _interopRequireWildcard(_token);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	TokenRequest.autoUpdate();
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	RouterWatcher.setup(_router2.default, _store2.default);
	
	_klicknotify2.default.init();
	
	exports.store = _store2.default;
	exports.router = _router2.default;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getScript = undefined;
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	var _config = __webpack_require__(93);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getScript = exports.getScript = function getScript() {
	  var box = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var klickboxManagerScript = _rebrand2.default.urls.KLICKBOX_MANAGER_SCRIPT;
	
	  return config.SCRIPT.replace('{{BOX_ID}}', box.id).replace('{{MANAGER_SCRIPT}}', klickboxManagerScript);
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _format = __webpack_require__(523);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formats = {
	  'pt-BR': 'DD/MM/YYYY HH:mm:ss',
	  en: 'MM/DD/YYYY HH:mm:ss',
	  es: 'DD/MM/YYYY HH:mm:ss'
	};
	
	var activeFormat = formats[_i18n2.default.locale];
	
	var formatedDate = function formatedDate(date) {
	  return (0, _format2.default)(date, activeFormat);
	};
	
	exports.default = formatedDate;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _svgPanZoom = __webpack_require__(551);
	
	var _svgPanZoom2 = _interopRequireDefault(_svgPanZoom);
	
	var _markup = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API = function () {
	  function API(graph, style) {
	    (0, _classCallCheck3.default)(this, API);
	
	    this.graph = graph;
	    this.style = style;
	  }
	
	  (0, _createClass3.default)(API, [{
	    key: 'build',
	    value: function build(holderNode) {
	      this.buildFluxogram();
	      var pan = this.buildPan(holderNode);
	
	      return { pan: pan };
	    }
	  }, {
	    key: 'buildFluxogram',
	    value: function buildFluxogram() {
	      return window.mermaid.init(undefined, '.' + _markup.FLUXOGRAM_NODE_CLASS);
	    }
	  }, {
	    key: 'buildPan',
	    value: function buildPan(holderNode) {
	      return (0, _svgPanZoom2.default)(holderNode.querySelector('svg'), {
	        zoomScaleSensitivity: 0.5,
	        maxZoom: 20,
	        minZoom: 0.1
	      });
	    }
	  }, {
	    key: 'sintaxIsValid',
	    value: function sintaxIsValid() {
	      return window.mermaid.parse(this.getCode());
	    }
	  }, {
	    key: 'getCode',
	    value: function getCode() {
	      return '' + this.graph.getCode() + this.style.get();
	    }
	  }]);
	  return API;
	}();
	
	exports.default = API;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(36);
	
	var config = _interopRequireWildcard(_config);
	
	var _jump = __webpack_require__(186);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JumpsController = function () {
	  function JumpsController(stepsController, stepModel) {
	    (0, _classCallCheck3.default)(this, JumpsController);
	
	    this.stepsController = stepsController;
	    this.step = stepModel;
	    this.jump = {};
	  }
	
	  (0, _createClass3.default)(JumpsController, [{
	    key: 'draw',
	    value: function draw() {
	      var _this = this;
	
	      this.step.jumps.forEach(function (jump) {
	        _this.jump = new _jump2.default(_this.step, jump);
	        _this.stepsController.style.bindIdToClass(_this.jump.id, config.STEP_JUMP_CLASS);
	
	        if (_this.step.isEmail()) {
	          return _this.drawKindEmail();
	        }
	
	        if (_this.shouldDrawConnection(jump)) {
	          _this.stepsController.graph.addNode(_this.jump.id, _this.jump.label);
	          _this.stepsController.graph.addEdge(_this.step.id, _this.jump.id);
	
	          _this.drawConnection(_this.jump.id);
	        }
	
	        return true;
	      });
	
	      return true;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      return this.step.jumps && this.step.jumps.filter(function (jump) {
	        return jump.destination_step_id;
	      }).length;
	    }
	  }, {
	    key: 'drawKindEmail',
	    value: function drawKindEmail() {
	      if (this.step.isRedirectEmailService()) {
	        return false;
	      }
	
	      return this.drawConnection(this.step.id);
	    }
	  }, {
	    key: 'drawConnection',
	    value: function drawConnection(originId) {
	      var destinationId = this.stepsController.getNextId(this.step, this.jump);
	
	      if (destinationId) {
	        this.stepsController.graph.addEdge(originId, destinationId);
	      }
	    }
	  }, {
	    key: 'shouldDrawConnection',
	    value: function shouldDrawConnection(jump) {
	      if (this.step.multiple_answers) {
	        return true;
	      }
	
	      if (jump.options_ids !== null) {
	        return true;
	      }
	
	      return this.step.optionsIds.sort().join() !== this.step.jumpOptionsIds.sort().join();
	    }
	  }]);
	  return JumpsController;
	}();
	
	exports.default = JumpsController;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(36);
	
	var config = _interopRequireWildcard(_config);
	
	var _option = __webpack_require__(187);
	
	var _option2 = _interopRequireDefault(_option);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptionsController = function () {
	  function OptionsController(stepsController, stepModel) {
	    (0, _classCallCheck3.default)(this, OptionsController);
	
	    this.stepsController = stepsController;
	    this.step = stepModel;
	    this.option = {};
	  }
	
	  (0, _createClass3.default)(OptionsController, [{
	    key: 'draw',
	    value: function draw() {
	      var _this = this;
	
	      if (!this.show()) {
	        return false;
	      }
	
	      this.step.options.forEach(function (option) {
	        _this.option = new _option2.default(option);
	
	        _this.stepsController.graph.addNode(option.id, option.label);
	        _this.stepsController.graph.addEdge(_this.step.id, option.id);
	        _this.stepsController.style.bindIdToClass(option.id, config.STEP_OPTION_CLASS);
	
	        _this.drawConnection();
	      });
	
	      return true;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      return this.step.options && this.step.options.length > 0 && this.step.jumps && this.step.jumps.length === 1;
	    }
	  }, {
	    key: 'drawConnection',
	    value: function drawConnection() {
	      var nextId = this.stepsController.getNextId(this.step, this.step.jumps[0]);
	
	      if (nextId) {
	        this.stepsController.graph.addEdge(this.option.id, nextId);
	      }
	    }
	  }]);
	  return OptionsController;
	}();
	
	exports.default = OptionsController;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(36);
	
	var config = _interopRequireWildcard(_config);
	
	var _step = __webpack_require__(188);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _options = __webpack_require__(181);
	
	var _options2 = _interopRequireDefault(_options);
	
	var _jumps = __webpack_require__(180);
	
	var _jumps2 = _interopRequireDefault(_jumps);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StepsController = function () {
	  function StepsController(graph, style, steps) {
	    (0, _classCallCheck3.default)(this, StepsController);
	
	    this.graph = graph;
	    this.style = style;
	    this.steps = steps;
	    this.step = {};
	  }
	
	  (0, _createClass3.default)(StepsController, [{
	    key: 'initialize',
	    value: function initialize() {
	      var _this = this;
	
	      this.steps.forEach(function (step) {
	        _this.step = new _step2.default(step);
	        var options = new _options2.default(_this, _this.step);
	        var jumps = new _jumps2.default(_this, _this.step);
	
	        _this.draw(_this.step);
	
	        if (options.show()) {
	          return options.draw();
	        }
	
	        if (jumps.show()) {
	          return jumps.draw();
	        }
	
	        if (_this.step.isText()) {
	          return jumps.drawConnection(_this.step.id);
	        }
	
	        return _this.removeThanksWithoutConnections();
	      });
	    }
	  }, {
	    key: 'draw',
	    value: function draw(step) {
	      this.graph.addNode(step.id, step.label);
	      this.style.bindIdToClass(step.id, config.STEP_CLASSES[step.kind]);
	    }
	  }, {
	    key: 'getNextId',
	    value: function getNextId(step, jump) {
	      var destinationId = this.getDestinationId(jump);
	
	      if (destinationId) {
	        return destinationId;
	      }
	
	      var next = this.steps[step.position + 1];
	
	      if (next) {
	        return next.id;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getDestinationId',
	    value: function getDestinationId(jump) {
	      return jump.destinationStepId || jump.destination_step_id;
	    }
	  }, {
	    key: 'hasConnections',
	    value: function hasConnections() {
	      return this.graph.nodeHasEdge(this.step.id);
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      this.graph.removeNode(this.step.id, this.step.label);
	    }
	  }, {
	    key: 'removeThanksWithoutConnections',
	    value: function removeThanksWithoutConnections() {
	      if (this.step.isThanks() && !this.hasConnections()) {
	        this.remove();
	      }
	    }
	  }]);
	  return StepsController;
	}();
	
	exports.default = StepsController;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Graph = function () {
	  function Graph() {
	    (0, _classCallCheck3.default)(this, Graph);
	
	    this.clearCode();
	  }
	
	  (0, _createClass3.default)(Graph, [{
	    key: 'clearCode',
	    value: function clearCode() {
	      this.code = 'graph TD\n';
	    }
	  }, {
	    key: 'addNode',
	    value: function addNode(id, label) {
	      this.code += this.getNodeCode(id, label);
	    }
	  }, {
	    key: 'removeNode',
	    value: function removeNode(id, label) {
	      this.code = this.code.replace(this.getNodeCode(id, label), '');
	    }
	  }, {
	    key: 'addEdge',
	    value: function addEdge(nodeIdA, nodeIdB) {
	      this.code += nodeIdA + ' --- ' + nodeIdB + '\n';
	    }
	  }, {
	    key: 'nodeHasEdge',
	    value: function nodeHasEdge(nodeId) {
	      return this.code.includes('--- ' + nodeId) || this.code.includes(nodeId + ' ---');
	    }
	  }, {
	    key: 'getNodeCode',
	    value: function getNodeCode(id, label) {
	      return id + '("' + this.adjustLabel(label) + '")\n';
	    }
	  }, {
	    key: 'getCode',
	    value: function getCode() {
	      return this.code;
	    }
	  }, {
	    key: 'adjustLabel',
	    value: function adjustLabel(label) {
	      if (label.includes('"')) {
	        label = label.replace(/"/g, '\'');
	      }
	      return this.breakLine(label);
	    }
	  }, {
	    key: 'breakLine',
	    value: function breakLine(text) {
	      var words = [];
	      var MAX_CHARS = 20;
	      var brokenText = '';
	      var charsLength = 0;
	
	      if (text.includes('<br>')) {
	        return text;
	      }
	
	      words = text.split(' ');
	
	      words.forEach(function (word) {
	        charsLength += word.length;
	
	        brokenText += word + ' ';
	
	        if (charsLength >= MAX_CHARS) {
	          brokenText += '<br>';
	          charsLength = 0;
	        }
	      });
	
	      return brokenText;
	    }
	  }]);
	  return Graph;
	}();
	
	exports.default = Graph;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _graph = __webpack_require__(183);
	
	var _graph2 = _interopRequireDefault(_graph);
	
	var _style = __webpack_require__(189);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _markup = __webpack_require__(185);
	
	var _markup2 = _interopRequireDefault(_markup);
	
	var _steps = __webpack_require__(182);
	
	var _steps2 = _interopRequireDefault(_steps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fluxogram = function () {
	  function Fluxogram() {
	    (0, _classCallCheck3.default)(this, Fluxogram);
	
	    this.graph = new _graph2.default();
	    this.style = new _style2.default();
	    this.markup = new _markup2.default(this.graph, this.style);
	  }
	
	  (0, _createClass3.default)(Fluxogram, [{
	    key: 'initialize',
	    value: function initialize(steps) {
	      this.graph.clearCode();
	      this.style.clear();
	
	      var stepsController = new _steps2.default(this.graph, this.style, steps);
	
	      stepsController.initialize();
	    }
	  }, {
	    key: 'build',
	    value: function build(steps, holderNode) {
	      if (steps.length <= 1) {
	        return null;
	      }
	
	      this.initialize(steps);
	
	      return this.markup.build(holderNode);
	    }
	  }]);
	  return Fluxogram;
	}();
	
	exports.default = Fluxogram;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _api = __webpack_require__(179);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _markup = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Markup = function () {
	  function Markup(graph, style) {
	    (0, _classCallCheck3.default)(this, Markup);
	
	    this.api = new _api2.default(graph, style);
	  }
	
	  (0, _createClass3.default)(Markup, [{
	    key: 'build',
	    value: function build(holderNode) {
	      this.buildHtml(holderNode);
	
	      var api = this.buildFluxogram(holderNode);
	
	      return { api: api };
	    }
	  }, {
	    key: 'buildHtml',
	    value: function buildHtml(holderNode) {
	      var fluxogramNode = document.createElement('div');
	
	      fluxogramNode.className = _markup.FLUXOGRAM_NODE_CLASS;
	
	      fluxogramNode.appendChild(document.createTextNode(this.api.getCode()));
	
	      holderNode.innerHTML = '';
	      holderNode.appendChild(fluxogramNode);
	
	      return this;
	    }
	  }, {
	    key: 'buildFluxogram',
	    value: function buildFluxogram(holderNode) {
	      if (!this.api.sintaxIsValid()) {
	        return null;
	      }
	
	      return this.api.build(holderNode);
	    }
	  }]);
	  return Markup;
	}();
	
	exports.default = Markup;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(36);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JumpModel = function () {
	  function JumpModel(step, jump) {
	    (0, _classCallCheck3.default)(this, JumpModel);
	
	    this.step = step;
	    this.jump = jump;
	  }
	
	  (0, _createClass3.default)(JumpModel, [{
	    key: 'id',
	    get: function get() {
	      return this.jump.id;
	    }
	  }, {
	    key: 'destinationStepId',
	    get: function get() {
	      return this.jump.destination_step_id;
	    }
	  }, {
	    key: 'label',
	    get: function get() {
	      if (this.jump.options_ids) {
	        return this.optionsLabel;
	      }
	
	      return config.STEP_JUMP_OTHER_LABEL;
	    }
	  }, {
	    key: 'optionsLabel',
	    get: function get() {
	      var _this = this;
	
	      var label = '';
	
	      this.jump.options_ids.forEach(function (optionId) {
	        var option = _this.step.options.find(function (element) {
	          return element.id === optionId;
	        });
	        label += '<label>' + option.label + '</label><br>';
	      });
	
	      return label;
	    }
	  }]);
	  return JumpModel;
	}();
	
	exports.default = JumpModel;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptionModel = function () {
	  function OptionModel(option) {
	    (0, _classCallCheck3.default)(this, OptionModel);
	
	    this.option = option;
	  }
	
	  (0, _createClass3.default)(OptionModel, [{
	    key: "id",
	    get: function get() {
	      return this.option.id;
	    }
	  }]);
	  return OptionModel;
	}();
	
	exports.default = OptionModel;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StepModel = function () {
	  function StepModel(step) {
	    (0, _classCallCheck3.default)(this, StepModel);
	
	    this.step = step;
	  }
	
	  (0, _createClass3.default)(StepModel, [{
	    key: 'isEmail',
	    value: function isEmail() {
	      return this.step.kind === 'email';
	    }
	  }, {
	    key: 'isThanks',
	    value: function isThanks() {
	      return this.step.kind === 'thanks';
	    }
	  }, {
	    key: 'isText',
	    value: function isText() {
	      return this.step.kind === 'text';
	    }
	  }, {
	    key: 'isRedirectEmailService',
	    value: function isRedirectEmailService() {
	      return this.step.redirect_email_service;
	    }
	  }, {
	    key: 'normalizedTitle',
	    value: function normalizedTitle() {
	      return this.step.sanitized_title.replace(/\n/g, ' ');
	    }
	  }, {
	    key: 'id',
	    get: function get() {
	      return this.step.id;
	    }
	  }, {
	    key: 'kind',
	    get: function get() {
	      return this.step.kind;
	    }
	  }, {
	    key: 'label',
	    get: function get() {
	      return this.position + 1 + ' - ' + this.normalizedTitle();
	    }
	  }, {
	    key: 'position',
	    get: function get() {
	      return this.step.position;
	    }
	  }, {
	    key: 'options',
	    get: function get() {
	      return this.step.options;
	    }
	  }, {
	    key: 'jumps',
	    get: function get() {
	      return this.step.jumps;
	    }
	  }, {
	    key: 'optionsIds',
	    get: function get() {
	      return this.step.options.map(function (option) {
	        return option.id;
	      });
	    }
	  }, {
	    key: 'jumpOptionsIds',
	    get: function get() {
	      return this.step.jumps.filter(function (jump) {
	        return jump.options_ids !== null;
	      }).map(function (jump) {
	        return jump.options_ids[0];
	      });
	    }
	  }]);
	  return StepModel;
	}();
	
	exports.default = StepModel;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(37);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(36);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Style = function () {
	  function Style() {
	    (0, _classCallCheck3.default)(this, Style);
	
	    this.style = '';
	    this.ids = {};
	  }
	
	  (0, _createClass3.default)(Style, [{
	    key: 'clear',
	    value: function clear() {
	      this.style = '';
	    }
	  }, {
	    key: 'bindIdToClass',
	    value: function bindIdToClass(id, className) {
	      if (!this.ids[className]) {
	        this.ids[className] = [];
	      }
	
	      if (this.ids[className].includes(id)) {
	        return false;
	      }
	
	      this.ids[className].push(id);
	
	      return true;
	    }
	  }, {
	    key: 'bindAllClassesIds',
	    value: function bindAllClassesIds() {
	      var _this = this;
	
	      var classNames = (0, _keys2.default)(this.ids);
	
	      classNames.forEach(function (className) {
	        _this.defineClass(className, config.STEP_CLASSES_DEFINITIONS[className]);
	        _this.style += 'class ' + _this.ids[className].join() + ' ' + className + '\n';
	      });
	    }
	  }, {
	    key: 'defineClass',
	    value: function defineClass(className, definitions) {
	      this.style += 'classDef ' + className + ' ' + definitions + '\n';
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      this.bindAllClassesIds();
	      return this.style;
	    }
	  }]);
	  return Style;
	}();
	
	exports.default = Style;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regex = __webpack_require__(95);
	
	var _regex2 = _interopRequireDefault(_regex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addAttributeToEmailField = function addAttributeToEmailField(html) {
	  var regex = _regex2.default.EMAIL_FIELD;
	
	  return html.replace(regex, '$1 klickbox-quiz-email-field');
	};
	
	exports.default = addAttributeToEmailField;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getCanvas = __webpack_require__(14);
	
	var _getCanvas2 = _interopRequireDefault(_getCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addForToLabel = function addForToLabel(html) {
	  var canvas = (0, _getCanvas2.default)(html);
	  var form = canvas.querySelector('form');
	
	  if (!form) {
	    return html;
	  }
	
	  var fields = form.querySelectorAll('input[type=text], select, textarea');
	  var labels = form.querySelectorAll('label:not([for])');
	
	  if (!labels.length) {
	    return html;
	  }
	
	  (0, _from2.default)(fields).forEach(function (field, index) {
	    var label = labels[index];
	    var id = 'field-' + Math.random().toString(36).substring(2);
	
	    if (!field.getAttribute('id')) {
	      field.setAttribute('id', id);
	    }
	
	    if (label) {
	      label.setAttribute('for', id);
	    }
	  });
	
	  return canvas.innerHTML;
	};
	
	exports.default = addForToLabel;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getCanvas = __webpack_require__(14);
	
	var _getCanvas2 = _interopRequireDefault(_getCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyAttributes = function applyAttributes(html) {
	  var canvas = (0, _getCanvas2.default)(html);
	  var form = canvas.querySelector('form');
	
	  if (!form) {
	    return html;
	  }
	
	  var inputs = form.querySelectorAll('input:not([type="submit"])');
	  var buttons = form.querySelectorAll('button, input[type="submit"]');
	
	  form.classList.add('kbx-form');
	
	  (0, _from2.default)(inputs).forEach(function (input) {
	    input.classList.add('kbx-input');
	  });
	
	  (0, _from2.default)(buttons).forEach(function (button) {
	    button.classList.add('kbx-btn');
	    button.classList.add('kbx-btn-submit-form');
	  });
	
	  return canvas.innerHTML;
	};
	
	exports.default = applyAttributes;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getCanvas = __webpack_require__(14);
	
	var _getCanvas2 = _interopRequireDefault(_getCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearForm = function clearForm(html) {
	  var canvas = (0, _getCanvas2.default)(html);
	  var newForm = document.createElement('form');
	  var elementsSelector = 'input, textarea, select, button';
	
	  var oldForm = canvas.querySelector('form');
	  var scripts = canvas.querySelectorAll('script');
	
	  if (!oldForm) {
	    return html;
	  }
	
	  var elements = oldForm.querySelectorAll(elementsSelector);
	
	  newForm.setAttribute('method', 'POST');
	  newForm.setAttribute('action', oldForm.getAttribute('action'));
	
	  (0, _from2.default)(elements).forEach(function (element) {
	    element.removeAttribute('style');
	    element.removeAttribute('class');
	
	    newForm.appendChild(element);
	  });
	
	  (0, _from2.default)(scripts).forEach(function (script) {
	    newForm.appendChild(script);
	  });
	
	  return newForm.outerHTML;
	};
	
	exports.default = clearForm;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getCanvas = __webpack_require__(14);
	
	var _getCanvas2 = _interopRequireDefault(_getCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputImageToButton = function inputImageToButton(html) {
	  var canvas = (0, _getCanvas2.default)(html);
	  var inputImage = canvas.querySelector('input[type="image"]');
	  var button = document.createElement('button');
	
	  if (!inputImage) {
	    return html;
	  }
	
	  button.setAttribute('type', 'submit');
	  button.innerHTML = inputImage.getAttribute('alt');
	
	  inputImage.insertAdjacentHTML('afterEnd', button.outerHTML);
	  inputImage.remove();
	
	  return canvas.innerHTML;
	};
	
	exports.default = inputImageToButton;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getCanvas = __webpack_require__(14);
	
	var _getCanvas2 = _interopRequireDefault(_getCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var labelToPlaceholder = function labelToPlaceholder(html) {
	  var canvas = (0, _getCanvas2.default)(html);
	  var form = canvas.querySelector('form');
	
	  if (!form) {
	    return html;
	  }
	
	  var inputs = form.querySelectorAll('input');
	
	  (0, _from2.default)(inputs).forEach(function (element) {
	    var elementId = element.getAttribute('id');
	    var labels = form.querySelectorAll('label[for="' + elementId + '"]');
	
	    if (elementId && labels.length === 1) {
	      var label = labels[0];
	
	      element.setAttribute('placeholder', label.textContent);
	      label.parentNode.removeChild(label);
	    }
	  });
	
	  return canvas.innerHTML;
	};
	
	exports.default = labelToPlaceholder;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getCanvas = __webpack_require__(14);
	
	var _getCanvas2 = _interopRequireDefault(_getCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var labelToSelectOption = function labelToSelectOption(html) {
	  var canvas = (0, _getCanvas2.default)(html);
	  var form = canvas.querySelector('form');
	
	  if (!form) {
	    return html;
	  }
	
	  var selects = form.querySelectorAll('select');
	
	  (0, _from2.default)(selects).forEach(function (select) {
	    var selectId = select.getAttribute('id');
	    var labels = form.querySelectorAll('label[for="' + selectId + '"]');
	    var blankOptions = select.querySelectorAll('option[value=""]');
	
	    (0, _from2.default)(blankOptions).forEach(function (blankOption) {
	      blankOption.remove();
	    });
	
	    if (selectId && labels.length === 1) {
	      var label = labels[0];
	      var option = document.createElement('option');
	
	      option.innerHTML = '-- ' + label.textContent + ' --';
	      option.setAttribute('disabled', true);
	      option.setAttribute('selected', true);
	
	      select.insertBefore(option, select.firstChild);
	
	      label.parentNode.removeChild(label);
	    }
	  });
	
	  return canvas.innerHTML;
	};
	
	exports.default = labelToSelectOption;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getCanvas = __webpack_require__(14);
	
	var _getCanvas2 = _interopRequireDefault(_getCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linkSubmitToButton = function linkSubmitToButton(html) {
	  var canvas = (0, _getCanvas2.default)(html);
	  var link = canvas.querySelector('a[type="submit"]');
	  var button = document.createElement('button');
	
	  if (!link) {
	    return html;
	  }
	
	  button.setAttribute('type', 'submit');
	  button.innerHTML = link.textContent;
	
	  link.insertAdjacentHTML('afterEnd', button.outerHTML);
	  link.remove();
	
	  return canvas.innerHTML;
	};
	
	exports.default = linkSubmitToButton;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getCanvas = __webpack_require__(14);
	
	var _getCanvas2 = _interopRequireDefault(_getCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var normalizeHiddenFields = function normalizeHiddenFields(html) {
	  var canvas = (0, _getCanvas2.default)(html);
	  var nonStandardFields = canvas.querySelectorAll('input[tabindex="-1"]');
	
	  if (!nonStandardFields.length) {
	    return html;
	  }
	
	  (0, _from2.default)(nonStandardFields).forEach(function (field) {
	    field.setAttribute('type', 'hidden');
	  });
	
	  return canvas.innerHTML;
	};
	
	exports.default = normalizeHiddenFields;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getCanvas = __webpack_require__(14);
	
	var _getCanvas2 = _interopRequireDefault(_getCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isInputField = function isInputField(node) {
	  return node.nodeName === 'INPUT' && node.type === 'text';
	};
	
	var textNodeToLabel = function textNodeToLabel(html) {
	  var canvas = (0, _getCanvas2.default)(html);
	  var form = canvas.querySelector('form');
	
	  if (!form) {
	    return html;
	  }
	
	  var childNodes = form.childNodes;
	  var textNode = void 0;
	
	  if (canvas.querySelectorAll('label, input[placeholder]').length) {
	    return html;
	  }
	
	  (0, _from2.default)(childNodes).forEach(function (node, index) {
	    if (isInputField(node)) {
	      textNode = childNodes[index - 1];
	      node.setAttribute('placeholder', textNode.nodeValue.trim());
	    }
	  });
	
	  return canvas.innerHTML;
	};
	
	exports.default = textNodeToLabel;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apply = __webpack_require__(97);
	
	var _apply2 = _interopRequireDefault(_apply);
	
	var _standard = __webpack_require__(98);
	
	var _standard2 = _interopRequireDefault(_standard);
	
	var _factories = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filters = [_factories.addForToLabel, _factories.labelToPlaceholder, _factories.labelToSelectOption, _factories.textNodeToPlaceholder, _factories.inputImageToButton, _factories.normalizeHiddenFields, _factories.clearForm, _factories.applyAttributes];
	
	var format = function format(html) {
	  var standardResult = (0, _standard2.default)(html);
	
	  if (!standardResult) {
	    return '';
	  }
	
	  return (0, _apply2.default)(filters, standardResult);
	};
	
	exports.default = format;

/***/ },
/* 201 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var validator = function validator(validations, html) {
	  var results = validations.map(function (validation) {
	    return validation(html);
	  });
	
	  return results.every(function (result) {
	    return result;
	  });
	};
	
	exports.default = validator;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.format = exports.standard = undefined;
	
	var _standard = __webpack_require__(98);
	
	var _standard2 = _interopRequireDefault(_standard);
	
	var _format = __webpack_require__(200);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.standard = _standard2.default;
	exports.format = _format2.default;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regex = __webpack_require__(95);
	
	var _regex2 = _interopRequireDefault(_regex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emailField = function emailField(html) {
	  var regex = _regex2.default.EMAIL_FIELD;
	
	  return regex.test(html);
	};
	
	exports.default = emailField;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.emailField = undefined;
	
	var _emailField = __webpack_require__(203);
	
	var _emailField2 = _interopRequireDefault(_emailField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.emailField = _emailField2.default;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locale = _i18n2.default.locale;
	var messages = _i18n2.default.messages;
	
	exports.default = messages[locale];

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.token = undefined;
	
	var _token = __webpack_require__(207);
	
	var token = _interopRequireWildcard(_token);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.token = token;

/***/ },
/* 207 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUEST_BODY = exports.REQUEST_BODY = { application: 'klickbox' };
	var MINUTES_TO_UPDATE = exports.MINUTES_TO_UPDATE = 10;
	var PATH = exports.PATH = 'users/token';

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loader = exports.token = undefined;
	
	var _token = __webpack_require__(210);
	
	var _token2 = _interopRequireDefault(_token);
	
	var _loader = __webpack_require__(209);
	
	var loader = _interopRequireWildcard(_loader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.token = _token2.default;
	exports.loader = loader;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.response = exports.request = undefined;
	
	var _promise = __webpack_require__(61);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var events = {
	  requestStart: new Event('requestStart'),
	  requestEnd: new Event('requestEnd')
	};
	
	var request = exports.request = function request(config) {
	  if (config.showLoader) {
	    window.dispatchEvent(events.requestStart);
	  }
	
	  return config;
	};
	
	var response = {
	  success: function success(response) {
	    if (response.config.showLoader) {
	      window.dispatchEvent(events.requestEnd);
	    }
	
	    return response;
	  },
	  error: function error(_error) {
	    if (_error.config.showLoader) {
	      window.dispatchEvent(events.requestEnd);
	    }
	
	    return _promise2.default.reject(_error);
	  }
	};
	exports.response = response;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(61);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	var _token = __webpack_require__(103);
	
	var TokenRequest = _interopRequireWildcard(_token);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KLICKART_AUTH_URI = _rebrand2.default.urls.KLICKART_AUTH_URI;
	
	var shouldUpdateToken = function shouldUpdateToken(error) {
	  return error.response.status === 401 && !error.config.tokenUpdated;
	};
	
	exports.default = function (axiosInstance) {
	  return function (error) {
	    var requestConfig = error.config;
	
	    if (!shouldUpdateToken(error)) {
	      return _promise2.default.reject(error);
	    }
	
	    return TokenRequest.get().then(function (token) {
	      requestConfig.tokenUpdated = true;
	      requestConfig.headers.Authorization = 'token=' + token;
	
	      return axiosInstance(requestConfig);
	    }).catch(function () {
	      window.location = KLICKART_AUTH_URI;
	
	      return _promise2.default.reject(error);
	    });
	  };
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(26);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(28);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(27);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(25);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Jump = function (_API) {
	  (0, _inherits3.default)(Jump, _API);
	
	  function Jump() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Jump);
	
	    config.path = 'quizzes/' + config.quizId + '/steps/' + config.stepId + '/jumps';
	
	    return (0, _possibleConstructorReturn3.default)(this, (Jump.__proto__ || (0, _getPrototypeOf2.default)(Jump)).call(this, config));
	  }
	
	  return Jump;
	}(_api2.default);
	
	exports.default = Jump;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Klickart = function () {
	  function Klickart() {
	    (0, _classCallCheck3.default)(this, Klickart);
	
	    this.axios = _axios2.default.create({ baseURL: _rebrand2.default.urls.KLICKART_URL });
	  }
	
	  (0, _createClass3.default)(Klickart, [{
	    key: 'get',
	    value: function get() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.axios.get(resource, (0, _assign2.default)({}, this.config, config));
	    }
	  }, {
	    key: 'put',
	    value: function put() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var data = arguments[1];
	      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this.axios.put(resource, data, (0, _assign2.default)({}, this.config, config));
	    }
	  }, {
	    key: 'post',
	    value: function post(data) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var resource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	      return this.axios.post(resource, data, (0, _assign2.default)({}, this.config, config));
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.axios.delete(resource, (0, _assign2.default)({}, this.config, config));
	    }
	  }, {
	    key: 'config',
	    get: function get() {
	      return { withCredentials: true };
	    }
	  }]);
	  return Klickart;
	}();
	
	exports.default = Klickart;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(26);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(28);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(27);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(25);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Option = function (_API) {
	  (0, _inherits3.default)(Option, _API);
	
	  function Option() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Option);
	
	    config.path = 'quizzes/' + config.quizId + '/steps/' + config.stepId + '/options';
	
	    return (0, _possibleConstructorReturn3.default)(this, (Option.__proto__ || (0, _getPrototypeOf2.default)(Option)).call(this, config));
	  }
	
	  return Option;
	}(_api2.default);
	
	exports.default = Option;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(26);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(28);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(27);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(25);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step = function (_API) {
	  (0, _inherits3.default)(Step, _API);
	
	  function Step() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Step);
	
	    config.path = 'quizzes/' + config.quizId + '/steps';
	
	    return (0, _possibleConstructorReturn3.default)(this, (Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call(this, config));
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'ordinate',
	    value: function ordinate() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var data = arguments[1];
	      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this.put(resource + '/ordinate', data, config);
	    }
	  }, {
	    key: 'duplicate',
	    value: function duplicate() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this.post(data, config, resource + '/duplicate');
	    }
	  }]);
	  return Step;
	}(_api2.default);
	
	exports.default = Step;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Theme = function () {
	  function Theme() {
	    (0, _classCallCheck3.default)(this, Theme);
	  }
	
	  (0, _createClass3.default)(Theme, [{
	    key: 'get',
	    value: function get(slug) {
	      var path = '/themes/list.json';
	
	      if (slug) {
	        path = '/themes/' + slug + '/presets.json';
	      }
	      return _axios2.default.get('' + _rebrand2.default.urls.THEME_CDN_URI + path);
	    }
	  }]);
	  return Theme;
	}();
	
	exports.default = Theme;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(26);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(28);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(27);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _api = __webpack_require__(25);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = function (_API) {
	  (0, _inherits3.default)(User, _API);
	
	  function User() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, User);
	
	    config.path = 'users';
	
	    return (0, _possibleConstructorReturn3.default)(this, (User.__proto__ || (0, _getPrototypeOf2.default)(User)).call(this, config));
	  }
	
	  (0, _createClass3.default)(User, [{
	    key: 'identifier',
	    value: function identifier() {
	      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.get('identifier', params);
	    }
	  }]);
	  return User;
	}(_api2.default);
	
	exports.default = User;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _i18n = __webpack_require__(205);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kinds = {
	  'multiple-choice': {
	    kind: 'multiple-choice',
	    multiple_answers: false,
	    title: _i18n2.default.step_kinds.kinds.multiple_choise.title,
	    description_text: _i18n2.default.step_kinds.kinds.multiple_choise.description_text,
	    description_visibility: true,
	    position: 0
	  },
	  'yes-no': {
	    kind: 'yes-no',
	    title: _i18n2.default.step_kinds.kinds.yes_no.title,
	    description_text: _i18n2.default.step_kinds.kinds.yes_no.description_text,
	    description_visibility: true,
	    position: 0
	  },
	  text: {
	    kind: 'text',
	    title: _i18n2.default.step_kinds.kinds.text.title,
	    description_text: _i18n2.default.step_kinds.kinds.text.description_text,
	    description_visibility: false,
	    required: true,
	    text_size: 'short',
	    placeholder_text: _i18n2.default.step_kinds.kinds.text.placeholder,
	    position: 0
	  },
	  email: {
	    kind: 'email',
	    title: _i18n2.default.step_kinds.kinds.email.title,
	    description_text: _i18n2.default.step_kinds.kinds.email.description_text,
	    description_visibility: false,
	    redirect_email_service: true,
	    form_html: '',
	    position: 0
	  },
	  redirect: {
	    kind: 'redirect',
	    title: _i18n2.default.step_kinds.kinds.redirect.title,
	    description_text: _i18n2.default.step_kinds.kinds.redirect.description_text,
	    description_visibility: false,
	    redirect_automatic: false,
	    redirect_button_text: _i18n2.default.step_kinds.kinds.redirect.button_text,
	    redirect_url: 'http://klickpages.com.br',
	    final: true,
	    position: 0
	  },
	  thanks: {
	    kind: 'thanks',
	    title: _i18n2.default.step_kinds.kinds.thanks.title,
	    description_text: _i18n2.default.step_kinds.kinds.thanks.description_text,
	    description_visibility: true,
	    final: true,
	    position: 0
	  }
	};
	
	var options = {
	  'multiple-choice': [{ label: _i18n2.default.step_kinds.options.multiple_choise.first_option }, { label: _i18n2.default.step_kinds.options.multiple_choise.second_option }],
	  'yes-no': [{ label: _i18n2.default.step_kinds.options.yes_no.yes }, { label: _i18n2.default.step_kinds.options.yes_no.no }],
	  email: [],
	  redirect: [],
	  thanks: []
	};
	
	exports.default = {
	  generate: function generate(step) {
	    return (0, _assign2.default)({}, step, kinds[step.kind]);
	  },
	  getOptions: function getOptions(kind) {
	    return options[kind];
	  }
	};

/***/ },
/* 218 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['rgba(230,49,91,1)', 'rgba(121,49,131,1)', 'rgba(0,157,231,1)', 'rgba(0,181,156,1)', 'rgba(255,206,0,1)', 'rgba(255,74,33,1)', 'rgba(214,213,214,1)', 'rgba(255,255,255,1)', 'rgba(0,0,0,1)'];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.colors = undefined;
	
	var _colors = __webpack_require__(218);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.colors = _colors2.default;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = undefined;
	
	var _quill = __webpack_require__(547);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var create = exports.create = function create() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (!options.container) {
	    throw Error('TextEditor.create: container provided is invalid');
	  }
	
	  var boxContainer = document.querySelector('.kbx-container');
	  var editorContainer = options.container.querySelector('.kbx-text-editor');
	  var toolbarContainer = options.container.querySelector('.kbx-text-editor-toolbar');
	  var debounce = void 0;
	
	  editorContainer.innerHTML = options.content || '';
	
	  var editor = new _quill2.default(editorContainer, {
	    modules: {
	      toolbar: options.toolbar ? toolbarContainer : false
	    },
	    placeholder: options.placeholder || '',
	    theme: 'bubble'
	  });
	
	  editor.on('selection-change', function () {
	    if (!boxContainer) return;
	
	    var boxContainerClientRect = boxContainer.getBoundingClientRect();
	    var editorClientRect = editor.container.getBoundingClientRect();
	    var tooltip = editor.container.querySelector('.ql-tooltip');
	    var tooltipTop = editorClientRect.top - boxContainerClientRect.top;
	    var tooltipLeft = editorClientRect.left - boxContainerClientRect.left;
	
	    tooltip.style.marginTop = tooltipTop + 'px';
	    tooltip.style.marginLeft = tooltipLeft + 'px';
	  });
	
	  editor.on('text-change', function () {
	    if (debounce) {
	      clearTimeout(debounce);
	    }
	
	    debounce = setTimeout(function () {
	      options.onChange(editor.container.firstChild.innerHTML);
	    }, 1000);
	  });
	
	  return editor;
	};

/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var padTime = function padTime(time) {
	  var pad = '00';
	  time = time += '';
	
	  return pad.substring(0, pad.length - time.length) + time;
	};
	
	var toString = function toString(time) {
	  var hoursString = '00h ';
	  var minutesString = '00min ';
	  var secondsString = '00s';
	  var seconds = Math.floor(time / 1000);
	  var minutes = Math.floor(seconds / 60);
	
	  seconds = seconds - minutes * 60;
	
	  var hours = Math.round(minutes / 60);
	
	  minutes = minutes - hours * 60;
	
	  if (hours > 0) {
	    hoursString = padTime(hours) + 'h ';
	  }
	
	  if (minutes > 0) {
	    minutesString = padTime(minutes) + 'min ';
	  }
	
	  secondsString = seconds + 's';
	
	  return '' + hoursString + minutesString + secondsString;
	};
	
	exports.toString = toString;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsCookie = __webpack_require__(543);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _config = __webpack_require__(105);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLocale = function getLocale() {
	  return _jsCookie2.default.get(_config2.default.LOCALE_KEY);
	};
	
	exports.default = getLocale;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _en = __webpack_require__(224);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _es = __webpack_require__(225);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _ptBR = __webpack_require__(226);
	
	var _ptBR2 = _interopRequireDefault(_ptBR);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  en: _en2.default,
	  es: _es2.default,
	  'pt-BR': _ptBR2.default
	};

/***/ },
/* 224 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  general: {
	    labels: {
	      status: 'Status',
	      actions: 'Actions',
	      copied: 'Copied',
	      error: 'Error',
	      standard: 'Default',
	      step: 'Step',
	      steps: 'Steps',
	      times: 'times(s)',
	      table: 'Table ',
	      exporting: 'Exporting',
	      your: 'Your',
	      in: 'in',
	      date: 'DATE',
	      box_name: 'Research Form Name',
	      new_box: 'New Research Form',
	      next: 'NEXT',
	      edition: 'Edit',
	      editing: 'Editing',
	      description: 'Description',
	      title: 'Title',
	      days: 'Days',
	      configurations: 'Settings',
	      and: 'and',
	      seconds: 'Seconds',
	      homepage: 'Homepage',
	      hotmart_logo: 'Hotmart logo',
	      themes: 'Models',
	      saving: 'Saving',
	      jump: 'Jump',
	      destinations: 'Destinations',
	      first: 'First',
	      last: 'Last',
	      to: 'TO',
	      button: 'Button',
	      external: 'External',
	      center: 'Center',
	      left: 'Left',
	      right: 'Right',
	      other: 'Other',
	      option: 'Option'
	    },
	    actions: {
	      new: 'CREATE FORM',
	      delete: 'Delete',
	      export: 'Export',
	      report: 'Report',
	      edit: 'Edit',
	      copy: 'Copy',
	      close: 'Close',
	      cancel: 'Cancel',
	      duplicate: 'Duplicate',
	      publish: 'Post',
	      back: 'Back',
	      click: 'CLICK',
	      add: 'ADD'
	    }
	  },
	  index: {
	    title: 'Research Forms',
	    subtitle: 'The simplest, easiest way to create your Researches',
	    find_a_box: 'Search for a Research Form',
	    list_header: {
	      modality: 'Modality',
	      last_modification: 'Last change'
	    }
	  },
	  error: {
	    oops: 'oops',
	    page_not_exists: 'This page may not exist...',
	    check_url: 'Make sure the address is spelled correctly or try again later',
	    something_wrong: 'Something seems wrong...',
	    system_offline: 'The system may be down.',
	    our_devs: 'But our team is already working to get this problem solved.',
	    try_again_later: 'Try again in a few minutes'
	  },
	  modal: {
	    cant_export_table: {
	      title: 'This report cannot be exported',
	      max_limit: 'The maximum limit to export results is',
	      select_interval: ' answers. Please select a shorter period of time.'
	    },
	    code: {
	      step_one: 'Copy the Research Form code below and paste it on your page',
	      step_two: 'Copy the button code below',
	      step_three: 'and add it to the link or button that opens the Research Form'
	    },
	    delete_box: {
	      are_you_sure: 'Do you really wish to delete this Research Form?',
	      yes: 'Yes, I want to delete this Research Form!'
	    },
	    delete_step: {
	      are_you_sure: 'Do you really wish to delete this step?',
	      yes: 'Yes, I want to delete this step!'
	    },
	    duplicate_step: {
	      are_you_sure: 'Do you really wish to duplicate this step?',
	      yes: 'Yes, I want to duplicate this step!'
	    },
	    export_table: {
	      answer_table: 'Answer table',
	      insert: 'Enter your email below so we can send you the answer table as soon as it is ready'
	    },
	    export_table_in_progress: {
	      processing_request: 'request is being processed',
	      send_email: 'and as soon as it is complete we will send it to the email',
	      some_hours: 'This process could take a few hours'
	    }
	  },
	  report: {
	    menu: {
	      report_of: 'Report for',
	      back_to_answers_summary: 'Back to answer summary',
	      metrics: 'Metrics',
	      individual_answers: 'Individual answers',
	      box_options: 'Research Form options'
	    },
	    charts: {
	      total_answers: 'Total answers'
	    },
	    individual: {
	      date_filter: 'FILTER BY PERIOD OF TIME',
	      date_range: 'PERIOD OF TIME',
	      from: 'From',
	      to: 'to',
	      answered_in: 'Answered in',
	      obtained_answers: 'answers received'
	    },
	    metrics: {
	      total_visits: 'TOTAL VISITS',
	      visits_without_answers: 'VISITS WITH NO ANSWERS',
	      quizzes_not_completed: 'QUIZZES NOT COMPLETED',
	      quizzes_completed: 'QUIZZES COMPLETED',
	      completion_rate: 'COMPLETION RATE',
	      average_time_to_complete: 'AVERAGE TIME TO COMPLETE',
	      desktop: 'PCs & LAPTOPS',
	      tablet: 'tablet',
	      mobile: 'mobile',
	      others: 'other'
	    },
	    emails: {
	      captured_emails: 'captured emails',
	      who_answered: 'those who replied'
	    },
	    resume: {
	      question_not_answered: 'This question does not yet have an answer',
	      no_information_found: 'No information found'
	    }
	  },
	  edit: {
	    canvas: {
	      visualizing: 'Viewing',
	      active_item: 'Active Item',
	      default_item: 'Standard Item',
	      past_item: 'Past Item',
	      progressbar: 'Progress Bar',
	      general_styles: 'General Styles',
	      answer_options: 'Response Options',
	      redirect_button: 'Redirect Butoon',
	      positive_button: 'Positive Button',
	      positive_button_text: 'Positive Button Text',
	      negative_button: 'Negative Button',
	      negative_button_text: 'Text for the Negative Button',
	      welcome_title: 'Welcome Title',
	      welcome_description: 'Welcome Description',
	      welcome_buttons: 'Welcome Buttons',
	      welcome_active: 'Activate Welcome Step',
	      next_button: 'Next Button',
	      question_description: 'Question Description',
	      question_description_placeholder: 'Call Description',
	      question_title: 'Question Title',
	      question_title_placeholder: 'Type your question here',
	      all_steps: 'All of the Steps',
	      mail_service: 'Email service',
	      mail_service_text_area: 'Put the HTML code here for the form provided by your email service',
	      custom_html_form: 'Customized HTML Form',
	      redirect_by_mail_service: 'Redirection by email service',
	      multiple_answers: 'Allow more than one answer',
	      add_other_option: 'Add option "other"',
	      redirect_url: 'Redirecting URL',
	      auto_redirect: 'Automatic Redirection',
	      required_response: 'Answer Required',
	      multiline_response: 'Multi-line response',
	      multiple_choice_placeholder: 'Enter one response option',
	      add_option: 'Add Option ',
	      button_text: 'Button Text',
	      start_button_text: 'Start Button Text',
	      next_button_text: 'Next Button Text',
	      you_are_editing: 'You are editing the',
	      external_button: 'EXTERNAL BUTTON',
	      click_button: 'Click the button',
	      copy_the: 'Copy the',
	      box_code: 'Research Form code',
	      call_button_code: 'cta button code',
	      past_in_your_page: 'and paste it to your page',
	      add_to_link_or_button: 'and add it to the link or button that opens the Research Form',
	      see_flow: 'View Flow',
	      first_value_welcome_select: 'Yes or No',
	      second_value_welcome_select: 'Start'
	    },
	    sidebar: {
	      interval_until_action: 'Show in a set time interval until the visitor takes the action',
	      times_until_action: 'Display limited times until the visitor takes the action',
	      until_action: 'Display until the visitor carries out the action',
	      display_frequency: 'Display Frequency',
	      when_box_should_display: 'When should the Research Form appear?',
	      exibition_mode: 'View mode',
	      how_box_should_display: 'At what point should the Research Form appear to your visitor?',
	      when_leave_the_page: 'When leaving the page',
	      immediately_when_access: 'Immediately when accessing',
	      on_scroll: 'When scrolling',
	      until_page_top: 'At the top of the page (25%)',
	      until_page_middle: 'Up to half the page (50%)',
	      until_page_bottom: 'Up to the end of the page (75%)',
	      by_time_on_page: 'By time on page',
	      call_button_style: 'CTA Button Style',
	      background_color: 'Background color',
	      border_color: 'Border color',
	      border_radius: 'Rounding',
	      text_color: 'Text color',
	      visibility: 'Visibility',
	      font: 'Font',
	      font_size: 'Text size',
	      height: 'Height',
	      width: 'Width',
	      add_jump: 'Add Jump',
	      add_answer: 'Add answer',
	      select_destiny: 'Select a destination',
	      all_other_cases: 'In all other cases go to...',
	      always_jump_to: 'Always Jump to...',
	      select_one_answer: 'Select an answer',
	      select_the_answers: 'Select answers',
	      choose_one_answer: 'Choose an answer',
	      go_to_next: 'Go to the next',
	      add_one_question: 'add ONE question by CLICKING ON THIS BUTTON',
	      question: 'question',
	      yes_no: 'yes/no',
	      text: 'text',
	      capture: 'Email',
	      of_email: 'capture',
	      redirec: 'REDI',
	      tion: 'RECT',
	      format: 'Format',
	      choose_a_theme: 'PICK A TEMPLATE',
	      edit_theme: 'Edit theme ',
	      without_style: 'No Style',
	      alignment: 'Alignment',
	      call_button: 'CTA Button',
	      in_one_component: 'In one component',
	      one_component_to_integrate: 'A component to integrate into your page',
	      in_full_screen: 'In full screen',
	      one_screen_that_cover: 'A screen covers your page completely',
	      in_mini_slider: 'On a mini slide',
	      one_small_window_apper: 'A little window appearing on the lower corner of the page',
	      in_a_popup: 'In a pop-up',
	      one_box_apper_in_the_middle: 'A Research Form appearing in the middle of the screen',
	      in_a_slider: 'In a slide',
	      one_screen_apper_right: 'A screen appearing on the right',
	      how_might_show: 'How do you want to display it?',
	      select_box_format: 'Select the format of your Research Form',
	      auto: 'Automatically',
	      at_some_point: 'Sometime during access',
	      on_click: 'When clicking',
	      on_click_some_button: 'When clicking on a button within the page',
	      when_might_show: 'When do you want to display it?',
	      select_when_box_should_apper: 'Select when the Research Form should appear',
	      configure_box: 'Set up Research Form'
	    }
	  },
	  step_kinds: {
	    kinds: {
	      multiple_choise: {
	        title: 'What is your question?',
	        description_text: 'Question description'
	      },
	      yes_no: {
	        title: 'What is your question?',
	        description_text: 'Question description'
	      },
	      text: {
	        title: 'What is your name?',
	        description_text: '',
	        placeholder: 'Enter your name here...'
	      },
	      email: {
	        title: 'What is your email address?',
	        description_text: ''
	      },
	      redirect: {
	        title: 'Congratulations! Click here to access your personalized content',
	        description_text: '',
	        button_text: 'Access page'
	      },
	      thanks: {
	        title: 'Thank you!',
	        description_text: 'Your information has been successfully stored in our survey!'
	      }
	    },
	    options: {
	      multiple_choise: {
	        first_option: 'Option 1',
	        second_option: 'Option 2'
	      },
	      yes_no: {
	        yes: 'Yes',
	        no: 'No'
	      }
	    }
	  },
	  notifications: {
	    noNotifications: 'There are no new notifications.',
	    unableLoad: 'We were unable to load notifications at this time.'
	  },
	  empty: {
	    title: 'Create forms to get to know your customers better and capture contacts',
	    subtitle: 'You can conduct surveys that will help you understand your audience.\n               At the end of the form, gather the leads (contacts) of the people who will respond.',
	    link: 'Learn about form formats you can create',
	    button: 'Create form',
	    url: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox',
	    urlExtensions: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox'
	  }
	};

/***/ },
/* 225 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  general: {
	    labels: {
	      status: 'Estatus',
	      actions: 'Acciones',
	      copied: 'Copiado',
	      error: 'Error',
	      standard: 'Estándar',
	      step: 'Paso',
	      steps: 'Pasos',
	      times: 'vez o veces',
	      table: 'Planilla',
	      exporting: 'Exportando',
	      your: 'Tu',
	      in: 'en',
	      date: 'FECHA',
	      box_name: 'Nombre del Formulário de Búsqueda',
	      new_box: 'Nuevo Formulário de Búsqueda',
	      next: 'PRÓXIMO',
	      edition: 'Edición',
	      editing: 'Editando',
	      description: 'Descripción',
	      title: 'Título',
	      days: 'Días',
	      configurations: 'Configuraciones',
	      and: 'y',
	      seconds: 'Segundos',
	      homepage: 'Inicio',
	      hotmart_logo: 'Logo de Hotmart',
	      themes: 'Modelos',
	      saving: 'Salvando',
	      jump: 'Salto',
	      destinations: 'Destinos',
	      first: 'Primero',
	      last: 'Último',
	      to: 'PARA',
	      button: 'Botón',
	      external: 'Externo',
	      center: 'Centralizado',
	      left: 'Izquierda',
	      right: 'Derecha',
	      other: 'Otro',
	      option: 'Opción'
	    },
	    actions: {
	      new: 'NUVEVO FORMULARIO DE BÚSQUEDA',
	      delete: 'Eliminar',
	      export: 'Exportar',
	      report: 'Informe',
	      edit: 'Editar',
	      copy: 'Copiar',
	      close: 'Cerrar',
	      cancel: 'Cancelar',
	      duplicate: 'Duplicar',
	      publish: 'Publicar',
	      back: 'Volver',
	      click: 'CLIC',
	      add: 'ADICIONAR'
	    }
	  },
	  index: {
	    title: 'Formularios de Búsqueda',
	    subtitle: 'La manera más simple y fácil de crear tus Búsquedas',
	    find_a_box: 'Buscar un Formulario de Búsqueda',
	    list_header: {
	      modality: 'Modalidad',
	      last_modification: 'Última Modificación'
	    }
	  },
	  error: {
	    oops: 'oops',
	    page_not_exists: 'Es posible que esta página no exista...',
	    check_url: 'Verifica si la dirección está escrita correctamente o intenta de nuevo más tarde',
	    something_wrong: 'Algo parece estar errado...',
	    system_offline: 'El sistema puede estar no disponible. ',
	    our_devs: 'Pero nuestros técnicos ya están dedicados a resolver este problema. ',
	    try_again_later: 'Intenta de nuevo en instantes'
	  },
	  modal: {
	    cant_export_table: {
	      title: 'No es posible explorar este informe',
	      max_limit: 'Limite máximo para  de exploración de resultados son de ',
	      select_interval: ' respuestas. Por favor, selecciona un periodo de fechas menor'
	    },
	    code: {
	      step_one: 'Copia el código del Formulario de Búsqueda abajo y pégalo en tu página',
	      step_two: 'Copia el código del botón de llamada aquí abajo ',
	      step_three: 'y añade el link o botón que abrirá el Formulario de Búsqueda'
	    },
	    delete_box: {
	      are_you_sure: '¿Deseas realmente eliminar este Formulario de Búsqueda?',
	      yes: 'Sí, quiero eliminar este Formulario de Búsqueda'
	    },
	    delete_step: {
	      are_you_sure: '¿Deseas realmente eliminar este paso?',
	      yes: 'Sí, quiero eliminar este paso'
	    },
	    duplicate_step: {
	      are_you_sure: '¿Deseas realmente duplicar este paso?',
	      yes: 'Sí, quiero duplicar este paso'
	    },
	    export_table: {
	      answer_table: 'Tabla de respuestas',
	      insert: 'Ingresa aquí abajo tu email para que te enviemos la tabla de respuestas ' + 'cuando esté lista'
	    },
	    export_table_in_progress: {
	      processing_request: 'solicitación está siendo procesada',
	      send_email: 'y así que esté finalizada seráenviada para el e-mail',
	      some_hours: 'Este proceso puede llevar algunas horas'
	    }
	  },
	  report: {
	    menu: {
	      report_of: 'Report de',
	      back_to_answers_summary: 'Regresar para resumen de respuestas',
	      metrics: 'Métricas',
	      individual_answers: 'Respuestas Individuales',
	      box_options: 'Opciones de Formulario de Búsqueda'
	    },
	    charts: {
	      total_answers: 'Total de respuestas'
	    },
	    individual: {
	      date_filter: 'FILTRAR POR PERIODO',
	      date_range: 'PERIODO',
	      from: 'De',
	      to: 'a',
	      answered_in: 'Respondido en',
	      obtained_answers: 'respuestas obtenidas'
	    },
	    metrics: {
	      total_visits: 'VISITAS TOTALES',
	      visits_without_answers: 'VISITAS SIN RESPUESTAS',
	      quizzes_not_completed: 'QUIZZES NO CONCLUIDOS',
	      quizzes_completed: 'QUIZZES CONCLUIDOS',
	      completion_rate: 'TASA DE CONCLUSIÓN',
	      average_time_to_complete: 'TIEMPO MEDIO PARA CONCLUIR',
	      desktop: 'PCs & LAPTOPS',
	      tablet: 'tablet',
	      mobile: 'teléfono móvil',
	      others: 'otros'
	    },
	    emails: {
	      captured_emails: 'e-mails capturados',
	      who_answered: 'de quien respondió'
	    },
	    resume: {
	      question_not_answered: 'Esta pregunta aún no ha sido respondida',
	      no_information_found: 'Ninguna información encontrada'
	    }
	  },
	  edit: {
	    canvas: {
	      visualizing: 'Visualizando',
	      active_item: 'Ítem Activo',
	      default_item: 'Ítem Estándar',
	      past_item: 'Ítem pasado',
	      progressbar: 'Barra de Progreso',
	      general_styles: 'Estilos Generales',
	      answer_options: 'Opciones de Respuesta',
	      redirect_button: 'Botón de Redireccionamiento',
	      positive_button: 'Botón Positivo',
	      positive_button_text: 'Texto del Botón Positivo',
	      negative_button: 'Botón Negativo',
	      negative_button_text: 'Texto del Botón Negativo',
	      welcome_title: 'Título de Bienvenida',
	      welcome_description: 'Descripción de Bienvenida',
	      welcome_buttons: 'Botones de Bienvenida',
	      welcome_active: 'Activar Paso de Bienvenida',
	      next_button: 'Botón Próximo',
	      question_description: 'Descripción de la Pregunta',
	      question_description_placeholder: 'Descripción de la Llamada',
	      question_title: 'Título de la pergunta',
	      question_title_placeholder: 'Escribe aquí tu pregunta',
	      all_steps: 'Todos los Pasos',
	      mail_service: 'Servicios de Email',
	      mail_service_text_area: 'Pega aquí el código HTML del formulario proporcionado por tu ' + 'servicio de email',
	      custom_html_form: 'Formulario HTML personalizado',
	      redirect_by_mail_service: 'Redireccionar para el servicio de email',
	      multiple_answers: 'Permitir más de una respuesta',
	      add_other_option: 'Añadir opción "outra"',
	      redirect_url: 'URL de redireccionamiento',
	      auto_redirect: 'Redireccionamiento automático',
	      required_response: 'Respuesta obligatoria',
	      multiline_response: 'Respuesta en múltiples lineas',
	      multiple_choice_placeholder: 'Escribe aquí una opción de respuesta',
	      add_option: 'Agregar opción',
	      button_text: 'Texto del Botón',
	      start_button_text: 'Texto del Botón Iniciar',
	      next_button_text: 'Texto del Botón Próximo',
	      you_are_editing: 'Está editando el',
	      external_button: 'BOTÓN EXTERNO',
	      click_button: 'Haz clic en el botón',
	      copy_the: 'Pega el',
	      box_code: 'código del Formulário de Búsqueda',
	      call_button_code: 'código del botón de llamada',
	      past_in_your_page: ' y pega en tu página',
	      add_to_link_or_button: 'y añade el link o botón que abrirá el Formulário de Búsqueda',
	      see_flow: 'Ver Flujo',
	      first_value_welcome_select: 'Sí o No',
	      second_value_welcome_select: 'Iniciar'
	    },
	    sidebar: {
	      interval_until_action: 'Exhibir en intervalo de tiempo hasta que el visitante ' + 'realice la acción',
	      times_until_action: 'Exhibir limitadas veces hasta que el visitante realice la acción',
	      until_action: 'Exhibir hasta que el visitante realice la acción',
	      display_frequency: 'Frecuencia de Exhibición',
	      when_box_should_display: '¿Cuándo el Formulário de Búsqueda debe aparecer?',
	      exibition_mode: 'Modo de exhibición',
	      how_box_should_display: '\xBFEn que momento el Formul\xE1rio de B\xFAsqueda debe aparecer para\n      tu visitante?',
	      when_leave_the_page: 'Al salir de la página',
	      immediately_when_access: 'Inmediatamente al ingresar',
	      on_scroll: 'En el desplazamiento',
	      until_page_top: 'Hasta el comienzo de página (25%)',
	      until_page_middle: 'Hasta el medio de la página (50%)',
	      until_page_bottom: 'Hasta el final de la página (75%)',
	      by_time_on_page: 'Por tiempo en la página',
	      call_button_style: 'Estilo del Botón de Llamada',
	      background_color: 'Color de Fondo',
	      border_color: 'Color del Borde',
	      border_radius: 'Redondeo',
	      text_color: 'Color del texto',
	      visibility: 'Visibilidad',
	      font: 'Fuente',
	      font_size: 'Tamaño del texto',
	      height: 'Altura',
	      width: 'Anchura',
	      add_jump: 'Añadir Salto',
	      add_answer: 'Añadir respuesta',
	      select_destiny: 'Selecciona un destino',
	      all_other_cases: 'En todos los otros casos ir para...',
	      always_jump_to: 'Siempre Saltar para...',
	      select_one_answer: 'Selecciona una respuesta',
	      select_the_answers: 'Selecciona las respuestas',
	      choose_one_answer: 'Elige una respuesta',
	      go_to_next: 'Ir para el próximo',
	      add_one_question: 'añade UNA cuestión haciendo CLIC EN ESTE BOTÓN',
	      question: 'pregunta',
	      yes_no: 'sí/no',
	      text: 'texto',
	      capture: 'Captura',
	      of_email: 'de e-mail',
	      redirec: 'REDIRECCIO',
	      tion: 'NAMIENTO',
	      format: 'Formato',
	      choose_a_theme: 'ELIGE UN MODELO',
	      edit_theme: 'Editar tema',
	      without_style: 'Sin Estilo',
	      alignment: 'Alineación',
	      call_button: 'Botón de Llamada',
	      in_one_component: 'En un componente',
	      one_component_to_integrate: 'Un componente para integrar en tu página',
	      in_full_screen: 'En pantalla entera',
	      one_screen_that_cover: 'Una pantalla cubre tu página completamente',
	      in_mini_slider: 'En un mini slide',
	      one_small_window_apper: 'Una pequeña ventana surge en el margen inferior de la página',
	      in_a_popup: 'En un pop-up',
	      one_box_apper_in_the_middle: 'Una caja surge en el medio de la pantalla',
	      in_a_slider: 'En un slide',
	      one_screen_apper_right: 'Una pantalla que surge del lado derecho',
	      how_might_show: '¿Cómo deseas exhibir?',
	      select_box_format: 'Selecciona el formato de tu Formulário de Búsqueda',
	      auto: 'Automáticamente',
	      at_some_point: 'En algún momento durante el acceso',
	      on_click: 'Al hacer clic',
	      on_click_some_button: 'Al hacer clic en algún botón dentro de la página',
	      when_might_show: '¿Cuándo deseas exhibir?',
	      select_when_box_should_apper: 'Selecciona cuando el Formulário de Búsqueda debe aparecer',
	      configure_box: 'Configurar el Formulário de Búsqueda'
	    }
	  },
	  step_kinds: {
	    kinds: {
	      multiple_choise: {
	        title: '¿Cuál es tu pregunta?',
	        description_text: 'Descripción de la pregunta'
	      },
	      yes_no: {
	        title: '¿Cuál es tu pregunta?',
	        description_text: 'Descripción de la pregunta'
	      },
	      text: {
	        title: '¿Cuál es tu nombre?',
	        description_text: '',
	        placeholder: 'Escribe aquí tu nombre...'
	      },
	      email: {
	        title: '¿Cuál es tu email?',
	        description_text: ''
	      },
	      redirect: {
	        title: '¡Felicitaciones! Haz clic aquí para acceder a tu contenido personalizado',
	        description_text: '',
	        button_text: 'Acceder la página'
	      },
	      thanks: {
	        title: '¡Gracias!',
	        description_text: '¡Tus datos han sido computados con éxito en nuestra encuesta!'
	      }
	    },
	    options: {
	      multiple_choise: {
	        first_option: 'Opción 1',
	        second_option: 'Opción 2'
	      },
	      yes_no: {
	        yes: 'Sí',
	        no: 'No'
	      }
	    }
	  },
	  notifications: {
	    noNotifications: 'No hay notificaciones nuevas.',
	    unableLoad: 'No pudimos cargar notificaciones en este momento.'
	  },
	  empty: {
	    title: 'Crea formularios para conocer mejor a tus clientes y captar contactos',
	    subtitle: 'Puede realizar encuestas que lo ayudar\xE1n a comprender a su audiencia.\n               Al final del formulario, re\xFAna los clientes potenciales\n               (contactos) de las personas que responder\xE1n.',
	    link: 'Obtenga información sobre los formatos de formulario que puede crear',
	    button: 'Crear formulario',
	    url: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox',
	    urlExtensions: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox'
	  }
	};

/***/ },
/* 226 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  general: {
	    labels: {
	      status: 'Status',
	      actions: 'Ações',
	      copied: 'Copiado',
	      error: 'Erro',
	      standard: 'Padrão',
	      step: 'Passo',
	      steps: 'Passos',
	      times: 'vez(es)',
	      table: 'Tabela',
	      exporting: 'Exportando',
	      your: 'Sua',
	      in: 'em',
	      date: 'DATA',
	      box_name: 'Nome do Formulário de Pesquisa',
	      new_box: 'Novo Formulário de Pesquisa',
	      next: 'PRÓXIMO',
	      edition: 'Edição',
	      editing: 'Editando',
	      description: 'Descrição',
	      title: 'Título',
	      days: 'Dias',
	      configurations: 'Configurações',
	      and: 'e',
	      seconds: 'Segundos',
	      homepage: 'Página Inicial',
	      hotmart_logo: 'Logo da Hotmart',
	      themes: 'Modelos',
	      saving: 'Salvando',
	      jump: 'Salto',
	      destinations: 'Destinos',
	      first: 'Primeiro',
	      last: 'Último',
	      to: 'PARA',
	      button: 'Botão',
	      external: 'Externo',
	      center: 'Centralizado',
	      left: 'Esquerda',
	      right: 'Direita',
	      other: 'Outro',
	      option: 'Opção'
	    },
	    actions: {
	      new: 'CRIAR FORMULÁRIO',
	      delete: 'Deletar',
	      export: 'Exportar',
	      report: 'Relatório',
	      edit: 'Editar',
	      copy: 'Copiar',
	      close: 'Fechar',
	      cancel: 'Cancelar',
	      duplicate: 'Duplicar',
	      publish: 'Publicar',
	      back: 'Voltar',
	      click: 'CLIQUE',
	      add: 'ADICIONAR'
	    }
	  },
	  index: {
	    title: 'Formulários de Pesquisa',
	    subtitle: 'O jeito mais simples e fácil de criar suas pesquisas',
	    find_a_box: 'Procurar um Formulário de Pesquisa',
	    list_header: {
	      modality: 'Modalidad',
	      last_modification: 'Última Modificação'
	    }
	  },
	  error: {
	    oops: 'oops',
	    page_not_exists: 'É possível que essa página não exista...',
	    check_url: 'Verifique se o endereço está digitado corretamente ou tente novamente mais tarde',
	    something_wrong: 'Algo parece estar errado...',
	    system_offline: 'O sistema pode estar fora do ar. ',
	    our_devs: 'Mas os nossos técnicos já estão dedicados a resolver esse problema. ',
	    try_again_later: 'Tente novamente em instantes'
	  },
	  modal: {
	    cant_export_table: {
	      title: 'Não é possível exportar esse relatório',
	      max_limit: 'Limite máximo para exportação de resultados são de ',
	      select_interval: ' respostas. Por favor, selecione um período de datas menor'
	    },
	    code: {
	      step_one: 'Copie o código do Formulário de Pesquisa abaixo e cole na sua página',
	      step_two: 'Copie o código do botão de chamada abaixo ',
	      step_three: 'e adicione no link ou botão que abrirá o Formulário de Pesquisa'
	    },
	    delete_box: {
	      are_you_sure: 'Você deseja realmente deletar esse Formulário de Pesquisa?',
	      yes: 'Sim, eu quero deletar esse Formulário de Pesquisa!'
	    },
	    delete_step: {
	      are_you_sure: 'Você deseja realmente deletar esse passo?',
	      yes: 'Sim, eu quero deletar esse passo!'
	    },
	    duplicate_step: {
	      are_you_sure: 'Você deseja realmente duplicar esse passo?',
	      yes: 'Sim, eu quero duplicar esse passo!'
	    },
	    export_table: {
	      answer_table: 'Tabela de Respostas',
	      insert: 'Insira abaixo seu email para enviarmos a tabela de respostas quando estiver pronta'
	    },
	    export_table_in_progress: {
	      processing_request: 'solicitação está sendo processada',
	      send_email: 'e assim que for finalizada nós enviaremos para o e-mail',
	      some_hours: 'Esse processo pode levar algumas horas'
	    }
	  },
	  report: {
	    menu: {
	      report_of: 'Report de',
	      back_to_answers_summary: 'Voltar para resumo de respostas',
	      metrics: 'Métricas',
	      individual_answers: 'Respostas Individuais',
	      box_options: 'Opções do Formulário de Pesquisa'
	    },
	    charts: {
	      total_answers: 'Total de respostas'
	    },
	    individual: {
	      date_filter: 'FILTRAR POR PERÍODO',
	      date_range: 'PERÍODO',
	      from: 'De',
	      to: 'Até',
	      answered_in: 'Respondido em',
	      obtained_answers: 'respostas obtidas'
	    },
	    metrics: {
	      total_visits: 'VISITAS TOTAIS',
	      visits_without_answers: 'VISITAS SEM RESPOSTAS',
	      quizzes_not_completed: 'QUIZZES NÃO CONCLUÍDOS',
	      quizzes_completed: 'QUIZZES CONCLUÍDOS',
	      completion_rate: 'TAXA DE CONCLUSÃO',
	      average_time_to_complete: 'TEMPO MÉDIO PARA CONCLUIR',
	      desktop: 'PCs & LAPTOPS',
	      tablet: 'tablet',
	      mobile: 'celular',
	      others: 'outros'
	    },
	    emails: {
	      captured_emails: 'e-mails capturados',
	      who_answered: 'de quem respondeu'
	    },
	    resume: {
	      question_not_answered: 'Essa pergunta ainda não possui uma resposta',
	      no_information_found: 'Nenhuma informação encontrada'
	    }
	  },
	  edit: {
	    canvas: {
	      visualizing: 'Visualizando',
	      active_item: 'Item Ativo',
	      default_item: 'Item Padrão',
	      past_item: 'Item passado',
	      progressbar: 'Barra de Progresso',
	      general_styles: 'Estilos Gerais',
	      answer_options: 'Opções de Resposta',
	      redirect_button: 'Botão de Redirecionamento',
	      positive_button: 'Botão Posexternalitivo',
	      positive_button_text: 'Texto do Botão Positivo',
	      negative_button: 'Botão Negativo',
	      negative_button_text: 'Texto do Botão Negativo',
	      welcome_title: 'Título de Boas Vindas',
	      welcome_description: 'Descrição de Boas Vindas',
	      welcome_buttons: 'Botões de Boas Vindas',
	      welcome_active: 'Ativar Passo de Boas Vindas',
	      next_button: 'Botão Próximo',
	      question_description: 'Descrição da Pergunta',
	      question_description_placeholder: 'Descrição da Chamada',
	      question_title: 'Título da Pergunta',
	      question_title_placeholder: 'Digite aqui sua pergunta',
	      all_steps: 'Todos os Passos',
	      mail_service: 'Serviço de Email',
	      mail_service_text_area: 'Cole aqui o código HTML do formulário ' + 'fornecido pelo seu serviço de email',
	      custom_html_form: 'Formulário HTML customizado',
	      redirect_by_mail_service: 'Redirecionar pelo serviço de email',
	      multiple_answers: 'Permitir mais de uma resposta',
	      add_other_option: 'Adicionar opção "outra"',
	      redirect_url: 'URL de redirecionamento',
	      auto_redirect: 'Redirecionamento Automático',
	      required_response: 'Resposta obrigatória',
	      multiline_response: 'Resposta em múltiplas linhas',
	      multiple_choice_placeholder: 'Escreva aqui uma opção de resposta',
	      add_option: 'Adicionar Opção',
	      button_text: 'Texto do Botão',
	      start_button_text: 'Texto do Botão Iniciar',
	      next_button_text: 'Texto do Botão Próximo',
	      you_are_editing: 'Você está editando o',
	      external_button: 'BOTÃO EXTERNO',
	      click_button: 'Clique no botão',
	      copy_the: 'Copie o',
	      box_code: 'código do Formulário de Pesquisa',
	      call_button_code: 'código do botão de chamada',
	      past_in_your_page: ' e cole na sua página',
	      add_to_link_or_button: 'e adicione no link ou botão que abrirá o Formulário de Pesquisa',
	      see_flow: 'Ver Fluxo',
	      first_value_welcome_select: 'Sim ou Não',
	      second_value_welcome_select: 'Iniciar'
	    },
	    sidebar: {
	      interval_until_action: 'Exibir em intervalo de tempo até que o visitante realize a ação',
	      times_until_action: 'Exibir limitadas vezes até que o visitante realize a ação',
	      until_action: 'Exibir até que o visitante realize a ação',
	      display_frequency: 'Frequência de Exibição',
	      when_box_should_display: 'Quando o Formulário de Pesquisa deve aparecer?',
	      exibition_mode: 'Modo de exibição',
	      how_box_should_display: 'Em que momento o Formul\xE1rio de Pesquisa deve aparecer para o\n      seu visitante?',
	      when_leave_the_page: 'Ao sair da página',
	      immediately_when_access: 'Imediatamente ao acessar',
	      on_scroll: 'Na rolagem',
	      until_page_top: 'Até começo da página (25%)',
	      until_page_middle: 'Até meio da página (50%)',
	      until_page_bottom: 'Até final da página (75%)',
	      by_time_on_page: 'Por tempo na página',
	      call_button_style: 'Estilo do Botão de Chamada',
	      background_color: 'Cor de Fundo',
	      border_color: 'Cor da Borda',
	      border_radius: 'Arredondamento',
	      text_color: 'Cor do Texto',
	      visibility: 'Visibilidade',
	      font: 'Fonte',
	      font_size: 'Tamanho do Texto',
	      height: 'Altura',
	      width: 'Largura',
	      add_jump: 'Adicionar Salto',
	      add_answer: 'Adicionar resposta',
	      select_destiny: 'Selecione um destino',
	      all_other_cases: 'Em todos os outros casos ir para...',
	      always_jump_to: 'Sempre Saltar para...',
	      select_one_answer: 'Selecione uma resposta',
	      select_the_answers: 'Selecione as respostas',
	      choose_one_answer: 'Escolha uma resposta',
	      go_to_next: 'Ir para o próximo',
	      add_one_question: 'adicione UMA questão CLICANDO NESTE BOTÃO',
	      question: 'pergunta',
	      yes_no: 'sim/não',
	      text: 'texto',
	      capture: 'Captura',
	      of_email: 'de e-mail',
	      redirec: 'REDIRECIO',
	      tion: 'NAMENTO',
	      format: 'Formato',
	      choose_a_theme: 'ESCOLHA UM MODELO',
	      edit_theme: 'Editar tema',
	      without_style: 'Sem Estilo',
	      alignment: 'Alinhamento',
	      call_button: 'Botão de Chamada',
	      in_one_component: 'Em um componente',
	      one_component_to_integrate: 'Um componente para integrar em sua página',
	      in_full_screen: 'Em tela inteira',
	      one_screen_that_cover: 'Uma tela cobre a sua página completamente',
	      in_mini_slider: 'Em um mini slide',
	      one_small_window_apper: 'Uma pequena janela surge no canto inferior da página',
	      in_a_popup: 'Em um pop-up',
	      one_box_apper_in_the_middle: 'Uma caixa surge no meio da tela',
	      in_a_slider: 'Em um slide',
	      one_screen_apper_right: 'Uma tela que surge do lado direito',
	      how_might_show: 'Como deseja exibir?',
	      select_box_format: 'Selecione o formato do seu Formulário de Pesquisa',
	      auto: 'Automaticamente',
	      at_some_point: 'Em algum momento durante o acesso',
	      on_click: 'Ao clicar',
	      on_click_some_button: 'Ao clicar em algum botão dentro da página',
	      when_might_show: 'Quando deseja exibir?',
	      select_when_box_should_apper: 'Selecione quando o Formulário de Pesquisa deve aparecer',
	      configure_box: 'Configurar o Formulário de Pesquisa'
	    }
	  },
	  step_kinds: {
	    kinds: {
	      multiple_choise: {
	        title: 'Qual é a sua pergunta?',
	        description_text: 'Descrição da pergunta'
	      },
	      yes_no: {
	        title: 'Qual é a sua pergunta?',
	        description_text: 'Descrição da pergunta'
	      },
	      text: {
	        title: 'Qual é seu nome?',
	        description_text: '',
	        placeholder: 'Digite aqui seu nome...'
	      },
	      email: {
	        title: 'Qual é o seu email?',
	        description_text: ''
	      },
	      redirect: {
	        title: 'Parabéns! Clique aqui para acessar seu conteúdo personalizado',
	        description_text: '',
	        button_text: 'Acessar a página'
	      },
	      thanks: {
	        title: 'Obrigado!',
	        description_text: 'Seus dados foram computados com sucesso na nossa pesquisa!'
	      }
	    },
	    options: {
	      multiple_choise: {
	        first_option: 'Opção 1',
	        second_option: 'Opção 2'
	      },
	      yes_no: {
	        yes: 'Sim',
	        no: 'Não'
	      }
	    }
	  },
	  notifications: {
	    noNotifications: 'Não há novas notificações.',
	    unableLoad: 'Não foi possível carregar as notificações no momento.'
	  },
	  empty: {
	    title: 'Crie formulários para conhecer melhor seus clientes e capturar contatos',
	    subtitle: 'Voc\xEA pode realizar pesquisas que te ajudam a entender seu p\xFAblico.\n               Ao final do formul\xE1rio, colete os leads (contatos) das pessoas que responderam.',
	    link: 'Saiba mais sobre formatos de formulários que você pode criar',
	    button: 'Criar formulário',
	    url: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox',
	    urlExtensions: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox'
	  }
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Locale = __webpack_require__(577);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Index = __webpack_require__(576);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Edit = __webpack_require__(575);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _Report = __webpack_require__(579);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	var _Metrics = __webpack_require__(742);
	
	var _Metrics2 = _interopRequireDefault(_Metrics);
	
	var _Main = __webpack_require__(739);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Auth = __webpack_require__(574);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _NotFound = __webpack_require__(578);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  path: '/:locale',
	  component: _Locale2.default,
	  children: [{ path: '', name: 'index', component: _Index2.default }, { path: ':boxId/edit', name: 'boxEdit', component: _Edit2.default }, {
	    path: ':boxId/report/',
	    name: 'boxReports',
	    component: _Report2.default,
	    children: [{ path: '', component: _Metrics2.default, name: 'boxReportsMetrics' }, { path: 'individuals', component: _Main2.default, name: 'boxReportsIndividuals' }]
	  }, { path: 'auth', name: 'auth', component: _Auth2.default }]
	}, { path: '*', name: 'not-found', component: _NotFound2.default }];

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var resetStateToIndex = function resetStateToIndex(store) {
	  store.dispatch('canvasResetState');
	  store.dispatch('boxResetActive');
	  store.dispatch('jumpResetActive');
	  store.dispatch('optionResetActive');
	  store.dispatch('reportResetState');
	  store.dispatch('stepResetState');
	  store.dispatch('sidebarResetState');
	  store.dispatch('quizResetState');
	  store.dispatch('themeResetState');
	};
	
	var setup = exports.setup = function setup(router, store) {
	  router.beforeEach(function (to, from, next) {
	    if (to.name === 'index') {
	      resetStateToIndex(store);
	    }
	    next();
	  });
	};

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(1);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _box = __webpack_require__(234);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _sidebar = __webpack_require__(278);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _step = __webpack_require__(282);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _option = __webpack_require__(254);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _jump = __webpack_require__(246);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	var _auth = __webpack_require__(231);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _canvas = __webpack_require__(238);
	
	var _canvas2 = _interopRequireDefault(_canvas);
	
	var _modal = __webpack_require__(250);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _code = __webpack_require__(242);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _tableData = __webpack_require__(274);
	
	var _tableData2 = _interopRequireDefault(_tableData);
	
	var _metrics = __webpack_require__(262);
	
	var _metrics2 = _interopRequireDefault(_metrics);
	
	var _quiz = __webpack_require__(258);
	
	var _quiz2 = _interopRequireDefault(_quiz);
	
	var _theme = __webpack_require__(286);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _optionEmails = __webpack_require__(266);
	
	var _optionEmails2 = _interopRequireDefault(_optionEmails);
	
	var _resume = __webpack_require__(270);
	
	var _resume2 = _interopRequireDefault(_resume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production' || ("production") !== 'staging';
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    box: _box2.default,
	    sidebar: _sidebar2.default,
	    step: _step2.default,
	    option: _option2.default,
	    jump: _jump2.default,
	    auth: _auth2.default,
	    canvas: _canvas2.default,
	    modal: _modal2.default,
	    code: _code2.default,
	    tableData: _tableData2.default,
	    metrics: _metrics2.default,
	    quiz: _quiz2.default,
	    theme: _theme2.default,
	    optionEmails: _optionEmails2.default,
	    resume: _resume2.default
	  },
	  strict: debug
	});

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInit = undefined;
	
	var _token = __webpack_require__(92);
	
	var AuthToken = _interopRequireWildcard(_token);
	
	var _router = __webpack_require__(59);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var KLICKART_AUTH_URI = ("https://art.klickpages.com.br/crossapp/klickbox");
	var authInit = exports.authInit = function authInit(_ref) {
	  var rootState = _ref.rootState;
	  var redirect = rootState.route.query.redirect;
	  var locale = rootState.route.params.locale;
	  var token = rootState.route.query.token;
	
	
	  if (!token) {
	    window.location = KLICKART_AUTH_URI;
	    return;
	  }
	
	  token = token.replace(/\s/g, '+');
	
	  AuthToken.set(token);
	
	  if (redirect) {
	    window.location = redirect;
	    return;
	  }
	
	  _router2.default.push({ name: 'index', params: { locale: locale } });
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(230);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateKlickpagesHeaderShowStatus = exports.boxUpdateContentBody = exports.boxPreviewConfigStyleChange = exports.boxUpdateConfigStyle = exports.boxUpdateConfig = exports.boxResetActive = exports.boxSetTheme = exports.boxAdd = exports.boxesDelete = exports.boxesSetName = exports.boxSave = exports.boxSetName = exports.boxSetFormat = exports.boxSetKind = exports.boxSetActive = exports.boxGet = exports.boxGetAll = undefined;
	
	var _klicknotify = __webpack_require__(80);
	
	var _klicknotify2 = _interopRequireDefault(_klicknotify);
	
	var _types = __webpack_require__(106);
	
	var types = _interopRequireWildcard(_types);
	
	var _types2 = __webpack_require__(60);
	
	var stepTypes = _interopRequireWildcard(_types2);
	
	var _box = __webpack_require__(48);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _router = __webpack_require__(59);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _internalstyle = __webpack_require__(58);
	
	var internalStyleHelper = _interopRequireWildcard(_internalstyle);
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locale = _i18n2.default.locale;
	var messages = _i18n2.default.messages[locale];
	
	var BoxRequest = new _box2.default();
	
	var boxGetAll = exports.boxGetAll = function boxGetAll(_ref) {
	  var commit = _ref.commit;
	
	  BoxRequest.get('', { catchError: true }).then(function (response) {
	    return commit(types.BOX_LIST_SET, response.data);
	  });
	};
	
	var boxGet = exports.boxGet = function boxGet(_ref2) {
	  var commit = _ref2.commit,
	      dispatch = _ref2.dispatch,
	      rootState = _ref2.rootState;
	
	  var boxId = rootState.route.params.boxId;
	
	  return BoxRequest.get(boxId, { catchError: true }).then(function (response) {
	    var box = response.data;
	    commit(types.BOX_ACTIVE_SET, box);
	    commit(stepTypes.STEP_UPDATE_QUIZ_ID, box.quiz_id);
	    dispatch('quizGet', box.quiz_id);
	    dispatch('themeGet', box.theme_slug);
	
	    return box;
	  });
	};
	
	var boxSetActive = exports.boxSetActive = function boxSetActive(_ref3, box) {
	  var commit = _ref3.commit;
	
	  commit(types.BOX_ACTIVE_SET, box);
	};
	
	var boxSetKind = exports.boxSetKind = function boxSetKind(_ref4, type) {
	  var rootState = _ref4.rootState,
	      dispatch = _ref4.dispatch,
	      commit = _ref4.commit;
	
	  var boxId = rootState.route.params.boxId;
	
	  BoxRequest.put(boxId, { kind: type }, { showLoader: true }).then(function () {
	    commit(types.BOX_ACTIVE_UPDATE_KIND, type);
	    dispatch('sidebarChangePanel', 'themes');
	  });
	};
	
	var boxSetFormat = exports.boxSetFormat = function boxSetFormat(_ref5, format) {
	  var rootState = _ref5.rootState,
	      dispatch = _ref5.dispatch,
	      commit = _ref5.commit;
	
	  var boxId = rootState.route.params.boxId;
	
	  BoxRequest.put(boxId, { format: format }, { showLoader: true }).then(function () {
	    var nextPanel = format === 'component' ? 'themes' : 'viewmode';
	
	    commit(types.BOX_ACTIVE_UPDATE_FORMAT, format);
	    dispatch('sidebarChangePanel', nextPanel);
	  });
	};
	
	var boxSetName = exports.boxSetName = function boxSetName(_ref6, event) {
	  var commit = _ref6.commit,
	      rootState = _ref6.rootState;
	
	  var boxId = rootState.route.params.boxId;
	  var name = event.currentTarget.value;
	
	  BoxRequest.put(boxId, { name: name }, { showLoader: true }).then(function () {
	    return commit(types.BOX_ACTIVE_UPDATE_NAME, name);
	  });
	};
	
	var boxSave = exports.boxSave = function boxSave(_ref7, publish) {
	  var state = _ref7.state,
	      rootState = _ref7.rootState;
	
	  var boxId = rootState.route.params.boxId;
	  var box = state.active;
	
	  box.publish = publish;
	
	  return BoxRequest.put(boxId, box).then(function () {
	    return _klicknotify2.default.success({
	      message: 'Box salvo com sucesso!',
	      autoHide: true
	    });
	  }).catch(function () {
	    return _klicknotify2.default.error({
	      message: 'Não foi possível salvar o box. Tente novamente.',
	      autoHide: true
	    });
	  });
	};
	
	var boxesSetName = exports.boxesSetName = function boxesSetName(_ref8, data) {
	  var commit = _ref8.commit;
	
	  BoxRequest.put(data.id, { name: data.event.target.value }).then(function (response) {
	    return commit(types.BOX_LIST_UPDATE_NAME, response.data);
	  });
	};
	
	var boxesDelete = exports.boxesDelete = function boxesDelete(_ref9) {
	  var commit = _ref9.commit,
	      state = _ref9.state,
	      dispatch = _ref9.dispatch;
	
	  var box = state.active;
	
	  BoxRequest.delete(box.id).then(function () {
	    commit(types.BOX_LIST_REMOVE, box);
	    dispatch('modalClose');
	  });
	};
	
	var boxAdd = exports.boxAdd = function boxAdd() {
	  var newBox = {
	    name: messages.general.labels.new_box,
	    kind: null,
	    content_body: '<div id="klickbox-quiz-canvas"></div>',
	    config: {
	      trigger_button: {
	        style: {
	          backgroundColor: '#44B3F2',
	          color: '#fff',
	          borderRadius: '5px',
	          width: '250px'
	        },
	        kind: 'basic',
	        text: 'Responda nossa pesquisa'
	      },
	      progressbar: {
	        kind: 'standard',
	        svg: {
	          bullet: '<svg></svg>',
	          bar: '<svg></svg>'
	        },
	        step: 0
	      },
	      advanced: {
	        view_mode: 'click',
	        exibition_mode: 'immediately',
	        exibition_mode_time_value: 5,
	        exibition_mode_scroll_value: 50,
	        exibition_frequency: 'until_action',
	        exibition_frequency_times_value: 3,
	        exibition_frequency_interval_value: 3
	      }
	    }
	  };
	
	  BoxRequest.post(newBox).then(function (response) {
	    var boxId = response.data.id;
	
	    _router2.default.push({
	      name: 'boxEdit',
	      params: {
	        locale: _i18n2.default.locale,
	        boxId: boxId
	      }
	    });
	  });
	};
	
	var boxSetTheme = exports.boxSetTheme = function boxSetTheme(_ref10, data) {
	  var commit = _ref10.commit;
	
	  BoxRequest.put(data.id, { theme_slug: data.theme_slug, theme_fonts: data.theme_fonts }).then(function (response) {
	    commit(types.BOX_ACTIVE_UPDATE_THEME_SLUG, response.data);
	    commit(types.BOX_ACTIVE_UPDATE_THEME_FONTS, response.data);
	  });
	};
	
	var boxResetActive = exports.boxResetActive = function boxResetActive(_ref11) {
	  var commit = _ref11.commit;
	
	  commit(types.BOX_ACTIVE_RESET);
	};
	
	var boxUpdateConfig = exports.boxUpdateConfig = function boxUpdateConfig(_ref12, _ref13) {
	  var commit = _ref12.commit,
	      state = _ref12.state;
	  var item = _ref13.item,
	      key = _ref13.key,
	      value = _ref13.value;
	
	  var config = state.active.config;
	
	  commit(types.BOX_UPDATE_CONFIG, { item: item, key: key, value: value });
	
	  BoxRequest.put(state.active.id, { config: config }, { showLoader: true }).then(function (response) {
	    return commit(types.BOX_SET_CONFIG, response.data.config);
	  }).catch(function () {
	    return commit(types.BOX_SET_CONFIG, config);
	  });
	};
	
	var boxUpdateConfigStyle = exports.boxUpdateConfigStyle = function boxUpdateConfigStyle(_ref14, _ref15) {
	  var commit = _ref14.commit,
	      state = _ref14.state;
	  var item = _ref15.item,
	      rule = _ref15.rule,
	      value = _ref15.value;
	
	  var config = state.active.config;
	
	  commit(types.BOX_UPDATE_CONFIG_STYLE, { item: item, rule: rule, value: value });
	
	  BoxRequest.put(state.active.id, { config: config }, { showLoader: true }).then(function (response) {
	    return commit(types.BOX_SET_CONFIG, response.data.config);
	  }).catch(function () {
	    return commit(types.BOX_SET_CONFIG, config);
	  });
	};
	
	var boxPreviewConfigStyleChange = exports.boxPreviewConfigStyleChange = function boxPreviewConfigStyleChange(_ref16, _ref17) {
	  var commit = _ref16.commit;
	  var item = _ref17.item,
	      rule = _ref17.rule,
	      value = _ref17.value;
	
	  commit(types.BOX_UPDATE_CONFIG_STYLE, { item: item, rule: rule, value: value });
	};
	
	var boxUpdateContentBody = exports.boxUpdateContentBody = function boxUpdateContentBody(_ref18, styles) {
	  var commit = _ref18.commit,
	      state = _ref18.state;
	
	  var styleTag = internalStyleHelper.getHtmlTag(styles);
	  var contentBody = styleTag + '<div id="klickbox-quiz-canvas"></div>';
	
	  BoxRequest.put(state.active.id, { content_body: contentBody }, { showLoader: true }).then(function (response) {
	    return commit(types.BOX_UPDATE_CONTENT_BODY, response.data.content_body);
	  });
	};
	
	var updateKlickpagesHeaderShowStatus = exports.updateKlickpagesHeaderShowStatus = function updateKlickpagesHeaderShowStatus(_ref19, data) {
	  var commit = _ref19.commit;
	
	  commit(types.KLICKPAGES_HEADER_ACTIVE, data);
	};

/***/ },
/* 233 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var boxName = exports.boxName = function boxName(state) {
	  return state.active.name;
	};
	
	var boxKind = exports.boxKind = function boxKind(state) {
	  return state.active.kind;
	};
	
	var boxFormat = exports.boxFormat = function boxFormat(state) {
	  return state.active.format;
	};
	
	var boxThemeSlug = exports.boxThemeSlug = function boxThemeSlug(state) {
	  return state.active.theme_slug;
	};
	
	var boxThemeFonts = exports.boxThemeFonts = function boxThemeFonts(state) {
	  return state.active.theme_fonts;
	};
	
	var boxList = exports.boxList = function boxList(state) {
	  return state.list;
	};
	
	var boxId = exports.boxId = function boxId(state) {
	  return state.active.id;
	};
	
	var boxActive = exports.boxActive = function boxActive(state) {
	  return state.active;
	};
	
	var boxConfig = exports.boxConfig = function boxConfig(state) {
	  return state.active.config;
	};
	
	var showKlickpagesHeader = exports.showKlickpagesHeader = function showKlickpagesHeader(state) {
	  return state.showKlickpagesHeader;
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(232);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(233);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(235);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(106);
	
	var types = _interopRequireWildcard(_types);
	
	var _merge = __webpack_require__(100);
	
	var merge = _interopRequireWildcard(_merge);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultConfig = {
	  trigger_button: {
	    style: {
	      backgroundColor: '#44B3F2',
	      color: '#fff',
	      borderRadius: '5px',
	      width: '250px'
	    },
	    kind: 'basic',
	    text: 'Responda nossa pesquisa'
	  },
	  progressbar: {
	    kind: 'standard',
	    svg: {
	      bullet: '<svg></svg>',
	      bar: '<svg></svg>'
	    },
	    step: 0
	  },
	  advanced: {
	    view_mode: 'click',
	    exibition_mode: 'immediately',
	    exibition_mode_time_value: 5,
	    exibition_mode_scroll_value: 50,
	    exibition_frequency: 'until_action',
	    exibition_frequency_times_value: 3,
	    exibition_frequency_interval_value: 3
	  }
	};
	
	var state = exports.state = {
	  list: [],
	  active: {
	    config: defaultConfig
	  },
	  showKlickpagesHeader: true
	};
	
	var find = function find(state, data, callback) {
	  return state.list.map(function (box, index) {
	    if (box.id === data.id) {
	      callback(box, index);
	    }
	
	    return box;
	  });
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.BOX_ACTIVE_SET, function (state, box) {
	  box.config = merge.deep({}, defaultConfig, box.config);
	
	  state.active = box;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_LIST_SET, function (state, boxes) {
	  state.list = boxes;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_ACTIVE_UPDATE_KIND, function (state, type) {
	  state.active.kind = type;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_ACTIVE_UPDATE_FORMAT, function (state, format) {
	  state.active.format = format;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_ACTIVE_UPDATE_THEME_SLUG, function (state, data) {
	  state.active.theme_slug = data.theme_slug;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_ACTIVE_UPDATE_THEME_FONTS, function (state, data) {
	  state.active.theme_fonts = data.theme_fonts;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_ACTIVE_UPDATE_NAME, function (state, name) {
	  state.active.name = name;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_LIST_UPDATE_NAME, function (state, data) {
	  find(state, data, function (box) {
	    box.name = data.name;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.BOX_LIST_REMOVE, function (state, data) {
	  find(state, data, function (box, index) {
	    state.list.splice(index, 1);
	  });
	}), (0, _defineProperty3.default)(_mutations, types.BOX_ACTIVE_RESET, function (state) {
	  state.active = {
	    config: defaultConfig
	  };
	}), (0, _defineProperty3.default)(_mutations, types.BOX_SET_CONFIG, function (state, config) {
	  state.active.config = config;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_UPDATE_CONFIG, function (state, _ref) {
	  var item = _ref.item,
	      key = _ref.key,
	      value = _ref.value;
	
	  state.active.config[item][key] = value;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_UPDATE_CONFIG_STYLE, function (state, _ref2) {
	  var item = _ref2.item,
	      rule = _ref2.rule,
	      value = _ref2.value;
	
	  state.active.config[item].style[rule] = value;
	}), (0, _defineProperty3.default)(_mutations, types.BOX_UPDATE_CONTENT_BODY, function (state, contentBody) {
	  state.active.content_body = contentBody;
	}), (0, _defineProperty3.default)(_mutations, types.KLICKPAGES_HEADER_ACTIVE, function (state, data) {
	  state.showKlickpagesHeader = data;
	}), _mutations);

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canvasResetState = exports.canvasDisableHighlight = exports.canvasEnableHighlight = exports.canvasChangePreviewDevice = exports.canvasChangeView = undefined;
	
	var _types = __webpack_require__(107);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var canvasChangeView = exports.canvasChangeView = function canvasChangeView(_ref, panel) {
	  var commit = _ref.commit;
	
	  commit(types.CANVAS_CHANGE_VIEW, panel);
	};
	
	var canvasChangePreviewDevice = exports.canvasChangePreviewDevice = function canvasChangePreviewDevice(_ref2, device) {
	  var commit = _ref2.commit;
	
	  commit(types.CANVAS_CHANGE_PREVIEW_DEVICE, device);
	};
	
	var canvasEnableHighlight = exports.canvasEnableHighlight = function canvasEnableHighlight(_ref3, data) {
	  var commit = _ref3.commit;
	
	  commit(types.CANVAS_ENABLE_HIGHLIGHT, data.event.target);
	};
	
	var canvasDisableHighlight = exports.canvasDisableHighlight = function canvasDisableHighlight(_ref4) {
	  var commit = _ref4.commit;
	
	  commit(types.CANVAS_DISABLE_HIGHLIGHT);
	};
	
	var canvasResetState = exports.canvasResetState = function canvasResetState(_ref5) {
	  var commit = _ref5.commit;
	
	  commit(types.CANVAS_RESET_STATE);
	};

/***/ },
/* 237 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canvasCurrentView = exports.canvasCurrentView = function canvasCurrentView(state) {
	  return state.currentView;
	};
	
	var canvasPreviewDevice = exports.canvasPreviewDevice = function canvasPreviewDevice(state) {
	  return state.previewDevice;
	};
	
	var canvasHighlightStyle = exports.canvasHighlightStyle = function canvasHighlightStyle(state) {
	  var _state$highlight$styl = state.highlight.style,
	      top = _state$highlight$styl.top,
	      left = _state$highlight$styl.left,
	      width = _state$highlight$styl.width,
	      height = _state$highlight$styl.height,
	      display = _state$highlight$styl.display;
	
	
	  return {
	    container: { top: top, left: left, width: width, display: display },
	    right: { left: width, height: height },
	    bottom: { top: height },
	    left: { height: height }
	  };
	};
	
	var canvasHighlightElement = exports.canvasHighlightElement = function canvasHighlightElement(state) {
	  return state.highlight.element;
	};

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(236);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(237);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(239);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(107);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = exports.state = {
	  currentView: 'steps',
	  previewStep: 'question',
	  previewDevice: 'desktop',
	  highlight: {
	    style: {
	      top: '0px',
	      left: '0px',
	      width: '0px',
	      height: '0px',
	      display: 'none'
	    },
	    element: null
	  }
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.CANVAS_CHANGE_VIEW, function (state, view) {
	  state.currentView = view;
	}), (0, _defineProperty3.default)(_mutations, types.CANVAS_CHANGE_PREVIEW_DEVICE, function (state, device) {
	  state.previewDevice = device;
	}), (0, _defineProperty3.default)(_mutations, types.CANVAS_ENABLE_HIGHLIGHT, function (state, element) {
	  state.highlight.element = element;
	  state.highlight.style = {
	    top: element.offsetTop + 'px',
	    left: element.offsetLeft + 'px',
	    width: element.offsetWidth - 1 + 'px',
	    height: element.offsetHeight - 1 + 'px',
	    display: 'block'
	  };
	}), (0, _defineProperty3.default)(_mutations, types.CANVAS_DISABLE_HIGHLIGHT, function (state) {
	  state.highlight.element = null;
	  state.highlight.style = {
	    top: '0px',
	    left: '0px',
	    width: '0px',
	    height: '0px',
	    display: 'none'
	  };
	}), (0, _defineProperty3.default)(_mutations, types.CANVAS_RESET_STATE, function (state) {
	  state.currentView = 'steps';
	  state.previewStep = 'question';
	  state.previewDevice = 'desktop';
	  state.highlight.element = null;
	  state.highlight.style = {
	    top: '0px',
	    left: '0px',
	    width: '0px',
	    height: '0px',
	    display: 'none'
	  };
	}), _mutations);

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.codeSetupBox = undefined;
	
	var _types = __webpack_require__(108);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var codeSetupBox = exports.codeSetupBox = function codeSetupBox(_ref, box) {
	  var commit = _ref.commit;
	
	  commit(types.CODE_SET_BOX, box);
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.codeButtonAttribute = exports.codeScript = exports.codeBox = undefined;
	
	var _code = __webpack_require__(177);
	
	var code = _interopRequireWildcard(_code);
	
	var _config = __webpack_require__(93);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var codeBox = exports.codeBox = function codeBox(state) {
	  return state.box;
	};
	var codeScript = exports.codeScript = function codeScript(state) {
	  return code.getScript(state.box);
	};
	var codeButtonAttribute = exports.codeButtonAttribute = function codeButtonAttribute(state) {
	  return config.TRIGGER_BUTTON_ATTR + '="' + state.box.id + '"';
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(240);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(241);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(243);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _types = __webpack_require__(108);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = exports.state = {
	  box: {}
	};
	
	var mutations = exports.mutations = (0, _defineProperty3.default)({}, types.CODE_SET_BOX, function (state, box) {
	  state.box = box;
	});

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.jumpResetActive = exports.jumpUpdateDestinationStepId = exports.jumpUpdateOptionId = exports.jumpRemoveOptionId = exports.jumpAddOptionId = exports.jumpSetActive = exports.jumpRemove = exports.jumpAdd = exports.jumpConfigRequest = undefined;
	
	var _types = __webpack_require__(109);
	
	var types = _interopRequireWildcard(_types);
	
	var _jump = __webpack_require__(211);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var JumpRequest = void 0;
	
	var jumpConfigRequest = exports.jumpConfigRequest = function jumpConfigRequest(_ref, data) {
	  var commit = _ref.commit;
	  var quizId = data.quizId,
	      stepId = data.stepId;
	
	  JumpRequest = new _jump2.default({ quizId: quizId, stepId: stepId });
	};
	
	var jumpAdd = exports.jumpAdd = function jumpAdd(_ref2, data) {
	  var commit = _ref2.commit;
	
	  var jump = {
	    destination_step_id: null,
	    options_ids: data.options_ids || null
	  };
	
	  JumpRequest.post(jump, { showLoader: true }).then(function (response) {
	    return commit(types.JUMP_ADD, { data: response.data });
	  });
	};
	
	var jumpRemove = exports.jumpRemove = function jumpRemove(_ref3, data) {
	  var commit = _ref3.commit;
	
	  JumpRequest.delete(data.id, { showLoader: true }).then(function () {
	    return commit(types.JUMP_REMOVE, { data: data });
	  });
	};
	
	var jumpSetActive = exports.jumpSetActive = function jumpSetActive(_ref4, jumps) {
	  var commit = _ref4.commit;
	
	  commit(types.JUMP_SET_ACTIVE, { jumps: jumps });
	};
	
	var jumpAddOptionId = exports.jumpAddOptionId = function jumpAddOptionId(_ref5, data) {
	  var commit = _ref5.commit;
	
	  var optionsIds = data.jump.options_ids.slice(0);
	  optionsIds.push('');
	
	  JumpRequest.put(data.jump.id, { options_ids: optionsIds }, { showLoader: true }).then(function (response) {
	    return commit(types.JUMP_UPDATE_OPTION_ID, { data: response.data });
	  });
	};
	
	var jumpRemoveOptionId = exports.jumpRemoveOptionId = function jumpRemoveOptionId(_ref6, data) {
	  var commit = _ref6.commit;
	
	  var optionsIds = data.jump.options_ids.slice(0);
	  optionsIds.splice(data.index, 1);
	
	  JumpRequest.put(data.jump.id, { options_ids: optionsIds }, { showLoader: true }).then(function (response) {
	    return commit(types.JUMP_UPDATE_OPTION_ID, { data: response.data });
	  });
	};
	
	var jumpUpdateOptionId = exports.jumpUpdateOptionId = function jumpUpdateOptionId(_ref7, data) {
	  var commit = _ref7.commit;
	
	  data.jump.options_ids[data.index] = data.event.target.value;
	
	  JumpRequest.put(data.jump.id, data.jump, { showLoader: true }).then(function (response) {
	    return commit(types.JUMP_UPDATE_OPTION_ID, { data: response.data });
	  });
	};
	
	var jumpUpdateDestinationStepId = exports.jumpUpdateDestinationStepId = function jumpUpdateDestinationStepId(_ref8, data) {
	  var commit = _ref8.commit;
	
	  var config = { showLoader: true };
	
	  JumpRequest.put(data.jump.id, { destination_step_id: data.event.target.value }, config).then(function (response) {
	    return commit(types.JUMP_UPDATE_DESTINATION_STEP_ID, { data: response.data });
	  });
	};
	
	var jumpResetActive = exports.jumpResetActive = function jumpResetActive(_ref9) {
	  var commit = _ref9.commit;
	
	  commit(types.JUMP_RESET_ACTIVE);
	};

/***/ },
/* 245 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var jumpList = exports.jumpList = function jumpList(state) {
	  return state.list;
	};
	var jumpCount = exports.jumpCount = function jumpCount() {
	  return function (jumps) {
	    if (!Array.isArray(jumps)) {
	      return 0;
	    }
	
	    var count = jumps.filter(function (jump) {
	      return jump.destination_step_id;
	    }).length;
	
	    return count;
	  };
	};

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(244);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(245);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(247);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(109);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = exports.state = {
	  list: []
	};
	
	var sort = function sort() {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return list.sort(function (a, b) {
	    if (!a.options_ids && b.options_ids) {
	      return 1;
	    }
	
	    if (!b.options_ids && a.options_ids) {
	      return -1;
	    }
	
	    return 0;
	  });
	};
	
	var find = function find(state, data, callback) {
	  return state.list.map(function (jump) {
	    if (jump.id === data.id) {
	      callback(jump);
	    }
	
	    return jump;
	  });
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.JUMP_ADD, function (state, _ref) {
	  var data = _ref.data;
	
	  state.list.push(data);
	  state.list = sort(state.list);
	}), (0, _defineProperty3.default)(_mutations, types.JUMP_REMOVE, function (state, _ref2) {
	  var data = _ref2.data;
	
	  state.list.splice(data.index, 1);
	  state.list = sort(state.list);
	}), (0, _defineProperty3.default)(_mutations, types.JUMP_CLEAR, function (state) {
	  state.list = [];
	}), (0, _defineProperty3.default)(_mutations, types.JUMP_SET_ACTIVE, function (state, _ref3) {
	  var jumps = _ref3.jumps;
	
	  state.list = jumps;
	  state.list = sort(state.list);
	}), (0, _defineProperty3.default)(_mutations, types.JUMP_UPDATE_OPTION_ID, function (state, _ref4) {
	  var data = _ref4.data;
	
	  find(state, data, function (jump) {
	    jump.options_ids = data.options_ids;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.JUMP_UPDATE_DESTINATION_STEP_ID, function (state, _ref5) {
	  var data = _ref5.data;
	
	  find(state, data, function (jump) {
	    jump.destination_step_id = data.destination_step_id;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.JUMP_RESET_ACTIVE, function (state) {
	  state.list = [];
	}), _mutations);

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modalClose = exports.modalOpen = undefined;
	
	var _types = __webpack_require__(110);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var modalOpen = exports.modalOpen = function modalOpen(_ref, modal) {
	  var commit = _ref.commit;
	
	  commit(types.MODAL_OPEN, modal);
	};
	
	var modalClose = exports.modalClose = function modalClose(_ref2) {
	  var commit = _ref2.commit;
	
	  commit(types.MODAL_CLOSE);
	};

/***/ },
/* 249 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var modalVisible = exports.modalVisible = function modalVisible(state) {
	  return state.isVisible;
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(248);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(249);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(251);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(110);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = exports.state = {
	  isVisible: false
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.MODAL_OPEN, function (state, modal) {
	  state.isVisible = modal;
	}), (0, _defineProperty3.default)(_mutations, types.MODAL_CLOSE, function (state) {
	  state.isVisible = '';
	}), _mutations);

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(111);
	
	var types = _interopRequireWildcard(_types);
	
	var _option = __webpack_require__(213);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var locale = _i18n2.default.locale;
	var messages = _i18n2.default.messages[locale];
	
	var actions = {};
	var OptionRequest = void 0;
	
	actions.optionConfigRequest = function (_ref, data) {
	  var commit = _ref.commit;
	  var quizId = data.quizId,
	      stepId = data.stepId;
	
	
	  OptionRequest = new _option2.default({ quizId: quizId, stepId: stepId });
	};
	
	actions.optionAdd = function (_ref2, data) {
	  var commit = _ref2.commit,
	      state = _ref2.state;
	
	  var optionsLength = state.list.filter(function (option) {
	    return !option.other;
	  }).length;
	  var option = {
	    label: data.label || messages.general.labels.option + ' ' + (optionsLength + 1),
	    other: data.other
	  };
	
	  OptionRequest.post(option, { showLoader: true }).then(function (response) {
	    return commit(types.OPTION_ADD, { data: response.data });
	  });
	};
	
	actions.optionRemove = function (_ref3, data) {
	  var commit = _ref3.commit;
	
	  OptionRequest.delete(data.id, { showLoader: true }).then(function () {
	    return commit(types.OPTION_REMOVE, data.index);
	  });
	};
	
	actions.optionUpdateText = function (_ref4, data) {
	  var commit = _ref4.commit;
	
	  OptionRequest.put(data.id, { label: data.event.target.value }, { showLoader: true }).then(function (response) {
	    return commit(types.OPTION_UPDATE_LABEL, response.data);
	  });
	};
	
	actions.optionUpdateOtherAnswer = function (_ref5, data) {
	  var commit = _ref5.commit,
	      state = _ref5.state;
	
	  var otherOptionIndex = state.list.findIndex(function (option) {
	    return option.other;
	  });
	
	  if (data.event.target.checked) {
	    actions.optionAdd({ commit: commit, state: state }, { label: messages.general.labels.other, other: true });
	    return;
	  }
	
	  actions.optionRemove({ commit: commit }, {
	    id: state.list[otherOptionIndex].id,
	    index: otherOptionIndex
	  });
	};
	
	actions.optionSetActive = function (_ref6, options) {
	  var commit = _ref6.commit;
	
	  commit(types.OPTION_SET_ACTIVE, options);
	};
	
	actions.optionResetActive = function (_ref7) {
	  var commit = _ref7.commit;
	
	  commit(types.OPTION_RESET_ACTIVE);
	};
	
	exports.default = actions;

/***/ },
/* 253 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var optionList = exports.optionList = function optionList(state) {
	  return state.list;
	};
	var optionOtherAnswer = exports.optionOtherAnswer = function optionOtherAnswer(state) {
	  return !!state.list.find(function (option) {
	    return option.other;
	  });
	};

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(252);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _getters = __webpack_require__(253);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(255);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  actions: _actions2.default,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(111);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = exports.state = {
	  list: []
	};
	
	var find = function find(state, data, callback) {
	  return state.list.map(function (option) {
	    if (option.id === data.id) {
	      callback(option);
	    }
	
	    return option;
	  });
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.OPTION_ADD, function (state, _ref) {
	  var data = _ref.data;
	
	  var otherOptionIndex = state.list.findIndex(function (option) {
	    return option.other;
	  });
	
	  state.list.push(data);
	
	  if (otherOptionIndex > -1) {
	    state.list.push(state.list.splice(otherOptionIndex, 1)[0]);
	  }
	}), (0, _defineProperty3.default)(_mutations, types.OPTION_REMOVE, function (state, index) {
	  state.list.splice(index, 1);
	}), (0, _defineProperty3.default)(_mutations, types.OPTION_UPDATE_LABEL, function (state, data) {
	  find(state, data, function (option) {
	    option.label = data.label;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.OPTION_SET_ACTIVE, function (state, options) {
	  state.list = options;
	}), (0, _defineProperty3.default)(_mutations, types.OPTION_RESET_ACTIVE, function (state) {
	  state.list = [];
	}), _mutations);

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.quizResetState = exports.quizSetStyle = exports.quizPreviewStyleChange = exports.quizUpdateStyle = exports.quizGet = undefined;
	
	var _types = __webpack_require__(112);
	
	var types = _interopRequireWildcard(_types);
	
	var _quiz = __webpack_require__(102);
	
	var _quiz2 = _interopRequireDefault(_quiz);
	
	var _merge = __webpack_require__(100);
	
	var merge = _interopRequireWildcard(_merge);
	
	var _internalstyle = __webpack_require__(58);
	
	var internalStyleHelper = _interopRequireWildcard(_internalstyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var QuizRequest = new _quiz2.default();
	
	var quizGet = exports.quizGet = function quizGet(_ref, quizId) {
	  var commit = _ref.commit,
	      rootState = _ref.rootState;
	
	  commit(types.QUIZ_SET_ID, quizId);
	
	  QuizRequest.get(quizId).then(function (response) {
	    var styles = merge.deep({}, rootState.theme.active.styles, response.data.styles);
	
	    commit(types.QUIZ_SET_STYLES, styles);
	  });
	};
	
	var quizUpdateStyle = exports.quizUpdateStyle = function quizUpdateStyle(_ref2, _ref3) {
	  var commit = _ref2.commit,
	      state = _ref2.state,
	      dispatch = _ref2.dispatch;
	  var item = _ref3.item,
	      rule = _ref3.rule,
	      value = _ref3.value;
	
	  var styles = state.styles;
	
	  commit(types.QUIZ_UPDATE_STYLE, { item: item, rule: rule, value: value });
	
	  var internalStyleElement = internalStyleHelper.getElement(item);
	
	  if (internalStyleElement) {
	    dispatch('boxUpdateContentBody', styles);
	  }
	
	  QuizRequest.put(state.id, { styles: styles }, { showLoader: true }).then(function (response) {
	    return commit(types.QUIZ_SET_STYLES, response.data.styles);
	  }).catch(function () {
	    return commit(types.QUIZ_SET_STYLES, styles);
	  });
	};
	
	var quizPreviewStyleChange = exports.quizPreviewStyleChange = function quizPreviewStyleChange(_ref4, _ref5) {
	  var commit = _ref4.commit,
	      state = _ref4.state;
	  var item = _ref5.item,
	      rule = _ref5.rule,
	      value = _ref5.value;
	
	  commit(types.QUIZ_UPDATE_STYLE, { item: item, rule: rule, value: value });
	};
	
	var quizSetStyle = exports.quizSetStyle = function quizSetStyle(_ref6, presets) {
	  var commit = _ref6.commit,
	      state = _ref6.state,
	      dispatch = _ref6.dispatch;
	
	  dispatch('boxUpdateContentBody', presets);
	
	  QuizRequest.put(state.id, { styles: presets }, { showLoader: true }).then(function (response) {
	    return commit(types.QUIZ_SET_STYLES, response.data.styles);
	  });
	};
	
	var quizResetState = exports.quizResetState = function quizResetState(_ref7) {
	  var commit = _ref7.commit;
	
	  commit(types.QUIZ_RESET_STATE);
	};

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.quizInternalStyle = exports.quizStyle = undefined;
	
	var _internalstyle = __webpack_require__(58);
	
	var internalStyleHelper = _interopRequireWildcard(_internalstyle);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var quizStyle = exports.quizStyle = function quizStyle(state) {
	  return function (key) {
	    var style = state.styles[key];
	    return style ? style.rules : {};
	  };
	};
	
	var quizInternalStyle = exports.quizInternalStyle = function quizInternalStyle(state) {
	  return internalStyleHelper.getHtmlTag(state.styles);
	};

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(256);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(257);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(259);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutations;
	
	var _types = __webpack_require__(112);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  general: {
	    selector: '*',
	    rules: {
	      fontFamily: 'Lato,sans-serif'
	    }
	  },
	  title: {
	    selector: '.kbx-title',
	    rules: {
	      color: '#49B3F2'
	    }
	  },
	  description: {
	    selector: '.kbx-description',
	    rules: {
	      color: '#a3a3a3'
	    }
	  },
	  option: {
	    selector: '.kbx-radio, .kbx-checkbox',
	    rules: {
	      color: '#777777'
	    }
	  },
	  button: {
	    selector: '.kbx-btn',
	    rules: {
	      backgroundColor: '#44b3f2',
	      color: '#fff',
	      borderRadius: '5px',
	      width: '250px',
	      height: '50px',
	      fontSize: '18px'
	    }
	  }
	};
	
	var state = exports.state = {
	  id: null,
	  styles: styles
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.QUIZ_SET_ID, function (state, id) {
	  state.id = id;
	}), (0, _defineProperty3.default)(_mutations, types.QUIZ_SET_STYLES, function (state, quizStyles) {
	  state.styles = (0, _assign2.default)({}, state.styles, quizStyles);
	}), (0, _defineProperty3.default)(_mutations, types.QUIZ_UPDATE_STYLE, function (state, _ref) {
	  var item = _ref.item,
	      rule = _ref.rule,
	      value = _ref.value;
	
	  if (!state.styles[item]) {
	    state.styles[item] = { rules: {} };
	  }
	  state.styles[item].rules[rule] = value;
	}), (0, _defineProperty3.default)(_mutations, types.QUIZ_RESET_STATE, function (state) {
	  state.id = null;
	  state.styles = styles;
	}), _mutations);

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.metricsResetState = exports.metricsRequestData = undefined;
	
	var _types = __webpack_require__(113);
	
	var types = _interopRequireWildcard(_types);
	
	var _box = __webpack_require__(48);
	
	var _box2 = _interopRequireDefault(_box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BoxRequest = new _box2.default();
	
	var metricsRequestData = exports.metricsRequestData = function metricsRequestData(_ref) {
	  var commit = _ref.commit,
	      rootState = _ref.rootState;
	
	  var boxId = rootState.route.params.boxId;
	
	  BoxRequest.metrics(boxId).then(function (response) {
	    return commit(types.METRICS_SET_DATA, response.data);
	  });
	};
	
	var metricsResetState = exports.metricsResetState = function metricsResetState(_ref2) {
	  var commit = _ref2.commit;
	
	  commit(types.METRICS_RESET_STATE);
	};

/***/ },
/* 261 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var metricsData = exports.metricsData = function metricsData(state) {
	  return state.metrics;
	};
	
	var getDeviceMetric = function getDeviceMetric(deviceName, details) {
	  var device = details.filter(function (deviceMetric) {
	    return deviceMetric.user_agent === deviceName;
	  });
	  return device[0];
	};
	
	var devicesMetrics = exports.devicesMetrics = function devicesMetrics(state) {
	  return function (deviceName) {
	    var device = getDeviceMetric(deviceName, state.metrics.details);
	
	    var defaultData = {
	      box_hits: 0,
	      conclusion_average_time: 0,
	      conclusion_rate: 0,
	      completed_submissions_count: 0,
	      uncompleted_submissions_count: 0
	    };
	
	    if (!device) {
	      return defaultData;
	    }
	
	    return device;
	  };
	};

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(260);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(261);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(263);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(113);
	
	var types = _interopRequireWildcard(_types);
	
	var _time = __webpack_require__(221);
	
	var time = _interopRequireWildcard(_time);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = exports.state = {
	  metrics: {
	    box_hits: 0,
	    conclusion_average_time: 0,
	    conclusion_rate: 0,
	    completed_submissions_count: 0,
	    uncompleted_submissions_count: 0,
	    details: [{
	      user_agent: 'others',
	      box_hits: 0,
	      conclusion_average_time: 0,
	      conclusion_rate: 0,
	      unanswered_submissions_count: 0,
	      completed_submissions_count: 0,
	      uncompleted_submissions_count: 0
	    }, {
	      user_agent: 'mobile',
	      box_hits: 0,
	      conclusion_average_time: 0,
	      conclusion_rate: 0,
	      unanswered_submissions_count: 0,
	      completed_submissions_count: 0,
	      uncompleted_submissions_count: 0
	    }, {
	      user_agent: 'desktop',
	      box_hits: 0,
	      conclusion_average_time: 0,
	      conclusion_rate: 0,
	      unanswered_submissions_count: 0,
	      completed_submissions_count: 0,
	      uncompleted_submissions_count: 0
	    }, {
	      user_agent: 'tablet',
	      box_hits: 0,
	      conclusion_average_time: 0,
	      conclusion_rate: 0,
	      unanswered_submissions_count: 0,
	      completed_submissions_count: 0,
	      uncompleted_submissions_count: 0
	    }]
	  },
	  boxId: ''
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.METRICS_SET_DATA, function (state, data) {
	  var conclusionRate = (data.conclusion_rate * 100).toFixed(2);
	  data.conclusion_average_time = time.toString(data.conclusion_average_time);
	  data.conclusion_rate = conclusionRate + '%';
	
	  data.details.forEach(function (device) {
	    var averageTime = device.conclusion_average_time;
	    var conclusionRateOfDevice = (device.conclusion_rate * 100).toFixed(2);
	    device.conclusion_average_time = time.toString(averageTime);
	    device.conclusion_rate = conclusionRateOfDevice + '%';
	  });
	
	  state.metrics = data;
	}), (0, _defineProperty3.default)(_mutations, types.METRICS_RESET_STATE, function (state) {
	  state.metrics = {};
	  state.boxId = '';
	}), _mutations);

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.optionEmailsRequestData = undefined;
	
	var _types = __webpack_require__(114);
	
	var types = _interopRequireWildcard(_types);
	
	var _box = __webpack_require__(48);
	
	var _box2 = _interopRequireDefault(_box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BoxRequest = new _box2.default();
	
	var optionEmailsRequestData = exports.optionEmailsRequestData = function optionEmailsRequestData(_ref) {
	  var commit = _ref.commit,
	      rootState = _ref.rootState;
	
	  var boxId = rootState.route.params.boxId;
	  var optionId = rootState.route.params.optionId;
	  var requestResouce = boxId + '/option/' + optionId;
	
	  BoxRequest.resumeEmails(requestResouce).then(function (response) {
	    return commit(types.RESUME_EMAILS_SET_DATA, response.data);
	  });
	};

/***/ },
/* 265 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var resumeEmails = exports.resumeEmails = function resumeEmails(state) {
	  return state.resumeEmails;
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(264);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(265);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(267);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _types = __webpack_require__(114);
	
	var types = _interopRequireWildcard(_types);
	
	var _htmlSanitize = __webpack_require__(47);
	
	var htmlSanitize = _interopRequireWildcard(_htmlSanitize);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultData = {
	  emails: []
	};
	
	var state = exports.state = {
	  resumeEmails: defaultData
	};
	
	var mutations = exports.mutations = (0, _defineProperty3.default)({}, types.RESUME_EMAILS_SET_DATA, function (state, data) {
	  data.step_label = htmlSanitize.text(data.step_label);
	  state.resumeEmails = data;
	});

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resumeReloadCharts = exports.resumeSetDateTo = exports.resumeSetDateFrom = exports.resumeResetState = exports.resumeRequestData = undefined;
	
	var _types = __webpack_require__(115);
	
	var types = _interopRequireWildcard(_types);
	
	var _box = __webpack_require__(48);
	
	var _box2 = _interopRequireDefault(_box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BoxRequest = new _box2.default();
	
	var resumeRequestData = exports.resumeRequestData = function resumeRequestData(_ref) {
	  var commit = _ref.commit,
	      rootState = _ref.rootState;
	
	  var boxId = rootState.route.params.boxId;
	
	  var queryString = {
	    params: {
	      from: rootState.resume.dateFrom,
	      to: rootState.resume.dateTo
	    }
	  };
	
	  BoxRequest.resume(boxId, queryString).then(function (response) {
	    return commit(types.RESUME_SET_DATA, response.data);
	  });
	};
	
	var resumeResetState = exports.resumeResetState = function resumeResetState(_ref2) {
	  var commit = _ref2.commit;
	
	  commit(types.RESUME_RESET_STATE);
	};
	
	var resumeSetDateFrom = exports.resumeSetDateFrom = function resumeSetDateFrom(_ref3, dateFrom) {
	  var commit = _ref3.commit;
	
	  commit(types.RESUME_SET_DATE_FROM, dateFrom);
	};
	
	var resumeSetDateTo = exports.resumeSetDateTo = function resumeSetDateTo(_ref4, dateTo) {
	  var commit = _ref4.commit;
	
	  commit(types.RESUME_SET_DATE_TO, dateTo);
	};
	
	var resumeReloadCharts = exports.resumeReloadCharts = function resumeReloadCharts(_ref5) {
	  var dispatch = _ref5.dispatch;
	
	  dispatch('resumeRequestData');
	};

/***/ },
/* 269 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var resumeData = exports.resumeData = function resumeData(state) {
	  return state.data;
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(268);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(269);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(271);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(115);
	
	var types = _interopRequireWildcard(_types);
	
	var _htmlSanitize = __webpack_require__(47);
	
	var htmlSanitize = _interopRequireWildcard(_htmlSanitize);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultData = {
	  steps: [{
	    id: '',
	    title: '-',
	    quantity_of_answers: 0,
	    options: [{
	      label: '-',
	      answers_count: 0
	    }]
	  }]
	};
	
	var state = exports.state = {
	  data: defaultData
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.RESUME_SET_DATA, function (state, data) {
	  data.steps = htmlSanitize.stepList(data.steps);
	  state.data = data;
	}), (0, _defineProperty3.default)(_mutations, types.RESUME_RESET_STATE, function (state) {
	  state.resume = defaultData;
	}), (0, _defineProperty3.default)(_mutations, types.RESUME_SET_DATE_FROM, function (state, dateFrom) {
	  state.dateFrom = dateFrom;
	}), (0, _defineProperty3.default)(_mutations, types.RESUME_SET_DATE_TO, function (state, dateTo) {
	  state.dateTo = dateTo;
	}), _mutations);

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reportResetState = exports.reportExport = exports.reportPreviousPage = exports.reportNextPage = exports.reportRequestAnswers = exports.reportSetAnswers = exports.reportSetDateTo = exports.reportSetDateFrom = exports.reportSetPage = exports.reportSetQuizId = undefined;
	
	var _types = __webpack_require__(116);
	
	var types = _interopRequireWildcard(_types);
	
	var _quiz = __webpack_require__(102);
	
	var _quiz2 = _interopRequireDefault(_quiz);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var QuizRequest = new _quiz2.default();
	
	var reportSetQuizId = exports.reportSetQuizId = function reportSetQuizId(_ref) {
	  var commit = _ref.commit,
	      rootState = _ref.rootState;
	
	  commit(types.REPORT_SET_QUIZ_ID, rootState.box.active.quiz_id);
	};
	
	var reportSetPage = exports.reportSetPage = function reportSetPage(_ref2, page) {
	  var commit = _ref2.commit;
	
	  commit(types.REPORT_SET_PAGE, page);
	};
	
	var reportSetDateFrom = exports.reportSetDateFrom = function reportSetDateFrom(_ref3, dateFrom) {
	  var commit = _ref3.commit;
	
	  commit(types.REPORT_SET_DATE_FROM, dateFrom);
	};
	
	var reportSetDateTo = exports.reportSetDateTo = function reportSetDateTo(_ref4, dateTo) {
	  var commit = _ref4.commit;
	
	  commit(types.REPORT_SET_DATE_TO, dateTo);
	};
	
	var reportSetAnswers = exports.reportSetAnswers = function reportSetAnswers(_ref5) {
	  var dispatch = _ref5.dispatch;
	
	  dispatch('reportSetQuizId');
	  dispatch('reportRequestAnswers', types.REPORT_SET_ANSWERS);
	};
	
	var reportRequestAnswers = exports.reportRequestAnswers = function reportRequestAnswers(_ref6, mutationType) {
	  var commit = _ref6.commit,
	      state = _ref6.state;
	
	  var queryString = {
	    params: {
	      page: state.page,
	      from: state.dateFrom,
	      to: state.dateTo
	    }
	  };
	
	  QuizRequest.answers(state.quizId, queryString).then(function (response) {
	    return commit(mutationType, response.data);
	  });
	};
	
	var reportNextPage = exports.reportNextPage = function reportNextPage(_ref7) {
	  var state = _ref7.state,
	      dispatch = _ref7.dispatch,
	      commit = _ref7.commit;
	
	  commit(types.REPORT_SET_PAGE, state.page + 1);
	  dispatch('reportRequestAnswers', types.REPORT_SET_ANSWERS);
	};
	
	var reportPreviousPage = exports.reportPreviousPage = function reportPreviousPage(_ref8) {
	  var state = _ref8.state,
	      dispatch = _ref8.dispatch,
	      commit = _ref8.commit;
	
	  commit(types.REPORT_SET_PAGE, state.page - 1);
	  dispatch('reportRequestAnswers', types.REPORT_SET_ANSWERS);
	};
	
	var reportExport = exports.reportExport = function reportExport(_ref9, email) {
	  var state = _ref9.state,
	      dispatch = _ref9.dispatch,
	      commit = _ref9.commit;
	
	  commit(types.REPORT_SET_EXPORT_EMAIL, email);
	  dispatch('reportSetQuizId');
	
	  var queryString = {
	    params: {
	      from: state.dateFrom,
	      to: state.dateTo
	    }
	  };
	
	  QuizRequest.export(state.quizId, { email: email }, queryString).then(function () {
	    return dispatch('modalOpen', 'report-export-in-progress');
	  });
	};
	
	var reportResetState = exports.reportResetState = function reportResetState(_ref10) {
	  var commit = _ref10.commit;
	
	  commit(types.REPORT_RESET_STATE);
	};

/***/ },
/* 273 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var reportList = exports.reportList = function reportList(state) {
	  return state.list;
	};
	var reportPage = exports.reportPage = function reportPage(state) {
	  return state.page;
	};
	var reportExportLimit = exports.reportExportLimit = function reportExportLimit(state) {
	  return state.reportExportLimit;
	};
	var reportExportEmail = exports.reportExportEmail = function reportExportEmail(state) {
	  return state.email;
	};
	
	var groupedAnswers = exports.groupedAnswers = function groupedAnswers() {
	  return function (answers, stepId) {
	    return answers.filter(function (answer) {
	      return answer.step_id === stepId;
	    });
	  };
	};

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(272);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(273);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(275);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(116);
	
	var types = _interopRequireWildcard(_types);
	
	var _htmlSanitize = __webpack_require__(47);
	
	var htmlSanitize = _interopRequireWildcard(_htmlSanitize);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = exports.state = {
	  list: {
	    steps: [],
	    submissions: [],
	    submissions_total: 0,
	    is_last_page: true
	  },
	  quizId: 0,
	  page: 1,
	  dateFrom: null,
	  dateTo: null,
	  reportExportLimit: (15000),
	  email: ''
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.REPORT_SET_ANSWERS, function (state, data) {
	  var excludedKindsOnResult = ['thanks', 'redirect'];
	  var filteredSteps = data.steps.filter(function (step) {
	    return !excludedKindsOnResult.includes(step.kind);
	  });
	
	  data.steps = htmlSanitize.stepList(filteredSteps);
	
	  state.list = data;
	}), (0, _defineProperty3.default)(_mutations, types.REPORT_SET_QUIZ_ID, function (state, quizId) {
	  state.quizId = quizId;
	}), (0, _defineProperty3.default)(_mutations, types.REPORT_SET_PAGE, function (state, page) {
	  state.page = page;
	}), (0, _defineProperty3.default)(_mutations, types.REPORT_SET_DATE_FROM, function (state, dateFrom) {
	  state.dateFrom = dateFrom;
	}), (0, _defineProperty3.default)(_mutations, types.REPORT_SET_DATE_TO, function (state, dateTo) {
	  state.dateTo = dateTo;
	}), (0, _defineProperty3.default)(_mutations, types.REPORT_RESET_STATE, function (state) {
	  state.list = {};
	  state.quizId = 0;
	  state.page = 1;
	  state.dateFrom = null;
	  state.dateTo = null;
	}), (0, _defineProperty3.default)(_mutations, types.REPORT_SET_EXPORT_EMAIL, function (state, email) {
	  state.email = email;
	}), _mutations);

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sidebarResetState = exports.sidebarSetElement = exports.sidebarChangeActiveButton = exports.sidebarChangePanel = undefined;
	
	var _types = __webpack_require__(117);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var sidebarChangePanel = exports.sidebarChangePanel = function sidebarChangePanel(_ref, panel) {
	  var commit = _ref.commit;
	
	  commit(types.SIDEBAR_UPDATE_VISIBILITY, panel);
	};
	
	var sidebarChangeActiveButton = exports.sidebarChangeActiveButton = function sidebarChangeActiveButton(_ref2, button) {
	  var commit = _ref2.commit;
	
	  commit(types.SIDEBAR_UPDATE_ACTIVE_BUTTON, button);
	};
	
	var sidebarSetElement = exports.sidebarSetElement = function sidebarSetElement(_ref3, element) {
	  var commit = _ref3.commit;
	
	  commit(types.SIDEBAR_SET_ELEMENT, element);
	};
	
	var sidebarResetState = exports.sidebarResetState = function sidebarResetState(_ref4) {
	  var commit = _ref4.commit;
	
	  commit(types.SIDEBAR_RESET_STATE);
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sidebarElementItem = exports.sidebarElementModifiers = exports.sidebarCurrentElement = exports.sidebarActiveButton = exports.sidebarCurrentPanel = undefined;
	
	var _keys = __webpack_require__(37);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sidebarCurrentPanel = exports.sidebarCurrentPanel = function sidebarCurrentPanel(state) {
	  return state.currentPanel;
	};
	var sidebarActiveButton = exports.sidebarActiveButton = function sidebarActiveButton(state) {
	  return state.activeButton;
	};
	var sidebarCurrentElement = exports.sidebarCurrentElement = function sidebarCurrentElement(state) {
	  return state.currentElement;
	};
	
	var sidebarElementModifiers = exports.sidebarElementModifiers = function sidebarElementModifiers(state, rootState) {
	  var element = state.currentElement;
	
	  if (!element) {
	    return [];
	  }
	
	  var item = element.getAttribute('klickbox-edit-item');
	
	  if (!item || item === '') {
	    return [];
	  }
	
	  return (0, _keys2.default)(rootState.quizStyle(item));
	};
	
	var sidebarElementItem = exports.sidebarElementItem = function sidebarElementItem(state) {
	  var element = state.currentElement;
	
	  if (!element) {
	    return '';
	  }
	
	  return element.getAttribute('klickbox-edit-item');
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(276);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(277);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(279);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(117);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = exports.state = {
	  currentPanel: 'steps',
	  activeButton: 'steps',
	  currentElement: null
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SIDEBAR_UPDATE_VISIBILITY, function (state, panel) {
	  state.currentPanel = panel;
	}), (0, _defineProperty3.default)(_mutations, types.SIDEBAR_UPDATE_ACTIVE_BUTTON, function (state, button) {
	  state.activeButton = button;
	}), (0, _defineProperty3.default)(_mutations, types.SIDEBAR_SET_ELEMENT, function (state, element) {
	  state.currentElement = element;
	}), (0, _defineProperty3.default)(_mutations, types.SIDEBAR_RESET_STATE, function (state) {
	  state.currentPanel = 'steps';
	  state.activeButton = 'steps';
	}), _mutations);

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stepResetState = exports.stepPreviewStyleChange = exports.stepUpdateStyle = exports.stepSetPreview = exports.stepUpdateNextButtonText = exports.stepUpdateTextPlaceholder = exports.stepUpdateTextSize = exports.stepUpdateTextRequired = exports.stepUpdateWelcomeOption = exports.stepUpdateWelcomeActive = exports.stepDuplicate = exports.stepUpdateDescriptionText = exports.stepChangeDescriptionVisibity = exports.stepUpdateOrder = exports.stepUpdateRedirectEmailService = exports.stepUpdateTitle = exports.stepUpdateRedirectButtonText = exports.stepUpdateRedirectUrl = exports.stepUpdateRedirectAutomatic = exports.stepUpdateCustomizedForm = exports.stepUpdateFormHtml = exports.stepUpdateMultipleAnswers = exports.stepRemove = exports.stepAdd = exports.stepSetActive = exports.stepSet = exports.stepGet = exports.stepConfigRequest = exports.stepUpdateSubRequest = undefined;
	
	var _he = __webpack_require__(79);
	
	var _he2 = _interopRequireDefault(_he);
	
	var _types = __webpack_require__(60);
	
	var types = _interopRequireWildcard(_types);
	
	var _step = __webpack_require__(214);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _stepKind = __webpack_require__(217);
	
	var _stepKind2 = _interopRequireDefault(_stepKind);
	
	var _filters = __webpack_require__(202);
	
	var filters = _interopRequireWildcard(_filters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StepRequest = void 0;
	
	var stepUpdateSubRequest = exports.stepUpdateSubRequest = function stepUpdateSubRequest(_ref, data) {
	  var dispatch = _ref.dispatch;
	  var quizId = data.quizId,
	      stepId = data.stepId;
	
	
	  dispatch('optionConfigRequest', { quizId: quizId, stepId: stepId });
	  dispatch('jumpConfigRequest', { quizId: quizId, stepId: stepId });
	};
	
	var stepConfigRequest = exports.stepConfigRequest = function stepConfigRequest(_ref2) {
	  var dispatch = _ref2.dispatch,
	      state = _ref2.state;
	  var quizId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.quiz_id;
	
	  StepRequest = new _step2.default({ quizId: quizId });
	  dispatch('stepGet');
	};
	
	var stepGet = exports.stepGet = function stepGet(_ref3) {
	  var dispatch = _ref3.dispatch;
	
	  StepRequest.get().then(function (response) {
	    dispatch('stepSet', { steps: response.data });
	  });
	};
	
	var stepSet = exports.stepSet = function stepSet(_ref4, data) {
	  var commit = _ref4.commit,
	      dispatch = _ref4.dispatch;
	
	  var steps = data.steps;
	
	  commit(types.STEPS_SET, { steps: steps });
	  dispatch('stepSetActive', steps[0]);
	};
	
	var stepSetActive = exports.stepSetActive = function stepSetActive(_ref5, step) {
	  var commit = _ref5.commit,
	      dispatch = _ref5.dispatch,
	      state = _ref5.state;
	
	  commit(types.STEP_SET_ACTIVE, { step: step });
	  dispatch('optionSetActive', step.options);
	  dispatch('jumpSetActive', step.jumps);
	  dispatch('stepUpdateSubRequest', { quizId: state.quiz_id, stepId: step.id });
	};
	
	var stepAdd = exports.stepAdd = function stepAdd(_ref6, kind) {
	  var state = _ref6.state,
	      commit = _ref6.commit,
	      dispatch = _ref6.dispatch;
	
	  var step = _stepKind2.default.generate({ kind: kind });
	
	  step.position = state.list.length - 1;
	
	  StepRequest.post(step, { showLoader: true }).then(function (response) {
	    step = response.data;
	    commit(types.STEP_ADD, { step: step });
	    commit(types.STEP_UPDATE_POSITIONS);
	    dispatch('stepSetActive', step);
	  });
	};
	
	var stepRemove = exports.stepRemove = function stepRemove(_ref7) {
	  var commit = _ref7.commit,
	      dispatch = _ref7.dispatch,
	      state = _ref7.state;
	
	  var step = state.active;
	  StepRequest.delete(step.id, { showLoader: true }).then(function () {
	    commit(types.STEP_REMOVE, step.position);
	    commit(types.STEP_UPDATE_POSITIONS);
	    dispatch('optionResetActive');
	    dispatch('modalClose');
	    if (state.list.length > 0) {
	      dispatch('stepSetActive', state.list[0]);
	    }
	  });
	};
	
	var stepUpdateMultipleAnswers = exports.stepUpdateMultipleAnswers = function stepUpdateMultipleAnswers(_ref8, data) {
	  var commit = _ref8.commit;
	
	  StepRequest.put(data.id, { multiple_answers: data.event.target.checked }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_MULTIPLE_ANSWER, response.data);
	  });
	};
	
	var stepUpdateFormHtml = exports.stepUpdateFormHtml = function stepUpdateFormHtml(_ref9, data) {
	  var commit = _ref9.commit;
	
	  var formHtml = filters.standard(data.html);
	  var customizedForm = false;
	  var config = { showLoader: true };
	
	  StepRequest.put(data.id, {
	    form_html: formHtml,
	    original_form_html: data.html,
	    customized_form: customizedForm
	  }, config).then(function (response) {
	    commit(types.STEP_UPDATE_FORM_HTML, response.data);
	    commit(types.STEP_UPDATE_ORIGINAL_FORM_HTML, response.data);
	    commit(types.STEP_UPDATE_FORM_CUSTOMIZED, response.data);
	  });
	};
	
	var stepUpdateCustomizedForm = exports.stepUpdateCustomizedForm = function stepUpdateCustomizedForm(_ref10, data) {
	  var commit = _ref10.commit,
	      state = _ref10.state;
	
	  var originalFormHtml = _he2.default.decode(state.active.original_form_html);
	  var customizedForm = data.event.target.checked;
	  var config = { showLoader: true };
	
	  var formHtml = filters.standard(originalFormHtml);
	
	  if (customizedForm) {
	    formHtml = filters.format(originalFormHtml);
	  }
	
	  StepRequest.put(data.id, {
	    customized_form: customizedForm,
	    form_html: formHtml
	  }, config).then(function (response) {
	    commit(types.STEP_UPDATE_FORM_CUSTOMIZED, response.data);
	    commit(types.STEP_UPDATE_FORM_HTML, response.data);
	  });
	};
	
	var stepUpdateRedirectAutomatic = exports.stepUpdateRedirectAutomatic = function stepUpdateRedirectAutomatic(_ref11, data) {
	  var commit = _ref11.commit;
	
	  StepRequest.put(data.id, { redirect_automatic: data.event.target.checked }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_REDIRECT_AUTOMATIC, response.data);
	  });
	};
	
	var stepUpdateRedirectUrl = exports.stepUpdateRedirectUrl = function stepUpdateRedirectUrl(_ref12, data) {
	  var commit = _ref12.commit;
	
	  StepRequest.put(data.id, { redirect_url: data.event.target.value }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_REDIRECT_URL, response.data);
	  });
	};
	
	var stepUpdateRedirectButtonText = exports.stepUpdateRedirectButtonText = function stepUpdateRedirectButtonText(_ref13, data) {
	  var commit = _ref13.commit;
	
	  StepRequest.put(data.id, { redirect_button_text: data.event.target.value }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_REDIRECT_BUTTON_TEXT, response.data);
	  });
	};
	
	var stepUpdateTitle = exports.stepUpdateTitle = function stepUpdateTitle(_ref14, data) {
	  var commit = _ref14.commit;
	
	  StepRequest.put(data.id, { title: data.event.target.value }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_TITLE, response.data);
	  });
	};
	
	var stepUpdateRedirectEmailService = exports.stepUpdateRedirectEmailService = function stepUpdateRedirectEmailService(_ref15, data) {
	  var commit = _ref15.commit;
	
	  var config = { showLoader: true };
	
	  StepRequest.put(data.id, { redirect_email_service: data.event.target.checked }, config).then(function (response) {
	    return commit(types.STEP_UPDATE_REDIRECT_EMAIL_SERVICE, response.data);
	  });
	};
	
	var stepUpdateOrder = exports.stepUpdateOrder = function stepUpdateOrder(_ref16, data) {
	  var state = _ref16.state,
	      commit = _ref16.commit;
	
	  var list = state.list;
	  var config = { showLoader: true };
	
	  commit(types.STEPS_SET, { steps: data.list });
	
	  StepRequest.ordinate(data.event.item.id, { destination_position: data.event.newIndex }, config).then(function (response) {
	    return commit(types.STEPS_SET, { steps: response.data });
	  }).catch(function () {
	    return commit(types.STEPS_SET, { steps: list });
	  });
	};
	
	var stepChangeDescriptionVisibity = exports.stepChangeDescriptionVisibity = function stepChangeDescriptionVisibity(_ref17, data) {
	  var commit = _ref17.commit;
	
	  var config = { showLoader: true };
	
	  StepRequest.put(data.id, { description_visibility: data.event.target.checked }, config).then(function (response) {
	    return commit(types.STEP_UPDATE_DESCRIPTION_VISIBILITY, response.data);
	  });
	};
	
	var stepUpdateDescriptionText = exports.stepUpdateDescriptionText = function stepUpdateDescriptionText(_ref18, data) {
	  var commit = _ref18.commit;
	
	  StepRequest.put(data.id, { description_text: data.event.target.value }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_DESCRIPTION, response.data);
	  });
	};
	
	var stepDuplicate = exports.stepDuplicate = function stepDuplicate(_ref19, quantity) {
	  var commit = _ref19.commit,
	      dispatch = _ref19.dispatch,
	      state = _ref19.state;
	
	  var step = state.active;
	  StepRequest.duplicate(step.id, { quantity: quantity }, { showLoader: true }).then(function (response) {
	    commit(types.STEP_PUSH, { steps: response.data });
	    commit(types.STEP_UPDATE_POSITIONS);
	    dispatch('stepSetActive', response.data[0]);
	    dispatch('modalClose');
	  });
	};
	
	var stepUpdateWelcomeActive = exports.stepUpdateWelcomeActive = function stepUpdateWelcomeActive(_ref20, data) {
	  var commit = _ref20.commit,
	      dispatch = _ref20.dispatch;
	
	  var welcomeActive = data.event.target.checked;
	
	  StepRequest.put(data.id, { welcome_active: welcomeActive }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_WELCOME_ACTIVE, response.data);
	  });
	};
	
	var stepUpdateWelcomeOption = exports.stepUpdateWelcomeOption = function stepUpdateWelcomeOption(_ref21, data) {
	  var commit = _ref21.commit;
	
	  StepRequest.put(data.id, { welcome_option: data.event.target.value }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_WELCOME_OPTION, response.data);
	  });
	};
	
	var stepUpdateTextRequired = exports.stepUpdateTextRequired = function stepUpdateTextRequired(_ref22, data) {
	  var commit = _ref22.commit;
	
	  StepRequest.put(data.id, { required: data.event.target.checked }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_TEXT_REQUIRED, response.data);
	  });
	};
	
	var stepUpdateTextSize = exports.stepUpdateTextSize = function stepUpdateTextSize(_ref23, data) {
	  var commit = _ref23.commit;
	
	  var textSize = 'short';
	
	  if (data.event.target.checked) {
	    textSize = 'long';
	  }
	
	  StepRequest.put(data.id, { text_size: textSize }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_TEXT_SIZE, response.data);
	  });
	};
	
	var stepUpdateTextPlaceholder = exports.stepUpdateTextPlaceholder = function stepUpdateTextPlaceholder(_ref24, data) {
	  var commit = _ref24.commit;
	
	  StepRequest.put(data.id, { placeholder_text: data.placeholderText }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_TEXT_PLACEHOLDER, response.data);
	  });
	};
	
	var stepUpdateNextButtonText = exports.stepUpdateNextButtonText = function stepUpdateNextButtonText(_ref25, data) {
	  var commit = _ref25.commit;
	
	  StepRequest.put(data.id, { next_button_text: data.event.target.value }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_UPDATE_NEXT_BUTTON_TEXT, response.data);
	  });
	};
	
	var stepSetPreview = exports.stepSetPreview = function stepSetPreview(_ref26, step) {
	  var commit = _ref26.commit;
	
	  commit(types.STEP_SET_PREVIEW, { step: step });
	};
	
	var stepUpdateStyle = exports.stepUpdateStyle = function stepUpdateStyle(_ref27, _ref28) {
	  var commit = _ref27.commit,
	      state = _ref27.state,
	      dispatch = _ref27.dispatch;
	  var item = _ref28.item,
	      rule = _ref28.rule,
	      value = _ref28.value;
	
	  var styles = state.preview.styles;
	
	  commit(types.STEP_UPDATE_STYLE, { item: item, rule: rule, value: value });
	  StepRequest.put(state.preview.id, { styles: styles }, { showLoader: true }).then(function (response) {
	    return commit(types.STEP_SET_STYLES, response.data.styles);
	  }).catch(function () {
	    return commit(types.STEP_SET_STYLES, styles);
	  });
	};
	
	var stepPreviewStyleChange = exports.stepPreviewStyleChange = function stepPreviewStyleChange(_ref29, _ref30) {
	  var commit = _ref29.commit;
	  var item = _ref30.item,
	      rule = _ref30.rule,
	      value = _ref30.value;
	
	  commit(types.STEP_UPDATE_STYLE, { item: item, rule: rule, value: value });
	};
	
	var stepResetState = exports.stepResetState = function stepResetState(_ref31) {
	  var commit = _ref31.commit;
	
	  commit(types.STEP_RESET_STATE);
	};

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stepPreview = exports.stepStyle = exports.stepJumpSelectOptions = exports.stepIdsUsedInJumps = exports.stepHasOnlyThanks = exports.stepDisplayPosition = exports.stepInactiveList = exports.stepTextPlaceholder = exports.stepOriginalFormHtmlDecoded = exports.stepFormHtmlDecoded = exports.stepCustomizedForm = exports.stepDescriptionVisibility = exports.stepRedirectEmailService = exports.stepActive = exports.stepListHasJumps = exports.stepListCount = exports.stepList = undefined;
	
	var _toConsumableArray2 = __webpack_require__(120);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _he = __webpack_require__(79);
	
	var _he2 = _interopRequireDefault(_he);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stepPreviewDefault = {
	  isGeneral: true,
	  title: 'Título de todos passos',
	  kind: 'multiple-choice',
	  description_visibility: true,
	  description_text: 'Descrição da pergunta',
	  options: [{ label: 'Resposta 1' }, { label: 'Resposta 2' }]
	};
	
	var getJumpsDestinations = function getJumpsDestinations(steps) {
	  var getJumpDestination = function getJumpDestination(jump) {
	    return jump.destination_step_id;
	  };
	
	  return steps.filter(function (step) {
	    return step.jumps;
	  }).map(function (step) {
	    return step.jumps.filter(getJumpDestination).map(getJumpDestination);
	  });
	};
	
	var reduceStepIds = function reduceStepIds(steps, step) {
	  if (steps.indexOf(step) < 0) {
	    steps.push(step);
	  }
	
	  return steps;
	};
	
	var stepList = exports.stepList = function stepList(state) {
	  return state.list;
	};
	
	var stepListCount = exports.stepListCount = function stepListCount(state) {
	  var countableSteps = function countableSteps(step) {
	    return step.kind !== 'redirect' && step.kind !== 'thanks';
	  };
	
	  return state.list.filter(countableSteps).length;
	};
	
	var stepListHasJumps = exports.stepListHasJumps = function stepListHasJumps(state) {
	  var reduceJumps = function reduceJumps(jumpList, stepJumps) {
	    jumpList.push.apply(jumpList, (0, _toConsumableArray3.default)(stepJumps));
	
	    return jumpList;
	  };
	
	  return state.list.filter(function (step) {
	    return step.kind !== 'welcome';
	  }).map(function (step) {
	    return step.jumps;
	  }).reduce(reduceJumps, []).some(function (jump) {
	    return jump.destination_step_id;
	  });
	};
	
	var stepActive = exports.stepActive = function stepActive(state) {
	  return state.active;
	};
	
	var stepRedirectEmailService = exports.stepRedirectEmailService = function stepRedirectEmailService(state) {
	  return state.active.redirect_email_service;
	};
	
	var stepDescriptionVisibility = exports.stepDescriptionVisibility = function stepDescriptionVisibility(state) {
	  return state.active.description_visibility;
	};
	
	var stepCustomizedForm = exports.stepCustomizedForm = function stepCustomizedForm(state) {
	  return state.active.customized_form;
	};
	
	var stepFormHtmlDecoded = exports.stepFormHtmlDecoded = function stepFormHtmlDecoded(state) {
	  if (!state.active.form_html) {
	    return '';
	  }
	
	  return _he2.default.decode(state.active.form_html);
	};
	
	var stepOriginalFormHtmlDecoded = exports.stepOriginalFormHtmlDecoded = function stepOriginalFormHtmlDecoded(state) {
	  if (!state.active.original_form_html) {
	    return '';
	  }
	
	  return _he2.default.decode(state.active.original_form_html);
	};
	
	var stepTextPlaceholder = exports.stepTextPlaceholder = function stepTextPlaceholder(state) {
	  return state.active.placeholder_text;
	};
	
	var stepInactiveList = exports.stepInactiveList = function stepInactiveList(state) {
	  var active = stepActive(state);
	  return state.list.filter(function (step) {
	    return step.id !== active.id;
	  });
	};
	
	var stepDisplayPosition = exports.stepDisplayPosition = function stepDisplayPosition() {
	  return function (step) {
	    var position = parseInt(step.position, 10) + 1;
	
	    return position || '';
	  };
	};
	
	var stepHasOnlyThanks = exports.stepHasOnlyThanks = function stepHasOnlyThanks(state) {
	  var list = state.list;
	
	  return list.length === 1 && list[0].kind === 'thanks';
	};
	
	var stepIdsUsedInJumps = exports.stepIdsUsedInJumps = function stepIdsUsedInJumps(state) {
	  var stepsIds = getJumpsDestinations(state.list);
	
	  return [].concat.apply([], stepsIds).reduce(reduceStepIds, []);
	};
	
	var stepJumpSelectOptions = exports.stepJumpSelectOptions = function stepJumpSelectOptions(state) {
	  var steps = stepInactiveList(state);
	  var stepIds = stepIdsUsedInJumps(state);
	
	  return steps.map(function (step) {
	    var text = stepDisplayPosition()(step) + ' - ' + step.title;
	
	    return {
	      id: step.id,
	      text: text,
	      alreadyUsed: stepIds.indexOf(step.id) > -1
	    };
	  });
	};
	
	var stepStyle = exports.stepStyle = function stepStyle(state, rootState) {
	  return function (key) {
	    if (!state.preview || !state.preview.styles) {
	      return rootState.quizStyle(key);
	    }
	
	    var style = state.preview.styles[key];
	    return style ? style.rules : rootState.quizStyle(key);
	  };
	};
	
	var stepPreview = exports.stepPreview = function stepPreview(state) {
	  return state.preview ? state.preview : stepPreviewDefault;
	};

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(280);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(281);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(283);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(120);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _mutations;
	
	var _he = __webpack_require__(79);
	
	var _he2 = _interopRequireDefault(_he);
	
	var _types = __webpack_require__(60);
	
	var types = _interopRequireWildcard(_types);
	
	var _htmlSanitize = __webpack_require__(47);
	
	var htmlSanitize = _interopRequireWildcard(_htmlSanitize);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var find = function find(state, data, callback) {
	  return state.list.map(function (step) {
	    if (step.id === data.id) {
	      callback(step);
	    }
	
	    return step;
	  });
	};
	
	var state = exports.state = {
	  quiz_id: '',
	  list: [],
	  active: {},
	  preview: {}
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.STEPS_SET, function (state, _ref) {
	  var steps = _ref.steps;
	
	  state.list = htmlSanitize.stepList(steps);
	  state.active = steps[0];
	}), (0, _defineProperty3.default)(_mutations, types.STEP_ADD, function (state, _ref2) {
	  var step = _ref2.step;
	
	  step.sanitized_title = htmlSanitize.text(step.title);
	
	  state.list.splice(step.position, 0, step);
	}), (0, _defineProperty3.default)(_mutations, types.STEP_REMOVE, function (state, index) {
	  state.list.splice(index, 1);
	}), (0, _defineProperty3.default)(_mutations, types.STEP_SET_ACTIVE, function (state, _ref3) {
	  var step = _ref3.step;
	
	  step.sanitized_title = htmlSanitize.text(step.title);
	
	  state.active = step;
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_TITLE, function (state, data) {
	  find(state, data, function (step) {
	    step.title = data.title;
	    step.sanitized_title = htmlSanitize.text(data.title);
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_MULTIPLE_ANSWER, function (state, data) {
	  find(state, data, function (step) {
	    step.multiple_answers = data.multiple_answers;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_FORM_HTML, function (state, data) {
	  find(state, data, function (step) {
	    step.form_html = _he2.default.decode(data.form_html);
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_ORIGINAL_FORM_HTML, function (state, data) {
	  find(state, data, function (step) {
	    step.original_form_html = data.original_form_html;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_FORM_CUSTOMIZED, function (state, data) {
	  find(state, data, function (step) {
	    step.customized_form = data.customized_form;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_REDIRECT_AUTOMATIC, function (state, data) {
	  find(state, data, function (step) {
	    step.redirect_automatic = data.redirect_automatic;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_REDIRECT_URL, function (state, data) {
	  find(state, data, function (step) {
	    step.redirect_url = data.redirect_url;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_REDIRECT_BUTTON_TEXT, function (state, data) {
	  find(state, data, function (step) {
	    step.redirect_button_text = data.redirect_button_text;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_QUIZ_ID, function (state, quizId) {
	  state.quiz_id = quizId;
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_REDIRECT_EMAIL_SERVICE, function (state, data) {
	  find(state, data, function (step) {
	    step.redirect_email_service = data.redirect_email_service;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_DESCRIPTION_VISIBILITY, function (state, data) {
	  find(state, data, function (step) {
	    step.description_visibility = data.description_visibility;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_DESCRIPTION, function (state, data) {
	  find(state, data, function (step) {
	    step.description_text = data.description_text;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_POSITIONS, function (state) {
	  state.list = state.list.map(function (step, index) {
	    step.position = index;
	    return step;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_PUSH, function (state, _ref4) {
	  var _state$list;
	
	  var steps = _ref4.steps;
	
	  (_state$list = state.list).splice.apply(_state$list, [steps[0].position, 0].concat((0, _toConsumableArray3.default)(steps)));
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_WELCOME_ACTIVE, function (state, data) {
	  find(state, data, function (step) {
	    step.welcome_active = data.welcome_active;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_WELCOME_OPTION, function (state, data) {
	  find(state, data, function (step) {
	    step.welcome_option = data.welcome_option;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_TEXT_REQUIRED, function (state, data) {
	  find(state, data, function (step) {
	    step.required = data.required;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_TEXT_SIZE, function (state, data) {
	  find(state, data, function (step) {
	    step.text_size = data.text_size;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_TEXT_PLACEHOLDER, function (state, data) {
	  find(state, data, function (step) {
	    step.placeholder_text = data.placeholder_text;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_NEXT_BUTTON_TEXT, function (state, data) {
	  find(state, data, function (step) {
	    step.next_button_text = data.next_button_text;
	  });
	}), (0, _defineProperty3.default)(_mutations, types.STEP_SET_PREVIEW, function (state, _ref5) {
	  var step = _ref5.step;
	
	  state.preview = step;
	}), (0, _defineProperty3.default)(_mutations, types.STEP_SET_STYLES, function (state, styles) {
	  state.preview.styles = (0, _assign2.default)({}, state.preview.styles, styles);
	}), (0, _defineProperty3.default)(_mutations, types.STEP_UPDATE_STYLE, function (state, _ref6) {
	  var item = _ref6.item,
	      rule = _ref6.rule,
	      value = _ref6.value;
	
	  if (!state.preview.styles) {
	    state.preview.styles = {};
	  }
	
	  if (!state.preview.styles[item]) {
	    state.preview.styles[item] = { rules: {} };
	  }
	  state.preview.styles[item].rules[rule] = value;
	}), (0, _defineProperty3.default)(_mutations, types.STEP_RESET_STATE, function (state) {
	  state.quiz_id = '';
	  state.list = [];
	  state.active = {};
	  state.preview = {};
	}), _mutations);

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.themeResetState = exports.themeUpdateStyles = exports.themeSetActive = exports.themeGet = exports.themeGetAll = undefined;
	
	var _keys = __webpack_require__(37);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _theme = __webpack_require__(215);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _types = __webpack_require__(118);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemeRequest = new _theme2.default();
	
	var themeGetAll = exports.themeGetAll = function themeGetAll(_ref) {
	  var commit = _ref.commit;
	
	  ThemeRequest.get().then(function (response) {
	    return commit(types.THEME_SET_LIST, response.data.themes);
	  });
	};
	
	var themeGet = exports.themeGet = function themeGet(_ref2, slug) {
	  var dispatch = _ref2.dispatch;
	
	  if (!slug) {
	    dispatch('themeSetActive', { slug: 'theme1' });
	    dispatch('themeUpdateStyles', { slug: 'theme1' });
	    return;
	  }
	
	  dispatch('themeSetActive', { slug: slug });
	};
	
	var themeSetActive = exports.themeSetActive = function themeSetActive(_ref3, active) {
	  var commit = _ref3.commit,
	      dispatch = _ref3.dispatch,
	      state = _ref3.state;
	
	  ThemeRequest.get(active.slug).then(function (response) {
	    (0, _assign2.default)(response.data, active);
	
	    (0, _keys2.default)(response.data.progressbar).forEach(function (key) {
	      dispatch('boxUpdateConfig', {
	        item: 'progressbar',
	        key: key,
	        value: response.data.progressbar[key]
	      });
	    });
	
	    commit(types.THEME_SET_ACTIVE, response.data);
	  });
	};
	
	var themeUpdateStyles = exports.themeUpdateStyles = function themeUpdateStyles(_ref4, active) {
	  var dispatch = _ref4.dispatch,
	      rootState = _ref4.rootState;
	
	  var boxId = rootState.route.params.boxId;
	
	  ThemeRequest.get(active.slug).then(function (response) {
	    dispatch('boxSetTheme', {
	      id: boxId,
	      theme_slug: active.slug,
	      theme_fonts: response.data.fonts
	    });
	
	    dispatch('quizSetStyle', response.data.styles);
	  });
	};
	
	var themeResetState = exports.themeResetState = function themeResetState(_ref5) {
	  var commit = _ref5.commit;
	
	  commit(types.THEME_RESET_STATE);
	};

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.themeActiveStyles = exports.themeActive = exports.themeList = undefined;
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var themeList = exports.themeList = function themeList(state, rootState) {
	  var boxFormat = rootState.boxFormat;
	  return state.list.filter(function (theme) {
	    return theme.format.includes(boxFormat);
	  });
	};
	
	var themeActive = exports.themeActive = function themeActive(state) {
	  return state.active;
	};
	var themeActiveStyles = exports.themeActiveStyles = function themeActiveStyles(state) {
	  if (!state.active || !state.active.slug) {
	    return '';
	  }
	
	  return _rebrand2.default.urls.THEME_CDN_URI + '/themes/' + state.active.slug + '/main.css';
	};

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(284);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(285);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(287);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  actions: actions,
	  getters: getters,
	  mutations: _mutations.mutations,
	  state: _mutations.state
	};

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = undefined;
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(118);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = exports.state = {
	  list: [],
	  active: {}
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.THEME_SET_LIST, function (state, list) {
	  state.list = list;
	}), (0, _defineProperty3.default)(_mutations, types.THEME_SET_ACTIVE, function (state, active) {
	  state.active = active;
	}), (0, _defineProperty3.default)(_mutations, types.THEME_RESET_STATE, function (state) {
	  state.list = [];
	  state.active = {};
	}), _mutations);

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(61);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _instance = __webpack_require__(101);
	
	var _instance2 = _interopRequireDefault(_instance);
	
	var _ErrorPage = __webpack_require__(153);
	
	var _ErrorPage2 = _interopRequireDefault(_ErrorPage);
	
	var _user = __webpack_require__(216);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _vuex = __webpack_require__(1);
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserRequest = new _user2.default();
	
	exports.default = {
	  components: {
	    ErrorPage: _ErrorPage2.default
	  },
	  data: function data() {
	    return {
	      hotmartURL: ("https://extensions-scripts.hotmart.com/app.js"),
	      klickartURL: _rebrand2.default.urls.KLICKART_URL.replace('http:', 'https:'),
	      jwtSecret: ("4d810a9b0460249eeacdef8b3c642164"),
	      error: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['showKlickpagesHeader'])),
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    var instance = (0, _instance2.default)();
	
	    instance.interceptors.response.use(function (response) {
	      _this.error = null;
	
	      return _promise2.default.resolve(response);
	    }, function (error) {
	      if (error.config.catchError) {
	        _this.error = error.response.status;
	      }
	
	      return _promise2.default.reject(error);
	    });
	  },
	  created: function created() {
	    var _this2 = this;
	
	    UserRequest.identifier().then(function (response) {
	      _this2.$ga.set('userId', response.data.identifier);
	      _this2.$ga.page(_this2.$router);
	    });
	  }
	};

/***/ },
/* 289 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  created: function created() {
	    this.$store.dispatch('authInit');
	  }
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(632);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Main3 = __webpack_require__(711);
	
	var _Main4 = _interopRequireDefault(_Main3);
	
	var _Main5 = __webpack_require__(580);
	
	var _Main6 = _interopRequireDefault(_Main5);
	
	var _Code = __webpack_require__(84);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	var _DeleteStep = __webpack_require__(730);
	
	var _DeleteStep2 = _interopRequireDefault(_DeleteStep);
	
	var _DuplicateStep = __webpack_require__(731);
	
	var _DuplicateStep2 = _interopRequireDefault(_DuplicateStep);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Sidebar: _Main2.default,
	    Topbar: _Main4.default,
	    Edit: _Main6.default,
	    ModalCode: _Code2.default,
	    ModalDeleteStep: _DeleteStep2.default,
	    ModalDuplicateStep: _DuplicateStep2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['showKlickpagesHeader'])),
	  created: function created() {
	    var _this = this;
	
	    this.$store.dispatch('boxGet').then(function () {
	      _this.$store.dispatch('stepConfigRequest');
	    });
	    this.updateKlickpagesHeaderShowStatus(false);
	  },
	  destroyed: function destroyed() {
	    this.updateKlickpagesHeaderShowStatus(true);
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['updateKlickpagesHeaderShowStatus']))
	};

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Search = __webpack_require__(720);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Main = __webpack_require__(722);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Code = __webpack_require__(84);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	var _DeleteBox = __webpack_require__(729);
	
	var _DeleteBox2 = _interopRequireDefault(_DeleteBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Search: _Search2.default,
	    List: _Main2.default,
	    ModalCode: _Code2.default,
	    ModalDeleteBox: _DeleteBox2.default
	  }
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ErrorPage = __webpack_require__(153);
	
	var _ErrorPage2 = _interopRequireDefault(_ErrorPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ErrorPage: _ErrorPage2.default
	  }
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _ExportBox = __webpack_require__(735);
	
	var _ExportBox2 = _interopRequireDefault(_ExportBox);
	
	var _EditBox = __webpack_require__(734);
	
	var _EditBox2 = _interopRequireDefault(_EditBox);
	
	var _Code = __webpack_require__(84);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      i18n: _i18n2.default
	    };
	  },
	  created: function created() {
	    this.$store.dispatch('boxGet');
	  },
	
	  methods: {
	    showBackToResume: function showBackToResume() {
	      return this.$route.name === 'boxReportsEmails';
	    }
	  },
	  components: {
	    ExportBox: _ExportBox2.default,
	    EditBox: _EditBox2.default,
	    ModalCode: _Code2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxName: 'boxName',
	    boxActive: 'boxActive'
	  })
	};

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(612);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Main3 = __webpack_require__(581);
	
	var _Main4 = _interopRequireDefault(_Main3);
	
	var _Main5 = __webpack_require__(583);
	
	var _Main6 = _interopRequireDefault(_Main5);
	
	var _Main7 = __webpack_require__(630);
	
	var _Main8 = _interopRequireDefault(_Main7);
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      themeCdnUri: _rebrand2.default.urls.THEME_CDN_URI
	    };
	  },
	
	  components: {
	    Step: _Main2.default,
	    Fluxogram: _Main4.default,
	    Preview: _Main6.default,
	    TriggerButton: _Main8.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    canvasCurrentView: 'canvasCurrentView',
	    themeActiveStyles: 'themeActiveStyles',
	    boxThemeFonts: 'boxThemeFonts'
	  })
	};

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _fluxogram = __webpack_require__(184);
	
	var _fluxogram2 = _interopRequireDefault(_fluxogram);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fluxogram = new _fluxogram2.default();
	var holderNodeClass = '.klickbox-fluxogram-container';
	
	var graph = null;
	
	exports.default = {
	  updated: function updated() {
	    if (this.canvasCurrentView !== 'fluxogram') {
	      return;
	    }
	
	    var holderNode = this.$el.querySelector(holderNodeClass);
	
	    graph = fluxogram.build(this.steps, holderNode);
	  },
	
	  methods: (0, _extends3.default)({
	    fluxogramZoomIn: function fluxogramZoomIn() {
	      graph.api.pan.zoomIn();
	    },
	    fluxogramZoomOut: function fluxogramZoomOut() {
	      graph.api.pan.zoomOut();
	    }
	  }, (0, _vuex.mapActions)(['canvasChangeView'])),
	  computed: (0, _vuex.mapGetters)({
	    canvasCurrentView: 'canvasCurrentView',
	    steps: 'stepList'
	  })
	};

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel', 'sidebarSetElement', 'sidebarChangeActiveButton']),
	  computed: (0, _vuex.mapGetters)({
	    highlightStyle: 'canvasHighlightStyle',
	    highlightElement: 'canvasHighlightElement'
	  })
	};

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(596);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _StepSelect = __webpack_require__(584);
	
	var _StepSelect2 = _interopRequireDefault(_StepSelect);
	
	var _Highlight = __webpack_require__(582);
	
	var _Highlight2 = _interopRequireDefault(_Highlight);
	
	var _Main3 = __webpack_require__(586);
	
	var _Main4 = _interopRequireDefault(_Main3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Step: _Main2.default,
	    Highlight: _Highlight2.default,
	    StepSelect: _StepSelect2.default,
	    DeviceButtons: _Main4.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxFormat: 'boxFormat',
	    stepStyle: 'stepStyle',
	    canvasPreviewDevice: 'canvasPreviewDevice'
	  }),
	  methods: (0, _vuex.mapActions)(['stepSetPreview']),
	  mounted: function mounted() {
	    this.stepSetPreview(null);
	  }
	};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _jquery = __webpack_require__(33);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mounted: function mounted() {
	    var _this = this;
	
	    (0, _jquery2.default)(this.$el).val('').select2().on('change', function () {
	      var id = _this.$el.value;
	      var step = _this.stepList.find(function (step) {
	        return step.id === id;
	      });
	
	      _this.stepSetPreview(step);
	      _this.canvasDisableHighlight();
	      _this.sidebarChangePanel('style');
	    });
	  },
	
	  computed: (0, _vuex.mapGetters)({
	    stepList: 'stepList',
	    stepDisplayPosition: 'stepDisplayPosition',
	    stepActive: 'stepActive'
	  }),
	  methods: (0, _vuex.mapActions)(['stepSetPreview', 'canvasDisableHighlight', 'sidebarChangePanel'])
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = document.querySelector('html');
	
	exports.default = {
	  props: {
	    device: String
	  },
	  data: function data() {
	    return {
	      icons: {
	        desktop: 'pc',
	        tablet: 'tablet',
	        smartphone: 'mobile'
	      }
	    };
	  },
	  mounted: function mounted() {
	    html.setAttribute('data-preview-device', this.canvasPreviewDevice);
	  },
	
	  computed: (0, _vuex.mapGetters)({
	    canvasPreviewDevice: 'canvasPreviewDevice'
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['canvasChangePreviewDevice', 'canvasDisableHighlight', 'sidebarChangePanel']), {
	    activeButton: function activeButton(device) {
	      return {
	        active: this.canvasPreviewDevice === device
	      };
	    },
	    updateDevice: function updateDevice(device) {
	      html.setAttribute('data-preview-device', device);
	      this.canvasChangePreviewDevice(device);
	      this.canvasDisableHighlight();
	      this.sidebarChangePanel('style');
	    }
	  })
	};

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DeviceButton = __webpack_require__(585);
	
	var _DeviceButton2 = _interopRequireDefault(_DeviceButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DeviceButton: _DeviceButton2.default
	  }
	};

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(590);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Main3 = __webpack_require__(595);
	
	var _Main4 = _interopRequireDefault(_Main3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Numeric: _Main2.default,
	    Percent: _Main4.default
	  },
	  methods: {
	    getStyle: function getStyle() {
	      var styleProgress = this.stepStyle('progress');
	      var display = styleProgress.display;
	
	      if (styleProgress.display === null || styleProgress.display === undefined) {
	        display = 'none';
	      }
	
	      return (0, _assign2.default)(styleProgress, { display: display });
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle',
	    stepListHasJumps: 'stepListHasJumps'
	  })
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: {
	    getStyle: function getStyle() {
	      return this.stepStyle('progress-bullet-active');
	    },
	    getLiStyle: function getLiStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'bullet') {
	        return {};
	      }
	
	      if (kind === 'svg') {
	        return { color: styles.color };
	      }
	
	      return styles;
	    },
	    getSpanStyle: function getSpanStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'standard' || kind === 'mask') {
	        return {};
	      }
	
	      return styles;
	    },
	    getNumberStyle: function getNumberStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'svg') {
	        return { color: styles.color };
	      }
	
	      return {};
	    },
	    getSVG: function getSVG() {
	      var kind = this.boxConfig.progressbar.kind;
	
	      if (kind !== 'svg') {
	        return '';
	      }
	
	      var span = document.createElement('span');
	      var progressBarSVG = this.boxConfig.progressbar.svg.bullet;
	      var styles = this.getStyle();
	
	      if (!progressBarSVG) {
	        return span;
	      }
	
	      span.innerHTML = progressBarSVG;
	      var svg = span.firstChild;
	
	      if (!styles) {
	        return svg.outerHTML;
	      }
	
	      svg.style.fill = styles.backgroundColor;
	      svg.style.stroke = styles.borderColor;
	
	      return svg.outerHTML;
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig',
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: {
	    getStyle: function getStyle() {
	      return this.stepStyle('progress-bullet-default');
	    },
	    getLiStyle: function getLiStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'bullet') {
	        return {};
	      }
	
	      if (kind === 'svg') {
	        return { color: styles.color };
	      }
	
	      return styles;
	    },
	    getSpanStyle: function getSpanStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'standard' || kind === 'mask') {
	        return {};
	      }
	
	      return styles;
	    },
	    getNumberStyle: function getNumberStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'svg') {
	        return { color: styles.color };
	      }
	
	      return {};
	    },
	    getSVG: function getSVG() {
	      var kind = this.boxConfig.progressbar.kind;
	
	      if (kind !== 'svg') {
	        return '';
	      }
	
	      var span = document.createElement('span');
	      var progressBarSVG = this.boxConfig.progressbar.svg.bullet;
	      var styles = this.stepStyle('progress-bullet-default');
	
	      if (!progressBarSVG) {
	        return span;
	      }
	
	      span.innerHTML = progressBarSVG;
	      var svg = span.firstChild;
	
	      if (!styles) {
	        return svg.outerHTML;
	      }
	
	      svg.style.fill = styles.backgroundColor;
	      svg.style.stroke = styles.borderColor;
	
	      return svg.outerHTML;
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig',
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: {
	    getStyle: function getStyle() {
	      return this.stepStyle('progress-bullet-done');
	    },
	    getLiStyle: function getLiStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'bullet') {
	        return {};
	      }
	
	      if (kind === 'svg') {
	        return { color: styles.color };
	      }
	
	      return styles;
	    },
	    getSpanStyle: function getSpanStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'standard' || kind === 'mask') {
	        return {};
	      }
	
	      return styles;
	    },
	    getNumberStyle: function getNumberStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'svg') {
	        return { color: styles.color };
	      }
	
	      return {};
	    },
	    getSVG: function getSVG() {
	      var kind = this.boxConfig.progressbar.kind;
	
	      if (kind !== 'svg') {
	        return '';
	      }
	
	      var span = document.createElement('span');
	      var progressBarSVG = this.boxConfig.progressbar.svg.bullet;
	      var styles = this.stepStyle('progress-bullet-done');
	
	      if (!progressBarSVG) {
	        return span;
	      }
	
	      span.innerHTML = progressBarSVG;
	      var svg = span.firstChild;
	
	      if (!styles) {
	        return svg.outerHTML;
	      }
	
	      svg.style.fill = styles.backgroundColor;
	      svg.style.stroke = styles.borderColor;
	
	      return svg.outerHTML;
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig',
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Done = __webpack_require__(589);
	
	var _Done2 = _interopRequireDefault(_Done);
	
	var _Active = __webpack_require__(587);
	
	var _Active2 = _interopRequireDefault(_Active);
	
	var _Default = __webpack_require__(588);
	
	var _Default2 = _interopRequireDefault(_Default);
	
	var _Mask = __webpack_require__(591);
	
	var _Mask2 = _interopRequireDefault(_Mask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['canvasEnableHighlight']),
	  components: {
	    ItemDone: _Done2.default,
	    ItemActive: _Active2.default,
	    ItemDefault: _Default2.default,
	    ItemMask: _Mask2.default
	  }
	};

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: {
	    getStyle: function getStyle() {
	      return this.stepStyle('progress-bullet-active');
	    },
	    getLiStyle: function getLiStyle() {
	      var kind = this.boxConfig.progressbar.kind;
	      var styles = this.getStyle();
	
	      if (kind === 'mask') {
	        return { borderColor: styles.borderColor };
	      }
	
	      return {};
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig',
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: {
	    getStyle: function getStyle() {
	      return this.stepStyle('progress-bar-active');
	    },
	    getDivStyle: function getDivStyle() {
	      var styles = this.getStyle();
	
	      var kind = this.boxConfig.progressbar.kind;
	
	      if (kind === 'svg') {
	        return {};
	      }
	
	      return { backgroundColor: styles.borderColor };
	    },
	    getSpanStyle: function getSpanStyle() {
	      var styles = this.getStyle();
	
	      var kind = this.boxConfig.progressbar.kind;
	
	      if (kind === 'svg') {
	        return { color: styles.color };
	      }
	
	      return {
	        backgroundColor: styles.backgroundColor,
	        color: styles.color
	      };
	    },
	    getSVG: function getSVG() {
	      var kind = this.boxConfig.progressbar.kind;
	
	      if (kind !== 'svg') {
	        return '';
	      }
	
	      var span = document.createElement('span');
	      var progressBarSVG = this.boxConfig.progressbar.svg.bar;
	      var styles = this.getStyle();
	
	      if (!progressBarSVG) {
	        return span;
	      }
	
	      span.innerHTML = progressBarSVG;
	      var svg = span.firstChild;
	
	      if (!styles) {
	        return svg.outerHTML;
	      }
	
	      svg.style.fill = styles.backgroundColor;
	      svg.style.stroke = styles.borderColor;
	
	      return svg.outerHTML;
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle',
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: {
	    getStyle: function getStyle() {
	      var styles = this.stepStyle('progress-bar-done');
	      return { background: styles.backgroundColor };
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Active = __webpack_require__(592);
	
	var _Active2 = _interopRequireDefault(_Active);
	
	var _Done = __webpack_require__(593);
	
	var _Done2 = _interopRequireDefault(_Done);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    getStyle: function getStyle() {
	      return this.stepStyle('progress-bar-default');
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  }),
	  components: {
	    ItemActive: _Active2.default,
	    ItemDone: _Done2.default
	  }
	};

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Items = __webpack_require__(594);
	
	var _Items2 = _interopRequireDefault(_Items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['canvasEnableHighlight']),
	  components: {
	    Items: _Items2.default
	  }
	};

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle',
	    stepPreview: 'stepPreview'
	  }),
	  methods: {
	    hasOther: function hasOther() {
	      if (!this.stepPreview.options) {
	        return false;
	      }
	
	      return !!this.stepPreview.options.filter(function (option) {
	        return option.other;
	      }).length;
	    },
	    showButton: function showButton() {
	      if (this.stepPreview.final || this.stepPreview.kind === 'email') {
	        return false;
	      }
	
	      if (this.stepPreview.multiple_answers || this.hasOther()) {
	        return true;
	      }
	
	      if (this.stepPreview.isGeneral || this.stepPreview.kind === 'text') {
	        return true;
	      }
	
	      return false;
	    },
	    onChange: function onChange(text) {
	      this.$store.dispatch('stepUpdateNextButtonText', {
	        event: { target: { value: text } },
	        id: this.stepPreview.id
	      });
	    }
	  }
	};

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: {
	    getLabelStyle: function getLabelStyle() {
	      var _stepStyle = this.stepStyle('progress-bullet-default'),
	          color = _stepStyle.color;
	
	      return { color: color };
	    },
	    getDefaultStyle: function getDefaultStyle() {
	      var _stepStyle2 = this.stepStyle('progress-bullet-default'),
	          borderColor = _stepStyle2.borderColor;
	
	      return { borderColor: borderColor };
	    },
	    getDoneStyle: function getDoneStyle() {
	      var _stepStyle3 = this.stepStyle('progress-bullet-done'),
	          borderColor = _stepStyle3.borderColor;
	
	      return { borderColor: borderColor };
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(34);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TextEditor: _Main2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle',
	    stepPreview: 'stepPreview'
	  }),
	  methods: {
	    onChange: function onChange(text) {
	      this.$store.dispatch('stepUpdateDescriptionText', {
	        event: { target: { value: text } },
	        id: this.stepPreview.id
	      });
	    }
	  }
	};

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _highlight = __webpack_require__(99);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _Main = __webpack_require__(599);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Main3 = __webpack_require__(609);
	
	var _Main4 = _interopRequireDefault(_Main3);
	
	var _Main5 = __webpack_require__(598);
	
	var _Main6 = _interopRequireDefault(_Main5);
	
	var _Main7 = __webpack_require__(604);
	
	var _Main8 = _interopRequireDefault(_Main7);
	
	var _Main9 = __webpack_require__(602);
	
	var _Main10 = _interopRequireDefault(_Main9);
	
	var _Main11 = __webpack_require__(606);
	
	var _Main12 = _interopRequireDefault(_Main11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentStep = void 0;
	
	var highlightHelper = new _highlight2.default();
	
	exports.default = {
	  components: {
	    Question: _Main2.default,
	    Welcome: _Main4.default,
	    FormEmail: _Main6.default,
	    TextField: _Main8.default,
	    Redirect: _Main10.default,
	    Thanks: _Main12.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepPreview: 'stepPreview'
	  }),
	  methods: (0, _vuex.mapActions)(['canvasEnableHighlight', 'sidebarSetElement', 'sidebarChangePanel', 'sidebarChangeActiveButton']),
	  updated: function updated() {
	    if (currentStep !== this.stepPreview) {
	      currentStep = this.stepPreview;
	
	      var actions = {
	        sidebarChangePanel: this.sidebarChangePanel,
	        sidebarSetElement: this.sidebarSetElement,
	        canvasEnableHighlight: this.canvasEnableHighlight,
	        sidebarChangeActiveButton: this.sidebarChangeActiveButton
	      };
	
	      highlightHelper.bind(actions);
	    }
	  }
	};

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(34);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TextEditor: _Main2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    quizStyle: 'quizStyle',
	    stepStyle: 'stepStyle',
	    stepPreview: 'stepPreview'
	  }),
	  methods: {
	    onChange: function onChange(text) {
	      this.$store.dispatch('stepUpdateTitle', {
	        event: { target: { value: text } },
	        id: this.stepPreview.id
	      });
	    }
	  }
	};

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    formHtml: 'stepFormHtmlDecoded'
	  })
	};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(54);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Title = __webpack_require__(44);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Description = __webpack_require__(43);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _Form = __webpack_require__(597);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Counter = __webpack_require__(55);
	
	var _Counter2 = _interopRequireDefault(_Counter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ProgressBar: _Main2.default,
	    TitlePreview: _Title2.default,
	    Description: _Description2.default,
	    FormEmail: _Form2.default,
	    Counter: _Counter2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(54);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Title = __webpack_require__(44);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Description = __webpack_require__(43);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _Options = __webpack_require__(600);
	
	var _Options2 = _interopRequireDefault(_Options);
	
	var _ButtonNext = __webpack_require__(149);
	
	var _ButtonNext2 = _interopRequireDefault(_ButtonNext);
	
	var _Counter = __webpack_require__(55);
	
	var _Counter2 = _interopRequireDefault(_Counter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ProgressBar: _Main2.default,
	    TitlePreview: _Title2.default,
	    Description: _Description2.default,
	    Options: _Options2.default,
	    ButtonNext: _ButtonNext2.default,
	    Counter: _Counter2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle',
	    stepPreview: 'stepPreview'
	  }),
	  methods: (0, _vuex.mapActions)(['canvasEnableHighlight'])
	};

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    stepPreview: 'stepPreview',
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(54);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Title = __webpack_require__(44);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Description = __webpack_require__(43);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _Button = __webpack_require__(601);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Counter = __webpack_require__(55);
	
	var _Counter2 = _interopRequireDefault(_Counter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ProgressBar: _Main2.default,
	    TitlePreview: _Title2.default,
	    Description: _Description2.default,
	    ButtonRedirect: _Button2.default,
	    Counter: _Counter2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig',
	    stepActive: 'stepActive'
	  })
	};

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    placeholderText: 'stepTextPlaceholder'
	  })
	};

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(54);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Title = __webpack_require__(44);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Description = __webpack_require__(43);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _Input = __webpack_require__(603);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Textarea = __webpack_require__(605);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _ButtonNext = __webpack_require__(149);
	
	var _ButtonNext2 = _interopRequireDefault(_ButtonNext);
	
	var _Counter = __webpack_require__(55);
	
	var _Counter2 = _interopRequireDefault(_Counter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ProgressBar: _Main2.default,
	    TitlePreview: _Title2.default,
	    Description: _Description2.default,
	    InputField: _Input2.default,
	    TextareaField: _Textarea2.default,
	    ButtonNext: _ButtonNext2.default,
	    Counter: _Counter2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig',
	    stepActive: 'stepActive'
	  })
	};

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    placeholderText: 'stepTextPlaceholder',
	    stepActive: 'stepActive'
	  })
	};

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Title = __webpack_require__(44);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Description = __webpack_require__(43);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TitlePreview: _Title2.default,
	    Description: _Description2.default
	  }
	};

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle',
	    stepPreview: 'stepPreview'
	  }),
	  methods: (0, _vuex.mapActions)(['canvasEnableHighlight'])
	};

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(34);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TextEditor: _Main2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle',
	    stepPreview: 'stepPreview'
	  }),
	  methods: {
	    onChange: function onChange(text) {
	      this.$store.dispatch('stepUpdateDescriptionText', {
	        event: { target: { value: text } },
	        id: this.stepPreview.id
	      });
	    }
	  }
	};

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Title = __webpack_require__(610);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Description = __webpack_require__(608);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _Buttons = __webpack_require__(607);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TitlePreview: _Title2.default,
	    Description: _Description2.default,
	    Buttons: _Buttons2.default
	  }
	};

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(34);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TextEditor: _Main2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle',
	    stepPreview: 'stepPreview'
	  }),
	  methods: {
	    onChange: function onChange(text) {
	      this.$store.dispatch('stepUpdateTitle', {
	        event: { target: { value: text } },
	        id: this.stepPreview.id
	      });
	    }
	  }
	};

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _DescriptionCheckbox = __webpack_require__(616);
	
	var _DescriptionCheckbox2 = _interopRequireDefault(_DescriptionCheckbox);
	
	var _Main = __webpack_require__(34);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DescriptionCheckbox: _DescriptionCheckbox2.default,
	    TextEditor: _Main2.default
	  },
	  props: ['step'],
	  computed: (0, _vuex.mapGetters)({
	    descriptionVisibility: 'stepDescriptionVisibility'
	  }),
	  methods: {
	    changed: function changed(text) {
	      this.$store.dispatch('stepUpdateDescriptionText', {
	        event: { target: { value: text } },
	        id: this.step.id
	      });
	    }
	  }
	};

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _MultipleChoice = __webpack_require__(624);
	
	var _MultipleChoice2 = _interopRequireDefault(_MultipleChoice);
	
	var _Text = __webpack_require__(626);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Email = __webpack_require__(623);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _Redirect = __webpack_require__(625);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _Welcome = __webpack_require__(627);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _TopMessage = __webpack_require__(615);
	
	var _TopMessage2 = _interopRequireDefault(_TopMessage);
	
	var _Title = __webpack_require__(614);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Description = __webpack_require__(611);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _NextButton = __webpack_require__(613);
	
	var _NextButton2 = _interopRequireDefault(_NextButton);
	
	var _Main = __webpack_require__(618);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    MultipleChoice: _MultipleChoice2.default,
	    TextStep: _Text2.default,
	    Email: _Email2.default,
	    Redirect: _Redirect2.default,
	    Welcome: _Welcome2.default,
	    TopMessage: _TopMessage2.default,
	    StepTitle: _Title2.default,
	    StepDescription: _Description2.default,
	    StepNextButton: _NextButton2.default,
	    Config: _Main2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    stepActive: 'stepActive',
	    quizInternalStyle: 'quizInternalStyle'
	  }),
	  methods: (0, _vuex.mapActions)(['canvasChangeView'])
	};

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['step'],
	  methods: (0, _vuex.mapActions)(['stepUpdateNextButtonText'])
	};

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(34);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TextEditor: _Main2.default
	  },
	  props: ['step'],
	  methods: {
	    onChange: function onChange(text) {
	      this.$store.dispatch('stepUpdateTitle', {
	        event: { target: { value: text } },
	        id: this.step.id
	      });
	    }
	  }
	};

/***/ },
/* 334 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['step']
	};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    step: 'stepActive'
	  }),
	  methods: (0, _vuex.mapActions)(['stepChangeDescriptionVisibity'])
	};

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Exception = __webpack_require__(151);
	
	var _Exception2 = _interopRequireDefault(_Exception);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ExceptionSelect: _Exception2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    step: 'stepActive',
	    jump: 'jumpList',
	    redirect: 'stepRedirectEmailService',
	    customizedForm: 'stepCustomizedForm',
	    orginalForm: 'stepOriginalFormHtmlDecoded'
	  }),
	  methods: (0, _vuex.mapActions)(['stepUpdateFormHtml', 'stepUpdateCustomizedForm', 'stepUpdateRedirectEmailService'])
	};

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MultipleChoice = __webpack_require__(619);
	
	var _MultipleChoice2 = _interopRequireDefault(_MultipleChoice);
	
	var _Email = __webpack_require__(617);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _Redirect = __webpack_require__(620);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _Text = __webpack_require__(621);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Welcome = __webpack_require__(622);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    MultipleChoice: _MultipleChoice2.default,
	    Email: _Email2.default,
	    Redirect: _Redirect2.default,
	    TextStep: _Text2.default,
	    Welcome: _Welcome2.default
	  }
	};

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    step: 'stepActive',
	    optionOtherAnswer: 'optionOtherAnswer',
	    options: 'optionList'
	  }),
	  methods: (0, _vuex.mapActions)(['stepUpdateMultipleAnswers', 'optionUpdateOtherAnswer'])
	};

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    step: 'stepActive'
	  }),
	  methods: (0, _vuex.mapActions)(['stepUpdateRedirectAutomatic', 'stepUpdateRedirectUrl'])
	};

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    step: 'stepActive'
	  }),
	  methods: (0, _vuex.mapActions)(['stepUpdateTextRequired', 'stepUpdateTextSize'])
	};

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    step: 'stepActive'
	  }),
	  methods: (0, _vuex.mapActions)(['stepUpdateWelcomeActive', 'stepUpdateWelcomeOption'])
	};

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['step'],
	  computed: (0, _vuex.mapGetters)({
	    formHtml: 'stepFormHtmlDecoded'
	  })
	};

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['step'],
	  methods: (0, _vuex.mapActions)(['optionUpdateText', 'optionAdd', 'optionRemove'])
	};

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['step'],
	  methods: (0, _vuex.mapActions)(['stepUpdateRedirectButtonText'])
	};

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['step'],
	  computed: (0, _vuex.mapGetters)({
	    placeholderText: 'stepTextPlaceholder'
	  }),
	  methods: (0, _vuex.mapActions)(['stepUpdateTextPlaceholder'])
	};

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['step'],
	  methods: (0, _vuex.mapActions)(['optionUpdateText'])
	};

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      themeCdnUri: _rebrand2.default.urls.THEME_CDN_URI
	    };
	  },
	
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Basic = __webpack_require__(628);
	
	var _Basic2 = _interopRequireDefault(_Basic);
	
	var _Naked = __webpack_require__(631);
	
	var _Naked2 = _interopRequireDefault(_Naked);
	
	var _External = __webpack_require__(629);
	
	var _External2 = _interopRequireDefault(_External);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BasicButton: _Basic2.default,
	    NakedButton: _Naked2.default,
	    ExternalButton: _External2.default
	  }
	};

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(647);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Main3 = __webpack_require__(668);
	
	var _Main4 = _interopRequireDefault(_Main3);
	
	var _Main5 = __webpack_require__(701);
	
	var _Main6 = _interopRequireDefault(_Main5);
	
	var _Main7 = __webpack_require__(710);
	
	var _Main8 = _interopRequireDefault(_Main7);
	
	var _Main9 = __webpack_require__(686);
	
	var _Main10 = _interopRequireDefault(_Main9);
	
	var _Main11 = __webpack_require__(653);
	
	var _Main12 = _interopRequireDefault(_Main11);
	
	var _Main13 = __webpack_require__(693);
	
	var _Main14 = _interopRequireDefault(_Main13);
	
	var _Main15 = __webpack_require__(657);
	
	var _Main16 = _interopRequireDefault(_Main15);
	
	var _Main17 = __webpack_require__(633);
	
	var _Main18 = _interopRequireDefault(_Main17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    MenuButtons: _Main2.default,
	    Steps: _Main4.default,
	    Types: _Main6.default,
	    ViewMode: _Main8.default,
	    Themes: _Main10.default,
	    Config: _Main12.default,
	    TriggerButton: _Main14.default,
	    Modifiers: _Main16.default,
	    AdvancedConfig: _Main18.default
	  }
	};

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(641);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Main3 = __webpack_require__(635);
	
	var _Main4 = _interopRequireDefault(_Main3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ExibitionMode: _Main2.default,
	    ExibitionFrequency: _Main4.default
	  }
	};

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Header = __webpack_require__(634);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(637);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    AdvancedConfigHeader: _Header2.default,
	    AdvancedConfigOptions: _Main2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel',
	    boxActive: 'boxActive'
	  }),
	  methods: (0, _extends3.default)({
	    publishAndExport: function publishAndExport() {
	      var _this = this;
	
	      this.boxSave(true).then(function () {
	        _this.modalOpen('code');
	        _this.codeSetupBox(_this.boxActive);
	      });
	    }
	  }, (0, _vuex.mapActions)(['modalOpen', 'codeSetupBox', 'boxSave']))
	};

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(83);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OptionGeneral: _Main2.default
	  },
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UntilAction = __webpack_require__(639);
	
	var _UntilAction2 = _interopRequireDefault(_UntilAction);
	
	var _TimesUntilAction = __webpack_require__(638);
	
	var _TimesUntilAction2 = _interopRequireDefault(_TimesUntilAction);
	
	var _IntervalUntilAction = __webpack_require__(636);
	
	var _IntervalUntilAction2 = _interopRequireDefault(_IntervalUntilAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OptionUntilAction: _UntilAction2.default,
	    OptionTimesUntilAction: _TimesUntilAction2.default,
	    OptionIntervalUntilAction: _IntervalUntilAction2.default
	  }
	};

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(83);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OptionGeneral: _Main2.default
	  },
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(83);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OptionGeneral: _Main2.default
	  }
	};

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['value', 'label'],
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Header = __webpack_require__(640);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(644);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    AdvancedConfigHeader: _Header2.default,
	    AdvancedConfigOptions: _Main2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel'
	  }),
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel'])
	};

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(56);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OptionGeneral: _Main2.default
	  }
	};

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(56);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OptionGeneral: _Main2.default
	  }
	};

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Immediately = __webpack_require__(643);
	
	var _Immediately2 = _interopRequireDefault(_Immediately);
	
	var _Time = __webpack_require__(646);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _Exit = __webpack_require__(642);
	
	var _Exit2 = _interopRequireDefault(_Exit);
	
	var _Scroll = __webpack_require__(645);
	
	var _Scroll2 = _interopRequireDefault(_Scroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OptionImmediately: _Immediately2.default,
	    OptionTime: _Time2.default,
	    OptionExit: _Exit2.default,
	    OptionScroll: _Scroll2.default
	  }
	};

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(56);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OptionGeneral: _Main2.default
	  },
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(56);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OptionGeneral: _Main2.default
	  },
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['value', 'label'],
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Logo = __webpack_require__(649);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Steps = __webpack_require__(651);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Model = __webpack_require__(650);
	
	var _Model2 = _interopRequireDefault(_Model);
	
	var _Style = __webpack_require__(652);
	
	var _Style2 = _interopRequireDefault(_Style);
	
	var _AdvancedConfig = __webpack_require__(648);
	
	var _AdvancedConfig2 = _interopRequireDefault(_AdvancedConfig);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isLoading: false
	    };
	  },
	
	  components: {
	    Logo: _Logo2.default,
	    Steps: _Steps2.default,
	    Model: _Model2.default,
	    ButtonStyle: _Style2.default,
	    AdvancedConfig: _AdvancedConfig2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    topBarConfig: 'topBar/config'
	  }),
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('requestStart', function () {
	      _this.isLoading = true;
	    });
	
	    window.addEventListener('requestEnd', function () {
	      _this.isLoading = false;
	    });
	  }
	};

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    sidebarActiveButton: 'sidebarActiveButton',
	    boxConfig: 'boxConfig'
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['sidebarChangePanel', 'sidebarChangeActiveButton', 'canvasChangeView']), {
	    handleClick: function handleClick() {
	      if (this.boxConfig.advanced.view_mode === 'click') {
	        return false;
	      }
	
	      this.sidebarChangePanel('exibitionmode');
	      this.sidebarChangeActiveButton('advancedconfig');
	      this.canvasChangeView('preview');
	
	      return true;
	    }
	  })
	};

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      i18n: _i18n2.default
	    };
	  }
	};

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    sidebarActiveButton: 'sidebarActiveButton',
	    boxThemeSlug: 'boxThemeSlug',
	    boxFormat: 'boxFormat'
	  }),
	  methods: (0, _extends3.default)({
	    goToBox: function goToBox() {
	      var destiny = 'themes';
	
	      if (!this.boxFormat) {
	        destiny = 'types';
	      }
	
	      this.sidebarChangePanel(destiny);
	      this.sidebarChangeActiveButton('box');
	      this.canvasChangeView('preview');
	    }
	  }, (0, _vuex.mapActions)(['sidebarChangePanel', 'sidebarChangeActiveButton', 'canvasChangeView']))
	};

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    sidebarActiveButton: 'sidebarActiveButton'
	  }),
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel', 'sidebarChangeActiveButton', 'canvasChangeView'])
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    sidebarActiveButton: 'sidebarActiveButton'
	  }),
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel', 'sidebarChangeActiveButton', 'canvasChangeView'])
	};

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _TriggerButton = __webpack_require__(655);
	
	var _TriggerButton2 = _interopRequireDefault(_TriggerButton);
	
	var _Modifiers = __webpack_require__(654);
	
	var _Modifiers2 = _interopRequireDefault(_Modifiers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TriggerButtonConfig: _TriggerButton2.default,
	    ModifiersConfig: _Modifiers2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel',
	    boxConfig: 'boxConfig'
	  }),
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel', 'sidebarChangeActiveButton', 'canvasChangeView'])
	};

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(12);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      editables: []
	    };
	  },
	  mounted: function mounted() {
	    var selector = '[klickbox-edit-item]:not([klickbox-edit-item-dad])';
	    this.editables = (0, _from2.default)(document.querySelectorAll(selector));
	  },
	  updated: function updated() {
	    var _this = this;
	
	    var selector = '[klickbox-edit-item]:not([klickbox-edit-item-dad])';
	    setTimeout(function () {
	      _this.editables = (0, _from2.default)(document.querySelectorAll(selector));
	    }, 0);
	  },
	
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel', 'sidebarSetElement'])
	};

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel', 'canvasChangeView']),
	  computed: (0, _vuex.mapGetters)({
	    boxFormat: 'boxFormat'
	  })
	};

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    element: 'sidebarCurrentElement'
	  }),
	  methods: (0, _extends3.default)({
	    getElementLabel: function getElementLabel() {
	      return this.element ? this.element.getAttribute('klickbox-edit-label') : '';
	    }
	  }, (0, _vuex.mapActions)(['sidebarChangePanel']))
	};

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Header = __webpack_require__(656);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(666);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      subItems: []
	    };
	  },
	
	  components: {
	    HeaderConfig: _Header2.default,
	    Editor: _Main2.default
	  },
	  updated: function updated() {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.subItems = document.querySelectorAll('[klickbox-edit-item-dad="' + _this.item + '"]');
	    }, 0);
	  },
	
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel',
	    modifiers: 'sidebarElementModifiers',
	    item: 'sidebarElementItem',
	    stepPreview: 'stepPreview'
	  }),
	  methods: (0, _vuex.mapActions)(['sidebarSetElement'])
	};

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _ColorPicker = __webpack_require__(46);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = '#FFFFFF';
	
	exports.default = {
	  props: ['item', 'general'],
	  components: {
	    ColorPicker: _ColorPicker2.default
	  },
	  methods: (0, _extends3.default)({
	    getId: function getId() {
	      return 'backgroundColor-' + this.item;
	    },
	    value: function value() {
	      var style = this.stepStyle(this.item);
	
	      if (!style || !style.backgroundColor) {
	        return defaultValue;
	      }
	
	      return style.backgroundColor.replace('px', '');
	    },
	    onColorChange: function onColorChange(color) {
	      if (this.general) {
	        return this.quizUpdateStyle({
	          item: this.item,
	          rule: 'backgroundColor',
	          value: color
	        });
	      }
	
	      return this.stepUpdateStyle({
	        item: this.item,
	        rule: 'backgroundColor',
	        value: color
	      });
	    },
	    onMove: function onMove(color) {
	      if (this.general) {
	        return this.quizPreviewStyleChange({
	          item: this.item,
	          rule: 'backgroundColor',
	          value: color
	        });
	      }
	
	      return this.stepPreviewStyleChange({
	        item: this.item,
	        rule: 'backgroundColor',
	        value: color
	      });
	    }
	  }, (0, _vuex.mapActions)(['quizUpdateStyle', 'quizPreviewStyleChange', 'stepUpdateStyle', 'stepPreviewStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _ColorPicker = __webpack_require__(46);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = '#FFFFFF';
	
	exports.default = {
	  props: ['item', 'general'],
	  components: {
	    ColorPicker: _ColorPicker2.default
	  },
	  methods: (0, _extends3.default)({
	    getId: function getId() {
	      return 'borderColor-' + this.item;
	    },
	    value: function value() {
	      var style = this.stepStyle(this.item);
	
	      if (!style || !style.borderColor) {
	        return defaultValue;
	      }
	
	      return style.borderColor.replace('px', '');
	    },
	    onColorChange: function onColorChange(color) {
	      if (this.general) {
	        return this.quizUpdateStyle({ item: this.item, rule: 'borderColor', value: color });
	      }
	
	      return this.stepUpdateStyle({ item: this.item, rule: 'borderColor', value: color });
	    },
	    onMove: function onMove(color) {
	      if (this.general) {
	        return this.quizPreviewStyleChange({ item: this.item, rule: 'borderColor', value: color });
	      }
	
	      return this.stepPreviewStyleChange({ item: this.item, rule: 'borderColor', value: color });
	    }
	  }, (0, _vuex.mapActions)(['quizUpdateStyle', 'quizPreviewStyleChange', 'stepUpdateStyle', 'stepPreviewStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Range = __webpack_require__(20);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = 5;
	
	exports.default = {
	  props: ['item', 'general'],
	  components: {
	    Range: _Range2.default
	  },
	  methods: (0, _extends3.default)({
	    value: function value() {
	      var style = this.stepStyle(this.item);
	
	      if (!style || !style.borderRadius) {
	        return defaultValue;
	      }
	
	      return style.borderRadius.replace('px', '');
	    },
	    onChange: function onChange(value) {
	      if (this.general) {
	        return this.quizUpdateStyle({
	          item: this.item,
	          rule: 'borderRadius',
	          value: value + 'px'
	        });
	      }
	
	      return this.stepUpdateStyle({
	        item: this.item,
	        rule: 'borderRadius',
	        value: value + 'px'
	      });
	    },
	    onMove: function onMove(value) {
	      if (this.general) {
	        return this.quizPreviewStyleChange({
	          item: this.item,
	          rule: 'borderRadius',
	          value: value + 'px'
	        });
	      }
	
	      return this.stepPreviewStyleChange({
	        item: this.item,
	        rule: 'borderRadius',
	        value: value + 'px'
	      });
	    }
	  }, (0, _vuex.mapActions)(['quizUpdateStyle', 'quizPreviewStyleChange', 'stepUpdateStyle', 'stepPreviewStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _ColorPicker = __webpack_require__(46);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = '#FFFFFF';
	
	exports.default = {
	  props: ['item', 'general'],
	  components: {
	    ColorPicker: _ColorPicker2.default
	  },
	  methods: (0, _extends3.default)({
	    getId: function getId() {
	      return 'color-' + this.item;
	    },
	    value: function value() {
	      var style = this.stepStyle(this.item);
	
	      if (!style || !style.color) {
	        return defaultValue;
	      }
	
	      return style.color.replace('px', '');
	    },
	    onColorChange: function onColorChange(color) {
	      if (this.general) {
	        return this.quizUpdateStyle({ item: this.item, rule: 'color', value: color });
	      }
	
	      return this.stepUpdateStyle({ item: this.item, rule: 'color', value: color });
	    },
	    onMove: function onMove(color) {
	      if (this.general) {
	        return this.quizPreviewStyleChange({ item: this.item, rule: 'color', value: color });
	      }
	
	      return this.stepPreviewStyleChange({ item: this.item, rule: 'color', value: color });
	    }
	  }, (0, _vuex.mapActions)(['quizUpdateStyle', 'quizPreviewStyleChange', 'stepUpdateStyle', 'stepPreviewStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['item', 'general'],
	  methods: (0, _extends3.default)({
	    getValue: function getValue() {
	      var style = this.stepStyle(this.item);
	      return style.display !== 'none';
	    },
	    onChange: function onChange(event) {
	      var checked = event.target.checked;
	
	      var display = checked ? 'block' : 'none';
	
	      if (this.general) {
	        return this.quizUpdateStyle({ item: this.item, rule: 'display', value: display });
	      }
	
	      return this.stepUpdateStyle({ item: this.item, rule: 'display', value: display });
	    }
	  }, (0, _vuex.mapActions)(['quizUpdateStyle', 'stepUpdateStyle'])),
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['item', 'general'],
	  data: function data() {
	    return {
	      fontFamilies: [{ value: '', label: 'Padrão' }, { value: 'Arial, Helvetica Neue, Helvetica, sans-serif', label: 'Arial' }, { value: 'Comic Sans MS, cursive, sans-serif', label: 'Comic Sans MS' }, { value: 'Courier New, Courier, monospace', label: 'Courier New' }, { value: 'Georgia, serif', label: 'Georgia' }, { value: 'Lucida Sans Unicode, Lucida Grande, sans-serif', label: 'Lucida Sans Unicode' }, { value: 'Tahoma, Geneva, sans-serif', label: 'Tahoma' }, { value: 'Times New Roman, Times, serif', label: 'Times New Roman' }, { value: 'Trebuchet MS, Helvetica, sans-serif', label: 'Trebuchet MS' }, { value: 'Verdana, Geneva, sans-serif', label: 'Verdana' }]
	    };
	  },
	
	  methods: (0, _extends3.default)({
	    onChange: function onChange(event) {
	      var value = event.target.value;
	
	
	      if (this.general) {
	        return this.quizUpdateStyle({ item: this.item, rule: 'fontFamily', value: value });
	      }
	
	      return this.stepUpdateStyle({ item: this.item, rule: 'fontFamily', value: value });
	    }
	  }, (0, _vuex.mapActions)(['quizUpdateStyle', 'stepUpdateStyle'])),
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Range = __webpack_require__(20);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = 1;
	
	exports.default = {
	  props: ['item', 'general'],
	  components: {
	    Range: _Range2.default
	  },
	  methods: (0, _extends3.default)({
	    value: function value() {
	      var value = defaultValue;
	      var style = this.stepStyle(this.item);
	
	      if (!style || !style.fontSize) {
	        return value;
	      }
	
	      if (style.fontSize.includes('px')) {
	        var px = parseFloat(style.fontSize.replace('px', ''));
	        value = px / 10;
	
	        return value.toFixed(1).toString();
	      }
	
	      return style.fontSize.replace('rem', '');
	    },
	    onChange: function onChange(value) {
	      if (this.general) {
	        return this.quizUpdateStyle({
	          item: this.item,
	          rule: 'fontSize',
	          value: value + 'rem'
	        });
	      }
	
	      return this.stepUpdateStyle({
	        item: this.item,
	        rule: 'fontSize',
	        value: value + 'rem'
	      });
	    },
	    onMove: function onMove(value) {
	      if (this.general) {
	        return this.quizPreviewStyleChange({
	          item: this.item,
	          rule: 'fontSize',
	          value: value + 'rem'
	        });
	      }
	
	      return this.stepPreviewStyleChange({
	        item: this.item,
	        rule: 'fontSize',
	        value: value + 'rem'
	      });
	    }
	  }, (0, _vuex.mapActions)(['quizUpdateStyle', 'quizPreviewStyleChange', 'stepUpdateStyle', 'stepPreviewStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Range = __webpack_require__(20);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = 70;
	
	exports.default = {
	  props: ['item', 'general'],
	  components: {
	    Range: _Range2.default
	  },
	  methods: (0, _extends3.default)({
	    value: function value() {
	      var style = this.stepStyle(this.item);
	
	      if (!style || !style.height) {
	        return defaultValue;
	      }
	
	      return style.height.replace('px', '');
	    },
	    onChange: function onChange(value) {
	      if (this.general) {
	        return this.quizUpdateStyle({
	          item: this.item,
	          rule: 'height',
	          value: value + 'px'
	        });
	      }
	
	      return this.stepUpdateStyle({
	        item: this.item,
	        rule: 'height',
	        value: value + 'px'
	      });
	    },
	    onMove: function onMove(value) {
	      if (this.general) {
	        return this.quizPreviewStyleChange({
	          item: this.item,
	          rule: 'height',
	          value: value + 'px'
	        });
	      }
	
	      return this.stepPreviewStyleChange({
	        item: this.item,
	        rule: 'height',
	        value: value + 'px'
	      });
	    }
	  }, (0, _vuex.mapActions)(['quizUpdateStyle', 'quizPreviewStyleChange', 'stepUpdateStyle', 'stepPreviewStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BackgroundColor = __webpack_require__(658);
	
	var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);
	
	var _BorderColor = __webpack_require__(659);
	
	var _BorderColor2 = _interopRequireDefault(_BorderColor);
	
	var _BorderRadius = __webpack_require__(660);
	
	var _BorderRadius2 = _interopRequireDefault(_BorderRadius);
	
	var _Color = __webpack_require__(661);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _FontFamily = __webpack_require__(663);
	
	var _FontFamily2 = _interopRequireDefault(_FontFamily);
	
	var _FontSize = __webpack_require__(664);
	
	var _FontSize2 = _interopRequireDefault(_FontSize);
	
	var _Height = __webpack_require__(665);
	
	var _Height2 = _interopRequireDefault(_Height);
	
	var _Width = __webpack_require__(667);
	
	var _Width2 = _interopRequireDefault(_Width);
	
	var _Display = __webpack_require__(662);
	
	var _Display2 = _interopRequireDefault(_Display);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['modifier', 'general', 'item'],
	  components: {
	    BackgroundColor: _BackgroundColor2.default,
	    BorderColor: _BorderColor2.default,
	    BorderRadius: _BorderRadius2.default,
	    Color: _Color2.default,
	    FontFamily: _FontFamily2.default,
	    FontSize: _FontSize2.default,
	    Height: _Height2.default,
	    Width: _Width2.default,
	    Display: _Display2.default
	  }
	};

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Range = __webpack_require__(20);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = 250;
	
	exports.default = {
	  props: ['item', 'general'],
	  components: {
	    Range: _Range2.default
	  },
	  methods: (0, _extends3.default)({
	    value: function value() {
	      var style = this.stepStyle(this.item);
	
	      if (!style || !style.width) {
	        return defaultValue;
	      }
	
	      return style.width.replace('px', '');
	    },
	    onChange: function onChange(value) {
	      if (this.general) {
	        return this.quizUpdateStyle({
	          item: this.item,
	          rule: 'width',
	          value: value + 'px'
	        });
	      }
	
	      return this.stepUpdateStyle({
	        item: this.item,
	        rule: 'width',
	        value: value + 'px'
	      });
	    },
	    onMove: function onMove(value) {
	      if (this.general) {
	        return this.quizPreviewStyleChange({
	          item: this.item,
	          rule: 'width',
	          value: value + 'px'
	        });
	      }
	
	      return this.stepPreviewStyleChange({
	        item: this.item,
	        rule: 'width',
	        value: value + 'px'
	      });
	    }
	  }, (0, _vuex.mapActions)(['quizUpdateStyle', 'quizPreviewStyleChange', 'stepUpdateStyle', 'stepPreviewStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    stepStyle: 'stepStyle'
	  })
	};

/***/ },
/* 387 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['step']
	};

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Main = __webpack_require__(683);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _ButtonAdd = __webpack_require__(679);
	
	var _ButtonAdd2 = _interopRequireDefault(_ButtonAdd);
	
	var _Main3 = __webpack_require__(670);
	
	var _Main4 = _interopRequireDefault(_Main3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel',
	    stepHasOnlyThanks: 'stepHasOnlyThanks'
	  }),
	  components: {
	    List: _Main2.default,
	    ButtonAdd: _ButtonAdd2.default,
	    Jump: _Main4.default
	  }
	};

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Add = __webpack_require__(671);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _Remove = __webpack_require__(674);
	
	var _Remove2 = _interopRequireDefault(_Remove);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['index', 'jumpId'],
	  components: {
	    AddButton: _Add2.default,
	    RemoveButton: _Remove2.default
	  }
	};

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Icon = __webpack_require__(150);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AddFirst = __webpack_require__(672);
	
	var _AddFirst2 = _interopRequireDefault(_AddFirst);
	
	var _Header = __webpack_require__(669);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _MultipleAnswer = __webpack_require__(677);
	
	var _MultipleAnswer2 = _interopRequireDefault(_MultipleAnswer);
	
	var _SingleAnswer = __webpack_require__(678);
	
	var _SingleAnswer2 = _interopRequireDefault(_SingleAnswer);
	
	var _Destiny = __webpack_require__(676);
	
	var _Destiny2 = _interopRequireDefault(_Destiny);
	
	var _Exception = __webpack_require__(151);
	
	var _Exception2 = _interopRequireDefault(_Exception);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listSize = 0;
	
	exports.default = {
	  updated: function updated() {
	    var element = document.querySelector('.submenu-padding:last-of-type');
	
	    if (!this.jumpList) {
	      return;
	    }
	
	    if (listSize > this.jumpList.length) {
	      listSize = this.jumpList.length;
	      return;
	    }
	
	    if (element) {
	      element.scrollIntoView();
	    }
	
	    listSize = this.jumpList.length;
	  },
	
	  components: {
	    StepIcon: _Icon2.default,
	    AddFirstButton: _AddFirst2.default,
	    JumpHeader: _Header2.default,
	    MultipleAnswerSelect: _MultipleAnswer2.default,
	    SingleAnswerSelect: _SingleAnswer2.default,
	    DestinySelect: _Destiny2.default,
	    ExceptionSelect: _Exception2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel',
	    stepActive: 'stepActive',
	    jumpList: 'jumpList'
	  }),
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel'])
	};

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['jumpAdd'])
	};

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    jumpList: 'jumpList'
	  }),
	  methods: (0, _vuex.mapActions)(['jumpAdd'])
	};

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['jump', 'show'],
	  methods: (0, _vuex.mapActions)(['jumpAddOptionId'])
	};

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['index', 'jumpId'],
	  methods: (0, _vuex.mapActions)(['jumpRemove'])
	};

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['jump', 'index', 'show'],
	  methods: (0, _vuex.mapActions)(['jumpRemoveOptionId'])
	};

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StepJumpSelect = __webpack_require__(154);
	
	var _StepJumpSelect2 = _interopRequireDefault(_StepJumpSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    StepJumpSelect: _StepJumpSelect2.default
	  },
	  props: ['jump', 'selected']
	};

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _StepJumpSelect = __webpack_require__(154);
	
	var _StepJumpSelect2 = _interopRequireDefault(_StepJumpSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    StepJumpSelect: _StepJumpSelect2.default
	  },
	  props: ['jump', 'selected'],
	  computed: (0, _vuex.mapGetters)({
	    jumpList: 'jumpList'
	  })
	};

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _AddOption = __webpack_require__(673);
	
	var _AddOption2 = _interopRequireDefault(_AddOption);
	
	var _RemoveOption = __webpack_require__(675);
	
	var _RemoveOption2 = _interopRequireDefault(_RemoveOption);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['jump'],
	  components: {
	    AddOptionButton: _AddOption2.default,
	    RemoveOptionButton: _RemoveOption2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    optionList: 'optionList'
	  }),
	  methods: (0, _vuex.mapActions)(['jumpUpdateOptionId'])
	};

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['jump'],
	  computed: (0, _vuex.mapGetters)({
	    optionList: 'optionList'
	  }),
	  methods: (0, _vuex.mapActions)(['jumpUpdateOptionId'])
	};

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['stepAdd']),
	  computed: (0, _vuex.mapGetters)({
	    stepHasOnlyThanks: 'stepHasOnlyThanks',
	    topBarConfig: 'topBar/config'
	  })
	};

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['step'],
	  methods: (0, _vuex.mapActions)(['modalOpen', 'stepSetActive'])
	};

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['step'],
	  methods: (0, _vuex.mapActions)(['modalOpen', 'stepSetActive'])
	};

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['step'],
	  methods: (0, _vuex.mapActions)(['stepSetActive', 'sidebarChangePanel']),
	  computed: (0, _vuex.mapGetters)({
	    jumpCount: 'jumpCount'
	  })
	};

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Icon = __webpack_require__(150);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _vuedraggable = __webpack_require__(931);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _ButtonDuplicate = __webpack_require__(681);
	
	var _ButtonDuplicate2 = _interopRequireDefault(_ButtonDuplicate);
	
	var _ButtonJump = __webpack_require__(682);
	
	var _ButtonJump2 = _interopRequireDefault(_ButtonJump);
	
	var _ButtonDelete = __webpack_require__(680);
	
	var _ButtonDelete2 = _interopRequireDefault(_ButtonDelete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    StepIcon: _Icon2.default,
	    draggable: _vuedraggable2.default,
	    ButtonDuplicate: _ButtonDuplicate2.default,
	    ButtonJump: _ButtonJump2.default,
	    ButtonDelete: _ButtonDelete2.default
	  },
	  computed: (0, _extends3.default)({
	    list: function list() {
	      return this.steps.slice(0);
	    }
	  }, (0, _vuex.mapGetters)({
	    steps: 'stepList',
	    stepActive: 'stepActive',
	    stepDisplayPosition: 'stepDisplayPosition'
	  })),
	  methods: (0, _extends3.default)({
	    onDragEnd: function onDragEnd(event, list) {
	      if (event.newIndex === list.length - 1) {
	        return false;
	      }
	
	      this.stepUpdateOrder({ event: event, list: list });
	      return true;
	    }
	  }, (0, _vuex.mapActions)(['stepSetActive', 'stepUpdateOrder', 'canvasChangeView']))
	};

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel'])
	};

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _rebrand = __webpack_require__(11);
	
	var _rebrand2 = _interopRequireDefault(_rebrand);
	
	var _highlight = __webpack_require__(99);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var highlightHelper = new _highlight2.default();
	
	exports.default = {
	  data: function data() {
	    return {
	      themeUrl: _rebrand2.default.urls.THEME_CDN_URI
	    };
	  },
	
	  computed: (0, _vuex.mapGetters)({
	    themeList: 'themeList',
	    themeActive: 'themeActive'
	  }),
	  methods: (0, _extends3.default)({
	    thumbUrl: function thumbUrl(slug) {
	      return this.themeUrl + '/themes/' + slug + '/thumb.jpg';
	    },
	    changeTheme: function changeTheme(theme) {
	      this.canvasDisableHighlight();
	      this.themeSetActive(theme);
	      this.themeUpdateStyles(theme);
	
	      var actions = {
	        sidebarChangePanel: this.sidebarChangePanel,
	        sidebarSetElement: this.sidebarSetElement,
	        canvasEnableHighlight: this.canvasEnableHighlight,
	        sidebarChangeActiveButton: this.sidebarChangeActiveButton
	      };
	
	      highlightHelper.bind(actions);
	    }
	  }, (0, _vuex.mapActions)(['themeSetActive', 'themeUpdateStyles', 'sidebarChangePanel', 'sidebarSetElement', 'canvasEnableHighlight', 'canvasDisableHighlight', 'sidebarChangeActiveButton']))
	};

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Header = __webpack_require__(684);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _List = __webpack_require__(685);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ThemeHeader: _Header2.default,
	    ThemeList: _List2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel'
	  }),
	  mounted: function mounted() {
	    this.$store.dispatch('themeGetAll');
	  }
	};

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFloatValue = 'none';
	
	exports.default = {
	  mounted: function mounted() {
	    var _this = this;
	
	    var select = this.$el.querySelector('select');
	
	    select.addEventListener('change', function (event) {
	      _this.onChange(event.target.value);
	    });
	  },
	  updated: function updated() {
	    var margin = this.boxConfig.trigger_button.style.margin;
	
	    if (!margin) {
	      this.boxUpdateConfigStyle({
	        item: 'trigger_button',
	        rule: 'margin',
	        value: '0 auto'
	      });
	    }
	  },
	
	  methods: (0, _extends3.default)({
	    value: function value() {
	      var floatValue = this.boxConfig.trigger_button.style.float;
	
	      if (!floatValue) {
	        floatValue = defaultFloatValue;
	      }
	
	      return floatValue;
	    },
	    updateConfig: function updateConfig(float) {
	      this.boxUpdateConfigStyle({
	        item: 'trigger_button',
	        rule: 'float',
	        value: '' + float
	      });
	    },
	    onChange: function onChange(value) {
	      this.updateConfig(value);
	    }
	  }, (0, _vuex.mapActions)(['boxUpdateConfigStyle'])),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _ColorPicker = __webpack_require__(46);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ColorPicker: _ColorPicker2.default
	  },
	  methods: (0, _extends3.default)({
	    onColorChange: function onColorChange(color) {
	      this.boxUpdateConfigStyle({
	        item: 'trigger_button',
	        rule: 'backgroundColor',
	        value: color
	      });
	    },
	    onMove: function onMove(color) {
	      this.boxPreviewConfigStyleChange({
	        item: 'trigger_button',
	        rule: 'backgroundColor',
	        value: color
	      });
	    }
	  }, (0, _vuex.mapActions)(['boxUpdateConfigStyle', 'boxPreviewConfigStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Range = __webpack_require__(20);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Range: _Range2.default
	  },
	  methods: (0, _extends3.default)({
	    value: function value() {
	      return this.boxConfig.trigger_button.style.borderRadius.replace('px', '');
	    },
	    onChange: function onChange(value) {
	      this.boxUpdateConfigStyle({
	        item: 'trigger_button',
	        rule: 'borderRadius',
	        value: value + 'px'
	      });
	    },
	    onMove: function onMove(value) {
	      this.boxPreviewConfigStyleChange({
	        item: 'trigger_button',
	        rule: 'borderRadius',
	        value: value + 'px'
	      });
	    }
	  }, (0, _vuex.mapActions)(['boxUpdateConfigStyle', 'boxPreviewConfigStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Range = __webpack_require__(20);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = 18;
	
	exports.default = {
	  components: {
	    Range: _Range2.default
	  },
	  methods: (0, _extends3.default)({
	    value: function value() {
	      if (!this.boxConfig.trigger_button.style.fontSize) {
	        return defaultValue;
	      }
	
	      return this.boxConfig.trigger_button.style.fontSize.replace('px', '');
	    },
	    onChange: function onChange(value) {
	      this.boxUpdateConfigStyle({
	        item: 'trigger_button',
	        rule: 'fontSize',
	        value: value + 'px'
	      });
	    },
	    onMove: function onMove(value) {
	      this.boxPreviewConfigStyleChange({
	        item: 'trigger_button',
	        rule: 'fontSize',
	        value: value + 'px'
	      });
	    }
	  }, (0, _vuex.mapActions)(['boxUpdateConfigStyle', 'boxPreviewConfigStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['sidebarChangePanel', 'canvasChangeView'])
	};

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Range = __webpack_require__(20);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = 70;
	
	exports.default = {
	  components: {
	    Range: _Range2.default
	  },
	  methods: (0, _extends3.default)({
	    value: function value() {
	      if (!this.boxConfig.trigger_button.style.height) {
	        return defaultValue;
	      }
	
	      return this.boxConfig.trigger_button.style.height.replace('px', '');
	    },
	    onChange: function onChange(value) {
	      this.boxUpdateConfigStyle({
	        item: 'trigger_button',
	        rule: 'height',
	        value: value + 'px'
	      });
	    },
	    onMove: function onMove(value) {
	      this.boxPreviewConfigStyleChange({
	        item: 'trigger_button',
	        rule: 'height',
	        value: value + 'px'
	      });
	    }
	  }, (0, _vuex.mapActions)(['boxUpdateConfigStyle', 'boxPreviewConfigStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Header = __webpack_require__(691);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(698);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _BackgroundColor = __webpack_require__(688);
	
	var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);
	
	var _TextColor = __webpack_require__(694);
	
	var _TextColor2 = _interopRequireDefault(_TextColor);
	
	var _FontSize = __webpack_require__(690);
	
	var _FontSize2 = _interopRequireDefault(_FontSize);
	
	var _BorderRadius = __webpack_require__(689);
	
	var _BorderRadius2 = _interopRequireDefault(_BorderRadius);
	
	var _Width = __webpack_require__(695);
	
	var _Width2 = _interopRequireDefault(_Width);
	
	var _Height = __webpack_require__(692);
	
	var _Height2 = _interopRequireDefault(_Height);
	
	var _Align = __webpack_require__(687);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HeaderConfig: _Header2.default,
	    OptionsConfig: _Main2.default,
	    BackgroundColorConfig: _BackgroundColor2.default,
	    TextColorConfig: _TextColor2.default,
	    FontSizeConfig: _FontSize2.default,
	    BorderRadiusConfig: _BorderRadius2.default,
	    WidthConfig: _Width2.default,
	    HeightConfig: _Height2.default,
	    AlignConfig: _Align2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel',
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _ColorPicker = __webpack_require__(46);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ColorPicker: _ColorPicker2.default
	  },
	  methods: (0, _extends3.default)({
	    onColorChange: function onColorChange(color) {
	      this.boxUpdateConfigStyle({ item: 'trigger_button', rule: 'color', value: color });
	    },
	    onMove: function onMove(color) {
	      this.boxPreviewConfigStyleChange({ item: 'trigger_button', rule: 'color', value: color });
	    }
	  }, (0, _vuex.mapActions)(['boxUpdateConfigStyle', 'boxPreviewConfigStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Range = __webpack_require__(20);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Range: _Range2.default
	  },
	  methods: (0, _extends3.default)({
	    value: function value() {
	      return this.boxConfig.trigger_button.style.width.replace('px', '');
	    },
	    onChange: function onChange(value) {
	      this.boxUpdateConfigStyle({
	        item: 'trigger_button',
	        rule: 'width',
	        value: value + 'px'
	      });
	    },
	    onMove: function onMove(value) {
	      this.boxPreviewConfigStyleChange({
	        item: 'trigger_button',
	        rule: 'width',
	        value: value + 'px'
	      });
	    }
	  }, (0, _vuex.mapActions)(['boxUpdateConfigStyle', 'boxPreviewConfigStyleChange'])),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Basic = __webpack_require__(696);
	
	var _Basic2 = _interopRequireDefault(_Basic);
	
	var _Naked = __webpack_require__(699);
	
	var _Naked2 = _interopRequireDefault(_Naked);
	
	var _External = __webpack_require__(697);
	
	var _External2 = _interopRequireDefault(_External);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BasicOption: _Basic2.default,
	    NakedOption: _Naked2.default,
	    ExternalOption: _External2.default
	  }
	};

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig']),
	  computed: (0, _vuex.mapGetters)({
	    boxConfig: 'boxConfig'
	  })
	};

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Header = __webpack_require__(700);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Popup = __webpack_require__(705);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Fullscreen = __webpack_require__(703);
	
	var _Fullscreen2 = _interopRequireDefault(_Fullscreen);
	
	var _Component = __webpack_require__(702);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Slider = __webpack_require__(706);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _MiniSlide = __webpack_require__(704);
	
	var _MiniSlide2 = _interopRequireDefault(_MiniSlide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TypeHeader: _Header2.default,
	    TypePopup: _Popup2.default,
	    TypeFullscreen: _Fullscreen2.default,
	    TypeComponent: _Component2.default,
	    TypeSlider: _Slider2.default,
	    TypeMiniSlide: _MiniSlide2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel'
	  })
	};

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GeneralItem = __webpack_require__(45);
	
	var _GeneralItem2 = _interopRequireDefault(_GeneralItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    GeneralItem: _GeneralItem2.default
	  }
	};

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GeneralItem = __webpack_require__(45);
	
	var _GeneralItem2 = _interopRequireDefault(_GeneralItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    GeneralItem: _GeneralItem2.default
	  }
	};

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    format: String
	  },
	  methods: (0, _extends3.default)({
	    getImageUrl: function getImageUrl(format) {
	      var images = __webpack_require__(935);
	
	      return images('./' + format + '.svg');
	    }
	  }, (0, _vuex.mapActions)(['boxSetFormat', 'canvasDisableHighlight']))
	};

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GeneralItem = __webpack_require__(45);
	
	var _GeneralItem2 = _interopRequireDefault(_GeneralItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    GeneralItem: _GeneralItem2.default
	  }
	};

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GeneralItem = __webpack_require__(45);
	
	var _GeneralItem2 = _interopRequireDefault(_GeneralItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    GeneralItem: _GeneralItem2.default
	  }
	};

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GeneralItem = __webpack_require__(45);
	
	var _GeneralItem2 = _interopRequireDefault(_GeneralItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    GeneralItem: _GeneralItem2.default
	  }
	};

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig', 'sidebarChangePanel'])
	};

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['boxUpdateConfig', 'sidebarChangePanel'])
	};

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Header = __webpack_require__(709);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Automatic = __webpack_require__(707);
	
	var _Automatic2 = _interopRequireDefault(_Automatic);
	
	var _Click = __webpack_require__(708);
	
	var _Click2 = _interopRequireDefault(_Click);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TypeHeader: _Header2.default,
	    ViewmodeAutomatic: _Automatic2.default,
	    ViewmodeClick: _Click2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    sidebarCurrentPanel: 'sidebarCurrentPanel'
	  })
	};

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Name = __webpack_require__(712);
	
	var _Name2 = _interopRequireDefault(_Name);
	
	var _Export = __webpack_require__(713);
	
	var _Export2 = _interopRequireDefault(_Export);
	
	var _Publish = __webpack_require__(714);
	
	var _Publish2 = _interopRequireDefault(_Publish);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Name: _Name2.default,
	    Export: _Export2.default,
	    Publish: _Publish2.default
	  }
	};

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    name: 'boxName'
	  }),
	  methods: (0, _vuex.mapActions)(['boxSetName'])
	};

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['modalOpen', 'codeSetupBox']),
	  computed: (0, _vuex.mapGetters)({
	    boxActive: 'boxActive'
	  })
	};

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['boxSave'])
	};

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(550);
	
	var _jquery = __webpack_require__(33);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _tinycolor = __webpack_require__(557);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['id', 'label', 'change', 'move', 'value'],
	  data: function data() {
	    return {
	      config: {
	        preferredFormat: 'rgb',
	        color: this.value,
	        showPalette: true,
	        showAlpha: true,
	        togglePaletteMoreText: '+',
	        togglePaletteLessText: '',
	        containerClassName: 'kp-colorpicker',
	        replacerClassName: 'view-color',
	        palette: ['rgba(230,49,91,1)', 'rgba(121,49,131,1)', 'rgba(0,157,231,1)', 'rgba(0,181,156,1)', 'rgba(255,206,0,1)', 'rgba(255,74,33,1)', 'rgba(214,213,214,1)', 'rgba(255,255,255,1)', 'rgba(0,0,0,1)'],
	        localStorageKey: 'klick.edit.colors',
	        maxSelectionSize: 9,
	        chooseText: '',
	        cancelText: ''
	      }
	    };
	  },
	  updated: function updated() {
	    this.config.color = this.value;
	    this.getInput().spectrum('set', this.value);
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.bindEvents();
	    this.setup();
	    this.getInput().on('focus', function () {
	      return _this.open();
	    });
	  },
	
	  methods: {
	    open: function open() {
	      var _this2 = this;
	
	      this.setup();
	      setTimeout(function () {
	        return _this2.getInput().spectrum('show');
	      }, 75);
	    },
	    onChange: function onChange(color) {
	      this.change(this.getTinyColor(color));
	    },
	    onMove: function onMove(color) {
	      this.move(this.getTinyColor(color));
	    },
	    bindEvents: function bindEvents() {
	      this.config.change = this.onChange;
	      this.config.move = this.onMove;
	    },
	    setup: function setup() {
	      this.getInput().spectrum(this.config).show();
	    },
	    getTinyColor: function getTinyColor(color) {
	      if (!color.toRgbString) {
	        color = (0, _tinycolor2.default)(color);
	      }
	
	      return color.toRgbString();
	    },
	    getInput: function getInput() {
	      return (0, _jquery2.default)(document.getElementById(this.id));
	    }
	  }
	};

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _clipboard = __webpack_require__(520);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['text'],
	  mounted: function mounted() {
	    var _this = this;
	
	    var clipboard = new _clipboard2.default(this.$el);
	
	    clipboard.on('success', function () {
	      _this.$el.classList.add('active');
	
	      setTimeout(function () {
	        _this.$el.classList.remove('active');
	      }, 2000);
	    });
	  }
	};

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _date = __webpack_require__(178);
	
	var _date2 = _interopRequireDefault(_date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['date'],
	  computed: {
	    parsedDate: function parsedDate() {
	      return (0, _date2.default)(this.date);
	    }
	  }
	};

/***/ },
/* 438 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['error']
	};

/***/ },
/* 439 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['label', 'min', 'max', 'step', 'value', 'move', 'change'],
	  mounted: function mounted() {
	    var _this = this;
	
	    var input = this.$el.querySelector('input');
	
	    input.addEventListener('input', function (event) {
	      _this.move(event.target.value);
	    });
	
	    input.addEventListener('change', function (event) {
	      _this.change(event.target.value);
	    });
	  }
	};

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _jquery = __webpack_require__(33);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['jump', 'selected'],
	  mounted: function mounted() {
	    var _this = this;
	
	    var templateResult = function templateResult(step) {
	      var className = step.alreadyUsed ? 'step-already-used' : '';
	
	      return (0, _jquery2.default)('<span class="' + className + '">' + step.text + '</span>');
	    };
	
	    (0, _jquery2.default)(this.$el).val(this.selected).select2({
	      data: this.stepJumpSelectOptions,
	      templateResult: templateResult
	    }).on('change', function (event) {
	      _this.$store.dispatch('jumpUpdateDestinationStepId', { jump: _this.jump, event: event });
	    });
	  },
	
	  computed: (0, _vuex.mapGetters)({
	    jumpList: 'jumpList',
	    stepInactiveList: 'stepInactiveList',
	    stepDisplayPosition: 'stepDisplayPosition',
	    stepJumpSelectOptions: 'stepJumpSelectOptions'
	  }),
	  methods: (0, _vuex.mapActions)(['jumpUpdateDestinationStepId'])
	};

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(718);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _textEditor = __webpack_require__(220);
	
	var editor = _interopRequireWildcard(_textEditor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Toolbar: _Main2.default
	  },
	  props: {
	    placeholder: String,
	    content: String,
	    toolbar: Boolean,
	    change: Function
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.editorContainer = this.$el.querySelector('.kbx-text-editor');
	
	    this.editor = editor.create({
	      placeholder: this.placeholder,
	      container: this.$el,
	      toolbar: this.toolbar,
	      content: this.content,
	      onChange: function onChange(text) {
	        _this.change(text);
	      }
	    });
	  },
	
	  watch: {
	    content: function content(value) {
	      var _this2 = this;
	
	      var range = this.editor.getSelection();
	      var editor = this.editorContainer.querySelector('.ql-editor');
	
	      editor.innerHTML = value;
	
	      setTimeout(function () {
	        _this2.editor.setSelection(range);
	      }, 1);
	
	      return true;
	    }
	  }
	};

/***/ },
/* 442 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    type: String
	  }
	};

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(219);
	
	exports.default = {
	  props: {
	    type: String
	  },
	  data: function data() {
	    return {
	      pallete: _config.colors
	    };
	  }
	};

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(716);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Color = __webpack_require__(717);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    EditorButton: _Button2.default,
	    EditorColor: _Color2.default
	  }
	};

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['boxAdd']),
	  computed: (0, _vuex.mapGetters)({
	    topBarConfig: 'topBar/config'
	  })
	};

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    topBarConfig: 'topBar/config'
	  }),
	  methods: (0, _vuex.mapActions)(['boxAdd'])
	};

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _ListHeader = __webpack_require__(721);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _Main = __webpack_require__(727);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Empty = __webpack_require__(719);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ListHeader: _ListHeader2.default,
	    Item: _Main2.default,
	    Empty: _Empty2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    boxes: 'boxList'
	  }),
	  created: function created() {
	    this.$store.dispatch('boxGetAll');
	  }
	};

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  props: ['box'],
	  methods: (0, _vuex.mapActions)(['modalOpen', 'boxSetActive'])
	};

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      i18n: _i18n2.default
	    };
	  },
	
	  props: ['box']
	};

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['modalOpen', 'codeSetupBox']),
	  props: ['box']
	};

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      i18n: _i18n2.default
	    };
	  },
	
	  props: ['box']
	};

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _ButtonDelete = __webpack_require__(723);
	
	var _ButtonDelete2 = _interopRequireDefault(_ButtonDelete);
	
	var _ButtonEdit = __webpack_require__(724);
	
	var _ButtonEdit2 = _interopRequireDefault(_ButtonEdit);
	
	var _ButtonReport = __webpack_require__(726);
	
	var _ButtonReport2 = _interopRequireDefault(_ButtonReport);
	
	var _ButtonExport = __webpack_require__(725);
	
	var _ButtonExport2 = _interopRequireDefault(_ButtonExport);
	
	var _Date = __webpack_require__(152);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'button-delete': _ButtonDelete2.default,
	    'button-edit': _ButtonEdit2.default,
	    'button-report': _ButtonReport2.default,
	    'button-export': _ButtonExport2.default,
	    LocaleDate: _Date2.default
	  },
	  props: ['box', 'index'],
	  methods: (0, _vuex.mapActions)(['boxesSetName'])
	};

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _General = __webpack_require__(24);
	
	var _General2 = _interopRequireDefault(_General);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LayoutGeneral: _General2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    reportExportLimit: 'reportExportLimit',
	    modalVisible: 'modalVisible'
	  }),
	  methods: (0, _vuex.mapActions)(['modalClose'])
	};

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _General = __webpack_require__(24);
	
	var _General2 = _interopRequireDefault(_General);
	
	var _CopyButton = __webpack_require__(715);
	
	var _CopyButton2 = _interopRequireDefault(_CopyButton);
	
	var _autosize = __webpack_require__(158);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LayoutGeneral: _General2.default,
	    CopyButton: _CopyButton2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    modalVisible: 'modalVisible',
	    box: 'codeBox',
	    codeScript: 'codeScript',
	    codeButtonAttribute: 'codeButtonAttribute'
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['modalClose']), {
	    showButtonAttribute: function showButtonAttribute() {
	      return this.box.kind !== 'component' && this.box.config.trigger_button.kind === 'external';
	    }
	  }),
	  mounted: function mounted() {
	    if (this.$el && this.$el.querySelectorAll) {
	      (0, _autosize2.default)(this.$el.querySelectorAll('textarea'));
	    }
	  },
	  updated: function updated() {
	    if (this.$el && this.$el.querySelectorAll) {
	      (0, _autosize2.default)(this.$el.querySelectorAll('textarea'));
	    }
	  }
	};

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _General = __webpack_require__(24);
	
	var _General2 = _interopRequireDefault(_General);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LayoutGeneral: _General2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    modalVisible: 'modalVisible'
	  }),
	  methods: (0, _vuex.mapActions)(['boxesDelete', 'modalClose'])
	};

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _General = __webpack_require__(24);
	
	var _General2 = _interopRequireDefault(_General);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LayoutGeneral: _General2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    modalVisible: 'modalVisible'
	  }),
	  methods: (0, _vuex.mapActions)(['stepRemove', 'modalClose'])
	};

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _General = __webpack_require__(24);
	
	var _General2 = _interopRequireDefault(_General);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      number: 1
	    };
	  },
	
	  components: {
	    LayoutGeneral: _General2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    modalVisible: 'modalVisible'
	  }),
	  methods: (0, _vuex.mapActions)(['stepDuplicate', 'modalClose'])
	};

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _General = __webpack_require__(24);
	
	var _General2 = _interopRequireDefault(_General);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      email: ''
	    };
	  },
	
	  components: {
	    LayoutGeneral: _General2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    modalVisible: 'modalVisible'
	  }),
	  methods: (0, _vuex.mapActions)(['reportExport', 'modalClose'])
	};

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _General = __webpack_require__(24);
	
	var _General2 = _interopRequireDefault(_General);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['email'],
	  components: {
	    LayoutGeneral: _General2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    modalVisible: 'modalVisible'
	  }),
	  methods: (0, _vuex.mapActions)(['modalClose'])
	};

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(10);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      i18n: _i18n2.default
	    };
	  },
	
	  props: ['box']
	};

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['modalOpen', 'codeSetupBox']),
	  props: ['box']
	};

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _vuejsDatepicker = __webpack_require__(932);
	
	var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Datepicker: _vuejsDatepicker2.default
	  },
	  data: function data() {
	    return {
	      format: 'dd/MM/yyyy'
	    };
	  },
	
	  methods: (0, _extends3.default)({
	    selectedDateFrom: function selectedDateFrom(value) {
	      this.$store.dispatch('reportSetPage', null);
	      this.$store.dispatch('reportSetDateFrom', value.toLocaleDateString('pt-br') + ' 00:00:00');
	      this.$store.dispatch('reportSetAnswers');
	    },
	    selectedDateTo: function selectedDateTo(value) {
	      this.$store.dispatch('reportSetPage', null);
	      this.$store.dispatch('reportSetDateTo', value.toLocaleDateString('pt-br') + ' 23:59:59');
	      this.$store.dispatch('reportSetAnswers');
	    }
	  }, (0, _vuex.mapActions)(['reportSetPageId', 'reportSetDateFrom', 'reportSetDateTo', 'reportSetAnswers']))
	};

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    list: 'reportList',
	    reportExportLimit: 'reportExportLimit'
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['modalOpen']), {
	    checkModal: function checkModal() {
	      var numberOfSubmissions = this.list.quantity_of_submissions;
	      var targetModal = 'export-table';
	
	      if (numberOfSubmissions > this.reportExportLimit) {
	        targetModal = 'cant-export';
	      }
	
	      this.modalOpen(targetModal);
	    }
	  })
	};

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _PaginationButtons = __webpack_require__(740);
	
	var _PaginationButtons2 = _interopRequireDefault(_PaginationButtons);
	
	var _Date = __webpack_require__(152);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PaginationButtons: _PaginationButtons2.default,
	    LocaleDate: _Date2.default
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      debounce: null
	    };
	  },
	
	  methods: {
	    parseResponses: function parseResponses(answers) {
	      if (!answers || !answers.length) {
	        return '-';
	      }
	
	      if (answers.length === 1) {
	        return answers[0].label;
	      }
	
	      var answerList = answers.map(function (answer) {
	        return '<li>' + answer.label + '</li>';
	      }).join('');
	
	      return '<ul>' + answerList + '</ul>';
	    }
	  },
	  computed: (0, _vuex.mapGetters)({
	    list: 'reportList',
	    page: 'reportPage',
	    groupedAnswers: 'groupedAnswers'
	  })
	};

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _DateFilter = __webpack_require__(736);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _ExportButton = __webpack_require__(737);
	
	var _ExportButton2 = _interopRequireDefault(_ExportButton);
	
	var _List = __webpack_require__(738);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ExportTable = __webpack_require__(732);
	
	var _ExportTable2 = _interopRequireDefault(_ExportTable);
	
	var _CantExportTable = __webpack_require__(728);
	
	var _CantExportTable2 = _interopRequireDefault(_CantExportTable);
	
	var _ExportTableInProgress = __webpack_require__(733);
	
	var _ExportTableInProgress2 = _interopRequireDefault(_ExportTableInProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    var _this = this;
	
	    this.$store.dispatch('boxGet').then(function () {
	      _this.$store.dispatch('reportSetAnswers');
	    });
	  },
	
	  components: {
	    DateFilter: _DateFilter2.default,
	    ExportButton: _ExportButton2.default,
	    List: _List2.default,
	    ModalExportTable: _ExportTable2.default,
	    ModalCantExportTable: _CantExportTable2.default,
	    ModalExportInProgress: _ExportTableInProgress2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    reportExportEmail: 'reportExportEmail',
	    list: 'reportList'
	  })
	};

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
	  methods: (0, _vuex.mapActions)(['reportNextPage', 'reportPreviousPage']),
	  computed: (0, _vuex.mapGetters)({
	    list: 'reportList',
	    page: 'reportPage'
	  })
	};

/***/ },
/* 467 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Device',
	  props: {
	    metric: Object,
	    banner: String,
	    title: String
	  }
	};

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _Device = __webpack_require__(741);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.dispatch('metricsRequestData');
	  },
	
	  components: {
	    Device: _Device2.default
	  },
	  computed: (0, _vuex.mapGetters)({
	    metrics: 'metricsData',
	    devicesMetrics: 'devicesMetrics'
	  })
	};

/***/ },
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 538 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxMyAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjQxNzQgMTAuODYxMUMxMi40ODM2IDkuMzM3ODkgMTEuOTUzOCA2LjgyMTMxIDEwLjYyOTMgNC44MDE0QzEwLjU5NjIgNC43MzUxNiAxMC41MyA0Ljc2ODI5IDEwLjU2MzEgNC44MzQ1QzEwLjY2MjQgNS4xMzI1MyAxMC42NjI0IDUuNjk1NDMgMTAuMTY1NyA1LjY2MjMzQzkuMjcxNjYgNS41OTYxIDEwLjE2NTcgMy43NDE3OSA4LjI0NTE1IDIuNDUwMzdDOC4yMTIwNSAyLjQxNzI1IDguMTQ1ODIgMi40NTAzNiA4LjE3ODkyIDIuNTE2NTlDOC4zMTEzOCAyLjc4MTUgOC40MTA3MiAzLjU0MzA5IDguMDc5NTggMy44MDc5OUM3Ljg0Nzc4IDQuMDM5NzkgNy4zODQyMSAzLjk3MzU2IDYuOTUzNzQgMy4yNzgxOUM2LjIyNTI3IDIuMTE5MjQgNi40OTAxNyAwLjg2MDkzOSA2Ljk1Mzc0IDAuMDY2MjI1MUM2Ljk4Njg0IC0xLjAxMzc2ZS0wNiA2Ljk1Mzc0IDAgNi44ODc1MSAwQzQuMjM4NDkgMC44OTQwNTIgMy43NDE3OSA0LjAzOTc5IDMuMTc4ODYgNS4xNjU2M0MzLjA3OTUyIDUuMzY0MzMgMy4wMTMyOSA1LjQ2MzY3IDIuODQ3NzMgNS40NjM2N0MyLjM1MTAzIDUuNDMwNTMgMi43MTUyOCA0LjQwNDAzIDIuODgwODQgNC4wMzk3OUMyLjkxMzk1IDMuOTczNTYgMi44NDc3MiAzLjk3MzU2IDIuODE0NjEgNC4wMDY2OUMxLjQ1Njk4IDUuNDMwNTMgMC4yMzE3OTMgNy44ODA5MSAwLjAzMzExNTIgMTAuMTMyNkMwLjAzMzExNTIgMTAuMDY2NCAwLjA2NjIzMDMgMTAuMDMzMyAwLjA2NjIzMDMgOS45NjcwM0MwLjAzMzExNzEgMTAuMTMyNiAwLjAzMzExMzIgMTAuMjk4MiAwIDEwLjQ5NjhDMCAxMC41NjMxIDAgMTAuNjI5MyAwIDEwLjY5NTVDMCAxMC43NjE3IDAgMTAuODYxMSAwIDEwLjk2MDRDMCAxNC4zNzExIDIuNzgxNSAxNy4xNTI2IDYuMTkyMTQgMTcuMTUyNkM5LjYwMjc5IDE3LjE1MjYgMTIuMzg0MyAxNC4zNzExIDEyLjM4NDMgMTAuOTYwNEMxMi40MTc0IDEwLjg5NDIgMTIuNDE3NCAxMC44NjExIDEyLjQxNzQgMTAuODYxMVpNNi4yMjUyNyAxMy43NzVDNC42MzU4MyAxMy43NzUgMy4zNDQ0MiAxMi40ODM2IDMuMzQ0NDIgMTAuODk0MkMzLjM0NDQyIDkuMzA0NzYgNC42MzU4MyA4LjAxMzM1IDYuMjI1MjcgOC4wMTMzNUM3LjgxNDY4IDguMDEzMzUgOS4xMDYwOSA5LjMwNDc2IDkuMTA2MDkgMTAuODk0MkM5LjEwNjA5IDEyLjQ4MzYgNy44MTQ2OCAxMy43NzUgNi4yMjUyNyAxMy43NzVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ },
/* 559 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 560 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/box-frequency.9fc914c.svg";

/***/ },
/* 562 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 563 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyNzYuNjY3IDIwMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjc2LjY2NyAyMDIiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHJlY3QgeD0iLTExMiIgeT0iLTE0OSIgZGlzcGxheT0ibm9uZSIgZmlsbD0iI0YwRjVGNyIgd2lkdGg9IjUwMCIgaGVpZ2h0PSI1MDAiLz4NCjxnPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIHN0cm9rZT0iIzg3QUFFMiIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0yNjQuNTcxLDE4NC4xOTENCgkJYzAsMy4xODQtMi41ODEsNS43NjYtNS43NjYsNS43NjZIMTcuMTk1Yy0zLjE4NCwwLTUuNzY2LTIuNTgxLTUuNzY2LTUuNzY2VjE3LjgwOWMwLTMuMTg0LDIuNTgxLTUuNzY2LDUuNzY2LTUuNzY2aDI0MS42MQ0KCQljMy4xODQsMCw1Ljc2NiwyLjU4MSw1Ljc2Niw1Ljc2NkwyNjQuNTcxLDE4NC4xOTFMMjY0LjU3MSwxODQuMTkxeiIvPg0KCTxnPg0KCQk8cmVjdCB4PSIyMy4wODMiIHk9IjI1Ljc5NyIgZmlsbD0iI0YyRjJGMiIgd2lkdGg9IjIzMC41IiBoZWlnaHQ9IjIwLjA5MyIvPg0KCTwvZz4NCgk8Zz4NCgkJPHJlY3QgeD0iMjMuMDgzIiB5PSIxNjAuNjQiIGZpbGw9IiNGMkYyRjIiIHdpZHRoPSIyMzAuNSIgaGVpZ2h0PSIxOC4yMzciLz4NCgk8L2c+DQoJPHBhdGggZmlsbD0iIzg3QUFFMiIgZD0iTTI2NC41NzEsMTcuODA5Yy0zOS41MzYsMC0yMjguNDMxLDAtMjUzLjE0MSwwbDAsMGMwLTMuMTg0LDIuNTgxLTUuNzY2LDUuNzY2LTUuNzY2aDI0MS42MQ0KCQlDMjYxLjk4OSwxMi4wNDQsMjY0LjU3MSwxNC42MjUsMjY0LjU3MSwxNy44MDlMMjY0LjU3MSwxNy44MDl6Ii8+DQoJPHBhdGggZmlsbD0iI0FCQzlGNCIgZD0iTTE3Ni4zNywxMzIuOTJIMTAwLjNjLTEuMzYsMC0yLjQ3LDEuMTEtMi40NywyLjQ3djExLjIyYzAsMS4zNywxLjExLDIuNDcsMi40NywyLjQ3aDc2LjA3DQoJCWMxLjM2LDAsMi40Ny0xLjEsMi40Ny0yLjQ3di0xMS4yMkMxNzguODQsMTM0LjAyLDE3Ny43MywxMzIuOTIsMTc2LjM3LDEzMi45MnoiLz4NCgk8Zz4NCgkJPHBhdGggZmlsbD0iI0FCQzlGNCIgZD0iTTE0Mi4xNzEsNzguNzg0YzAsMS40NDEsMS4xNjgsMi42MDgsMi42MDgsMi42MDhoNTcuNjU3YzEuNDQxLDAsMi42MDgtMS4xNjgsMi42MDgtMi42MDhsMCwwDQoJCQljMC0xLjQ0MS0xLjE2OC0yLjYwOC0yLjYwOC0yLjYwOGgtNTcuNjU3QzE0My4zMzksNzYuMTc1LDE0Mi4xNzEsNzcuMzQzLDE0Mi4xNzEsNzguNzg0TDE0Mi4xNzEsNzguNzg0eiIvPg0KCQk8cGF0aCBmaWxsPSIjQUJDOUY0IiBkPSJNOTguNTE3LDc4Ljc4NGMwLDEuNDQxLDEuMTY4LDIuNjA4LDIuNjA4LDIuNjA4aDMxLjAyNWMxLjQ0MSwwLDIuNjA4LTEuMTY4LDIuNjA4LTIuNjA4bDAsMA0KCQkJYzAtMS40NDEtMS4xNjgtMi42MDgtMi42MDgtMi42MDhoLTMxLjAyNUM5OS42ODQsNzYuMTc1LDk4LjUxNyw3Ny4zNDMsOTguNTE3LDc4Ljc4NEw5OC41MTcsNzguNzg0eiIvPg0KCQk8cGF0aCBmaWxsPSIjODdBQUUyIiBkPSJNMTE1LjM4OCwxMTYuNTFjMCwxLjQ0MSwxLjE2OCwyLjYwOCwyLjYwOCwyLjYwOGgzMS4wMjVjMS40NDEsMCwyLjYwOC0xLjE2OCwyLjYwOC0yLjYwOGwwLDANCgkJCWMwLTEuNDQxLTEuMTY4LTIuNjA4LTIuNjA4LTIuNjA4aC0zMS4wMjVDMTE2LjU1NSwxMTMuOTAxLDExNS4zODgsMTE1LjA2OSwxMTUuMzg4LDExNi41MUwxMTUuMzg4LDExNi41MXoiLz4NCgkJPHBhdGggZmlsbD0iI0FCQzlGNCIgZD0iTTUwLjU2Miw2Mi40M2MwLDEuNDQxLDEuMTY4LDIuNjA4LDIuNjA4LDIuNjA4aDE3MC4zMjZjMS40NDEsMCwyLjYwOC0xLjE2OCwyLjYwOC0yLjYwOGwwLDANCgkJCWMwLTEuNDQxLTEuMTY4LTIuNjA4LTIuNjA4LTIuNjA4SDUzLjE3MUM1MS43Myw1OS44MjIsNTAuNTYyLDYwLjk5LDUwLjU2Miw2Mi40M0w1MC41NjIsNjIuNDN6Ii8+DQoJCTxwYXRoIGZpbGw9IiNBQkM5RjQiIGQ9Ik03Mi41MDIsNzguNzg0YzAsMS40NDEsMS4xNjgsMi42MDgsMi42MDgsMi42MDhoMTQuMjA4YzEuNDQxLDAsMi42MDgtMS4xNjgsMi42MDgtMi42MDhsMCwwDQoJCQljMC0xLjQ0MS0xLjE2OC0yLjYwOC0yLjYwOC0yLjYwOEg3NS4xMTFDNzMuNjcsNzYuMTc1LDcyLjUwMiw3Ny4zNDMsNzIuNTAyLDc4Ljc4NEw3Mi41MDIsNzguNzg0eiIvPg0KCQk8cGF0aCBmaWxsPSIjODdBQUUyIiBkPSJNNzIuNTAyLDExNi41MWMwLDEuNDQxLDEuMTY4LDIuNjA4LDIuNjA4LDIuNjA4aDMwLjk0OGMxLjQ0MSwwLDIuNjA4LTEuMTY4LDIuNjA4LTIuNjA4bDAsMA0KCQkJYzAtMS40NDEtMS4xNjgtMi42MDgtMi42MDgtMi42MDhINzUuMTExQzczLjY3LDExMy45MDEsNzIuNTAyLDExNS4wNjksNzIuNTAyLDExNi41MUw3Mi41MDIsMTE2LjUxeiIvPg0KCQk8cGF0aCBmaWxsPSIjQUJDOUY0IiBkPSJNMTM1LjM3NSw5Ny4yNmMwLTEuNDQxLTEuMTY4LTIuNjA5LTIuNjA4LTIuNjA4SDc1LjExYy0xLjQ0LDAtMi42MDgsMS4xNjctMi42MDgsMi42MDhsMCwwDQoJCQljMCwxLjQ0LDEuMTY3LDIuNjA4LDIuNjA4LDIuNjA4aDU3LjY1N0MxMzQuMjA3LDk5Ljg2OCwxMzUuMzc1LDk4LjcwMSwxMzUuMzc1LDk3LjI2TDEzNS4zNzUsOTcuMjZ6Ii8+DQoJCTxwYXRoIGZpbGw9IiNBQkM5RjQiIGQ9Ik0xNzkuMDI5LDk3LjI2YzAtMS40NDEtMS4xNjctMi42MDktMi42MDgtMi42MDhoLTMxLjAyNWMtMS40NCwwLTIuNjA4LDEuMTY3LTIuNjA4LDIuNjA4bDAsMA0KCQkJYzAsMS40NCwxLjE2NywyLjYwOCwyLjYwOCwyLjYwOGgzMS4wMjVDMTc3Ljg2MSw5OS44NjgsMTc5LjAyOSw5OC43MDEsMTc5LjAyOSw5Ny4yNkwxNzkuMDI5LDk3LjI2eiIvPg0KCTwvZz4NCjwvZz4NCjxnIGRpc3BsYXk9Im5vbmUiPg0KCQ0KCQk8Y2lyY2xlIGRpc3BsYXk9ImlubGluZSIgZmlsbD0iI0FCQzlGNCIgc3Ryb2tlPSIjQUJDOUY0IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgY3g9IjUxLjU3OSIgY3k9IjU2LjM3IiByPSIxNC40MjEiLz4NCgkNCgkJPGNpcmNsZSBkaXNwbGF5PSJpbmxpbmUiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0FCQzlGNCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGN4PSIxMDkuMTkzIiBjeT0iNTYuMzciIHI9IjE0LjQyMSIvPg0KCQ0KCQk8Y2lyY2xlIGRpc3BsYXk9ImlubGluZSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQUJDOUY0IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgY3g9IjE2Ni44MDciIGN5PSI1Ni4zNyIgcj0iMTQuNDIxIi8+DQoJDQoJCTxjaXJjbGUgZGlzcGxheT0iaW5saW5lIiBmaWxsPSJub25lIiBzdHJva2U9IiNBQkM5RjQiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBjeD0iMjI0LjQyMSIgY3k9IjU2LjM3IiByPSIxNC40MjEiLz4NCjwvZz4NCjxnPg0KCTxwYXRoIGZpbGw9IiM4N0FBRTIiIGQ9Ik01Ni4wMDYsMTIwLjUyN2MtMC4yOCwwLTAuNTQzLTAuMTE1LTAuNzQxLTAuMzI0TDUyLDExNi43NTdjLTAuNDA5LTAuNDMxLTAuNDA5LTEuMTMzLDAtMS41NjQNCgkJYzAuMTk4LTAuMjA5LDAuNDYxLTAuMzI0LDAuNzQxLTAuMzI0YzAuMjgxLDAsMC41NDQsMC4xMTUsMC43NDIsMC4zMjVsMi40MjksMi41NzJjMC4wMzIsMC4wMzQsMC4wNjksMC4wNDEsMC4wOTQsMC4wNDENCgkJYzAuMDI1LDAsMC4wNjItMC4wMDcsMC4wOTQtMC4wNDFsNS42OTQtNi4wMThjMC4xOTgtMC4yMDksMC40NjEtMC4zMjUsMC43NDEtMC4zMjVjMC4yNzgsMCwwLjU0LDAuMTE0LDAuNzM3LDAuMzJsMC4wMDQsMC4wMDQNCgkJYzAuNDA4LDAuNDMxLDAuNDA4LDEuMTMzLDAsMS41NjRsLTYuNTMsNi44OTFDNTYuNTQ5LDEyMC40MTIsNTYuMjg2LDEyMC41MjcsNTYuMDA2LDEyMC41Mjd6Ii8+DQo8L2c+DQo8Y2lyY2xlIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0FCQzlGNCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGN4PSI1Ni45NTgiIGN5PSI5Ny4yNiIgcj0iNC4zMTEiLz4NCjxjaXJjbGUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQUJDOUY0IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgY3g9IjU2Ljk1OCIgY3k9Ijc4Ljc4NCIgcj0iNC4zMTEiLz4NCjwvc3ZnPg0K"

/***/ },
/* 564 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 565 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyNTguMTQxIDE4Mi45MTMiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI1OC4xNDEgMTgyLjkxMyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiM4N0FBRTIiIHN0cm9rZS13aWR0aD0iNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjU1LjY0MSwxNzQuNjQ3DQoJYzAsMy4xODQtMi41ODEsNS43NjYtNS43NjYsNS43NjZIOC4yNjZjLTMuMTg0LDAtNS43NjYtMi41ODEtNS43NjYtNS43NjZWOC4yNjZDMi41LDUuMDgxLDUuMDgxLDIuNSw4LjI2NiwyLjVoMjQxLjYxDQoJYzMuMTg0LDAsNS43NjYsMi41ODEsNS43NjYsNS43NjZWMTc0LjY0N3oiLz4NCjxyZWN0IHg9IjE0LjA3MSIgeT0iMTcuMTQ1IiBmaWxsPSIjRjJGMkYyIiB3aWR0aD0iMjMwLjUiIGhlaWdodD0iNDguNSIvPg0KPHJlY3QgeD0iMTgyLjY1NiIgeT0iNzMuMTU2IiBmaWxsPSIjRjJGMkYyIiB3aWR0aD0iNjAuMjU5IiBoZWlnaHQ9Ijk0LjM5NSIvPg0KPHJlY3QgeD0iMTE2LjQ4NCIgeT0iNzMuMTU2IiBmaWxsPSIjRjJGMkYyIiB3aWR0aD0iNjAuMjU5IiBoZWlnaHQ9Ijk0LjM5NSIvPg0KPHJlY3QgeD0iMTQuMDcxIiB5PSI3My4xNTYiIGZpbGw9IiNGMkYyRjIiIHdpZHRoPSI5Ni41IiBoZWlnaHQ9IjI2LjkxNCIvPg0KPHJlY3QgeD0iMTQuMDcxIiB5PSIxMDYuODk3IiBmaWxsPSIjRjJGMkYyIiB3aWR0aD0iOTYuNSIgaGVpZ2h0PSIyNi45MTQiLz4NCjxyZWN0IHg9IjE0LjA3MSIgeT0iMTQwLjYzNyIgZmlsbD0iI0YyRjJGMiIgd2lkdGg9Ijk2LjUiIGhlaWdodD0iMjYuOTE0Ii8+DQo8cGF0aCBmaWxsPSIjODdBQUUyIiBkPSJNMjU1LjY0MSw4LjI2NmMtMzkuNTM2LDAtMjI4LjQzMSwwLTI1My4xNDEsMGwwLDBDMi41LDUuMDgxLDUuMDgxLDIuNSw4LjI2NiwyLjVoMjQxLjYxDQoJQzI1My4wNiwyLjUsMjU1LjY0MSw1LjA4MSwyNTUuNjQxLDguMjY2TDI1NS42NDEsOC4yNjZ6Ii8+DQo8Zz4NCgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiM4N0FBRTIiIHN0cm9rZS13aWR0aD0iMy4yNDUxIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0yMzQuMzE0LDE3Ni45MzgNCgkJYzAsMS40NzEtMS4xOTMsMi42NjQtMi42NjQsMi42NjRoLTc4LjJjLTEuNDcxLDAtMi42NjQtMS4xOTMtMi42NjQtMi42NjR2LTc2Ljg2OGMwLTEuNDcxLDEuMTkzLTIuNjY0LDIuNjY0LTIuNjY0aDc4LjINCgkJYzEuNDcxLDAsMi42NjQsMS4xOTMsMi42NjQsMi42NjRWMTc2LjkzOHoiLz4NCgk8cGF0aCBmaWxsPSIjODdBQUUyIiBkPSJNMjM0LjMxNCwxMDAuMDY5Yy0xOC4yNjYsMC03Mi4xMTIsMC04My41MjgsMGwwLDBjMC0xLjQ3MSwxLjE5My0yLjY2NCwyLjY2NC0yLjY2NGg3OC4yDQoJCUMyMzMuMTIxLDk3LjQwNiwyMzQuMzE0LDk4LjU5OCwyMzQuMzE0LDEwMC4wNjlMMjM0LjMxNCwxMDAuMDY5eiIvPg0KCTxnPg0KCQk8cGF0aCBmaWxsPSIjODdBQUUyIiBkPSJNMjI1Ljc0OCwxNDAuNDA2YzAuMjEsMCwwLjM4LDAuMTcxLDAuMzgsMC4zODF2OC4xODJjMCwwLjIxLTAuMTcxLDAuMzgxLTAuMzgsMC4zODFoLTY3LjAwMw0KCQkJYy0wLjIxLDAtMC4zOC0wLjE3MS0wLjM4LTAuMzgxdi04LjE4MmMwLTAuMjEsMC4xNzEtMC4zODEsMC4zOC0wLjM4MUgyMjUuNzQ4IE0yMjUuNzQ4LDEzOS42NDVoLTY3LjAwMw0KCQkJYy0wLjYzLDAtMS4xNDIsMC41MTEtMS4xNDIsMS4xNDJ2OC4xODJjMCwwLjYzLDAuNTExLDEuMTQyLDEuMTQyLDEuMTQyaDY3LjAwM2MwLjYzLDAsMS4xNDItMC41MTEsMS4xNDItMS4xNDJ2LTguMTgyDQoJCQlDMjI2Ljg4OSwxNDAuMTU2LDIyNi4zNzgsMTM5LjY0NSwyMjUuNzQ4LDEzOS42NDVMMjI1Ljc0OCwxMzkuNjQ1eiIvPg0KCTwvZz4NCgk8cGF0aCBmaWxsPSIjODdBQUUyIiBkPSJNMjI2Ljg4OSwxNjYuNDFjMCwwLjYzLTAuNTExLDEuMTQyLTEuMTQyLDEuMTQyaC02Ny4wMDNjLTAuNjMsMC0xLjE0Mi0wLjUxMS0xLjE0Mi0xLjE0MnYtMTIuMzA0DQoJCWMwLTAuNjMsMC41MTEtMS4xNDIsMS4xNDItMS4xNDJoNjcuMDAzYzAuNjMsMCwxLjE0MiwwLjUxMSwxLjE0MiwxLjE0MlYxNjYuNDF6Ii8+DQoJPHBhdGggZmlsbD0iI0FCQzlGNCIgZD0iTTIxOC40NTgsMTExLjIzMmMwLDEuNzUxLTEuNDIsMy4xNzEtMy4xNzEsMy4xNzFoLTQxLjA5OGMtMS43NTEsMC0zLjE3MS0xLjQyLTMuMTcxLTMuMTcxbDAsMA0KCQljMC0xLjc1MSwxLjQyLTMuMTcxLDMuMTcxLTMuMTcxaDQxLjA5OEMyMTcuMDM5LDEwOC4wNjEsMjE4LjQ1OCwxMDkuNDgsMjE4LjQ1OCwxMTEuMjMyTDIxOC40NTgsMTExLjIzMnoiLz4NCgk8cGF0aCBmaWxsPSIjQUJDOUY0IiBkPSJNMTgwLjEwMywxMjEuMTg5YzAsMC42NjYtMC41NCwxLjIwNS0xLjIwNSwxLjIwNWgtMTQuMzM0Yy0wLjY2NiwwLTEuMjA1LTAuNTQtMS4yMDUtMS4yMDVsMCwwDQoJCWMwLTAuNjY2LDAuNTQtMS4yMDUsMS4yMDUtMS4yMDVoMTQuMzM0QzE3OS41NjQsMTE5Ljk4NCwxODAuMTAzLDEyMC41MjQsMTgwLjEwMywxMjEuMTg5TDE4MC4xMDMsMTIxLjE4OXoiLz4NCgk8cGF0aCBmaWxsPSIjQUJDOUY0IiBkPSJNMjExLjgxNSwxMjEuMTg5YzAsMC42NjYtMC41NCwxLjIwNS0xLjIwNSwxLjIwNWgtMTQuMzM0Yy0wLjY2NiwwLTEuMjA1LTAuNTQtMS4yMDUtMS4yMDVsMCwwDQoJCWMwLTAuNjY2LDAuNTQtMS4yMDUsMS4yMDUtMS4yMDVoMTQuMzM0QzIxMS4yNzUsMTE5Ljk4NCwyMTEuODE1LDEyMC41MjQsMjExLjgxNSwxMjEuMTg5TDIxMS44MTUsMTIxLjE4OXoiLz4NCgk8cGF0aCBmaWxsPSIjQUJDOUY0IiBkPSJNMTkyLjEyMiwxMjEuMTg5YzAsMC42NjYtMC41NCwxLjIwNS0xLjIwNSwxLjIwNWgtNi41NjRjLTAuNjY2LDAtMS4yMDUtMC41NC0xLjIwNS0xLjIwNWwwLDANCgkJYzAtMC42NjYsMC41NC0xLjIwNSwxLjIwNS0xLjIwNWg2LjU2NEMxOTEuNTgzLDExOS45ODQsMTkyLjEyMiwxMjAuNTI0LDE5Mi4xMjIsMTIxLjE4OUwxOTIuMTIyLDEyMS4xODl6Ii8+DQoJPHBhdGggZmlsbD0iI0FCQzlGNCIgZD0iTTIyMS40NTUsMTIxLjE4OWMwLDAuNjY2LTAuNTQsMS4yMDUtMS4yMDUsMS4yMDVoLTQuNjNjLTAuNjY2LDAtMS4yMDUtMC41NC0xLjIwNS0xLjIwNWwwLDANCgkJYzAtMC42NjYsMC41NC0xLjIwNSwxLjIwNS0xLjIwNWg0LjYzQzIyMC45MTUsMTE5Ljk4NCwyMjEuNDU1LDEyMC41MjQsMjIxLjQ1NSwxMjEuMTg5TDIyMS40NTUsMTIxLjE4OXoiLz4NCgk8cGF0aCBmaWxsPSIjQUJDOUY0IiBkPSJNMTk0LjQ1MywxMjYuNDIyYzAsMC42NjYsMC41NCwxLjIwNSwxLjIwNSwxLjIwNWgyNi42MzhjMC42NjYsMCwxLjIwNS0wLjU0LDEuMjA1LTEuMjA1bDAsMA0KCQljMC0wLjY2Ni0wLjU0LTEuMjA1LTEuMjA1LTEuMjA1aC0yNi42MzhDMTk0Ljk5MiwxMjUuMjE3LDE5NC40NTMsMTI1Ljc1NiwxOTQuNDUzLDEyNi40MjJMMTk0LjQ1MywxMjYuNDIyeiIvPg0KCTxwYXRoIGZpbGw9IiNBQkM5RjQiIGQ9Ik0xNzQuMjg0LDEyNi40MjJjMCwwLjY2NiwwLjU0LDEuMjA1LDEuMjA1LDEuMjA1aDE0LjMzNGMwLjY2NiwwLDEuMjA1LTAuNTQsMS4yMDUtMS4yMDVsMCwwDQoJCWMwLTAuNjY2LTAuNTQtMS4yMDUtMS4yMDUtMS4yMDVoLTE0LjMzNEMxNzQuODI0LDEyNS4yMTcsMTc0LjI4NCwxMjUuNzU2LDE3NC4yODQsMTI2LjQyMkwxNzQuMjg0LDEyNi40MjJ6Ii8+DQoJPHBhdGggZmlsbD0iI0FCQzlGNCIgZD0iTTE2Mi4yNjYsMTI2LjQyMmMwLDAuNjY2LDAuNTQsMS4yMDUsMS4yMDUsMS4yMDVoNi41NjRjMC42NjYsMCwxLjIwNS0wLjU0LDEuMjA1LTEuMjA1bDAsMA0KCQljMC0wLjY2Ni0wLjU0LTEuMjA1LTEuMjA1LTEuMjA1aC02LjU2NEMxNjIuODA1LDEyNS4yMTcsMTYyLjI2NiwxMjUuNzU2LDE2Mi4yNjYsMTI2LjQyMkwxNjIuMjY2LDEyNi40MjJ6Ii8+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ },
/* 566 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 567 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(288)
	
	/* template */
	var __vue_template__ = __webpack_require__(749)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(289)
	
	/* template */
	var __vue_template__ = __webpack_require__(857)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(290)
	
	/* template */
	var __vue_template__ = __webpack_require__(840)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(291)
	
	/* template */
	var __vue_template__ = __webpack_require__(919)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(758)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(292)
	
	/* template */
	var __vue_template__ = __webpack_require__(794)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(538)
	
	/* script */
	__vue_exports__ = __webpack_require__(293)
	
	/* template */
	var __vue_template__ = __webpack_require__(793)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(294)
	
	/* template */
	var __vue_template__ = __webpack_require__(801)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(295)
	
	/* template */
	var __vue_template__ = __webpack_require__(923)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(296)
	
	/* template */
	var __vue_template__ = __webpack_require__(757)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(297)
	
	/* template */
	var __vue_template__ = __webpack_require__(802)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(298)
	
	/* template */
	var __vue_template__ = __webpack_require__(748)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(299)
	
	/* template */
	var __vue_template__ = __webpack_require__(865)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(300)
	
	/* template */
	var __vue_template__ = __webpack_require__(871)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(302)
	
	/* template */
	var __vue_template__ = __webpack_require__(832)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(303)
	
	/* template */
	var __vue_template__ = __webpack_require__(860)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(304)
	
	/* template */
	var __vue_template__ = __webpack_require__(774)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(305)
	
	/* template */
	var __vue_template__ = __webpack_require__(835)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(306)
	
	/* template */
	var __vue_template__ = __webpack_require__(800)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(307)
	
	/* template */
	var __vue_template__ = __webpack_require__(803)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(308)
	
	/* template */
	var __vue_template__ = __webpack_require__(921)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(309)
	
	/* template */
	var __vue_template__ = __webpack_require__(890)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(310)
	
	/* template */
	var __vue_template__ = __webpack_require__(810)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(314)
	
	/* template */
	var __vue_template__ = __webpack_require__(755)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(316)
	
	/* template */
	var __vue_template__ = __webpack_require__(928)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(317)
	
	/* template */
	var __vue_template__ = __webpack_require__(848)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(318)
	
	/* template */
	var __vue_template__ = __webpack_require__(764)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(319)
	
	/* template */
	var __vue_template__ = __webpack_require__(891)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(320)
	
	/* template */
	var __vue_template__ = __webpack_require__(905)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(321)
	
	/* template */
	var __vue_template__ = __webpack_require__(807)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(322)
	
	/* template */
	var __vue_template__ = __webpack_require__(892)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(323)
	
	/* template */
	var __vue_template__ = __webpack_require__(759)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(324)
	
	/* template */
	var __vue_template__ = __webpack_require__(826)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(325)
	
	/* template */
	var __vue_template__ = __webpack_require__(830)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(326)
	
	/* template */
	var __vue_template__ = __webpack_require__(863)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(327)
	
	/* template */
	var __vue_template__ = __webpack_require__(927)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(328)
	
	/* template */
	var __vue_template__ = __webpack_require__(792)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(329)
	
	/* template */
	var __vue_template__ = __webpack_require__(866)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(330)
	
	/* template */
	var __vue_template__ = __webpack_require__(744)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(331)
	
	/* template */
	var __vue_template__ = __webpack_require__(786)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(332)
	
	/* template */
	var __vue_template__ = __webpack_require__(824)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(333)
	
	/* template */
	var __vue_template__ = __webpack_require__(782)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(334)
	
	/* template */
	var __vue_template__ = __webpack_require__(818)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(335)
	
	/* template */
	var __vue_template__ = __webpack_require__(881)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(336)
	
	/* template */
	var __vue_template__ = __webpack_require__(876)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(337)
	
	/* template */
	var __vue_template__ = __webpack_require__(829)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(338)
	
	/* template */
	var __vue_template__ = __webpack_require__(773)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(339)
	
	/* template */
	var __vue_template__ = __webpack_require__(750)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(340)
	
	/* template */
	var __vue_template__ = __webpack_require__(907)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(341)
	
	/* template */
	var __vue_template__ = __webpack_require__(834)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(342)
	
	/* template */
	var __vue_template__ = __webpack_require__(816)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(343)
	
	/* template */
	var __vue_template__ = __webpack_require__(887)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(344)
	
	/* template */
	var __vue_template__ = __webpack_require__(884)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(345)
	
	/* template */
	var __vue_template__ = __webpack_require__(817)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(346)
	
	/* template */
	var __vue_template__ = __webpack_require__(879)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(347)
	
	/* template */
	var __vue_template__ = __webpack_require__(920)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(348)
	
	/* template */
	var __vue_template__ = __webpack_require__(902)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(349)
	
	/* template */
	var __vue_template__ = __webpack_require__(903)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(350)
	
	/* template */
	var __vue_template__ = __webpack_require__(847)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(351)
	
	/* template */
	var __vue_template__ = __webpack_require__(787)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(352)
	
	/* template */
	var __vue_template__ = __webpack_require__(765)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(845)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(353)
	
	/* template */
	var __vue_template__ = __webpack_require__(838)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(354)
	
	/* template */
	var __vue_template__ = __webpack_require__(853)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(355)
	
	/* template */
	var __vue_template__ = __webpack_require__(837)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(356)
	
	/* template */
	var __vue_template__ = __webpack_require__(929)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(357)
	
	/* template */
	var __vue_template__ = __webpack_require__(806)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(904)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(359)
	
	/* template */
	var __vue_template__ = __webpack_require__(872)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(360)
	
	/* template */
	var __vue_template__ = __webpack_require__(772)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(361)
	
	/* template */
	var __vue_template__ = __webpack_require__(811)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(362)
	
	/* template */
	var __vue_template__ = __webpack_require__(855)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(363)
	
	/* template */
	var __vue_template__ = __webpack_require__(911)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(364)
	
	/* template */
	var __vue_template__ = __webpack_require__(770)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(366)
	
	/* template */
	var __vue_template__ = __webpack_require__(812)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(367)
	
	/* template */
	var __vue_template__ = __webpack_require__(924)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(368)
	
	/* template */
	var __vue_template__ = __webpack_require__(925)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(369)
	
	/* template */
	var __vue_template__ = __webpack_require__(778)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(370)
	
	/* template */
	var __vue_template__ = __webpack_require__(796)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(371)
	
	/* template */
	var __vue_template__ = __webpack_require__(743)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(372)
	
	/* template */
	var __vue_template__ = __webpack_require__(767)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(373)
	
	/* template */
	var __vue_template__ = __webpack_require__(825)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(374)
	
	/* template */
	var __vue_template__ = __webpack_require__(752)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(375)
	
	/* template */
	var __vue_template__ = __webpack_require__(878)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(376)
	
	/* template */
	var __vue_template__ = __webpack_require__(913)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(377)
	
	/* template */
	var __vue_template__ = __webpack_require__(760)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(378)
	
	/* template */
	var __vue_template__ = __webpack_require__(823)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(379)
	
	/* template */
	var __vue_template__ = __webpack_require__(790)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(380)
	
	/* template */
	var __vue_template__ = __webpack_require__(762)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(381)
	
	/* template */
	var __vue_template__ = __webpack_require__(753)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(382)
	
	/* template */
	var __vue_template__ = __webpack_require__(775)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(383)
	
	/* template */
	var __vue_template__ = __webpack_require__(918)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(384)
	
	/* template */
	var __vue_template__ = __webpack_require__(777)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(385)
	
	/* template */
	var __vue_template__ = __webpack_require__(836)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(386)
	
	/* template */
	var __vue_template__ = __webpack_require__(909)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(388)
	
	/* template */
	var __vue_template__ = __webpack_require__(916)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(389)
	
	/* template */
	var __vue_template__ = __webpack_require__(889)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(390)
	
	/* template */
	var __vue_template__ = __webpack_require__(874)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(391)
	
	/* template */
	var __vue_template__ = __webpack_require__(880)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(392)
	
	/* template */
	var __vue_template__ = __webpack_require__(833)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(393)
	
	/* template */
	var __vue_template__ = __webpack_require__(885)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(394)
	
	/* template */
	var __vue_template__ = __webpack_require__(870)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(395)
	
	/* template */
	var __vue_template__ = __webpack_require__(926)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(396)
	
	/* template */
	var __vue_template__ = __webpack_require__(769)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(398)
	
	/* template */
	var __vue_template__ = __webpack_require__(788)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(399)
	
	/* template */
	var __vue_template__ = __webpack_require__(771)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(400)
	
	/* template */
	var __vue_template__ = __webpack_require__(795)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(401)
	
	/* template */
	var __vue_template__ = __webpack_require__(828)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(402)
	
	/* template */
	var __vue_template__ = __webpack_require__(861)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(403)
	
	/* template */
	var __vue_template__ = __webpack_require__(864)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(404)
	
	/* template */
	var __vue_template__ = __webpack_require__(821)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(405)
	
	/* template */
	var __vue_template__ = __webpack_require__(910)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(406)
	
	/* template */
	var __vue_template__ = __webpack_require__(780)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(407)
	
	/* template */
	var __vue_template__ = __webpack_require__(839)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(408)
	
	/* template */
	var __vue_template__ = __webpack_require__(898)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(409)
	
	/* template */
	var __vue_template__ = __webpack_require__(893)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(410)
	
	/* template */
	var __vue_template__ = __webpack_require__(751)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(411)
	
	/* template */
	var __vue_template__ = __webpack_require__(798)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(412)
	
	/* template */
	var __vue_template__ = __webpack_require__(908)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(413)
	
	/* template */
	var __vue_template__ = __webpack_require__(875)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(414)
	
	/* template */
	var __vue_template__ = __webpack_require__(849)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(415)
	
	/* template */
	var __vue_template__ = __webpack_require__(886)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(416)
	
	/* template */
	var __vue_template__ = __webpack_require__(808)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(417)
	
	/* template */
	var __vue_template__ = __webpack_require__(754)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(418)
	
	/* template */
	var __vue_template__ = __webpack_require__(868)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(419)
	
	/* template */
	var __vue_template__ = __webpack_require__(822)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(420)
	
	/* template */
	var __vue_template__ = __webpack_require__(809)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(761)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(421)
	
	/* template */
	var __vue_template__ = __webpack_require__(756)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(422)
	
	/* template */
	var __vue_template__ = __webpack_require__(791)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(423)
	
	/* template */
	var __vue_template__ = __webpack_require__(842)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(425)
	
	/* template */
	var __vue_template__ = __webpack_require__(897)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(426)
	
	/* template */
	var __vue_template__ = __webpack_require__(896)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(427)
	
	/* template */
	var __vue_template__ = __webpack_require__(895)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(428)
	
	/* template */
	var __vue_template__ = __webpack_require__(814)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(429)
	
	/* template */
	var __vue_template__ = __webpack_require__(859)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(900)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(430)
	
	/* template */
	var __vue_template__ = __webpack_require__(862)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(431)
	
	/* template */
	var __vue_template__ = __webpack_require__(827)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(432)
	
	/* template */
	var __vue_template__ = __webpack_require__(813)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(433)
	
	/* template */
	var __vue_template__ = __webpack_require__(867)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(434)
	
	/* template */
	var __vue_template__ = __webpack_require__(781)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(436)
	
	/* template */
	var __vue_template__ = __webpack_require__(894)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(442)
	
	/* template */
	var __vue_template__ = __webpack_require__(856)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(443)
	
	/* template */
	var __vue_template__ = __webpack_require__(815)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(444)
	
	/* template */
	var __vue_template__ = __webpack_require__(768)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(445)
	
	/* template */
	var __vue_template__ = __webpack_require__(873)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(446)
	
	/* template */
	var __vue_template__ = __webpack_require__(804)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(883)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(447)
	
	/* template */
	var __vue_template__ = __webpack_require__(869)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(448)
	
	/* template */
	var __vue_template__ = __webpack_require__(901)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(449)
	
	/* template */
	var __vue_template__ = __webpack_require__(899)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(450)
	
	/* template */
	var __vue_template__ = __webpack_require__(819)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(451)
	
	/* template */
	var __vue_template__ = __webpack_require__(888)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(452)
	
	/* template */
	var __vue_template__ = __webpack_require__(820)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(453)
	
	/* template */
	var __vue_template__ = __webpack_require__(747)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(455)
	
	/* template */
	var __vue_template__ = __webpack_require__(915)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(456)
	
	/* template */
	var __vue_template__ = __webpack_require__(912)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(457)
	
	/* template */
	var __vue_template__ = __webpack_require__(841)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(458)
	
	/* template */
	var __vue_template__ = __webpack_require__(854)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(459)
	
	/* template */
	var __vue_template__ = __webpack_require__(922)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(460)
	
	/* template */
	var __vue_template__ = __webpack_require__(784)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(461)
	
	/* template */
	var __vue_template__ = __webpack_require__(930)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(462)
	
	/* template */
	var __vue_template__ = __webpack_require__(776)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(463)
	
	/* template */
	var __vue_template__ = __webpack_require__(779)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(464)
	
	/* template */
	var __vue_template__ = __webpack_require__(877)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(465)
	
	/* template */
	var __vue_template__ = __webpack_require__(789)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(466)
	
	/* template */
	var __vue_template__ = __webpack_require__(852)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(467)
	
	/* template */
	var __vue_template__ = __webpack_require__(783)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(468)
	
	/* template */
	var __vue_template__ = __webpack_require__(882)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 743 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    class: {
	      active: _vm.sidebarActiveButton === 'style'
	    },
	    attrs: {
	      "title": _vm.$t('general.labels.edition')
	    },
	    on: {
	      "click": function($event) {
	        _vm.sidebarChangePanel('style');
	        _vm.sidebarChangeActiveButton('style');
	        _vm.canvasChangeView('preview')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-kp-brush"
	  })])
	},staticRenderFns: []}

/***/ },
/* 744 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "klickbox-step-description",
	    staticStyle: {
	      "margin-top": "-11px"
	    }
	  }, [_c('div', {
	    staticClass: "klickbox-edit-title"
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('general.labels.description')) + "\n    "), _c('description-checkbox')], 1), _vm._v(" "), _c('text-editor', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.descriptionVisibility),
	      expression: "descriptionVisibility"
	    }],
	    attrs: {
	      "content": _vm.step.description_text,
	      "change": _vm.changed,
	      "placeholder": _vm.$t('edit.canvas.question_description_placeholder')
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "klickbox-step-bar"
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 745 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', {
	    staticClass: "kbx-title",
	    style: (_vm.stepStyle('title')),
	    attrs: {
	      "klickbox-edit-item": "title",
	      "klickbox-edit-label": _vm.$t('edit.canvas.question_title')
	    }
	  }, [(!_vm.stepPreview.isGeneral) ? _c('text-editor', {
	    attrs: {
	      "content": _vm.stepPreview.title,
	      "change": _vm.onChange,
	      "toolbar": true,
	      "placeholder": _vm.$t('edit.canvas.question_title_placeholder')
	    }
	  }) : _c('span', [_vm._v(_vm._s(_vm.stepPreview.title))])], 1)])
	},staticRenderFns: []}

/***/ },
/* 746 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-list-group-item clearfix"
	  }, [_c('label', {
	    staticClass: "kp-row box-title box-title__button box-radio",
	    on: {
	      "click": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'advanced',
	          key: 'exibition_frequency',
	          value: _vm.value
	        });
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "checked": _vm.boxConfig.advanced.exibition_frequency === _vm.value
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.boxConfig.advanced.exibition_frequency === _vm.value),
	      expression: "boxConfig.advanced.exibition_frequency === value"
	    }]
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ },
/* 747 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.modalVisible === 'cant-export') ? _c('layout-general', {
	    on: {
	      "close": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('modal.cant_export_table.title')))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('modal.cant_export_table.max_limit')) + _vm._s(_vm.reportExportLimit) + _vm._s(_vm.$t('modal.cant_export_table.select_interval')))])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.close')))])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 748 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('select', {
	    staticClass: "klickart-select",
	    staticStyle: {
	      "width": "97%"
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("0 - " + _vm._s(_vm.$t('edit.canvas.all_steps')))]), _vm._v(" "), _vm._l((_vm.stepList), function(step) {
	    return _c('option', {
	      domProps: {
	        "value": step.id,
	        "selected": step.id === _vm.stepActive.id
	      }
	    }, [_vm._v(_vm._s(((_vm.stepDisplayPosition(step)) + " - " + (step.sanitized_title))))])
	  })], 2)
	},staticRenderFns: []}

/***/ },
/* 749 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.showKlickpagesHeader) ? _c('klickpages-header', {
	    attrs: {
	      "klickartURL": _vm.klickartURL,
	      "jwtSecret": _vm.jwtSecret,
	      "hotmartURL": _vm.hotmartURL
	    }
	  }) : _vm._e(), _vm._v(" "), _c('error-page', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.error),
	      expression: "error"
	    }],
	    attrs: {
	      "error": _vm.error
	    }
	  }), _vm._v(" "), _c('router-view', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.error),
	      expression: "!error"
	    }]
	  }), _vm._v(" "), _c('klickpages-support-chat', {
	    attrs: {
	      "klickartURL": _vm.klickartURL
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 750 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.step.kind === 'redirect') ? _c('div', {
	    staticClass: "klickbox-edit-code"
	  }, [_c('div', {
	    staticClass: "klickbox-code-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.redirect_url')))]), _vm._v(" "), _c('input', {
	    staticClass: "klickbox-code-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.step.redirect_url
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateRedirectUrl({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label label__checkbox"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.auto_redirect')))]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.step.redirect_automatic
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateRedirectAutomatic({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }), _c('span')])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 751 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('range', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.border_radius'),
	      "min": "0",
	      "max": "50",
	      "step": "1",
	      "value": _vm.value(),
	      "change": _vm.onChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 752 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.boxFormat !== 'component') ? _c('div', {
	    staticClass: "kp-list-group-item clearfix"
	  }, [_c('label', {
	    staticClass: "kp-row box-title box-title__button",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sidebarChangePanel('triggerbutton');
	        _vm.canvasChangeView('triggerbutton')
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('edit.sidebar.call_button_style')) + "\n    "), _vm._m(0)]), _vm._v(" "), _c('span')]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-right"
	  }, [_c('span', {
	    staticClass: "btn is-circular has-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  })])])
	}]}

/***/ },
/* 753 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('edit.sidebar.visibility'))), _c('span', {
	    attrs: {
	      "klickart-info-tutorial": "edit-visibility"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-check pull-right kp-modular-check-with-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.getValue()
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onChange($event)
	      }
	    }
	  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-eye"
	  })])])
	},staticRenderFns: []}

/***/ },
/* 754 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "col-xs-4",
	    class: {
	      active: _vm.boxConfig.trigger_button.kind === 'basic'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'trigger_button',
	          key: 'kind',
	          value: 'basic'
	        })
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "kp-tab-label"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.button'))), _c('br'), _vm._v(_vm._s(_vm.$t('general.labels.standard')))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "kp-btn-action-lg-max",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-btn-default"
	  })])
	}]}

/***/ },
/* 755 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.stepPreview.kind === 'welcome') ? _c('welcome') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'multiple-choice' || _vm.stepPreview.kind === 'yes-no') ? _c('question') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'email') ? _c('form-email') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'text') ? _c('text-field') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'redirect') ? _c('redirect') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'thanks') ? _c('thanks') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 756 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sidebarCurrentPanel === 'types'),
	      expression: "sidebarCurrentPanel === 'types'"
	    }],
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.themes')))]), _vm._v(" "), _c('div', {
	    staticClass: "submenu-content sub-color"
	  }, [_c('type-header'), _vm._v(" "), _c('type-popup'), _vm._v(" "), _c('type-fullscreen'), _vm._v(" "), _c('type-component'), _vm._v(" "), _c('type-slider'), _vm._v(" "), _c('type-mini-slide')], 1)])])
	},staticRenderFns: []}

/***/ },
/* 757 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    style: (_vm.highlightStyle.container),
	    attrs: {
	      "kbx-highlight-hover-container": ""
	    }
	  }, [_c('div', {
	    attrs: {
	      "kbx-highlight-hover": "top"
	    }
	  }), _vm._v(" "), _c('div', {
	    style: (_vm.highlightStyle.right),
	    attrs: {
	      "kbx-highlight-hover": "right"
	    }
	  }), _vm._v(" "), _c('div', {
	    style: (_vm.highlightStyle.bottom),
	    attrs: {
	      "kbx-highlight-hover": "bottom"
	    }
	  }), _vm._v(" "), _c('div', {
	    style: (_vm.highlightStyle.left),
	    attrs: {
	      "kbx-highlight-hover": "left"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "klickart-element-highlight-tool-container"
	  }, [_c('button', {
	    staticClass: "klickart-highlight-tool",
	    on: {
	      "click": function($event) {
	        _vm.sidebarChangePanel('modifiers');
	        _vm.sidebarChangeActiveButton('style');
	        _vm.sidebarSetElement(_vm.highlightElement)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  })])])])])
	},staticRenderFns: []}

/***/ },
/* 758 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-view', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.error),
	      expression: "!error"
	    }]
	  })
	},staticRenderFns: []}

/***/ },
/* 759 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "klickbox-edit-item": "general",
	      "klickbox-edit-label": _vm.$t('edit.canvas.general_styles')
	    }
	  }, [(_vm.boxConfig.progressbar.kind !== 'counter') ? _c('progress-bar') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kbx-content"
	  }, [(_vm.boxConfig.progressbar.kind === 'counter') ? _c('counter') : _vm._e(), _vm._v(" "), _c('title-preview'), _vm._v(" "), _c('description'), _vm._v(" "), (_vm.stepActive.text_size === 'long') ? _c('textarea-field') : _c('input-field'), _vm._v(" "), _c('button-next')], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 760 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('color-picker', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.background_color'),
	      "id": _vm.getId(),
	      "value": _vm.value(),
	      "change": _vm.onColorChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 761 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.how_might_show')))]), _vm._v(" "), _c('div', {
	    staticClass: "box-description"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_box_format')))])])
	},staticRenderFns: []}

/***/ },
/* 762 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('color-picker', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.text_color'),
	      "id": _vm.getId(),
	      "value": _vm.value(),
	      "change": _vm.onColorChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 763 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.stepPreview.description_visibility) ? _c('h2', {
	    staticClass: "kbx-description",
	    style: (_vm.stepStyle('description')),
	    attrs: {
	      "klickbox-edit-item": "description",
	      "klickbox-edit-label": _vm.$t('edit.canvas.question_description')
	    }
	  }, [(!_vm.stepPreview.isGeneral) ? _c('text-editor', {
	    attrs: {
	      "content": _vm.stepPreview.description_text,
	      "change": _vm.onChange,
	      "toolbar": true,
	      "placeholder": _vm.$t('edit.canvas.question_description_placeholder')
	    }
	  }) : _c('span', [_vm._v(_vm._s(_vm.stepPreview.description_text))])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 764 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "klickbox-edit-item": "general",
	      "klickbox-edit-label": _vm.$t('edit.canvas.general_styles')
	    }
	  }, [(_vm.boxConfig.progressbar.kind !== 'counter') ? _c('progress-bar') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kbx-content"
	  }, [(_vm.boxConfig.progressbar.kind === 'counter') ? _c('counter') : _vm._e(), _vm._v(" "), _c('title-preview'), _vm._v(" "), _c('description'), _vm._v(" "), _c('options'), _vm._v(" "), _c('button-next')], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 765 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('exibition-mode'), _vm._v(" "), _c('exibition-frequency')], 1)
	},staticRenderFns: []}

/***/ },
/* 766 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kbx-step",
	    style: (_vm.getStyle())
	  }, [(_vm.stepListHasJumps) ? _c('percent') : _c('numeric')], 1)
	},staticRenderFns: []}

/***/ },
/* 767 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sidebarCurrentPanel === 'style'),
	      expression: "sidebarCurrentPanel === 'style'"
	    }],
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.labels.edition')) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "submenu-content sub-color"
	  }, [_c('modifiers-config'), _vm._v(" "), _c('trigger-button-config'), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.boxConfig.advanced.view_mode === 'automatic'),
	      expression: "boxConfig.advanced.view_mode === 'automatic'"
	    }],
	    staticClass: "btn",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sidebarChangePanel('exibitionmode');
	        _vm.sidebarChangeActiveButton('advancedconfig');
	        _vm.canvasChangeView('preview');
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.configure_box')))])], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 768 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kbx-text-editor-toolbar"
	  }, [_c('span', {
	    staticClass: "ql-formats"
	  }, [_c('editor-button', {
	    attrs: {
	      "type": "bold"
	    }
	  }), _vm._v(" "), _c('editor-button', {
	    attrs: {
	      "type": "italic"
	    }
	  }), _vm._v(" "), _c('editor-button', {
	    attrs: {
	      "type": "underline"
	    }
	  }), _vm._v(" "), _c('editor-button', {
	    attrs: {
	      "type": "strike"
	    }
	  })], 1), _vm._v(" "), _c('span', {
	    staticClass: "ql-formats"
	  }, [_c('editor-color', {
	    attrs: {
	      "type": "color"
	    }
	  }), _vm._v(" "), _c('editor-color', {
	    attrs: {
	      "type": "background"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 769 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-section"
	  }, [_c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_destiny')))]), _vm._v(" "), _c('step-jump-select', {
	    attrs: {
	      "jump": _vm.jump,
	      "selected": _vm.selected
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 770 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('option-general', {
	    attrs: {
	      "value": "time",
	      "label": _vm.$t('edit.sidebar.by_time_on_page')
	    }
	  }, [_c('div', {
	    staticClass: "box-input-group box-input-time"
	  }, [_c('i', {
	    staticClass: "box-input-group__icon icon-kp-clock"
	  }), _vm._v(" "), _c('input', {
	    staticClass: "box-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": _vm.boxConfig.advanced.exibition_mode_time_value
	    },
	    on: {
	      "change": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'advanced',
	          key: 'exibition_mode_time_value',
	          value: $event.target.value
	        });
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box-input-group-label"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.seconds')))])])])
	},staticRenderFns: []}

/***/ },
/* 771 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-section"
	  }, [_c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_one_answer')))]), _vm._v(" "), _c('select', {
	    staticClass: "klickart-select",
	    on: {
	      "change": function($event) {
	        return _vm.jumpUpdateOptionId({
	          jump: _vm.jump,
	          index: 0,
	          event: $event
	        })
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": "",
	      "selected": ""
	    }
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.choose_one_answer')))]), _vm._v(" "), _vm._l((_vm.optionList), function(option, index) {
	    return _c('option', {
	      domProps: {
	        "value": option.id,
	        "selected": option.id === _vm.jump.options_ids[0]
	      }
	    }, [_vm._v(_vm._s(option.label))])
	  })], 2)])
	},staticRenderFns: []}

/***/ },
/* 772 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('option-general', {
	    attrs: {
	      "value": "exit",
	      "label": _vm.$t('edit.sidebar.when_leave_the_page')
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 773 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.step.kind === 'multiple-choice') ? _c('div', {
	    staticClass: "klickbox-edit-code"
	  }, [_c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label label__checkbox"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.multiple_answers')))]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.step.multiple_answers
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateMultipleAnswers({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }), _c('span')])]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label label__checkbox"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.add_other_option')))]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.optionOtherAnswer
	    },
	    on: {
	      "change": function($event) {
	        return _vm.optionUpdateOtherAnswer({
	          event: $event
	        })
	      }
	    }
	  }), _c('span')])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 774 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('li', {
	    staticClass: "done",
	    style: (_vm.getLiStyle()),
	    attrs: {
	      "klickbox-edit-item": "progress-bullet-done",
	      "klickbox-edit-item-dad": "progress",
	      "klickbox-edit-label": _vm.$t('edit.canvas.past_item')
	    }
	  }, [_c('span', {
	    staticClass: "kbx-subtitle",
	    style: (_vm.getSpanStyle()),
	    domProps: {
	      "innerHTML": _vm._s(_vm.getSVG())
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "kbx-number",
	    style: (_vm.getNumberStyle())
	  }, [_vm._v("1")])])])
	},staticRenderFns: []}

/***/ },
/* 775 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.font')))]), _vm._v(" "), _c('select', {
	    staticClass: "klickart-select",
	    on: {
	      "change": function($event) {
	        return _vm.onChange($event)
	      }
	    }
	  }, _vm._l((_vm.fontFamilies), function(font) {
	    return _c('option', {
	      domProps: {
	        "value": font.value,
	        "selected": font.value === _vm.stepStyle(_vm.item).fontFamily
	      }
	    }, [_vm._v(_vm._s(font.label))])
	  }), 0)])
	},staticRenderFns: []}

/***/ },
/* 776 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content_period"
	  }, [_c('input', {
	    staticClass: "btn-period",
	    attrs: {
	      "id": "klickbox-filter-period",
	      "type": "checkbox"
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "kp-button kp-button__min btn-gray",
	    attrs: {
	      "for": "klickbox-filter-period"
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('report.individual.date_filter')) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "period"
	  }, [_c('h3', {
	    staticClass: "period-title"
	  }, [_vm._v(_vm._s(_vm.$t('report.individual.date_range')) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('report.individual.from')))]), _vm._v(" "), _c('datepicker', {
	    attrs: {
	      "format": _vm.format,
	      "language": "pt-br",
	      "placeholder": "dd/mm/aaaa"
	    },
	    on: {
	      "selected": _vm.selectedDateFrom
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('report.individual.to')))]), _vm._v(" "), _c('datepicker', {
	    attrs: {
	      "format": _vm.format,
	      "language": "pt-br",
	      "placeholder": "dd/mm/aaaa"
	    },
	    on: {
	      "selected": _vm.selectedDateTo
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 777 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('range', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.height'),
	      "min": "50",
	      "max": "150",
	      "step": "1",
	      "value": _vm.value(),
	      "change": _vm.onChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 778 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    class: {
	      active: _vm.sidebarActiveButton === 'box'
	    },
	    attrs: {
	      "title": _vm.$t('general.labels.themes')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.goToBox()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-pop-up"
	  })])
	},staticRenderFns: []}

/***/ },
/* 779 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "kp-button kp-button__min btn-gray",
	    on: {
	      "click": function($event) {
	        return _vm.checkModal();
	      }
	    }
	  }, [_c('span', {
	    staticClass: "kp-panel-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n  " + _vm._s(_vm.$t('general.actions.export').toUpperCase()) + " " + _vm._s(_vm.$t('general.labels.table').toUpperCase()) + "\n")])
	},staticRenderFns: []}

/***/ },
/* 780 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "submenu-padding sub-box scroll-person"
	  }, [_c('div', {
	    staticClass: "box-header no-padding--top"
	  }, [_c('div', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.choose_a_theme')))])]), _vm._v(" "), _vm._l((_vm.themeList), function(theme) {
	    return _c('div', {
	      staticClass: "kp-modular-row clearfix",
	      class: {
	        select: theme.slug === _vm.themeActive.slug
	      }
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.changeTheme(theme)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "media-hover"
	    }, [_c('div', {
	      staticClass: "theme_select"
	    }, [_c('i', {
	      staticClass: "icon-kp-check"
	    }), _vm._v(" "), _c('a', {
	      staticClass: "btn btn--inline",
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          _vm.sidebarChangePanel('style');
	          _vm.sidebarChangeActiveButton('style');
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.edit_theme')))])])]), _vm._v(" "), _c('img', {
	      staticClass: "media-image",
	      attrs: {
	        "src": _vm.thumbUrl(theme.slug),
	        "alt": theme.name
	      }
	    })])])
	  })], 2)
	},staticRenderFns: []}

/***/ },
/* 781 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "item button-publish bt-copy_url"
	  }, [_c('a', {
	    staticClass: "kp-modular-publish animate-in",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.boxSave(true)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-publish"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "txt"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.publish')))])])])
	},staticRenderFns: []}

/***/ },
/* 782 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "klickbox-step-title"
	  }, [_c('div', {
	    staticClass: "klickbox-edit-title"
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('general.labels.title')) + "\n  ")]), _vm._v(" "), _c('text-editor', {
	    attrs: {
	      "content": _vm.step.title,
	      "change": _vm.onChange,
	      "placeholder": _vm.$t('edit.canvas.question_title_placeholder')
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "klickbox-step-bar"
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 783 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "table_collumns-col"
	  }, [_c('div', {
	    staticClass: "table_collumns-title"
	  }, [_c('i', {
	    class: _vm.banner,
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "table_collumns-line"
	  }, [_c('span', {
	    staticClass: "data"
	  }, [_vm._v(_vm._s(_vm.metric.box_hits))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.total_visits')) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "table_collumns-line"
	  }, [_c('span', {
	    staticClass: "data"
	  }, [_vm._v(_vm._s(_vm.metric.unanswered_submissions_count))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.visits_without_answers')) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "table_collumns-line"
	  }, [_c('span', {
	    staticClass: "data"
	  }, [_vm._v(_vm._s(_vm.metric.uncompleted_submissions_count))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.quizzes_not_completed')) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "table_collumns-line"
	  }, [_c('span', {
	    staticClass: "data"
	  }, [_vm._v(_vm._s(_vm.metric.completed_submissions_count))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.quizzes_completed')) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "table_collumns-line"
	  }, [_c('span', {
	    staticClass: "data"
	  }, [_vm._v(_vm._s(_vm.metric.conclusion_rate))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.completion_rate')) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "table_collumns-line"
	  }, [_c('span', {
	    staticClass: "data"
	  }, [_vm._v(_vm._s(_vm.metric.conclusion_average_time))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.average_time_to_complete')) + "\n  ")])])
	},staticRenderFns: []}

/***/ },
/* 784 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "option mobile-hide",
	    attrs: {
	      "to": {
	        name: 'boxEdit',
	        params: {
	          locale: _vm.i18n.locale,
	          boxId: _vm.box.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-kp-edit"
	  }), _vm._v(" " + _vm._s(_vm.$t('general.actions.edit')) + " Box\n")])
	},staticRenderFns: []}

/***/ },
/* 785 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-error"
	  }, [_c('div', {
	    staticClass: "page-error-img",
	    class: {
	      'img-404': _vm.error == 404,
	      'img-500': _vm.error != 404
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-error-text"
	  }, [(_vm.error == 404) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('general.labels.error')) + " 404")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('error.oops')) + ",")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('error.page_not_exists')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('error.check_url')))])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('general.labels.error')))]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('error.oops')) + ",")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('error.something_wrong')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('error.system_offline')) + _vm._s(_vm.$t('error.our_devs')) + _vm._s(_vm.$t('error.try_again_later')))])])])])
	},staticRenderFns: []}

/***/ },
/* 786 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "klickbox-step-content"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.quizInternalStyle)
	    }
	  }), _vm._v(" "), _c('top-message', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }), _vm._v(" "), _c('config'), _vm._v(" "), _c('step-title', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }), _vm._v(" "), _c('step-description', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }), _vm._v(" "), (_vm.stepActive.kind === 'multiple-choice' || _vm.stepActive.kind === 'yes-no') ? _c('multiple-choice', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.stepActive.kind === 'text') ? _c('text-step', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.stepActive.kind === 'email') ? _c('email', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.stepActive.kind === 'redirect') ? _c('redirect', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.stepActive.kind === 'welcome') ? _c('welcome', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }) : _vm._e(), _vm._v(" "), ((_vm.stepActive.kind === 'multiple-choice' && _vm.stepActive.multiple_answers) || _vm.stepActive.kind === 'text') ? _c('step-next-button', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('a', {
	    staticClass: "flow_button",
	    on: {
	      "click": function($event) {
	        return _vm.canvasChangeView('fluxogram');
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sitemap"
	  }), _vm._v(_vm._s(_vm.$t('edit.canvas.see_flow')))])])
	},staticRenderFns: []}

/***/ },
/* 787 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "kp-modular-panel",
	    attrs: {
	      "id": "kp-modular-panel"
	    }
	  }, [_c('menu-buttons'), _vm._v(" "), _c('steps'), _vm._v(" "), _c('types'), _vm._v(" "), _c('view-mode'), _vm._v(" "), _c('themes'), _vm._v(" "), _c('config'), _vm._v(" "), _c('trigger-button'), _vm._v(" "), _c('modifiers'), _vm._v(" "), _c('advanced-config')], 1)
	},staticRenderFns: []}

/***/ },
/* 788 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-section"
	  }, [(_vm.jump.options_ids.length === 0) ? _c('div', [_c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_the_answers')))]), _vm._v(" "), _c('select', {
	    staticClass: "klickart-select",
	    on: {
	      "change": function($event) {
	        return _vm.jumpUpdateOptionId({
	          jump: _vm.jump,
	          index: 0,
	          event: $event
	        })
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": "",
	      "selected": ""
	    }
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.choose_one_answer')))]), _vm._v(" "), _vm._l((_vm.optionList), function(option) {
	    return _c('option', {
	      domProps: {
	        "value": option.id
	      }
	    }, [_vm._v(_vm._s(option.label))])
	  })], 2), _vm._v(" "), _c('add-option-button', {
	    attrs: {
	      "jump": _vm.jump,
	      "show": true
	    }
	  })], 1) : _c('div', [_c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_the_answers')))]), _vm._v(" "), _vm._l((_vm.jump.options_ids), function(optionId, index) {
	    return _c('div', [_c('div', {
	      staticClass: "klickart-select-inline"
	    }, [_c('select', {
	      staticClass: "klickart-select",
	      on: {
	        "change": function($event) {
	          return _vm.jumpUpdateOptionId({
	            jump: _vm.jump,
	            index: index,
	            event: $event
	          })
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "",
	        "disabled": "",
	        "selected": ""
	      }
	    }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.choose_one_answer')))]), _vm._v(" "), _vm._l((_vm.optionList), function(option) {
	      return _c('option', {
	        domProps: {
	          "value": option.id,
	          "selected": option.id === optionId
	        }
	      }, [_vm._v(_vm._s(option.label))])
	    })], 2), _vm._v(" "), _c('div', {
	      staticClass: "nav-button-inline"
	    }, [_c('remove-option-button', {
	      attrs: {
	        "jump": _vm.jump,
	        "index": index,
	        "show": _vm.jump.options_ids.length > 1
	      }
	    })], 1)]), _vm._v(" "), _c('add-option-button', {
	      attrs: {
	        "jump": _vm.jump,
	        "show": index === _vm.jump.options_ids.length - 1
	      }
	    })], 1)
	  })], 2)])
	},staticRenderFns: []}

/***/ },
/* 789 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.list) ? _c('div', {
	    staticClass: "content_pages",
	    attrs: {
	      "id": "report-individual"
	    }
	  }, [_c('div', {
	    staticClass: "table_bordered-header clearfix"
	  }, [_c('span', {
	    staticClass: "table_bordered-title"
	  }, [_c('i', {
	    staticClass: "kp-panel-check"
	  }), _vm._v("\n      " + _vm._s(_vm.list.quantity_of_submissions) + " " + _vm._s(_vm.$t('report.individual.obtained_answers')) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "content_filter"
	  }, [_c('export-button'), _vm._v(" "), _c('date-filter')], 1)]), _vm._v(" "), _c('modal-export-table'), _vm._v(" "), _c('modal-cant-export-table'), _vm._v(" "), _c('modal-export-in-progress', {
	    attrs: {
	      "email": _vm.reportExportEmail
	    }
	  }), _vm._v(" "), _c('list')], 1) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 790 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('range', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.border_radius'),
	      "min": "0",
	      "max": "50",
	      "step": "1",
	      "value": _vm.value(),
	      "change": _vm.onChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 791 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('general-item', {
	    attrs: {
	      "format": "component"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.in_one_component')))]), _vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "description"
	    },
	    slot: "description"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.one_component_to_integrate')))])])
	},staticRenderFns: []}

/***/ },
/* 792 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "kbx-welcome",
	    attrs: {
	      "klickbox-edit-item": "general",
	      "klickbox-edit-label": _vm.$t('edit.canvas.general_styles')
	    }
	  }, [_c('div', {
	    staticClass: "kbx-content"
	  }, [_c('description'), _vm._v(" "), _c('title-preview'), _vm._v(" "), _c('buttons')], 1)])])
	},staticRenderFns: []}

/***/ },
/* 793 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "title_bar"
	  }, [_c('div', {
	    staticClass: "container no-padding"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'index'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "title_bar-icon kp-panel-back",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('h1', {
	    staticClass: "title_bar-title"
	  }, [_c('i', {
	    staticClass: "kp-panel-report",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n        " + _vm._s(_vm.$t('report.menu.report_of')) + " “" + _vm._s(_vm.boxName) + "”\n        "), _c('p', [(_vm.showBackToResume()) ? _c('router-link', {
	    staticClass: "back-to-resume",
	    attrs: {
	      "to": {
	        name: 'boxReportsResume',
	        params: {
	          boxId: _vm.$route.params.boxId
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-back",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(_vm._s(_vm.$t('report.menu.back_to_answers_summary')) + "\n          ")]) : _vm._e()], 1)]), _vm._v(" "), _c('ul', {
	    staticClass: "tab_pages"
	  }, [_c('li', [_c('router-link', {
	    staticClass: "tab_pages-item",
	    attrs: {
	      "to": {
	        name: 'boxReportsMetrics',
	        params: {
	          locale: _vm.i18n.locale,
	          boxId: _vm.$route.params.boxId
	        }
	      },
	      "active-class": "active",
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-metrics",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(_vm._s(_vm.$t('report.menu.metrics')) + "\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "tab_pages-item",
	    attrs: {
	      "to": {
	        name: 'boxReportsIndividuals',
	        params: {
	          locale: _vm.i18n.locale,
	          boxId: _vm.$route.params.boxId
	        }
	      },
	      "active-class": "active",
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-table",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(_vm._s(_vm.$t('report.menu.individual_answers')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "report-box-options"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu"
	  }, [_c('ul', {
	    staticClass: "dropdown-menu-container"
	  }, [_c('li', {
	    staticClass: "highlight"
	  }, [_vm._v(_vm._s(_vm.$t('report.menu.box_options')))]), _vm._v(" "), _c('li', [_c('export-box', {
	    attrs: {
	      "box": _vm.boxActive
	    }
	  })], 1), _vm._v(" "), _c('li', {
	    staticClass: "mobile-hide"
	  }, [(_vm.boxActive.id) ? _c('edit-box', {
	    attrs: {
	      "box": _vm.boxActive
	    }
	  }) : _vm._e()], 1)])])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "container no-padding"
	  }, [_c('router-view')], 1), _vm._v(" "), _c('modal-code')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "tab_pages-item"
	  }, [_c('i', {
	    staticClass: "fa fa-ellipsis-h",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ },
/* 794 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('error-page', {
	    attrs: {
	      "error": "404"
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 795 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "menu_circle",
	    class: {
	      'btn_topbar_active': _vm.topBarConfig.user.ucode
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "klickbox-step-add-buttons-container"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "id": "klickbox-step-add-buttons-container"
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.stepHasOnlyThanks),
	      expression: "stepHasOnlyThanks"
	    }],
	    staticClass: "btn_circle-tooltip"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.add_one_question')))]), _vm._v(" "), _c('div', {
	    staticClass: "menu_circle-list"
	  }, [_c('span', {
	    staticClass: "btn_circle btn_circle__red",
	    attrs: {
	      "title": "múltipla escolha"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.stepAdd('multiple-choice')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-alternative"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "btn_circle-subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.question')))])]), _vm._v(" "), _c('span', {
	    staticClass: "btn_circle btn_circle__pink",
	    attrs: {
	      "title": "sim/não"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.stepAdd('yes-no')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-yes-no"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "btn_circle-subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.yes_no')))])]), _vm._v(" "), _c('span', {
	    staticClass: "btn_circle btn_circle__purple",
	    attrs: {
	      "title": "texto"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.stepAdd('text')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-text"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "btn_circle-subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.text')))])]), _vm._v(" "), _c('span', {
	    staticClass: "btn_circle btn_circle__blue",
	    attrs: {
	      "title": "e-mail"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.stepAdd('email')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-register"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "btn_circle-subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.capture'))), _c('br'), _vm._v(_vm._s(_vm.$t('edit.sidebar.of_email')))])]), _vm._v(" "), _c('span', {
	    staticClass: "btn_circle btn_circle__green",
	    attrs: {
	      "title": "link"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.stepAdd('redirect')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-kp-link"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "btn_circle-subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.redirec')) + "-"), _c('br'), _vm._v(_vm._s(_vm.$t('edit.sidebar.tion')))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "btn_circle btn_circle__big"
	  }, [_c('i', {
	    staticClass: "kp-panel-plus"
	  })])
	}]}

/***/ },
/* 796 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    class: {
	      active: _vm.sidebarActiveButton === 'steps'
	    },
	    attrs: {
	      "title": _vm.$t('general.labels.steps')
	    },
	    on: {
	      "click": function($event) {
	        _vm.sidebarChangePanel('steps');
	        _vm.sidebarChangeActiveButton('steps');
	        _vm.canvasChangeView('steps')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-question"
	  })])
	},staticRenderFns: []}

/***/ },
/* 797 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-list-group-item clearfix"
	  }, [_c('label', {
	    staticClass: "kp-row box-title box-title__button box-radio",
	    on: {
	      "click": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'advanced',
	          key: 'exibition_mode',
	          value: _vm.value
	        });
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "checked": _vm.boxConfig.advanced.exibition_mode === _vm.value
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box-title__label has-icon"
	  }, [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.boxConfig.advanced.exibition_mode === _vm.value),
	      expression: "boxConfig.advanced.exibition_mode === value"
	    }]
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ },
/* 798 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('range', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.font_size'),
	      "min": "12",
	      "max": "32",
	      "step": "1",
	      "value": _vm.value(),
	      "change": _vm.onChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 799 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.modalVisible === 'code') ? _c('layout-general', {
	    on: {
	      "close": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.export')) + " box")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('modal.code.step_one')))]), _vm._v(" "), _c('textarea', {
	    staticClass: "code-textarea",
	    attrs: {
	      "readonly": ""
	    },
	    on: {
	      "click": function($event) {
	        return $event.target.select()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.codeScript))]), _vm._v(" "), _c('copy-button', {
	    attrs: {
	      "text": _vm.codeScript
	    }
	  })], 1), _vm._v(" "), (_vm.showButtonAttribute()) ? _c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('modal.code.step_two')) + " " + _vm._s(_vm.$t('modal.code.step_three')))]), _vm._v(" "), _c('textarea', {
	    staticClass: "code-textarea",
	    attrs: {
	      "readonly": ""
	    },
	    on: {
	      "click": function($event) {
	        return $event.target.select()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.codeButtonAttribute))]), _vm._v(" "), _c('copy-button', {
	    attrs: {
	      "text": _vm.codeButtonAttribute
	    }
	  })], 1) : _vm._e()])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 800 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.boxConfig.progressbar.kind === 'mask') ? _c('li', {
	    staticClass: "mask",
	    staticStyle: {
	      "left": "50px",
	      "opacity": "1",
	      "background": "transparent"
	    },
	    style: (_vm.getLiStyle())
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 801 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "kp-modular-content"
	  }, [_c('link', {
	    attrs: {
	      "rel": "stylesheet",
	      "href": _vm.themeCdnUri + '/bootstrap-box.css'
	    }
	  }), _vm._v(" "), _c('link', {
	    attrs: {
	      "rel": "stylesheet",
	      "href": _vm.themeCdnUri + '/popup.css'
	    }
	  }), _vm._v(" "), _c('link', {
	    attrs: {
	      "rel": "stylesheet",
	      "href": _vm.themeActiveStyles
	    }
	  }), _vm._v(" "), _vm._l((_vm.boxThemeFonts), function(font) {
	    return _c('link', {
	      attrs: {
	        "rel": "stylesheet",
	        "href": font
	      }
	    })
	  }), _vm._v(" "), _c('step', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.canvasCurrentView === 'steps'),
	      expression: "canvasCurrentView === 'steps'"
	    }]
	  }), _vm._v(" "), _c('fluxogram'), _vm._v(" "), (_vm.canvasCurrentView === 'preview') ? _c('preview') : _vm._e(), _vm._v(" "), _c('trigger-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.canvasCurrentView === 'triggerbutton'),
	      expression: "canvasCurrentView === 'triggerbutton'"
	    }]
	  })], 2)
	},staticRenderFns: []}

/***/ },
/* 802 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box-preview-header clearfix"
	  }, [_c('div', {
	    staticClass: "tab"
	  }, [_c('div', {
	    staticClass: "tab-item active"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.labels.editing')) + " " + _vm._s(_vm.$t('general.labels.step')) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "tab-item",
	    staticStyle: {
	      "text-align": "left",
	      "text-transform": "none"
	    }
	  }, [_c('step-select')], 1)]), _vm._v(" "), _c('device-buttons')], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-container",
	    class: 'box-' + _vm.boxFormat + ' box-device-' + _vm.canvasPreviewDevice
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-preview-content"
	  }, [_c('div', {
	    class: 'kbx-modal is-open kbx-modal-type__' + _vm.boxFormat
	  }, [_c('a', {
	    staticClass: "kbx-modal-close",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kbx-container",
	    style: (_vm.stepStyle('general'))
	  }, [_c('step'), _vm._v(" "), _c('highlight')], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-preview-url-container"
	  }, [_c('input', {
	    staticClass: "box-preview-url-field",
	    attrs: {
	      "type": "text",
	      "value": "http://klickpages.com.br",
	      "disabled": ""
	    }
	  })])
	}]}

/***/ },
/* 803 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "kbx-progress-label",
	    staticStyle: {
	      "left": "50%"
	    },
	    style: (_vm.getDivStyle())
	  }, [_c('span', {
	    staticClass: "kbx-progress-svg",
	    domProps: {
	      "innerHTML": _vm._s(_vm.getSVG())
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "kbx-label-content",
	    style: (_vm.getSpanStyle()),
	    attrs: {
	      "klickbox-edit-item": "progress-bar-active",
	      "klickbox-edit-item-dad": "progress",
	      "klickbox-edit-label": _vm.$t('edit.canvas.active_item')
	    }
	  }, [_vm._v("50%")])])])
	},staticRenderFns: []}

/***/ },
/* 804 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "searchbar-user",
	    class: {
	      'hotmart-pro': _vm.topBarConfig.user.ucode
	    }
	  }, [_c('div', {
	    staticClass: "container no-padding"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('svg', {
	    staticClass: "navbar-icon fa kp-panel-pop-up",
	    attrs: {
	      "viewBox": "0 0 30 30",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M21.5 19.25V2.75C21.5 1.53125 20.4688 0.5 19.25 0.5H2.75C1.48438 0.5 0.5 1.53125 0.5 2.75V19.25C0.5 20.5156 1.48438 21.5 2.75 21.5H19.25C20.4688 21.5 21.5 20.5156 21.5 19.25ZM2.75 20C2.32812 20 2 19.6719 2 19.25V2.75C2 2.375 2.32812 2 2.75 2H19.25C19.625 2 20 2.375 20 2.75V19.25C20 19.6719 19.625 20 19.25 20H2.75ZM12.5 6.875V6.125C12.5 5.9375 12.3125 5.75 12.125 5.75H5.375C5.14062 5.75 5 5.9375 5 6.125V6.875C5 7.10938 5.14062 7.25 5.375 7.25H12.125C12.3125 7.25 12.5 7.10938 12.5 6.875ZM17 11.375V10.625C17 10.4375 16.8125 10.25 16.625 10.25H5.375C5.14062 10.25 5 10.4375 5 10.625V11.375C5 11.6094 5.14062 11.75 5.375 11.75H16.625C16.8125 11.75 17 11.6094 17 11.375ZM9.5 15.875V15.125C9.5 14.9375 9.3125 14.75 9.125 14.75H5.375C5.14062 14.75 5 14.9375 5 15.125V15.875C5 16.1094 5.14062 16.25 5.375 16.25H9.125C9.3125 16.25 9.5 16.1094 9.5 15.875Z"
	    }
	  })]), _vm._v("\n      " + _vm._s(_vm.$t('index.title')) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "subtitle"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('index.subtitle')) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "search-flex"
	  }, [_c('label', {
	    staticClass: "hide"
	  }, [_c('input', {
	    attrs: {
	      "type": "text",
	      "name": "q",
	      "placeholder": _vm.$t('index.find_a_box')
	    }
	  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
	    staticClass: "kp-filter-action"
	  }, [_c('a', {
	    staticClass: "none-mobile pull-right kp-button",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.boxAdd()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-kp-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(_vm._s(_vm.$t('general.actions.new')) + "\n        ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "filter_search icon-search"
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-times",
	    attrs: {
	      "klickart-folder-search-cancel": ""
	    }
	  })])
	}]}

/***/ },
/* 805 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box",
	    on: {
	      "click": function($event) {
	        _vm.canvasDisableHighlight();
	        _vm.boxSetFormat(_vm.format);
	      }
	    }
	  }, [_c('div', {
	    staticClass: "box-image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.getImageUrl(_vm.format)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('div', {
	    staticClass: "box-title"
	  }, [_vm._t("title")], 2), _vm._v(" "), _c('span', {
	    staticClass: "box-text"
	  }, [_vm._t("description")], 2)])])
	},staticRenderFns: []}

/***/ },
/* 806 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('option-general', {
	    attrs: {
	      "value": "until_action",
	      "label": _vm.$t('edit.sidebar.until_action')
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 807 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "klickbox-edit-item": "general",
	      "klickbox-edit-label": _vm.$t('edit.canvas.general_styles')
	    }
	  }, [(_vm.boxConfig.progressbar.kind !== 'counter') ? _c('progress-bar') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kbx-content"
	  }, [(_vm.boxConfig.progressbar.kind === 'counter') ? _c('counter') : _vm._e(), _vm._v(" "), _c('title-preview'), _vm._v(" "), _c('description'), _vm._v(" "), (!_vm.stepActive.redirect_automatic) ? _c('button-redirect') : _vm._e()], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 808 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('range', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.width'),
	      "min": "100",
	      "max": "500",
	      "step": "1",
	      "value": _vm.value(),
	      "change": _vm.onChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 809 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "col-xs-4",
	    class: {
	      active: _vm.boxConfig.trigger_button.kind === 'naked'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'trigger_button',
	          key: 'kind',
	          value: 'naked'
	        })
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "kp-tab-label"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.button'))), _c('br'), _vm._v(_vm._s(_vm.$t('edit.sidebar.without_style')))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "kp-btn-action-lg-max",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-btn-naked"
	  })])
	}]}

/***/ },
/* 810 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "kbx-content",
	    attrs: {
	      "klickbox-edit-item": "progress",
	      "klickbox-edit-label": _vm.$t('edit.canvas.progressbar')
	    }
	  }, [_c('items')], 1)])
	},staticRenderFns: []}

/***/ },
/* 811 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('option-general', {
	    attrs: {
	      "value": "immediately",
	      "label": _vm.$t('edit.sidebar.immediately_when_access')
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 812 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "kp-modular-menu"
	  }, [_c('logo'), _vm._v(" "), _c('steps'), _vm._v(" "), _c('model'), _vm._v(" "), _c('button-style'), _vm._v(" "), _c('advanced-config'), _vm._v(" "), _c('span', {
	    staticClass: "sidebar_notify__icon",
	    class: {
	      'notify_topbar_active': _vm.topBarConfig.user.ucode,
	      'is-loading': _vm.isLoading
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "sidebar_notify__label"
	  }, [_vm._v(_vm._s(_vm.isLoading ? _vm.$t('general.labels.saving') : 'OK'))])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "klickart-loader-container"
	  }, [_c('div', {
	    staticClass: "klickart-loader"
	  })])
	}]}

/***/ },
/* 813 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-nav-left"
	  }, [_c('div', {
	    staticClass: "kp-modular-name"
	  }, [_c('input', {
	    staticClass: "kp-modular-name-txt",
	    attrs: {
	      "type": "text",
	      "required": ""
	    },
	    domProps: {
	      "value": _vm.name
	    },
	    on: {
	      "change": function($event) {
	        return _vm.boxSetName($event)
	      }
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('general.labels.box_name')))])])])
	},staticRenderFns: []}

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box",
	    on: {
	      "click": function($event) {
	        _vm.boxUpdateConfig({
	          item: 'advanced',
	          key: 'view_mode',
	          value: 'automatic'
	        });
	        _vm.sidebarChangePanel('themes')
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('div', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.auto')))]), _vm._v(" "), _c('span', {
	    staticClass: "box-text"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.at_some_point')))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-image"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(559),
	      "alt": ""
	    }
	  })])
	}]}

/***/ },
/* 815 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('select', {
	    class: 'ql-' + _vm.type
	  }, _vm._l((_vm.pallete), function(color) {
	    return _c('option', {
	      domProps: {
	        "value": color
	      }
	    })
	  }), 0)
	},staticRenderFns: []}

/***/ },
/* 816 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.formHtml) ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.formHtml)
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 817 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "klickbox-step-text-edit"
	  }, [(_vm.step.text_size === 'long') ? _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.placeholderText),
	      expression: "placeholderText"
	    }],
	    staticClass: "klickbox-step-input-edit",
	    attrs: {
	      "rows": "5"
	    },
	    domProps: {
	      "value": (_vm.placeholderText)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateTextPlaceholder({
	          placeholderText: $event.target.value,
	          id: _vm.step.id
	        })
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.placeholderText = $event.target.value
	      }
	    }
	  }) : _c('input', {
	    staticClass: "klickbox-step-input-edit",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.placeholderText
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateTextPlaceholder({
	          placeholderText: $event.target.value,
	          id: _vm.step.id
	        })
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 818 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-label kp-label-step"
	  }, [_vm._v("\n  " + _vm._s(_vm.$t('edit.canvas.you_are_editing')) + " "), _c('span', {
	    staticClass: "kp-label-id"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.step')) + " " + _vm._s(_vm.step.position + 1))])])
	},staticRenderFns: []}

/***/ },
/* 819 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "kp-select-open",
	    attrs: {
	      "href": "javascript:;",
	      "title": "Exportar"
	    },
	    on: {
	      "click": function($event) {
	        _vm.modalOpen('code');
	        _vm.codeSetupBox(_vm.box)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-import"
	  }), _vm._v(_vm._s(_vm.$t('general.actions.export')) + "\n")])
	},staticRenderFns: []}

/***/ },
/* 820 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "kp-list-item"
	  }, [_c('div', {
	    staticClass: "kp-folder-name"
	  }, [_c('input', {
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.box.name
	    },
	    on: {
	      "change": function($event) {
	        _vm.boxesSetName(({
	          event: $event,
	          id: _vm.box.id
	        }))
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "kp-folder-testab"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "kp-folder-updatedate"
	  }, [_c('locale-date', {
	    attrs: {
	      "date": _vm.box.updated_at
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "kp-folder-status"
	  }), _vm._v(" "), _c('button-delete', {
	    attrs: {
	      "box": _vm.box,
	      "index": _vm.index
	    }
	  }), _vm._v(" "), _c('button-edit', {
	    attrs: {
	      "box": _vm.box
	    }
	  }), _vm._v(" "), _c('button-report', {
	    attrs: {
	      "box": _vm.box
	    }
	  }), _vm._v(" "), _c('button-export', {
	    attrs: {
	      "box": _vm.box
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 821 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "kp-list-group submenu-no-padding",
	    attrs: {
	      "id": "klickbox-step-list"
	    }
	  }, [_c('draggable', {
	    attrs: {
	      "list": _vm.list,
	      "options": {
	        filter: '.nondraggable'
	      }
	    },
	    on: {
	      "end": function($event) {
	        return _vm.onDragEnd($event, _vm.list)
	      }
	    }
	  }, _vm._l((_vm.list), function(step, index) {
	    return _c('li', {
	      staticClass: "kp-list-group-item",
	      class: {
	        active: _vm.stepActive.id === step.id,
	        nondraggable: step.kind === 'thanks'
	      },
	      attrs: {
	        "draggable": "",
	        "id": step.id
	      },
	      on: {
	        "click": function($event) {
	          _vm.stepSetActive(step);
	          _vm.canvasChangeView('steps')
	        }
	      }
	    }, [(step.kind === 'thanks') ? _c('span', {
	      staticClass: "kp-list-num"
	    }, [_c('i', {
	      staticClass: "kp-panel-flag"
	    })]) : _vm._e(), _vm._v(" "), (step.kind === 'welcome') ? _c('span', {
	      staticClass: "kp-list-num"
	    }, [(step.welcome_active) ? _c('i', {
	      staticClass: "kp-panel-home"
	    }) : _c('i', {
	      staticClass: "fa fa-times",
	      staticStyle: {
	        "color": "#e74c3c",
	        "opacity": "0.2"
	      }
	    })]) : _vm._e(), _vm._v(" "), (step.kind != 'thanks' && step.kind != 'welcome') ? _c('span', {
	      staticClass: "kp-list-num"
	    }, [_vm._v("\n        " + _vm._s(_vm.stepDisplayPosition(step)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "kp-row",
	      class: 'kp-row-' + step.kind,
	      staticStyle: {
	        "float": "left",
	        "width": "219px"
	      }
	    }, [_c('span', {
	      staticClass: "kp-list-label"
	    }, [_c('step-icon', {
	      attrs: {
	        "step": step
	      }
	    }), _vm._v("\n          " + _vm._s(step.sanitized_title) + "\n        ")], 1), _vm._v(" "), (step.kind === 'welcome') ? _c('span', {
	      staticClass: "kp-list-text"
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('general.labels.first').toUpperCase()) + " " + _vm._s(_vm.$t('general.labels.step').toUpperCase()) + "\n        ")]) : _vm._e(), _vm._v(" "), (step.kind === 'thanks') ? _c('span', {
	      staticClass: "kp-list-text"
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('general.labels.last').toUpperCase()) + " " + _vm._s(_vm.$t('general.labels.step').toUpperCase()) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "klickbox-step-buttons",
	      staticStyle: {
	        "float": "left",
	        "width": "219px"
	      }
	    }, [_c('button-jump', {
	      attrs: {
	        "step": step
	      }
	    }), _vm._v(" "), _c('button-duplicate', {
	      attrs: {
	        "step": step
	      }
	    }), _vm._v(" "), _c('button-delete', {
	      attrs: {
	        "step": step
	      }
	    })], 1)])
	  }), 0)], 1)
	},staticRenderFns: []}

/***/ },
/* 822 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "kp-tab-edit"
	  }, [_c('basic-option'), _vm._v(" "), _c('naked-option'), _vm._v(" "), _c('external-option')], 1)
	},staticRenderFns: []}

/***/ },
/* 823 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('color-picker', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.border_color'),
	      "id": _vm.getId(),
	      "value": _vm.value(),
	      "change": _vm.onColorChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 824 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "klickbox-edit-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.next_button_text')))]), _vm._v(" "), _c('input', {
	    staticClass: "btn",
	    staticStyle: {
	      "padding-top": "25px",
	      "margin-top": "-20px"
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.step.next_button_text || _vm.$t('general.labels.next')
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateNextButtonText({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 825 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', _vm._l((_vm.editables), function(editable) {
	    return _c('div', {
	      staticClass: "kp-list-group-item clearfix"
	    }, [_c('label', {
	      staticClass: "kp-row box-title box-title__button",
	      on: {
	        "click": function($event) {
	          _vm.sidebarChangePanel('modifiers');
	          _vm.sidebarSetElement(editable)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(editable.getAttribute('klickbox-edit-label')) + "\n      "), _vm._m(0, true)]), _vm._v(" "), _c('span')])
	  }), 0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-right"
	  }, [_c('span', {
	    staticClass: "btn is-circular has-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  })])])
	}]}

/***/ },
/* 826 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.stepActive.text_size === 'long') ? _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.placeholderText),
	      expression: "placeholderText"
	    }],
	    staticClass: "klickbox-step-input-edit",
	    attrs: {
	      "rows": "5"
	    },
	    domProps: {
	      "value": (_vm.placeholderText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.placeholderText = $event.target.value
	      }
	    }
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 827 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-user"
	  }, [_c('div', {
	    staticClass: "kp-modular-nav"
	  }, [_c('name'), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-nav-right"
	  }, [_c('ul', {
	    staticClass: "kp-list-actions clearfix"
	  }, [_c('export'), _vm._v(" "), _c('publish')], 1)])], 1)])
	},staticRenderFns: []}

/***/ },
/* 828 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.step.kind !== 'thanks' && _vm.step.kind !== 'welcome') ? _c('button', {
	    staticClass: "klickbox-step-button danger",
	    on: {
	      "click": function($event) {
	        _vm.stepSetActive(_vm.step);
	        _vm.modalOpen('delete-step')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-kp-delete"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "step-subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 829 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('multiple-choice'), _vm._v(" "), _c('email'), _vm._v(" "), _c('redirect'), _vm._v(" "), _c('text-step'), _vm._v(" "), _c('welcome')], 1)
	},staticRenderFns: []}

/***/ },
/* 830 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "klickbox-edit-item": "general",
	      "klickbox-edit-label": _vm.$t('edit.canvas.general_styles')
	    }
	  }, [_c('div', {
	    staticClass: "kbx-content"
	  }, [_c('title-preview'), _vm._v(" "), _c('description')], 1)])])
	},staticRenderFns: []}

/***/ },
/* 831 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('select', {
	    staticClass: "klickart-select"
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": ""
	    }
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.go_to_next')))]), _vm._v(" "), _vm._l((_vm.stepInactiveList), function(step) {
	    return _c('option', {
	      domProps: {
	        "value": step.id,
	        "selected": step.id === _vm.selected
	      }
	    }, [_vm._v(_vm._s(((_vm.stepDisplayPosition(step)) + " - " + (step.sanitized_title))))])
	  })], 2)
	},staticRenderFns: []}

/***/ },
/* 832 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('li', {
	    staticClass: "active",
	    style: (_vm.getLiStyle()),
	    attrs: {
	      "klickbox-edit-item": "progress-bullet-active",
	      "klickbox-edit-item-dad": "progress",
	      "klickbox-edit-label": _vm.$t('edit.canvas.active_item')
	    }
	  }, [_c('span', {
	    staticClass: "kbx-subtitle",
	    style: (_vm.getSpanStyle()),
	    domProps: {
	      "innerHTML": _vm._s(_vm.getSVG())
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "kbx-number",
	    style: (_vm.getNumberStyle())
	  }, [_vm._v("2")])])])
	},staticRenderFns: []}

/***/ },
/* 833 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.jumpList.length === 1),
	      expression: "jumpList.length === 1"
	    }],
	    staticClass: "btn btn__green",
	    on: {
	      "click": function($event) {
	        return _vm.jumpAdd({
	          options_ids: []
	        })
	      }
	    }
	  }, [_c('div', [_c('i', {
	    staticClass: "kp-panel-jump"
	  }), _vm._v(" " + _vm._s(_vm.$t('edit.sidebar.add_jump')))])])
	},staticRenderFns: []}

/***/ },
/* 834 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.step.kind === 'welcome') ? _c('div', {
	    staticClass: "klickbox-edit-code"
	  }, [_c('div', [_c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label label__checkbox"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.welcome_buttons')))]), _vm._v(" "), _c('select', {
	    staticClass: "klickart-select",
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateWelcomeOption({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "yes-no"
	    },
	    domProps: {
	      "selected": _vm.step.welcome_option === 'yes-no'
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('edit.canvas.first_value_welcome_select')) + "\n        ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "start"
	    },
	    domProps: {
	      "selected": _vm.step.welcome_option === 'start'
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('edit.canvas.second_value_welcome_select')) + "\n        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label label__checkbox"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.welcome_active')))]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.step.welcome_active
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateWelcomeActive({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }), _vm._v(" "), _c('span')])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 835 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ul', {
	    staticClass: "kbx-content",
	    attrs: {
	      "klickbox-edit-item": "progress",
	      "klickbox-edit-label": _vm.$t('edit.canvas.progressbar')
	    }
	  }, [_c('item-done'), _vm._v(" "), _c('item-active'), _vm._v(" "), _c('item-default'), _vm._v(" "), _c('item-mask')], 1)])
	},staticRenderFns: []}

/***/ },
/* 836 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.modifier === 'display') ? _c('display', {
	    attrs: {
	      "general": _vm.general,
	      "item": _vm.item
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'backgroundColor') ? _c('background-color', {
	    attrs: {
	      "general": _vm.general,
	      "item": _vm.item
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'borderColor') ? _c('border-color', {
	    attrs: {
	      "general": _vm.general,
	      "item": _vm.item
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'borderRadius') ? _c('border-radius', {
	    attrs: {
	      "general": _vm.general,
	      "item": _vm.item
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'color' && _vm.general) ? _c('color', {
	    attrs: {
	      "general": _vm.general,
	      "item": _vm.item
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'fontFamily') ? _c('font-family', {
	    attrs: {
	      "general": _vm.general,
	      "item": _vm.item
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'fontSize') ? _c('font-size', {
	    attrs: {
	      "general": _vm.general,
	      "item": _vm.item
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'height') ? _c('height', {
	    attrs: {
	      "general": _vm.general,
	      "item": _vm.item
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'width') ? _c('width', {
	    attrs: {
	      "general": _vm.general,
	      "item": _vm.item
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 837 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('option-until-action'), _vm._v(" "), _c('option-times-until-action'), _vm._v(" "), _c('option-interval-until-action')], 1)
	},staticRenderFns: []}

/***/ },
/* 838 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sidebarCurrentPanel === 'exibitionfrequency'),
	      expression: "sidebarCurrentPanel === 'exibitionfrequency'"
	    }],
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.labels.configurations')) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "submenu-content sub-color"
	  }, [_c('advanced-config-header'), _vm._v(" "), _c('advanced-config-options'), _vm._v(" "), _c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.publishAndExport()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.publish')) + " " + _vm._s(_vm.$t('general.labels.and')) + " " + _vm._s(_vm.$t('general.actions.export')))])], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 839 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sidebarCurrentPanel === 'themes'),
	      expression: "sidebarCurrentPanel === 'themes'"
	    }],
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.themes')))]), _vm._v(" "), _c('div', {
	    staticClass: "submenu-content sub-color"
	  }, [_c('theme-header'), _vm._v(" "), _c('theme-list')], 1)])])
	},staticRenderFns: []}

/***/ },
/* 840 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('sidebar'), _vm._v(" "), _c('topbar'), _vm._v(" "), _c('edit'), _vm._v(" "), _c('modal-code'), _vm._v(" "), _c('modal-delete-step'), _vm._v(" "), _c('modal-duplicate-step')], 1)
	},staticRenderFns: []}

/***/ },
/* 841 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.modalVisible === 'duplicate-step') ? _c('layout-general', {
	    on: {
	      "close": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.duplicate')) + " " + _vm._s(_vm.$t('general.labels.step')))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('modal.duplicate_step.are_you_sure')))])]), _vm._v(" "), _c('div', [_c('p', {
	    staticClass: "help-block"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.actions.duplicate')) + "\n        "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.number),
	      expression: "number"
	    }],
	    staticClass: "klickart-select",
	    staticStyle: {
	      "width": "60px"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.number = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("6")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v("9")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("10")])]), _vm._v("\n        " + _vm._s(_vm.$t('general.labels.times')) + "\n      ")])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    on: {
	      "click": function($event) {
	        return _vm.stepDuplicate(_vm.number)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "txt"
	  }, [_vm._v(_vm._s(_vm.$t('modal.duplicate_step.yes')))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "txt"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 842 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('general-item', {
	    attrs: {
	      "format": "fullscreen"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.in_full_screen')))]), _vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "description"
	    },
	    slot: "description"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.one_screen_that_cover')))])])
	},staticRenderFns: []}

/***/ },
/* 843 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-section clearfix"
	  }, [(_vm.jumpList.length > 1) ? _c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.all_other_cases')))]) : _c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.always_jump_to')))]), _vm._v(" "), _c('step-jump-select', {
	    attrs: {
	      "jump": _vm.jump,
	      "selected": _vm.selected
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 844 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-label-aling"
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "range",
	      "min": _vm.min,
	      "max": _vm.max,
	      "step": _vm.step
	    },
	    domProps: {
	      "value": _vm.value
	    }
	  }), _vm._v(" "), _c('output', {
	    staticClass: "range-output"
	  }, [_vm._v(_vm._s(_vm.value))])])
	},staticRenderFns: []}

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.display_frequency')))]), _vm._v(" "), _c('div', {
	    staticClass: "box-description"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.when_box_should_display')))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-image"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(561),
	      "alt": ""
	    }
	  })])
	}]}

/***/ },
/* 846 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "kbx-counter",
	    attrs: {
	      "klickbox-edit-item": "counter",
	      "klickbox-edit-label": _vm.$t('edit.canvas.progressbar')
	    }
	  }, [_c('span', {
	    staticClass: "kbx-counter-label",
	    style: (_vm.getLabelStyle())
	  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
	    staticClass: "kbx-counter-pie",
	    attrs: {
	      "klickbox-edit-item-dad": "counter",
	      "klickbox-edit-item": "progress-bullet-done",
	      "klickbox-edit-label": _vm.$t('edit.canvas.active_item'),
	      "klickbox-edit-not-highlight": ""
	    }
	  }, [_c('div', {
	    staticClass: "left-side half-circle",
	    style: (_vm.getDoneStyle())
	  }), _vm._v(" "), _c('div', {
	    staticClass: "right-side half-circle",
	    style: (_vm.getDoneStyle())
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "kbx-counter-shadow",
	    style: (_vm.getDefaultStyle()),
	    attrs: {
	      "klickbox-edit-item-dad": "counter",
	      "klickbox-edit-item": "progress-bullet-default",
	      "klickbox-edit-label": _vm.$t('edit.canvas.default_item'),
	      "klickbox-edit-not-highlight": ""
	    }
	  })])])
	},staticRenderFns: []}

/***/ },
/* 847 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kbx-trigger-content"
	  }, [(_vm.boxConfig.trigger_button.kind === 'naked') ? _c('input', {
	    staticClass: "kbx-trigger-btn naked",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.boxConfig.trigger_button.text
	    },
	    on: {
	      "change": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'trigger_button',
	          key: 'text',
	          value: $event.target.value
	        })
	      }
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 848 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "klickbox-edit-item": "general",
	      "klickbox-edit-label": _vm.$t('edit.canvas.general_styles')
	    }
	  }, [(_vm.boxConfig.progressbar.kind !== 'counter') ? _c('progress-bar') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "kbx-content"
	  }, [(_vm.boxConfig.progressbar.kind === 'counter') ? _c('counter') : _vm._e(), _vm._v(" "), _c('title-preview'), _vm._v(" "), _c('description'), _vm._v(" "), _c('form-email')], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 849 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sidebarCurrentPanel === 'triggerbutton'),
	      expression: "sidebarCurrentPanel === 'triggerbutton'"
	    }],
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('edit.sidebar.call_button')) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "submenu-content sub-color"
	  }, [_c('header-config'), _vm._v(" "), _c('div', {
	    staticClass: "submenu-padding"
	  }, [_c('options-config'), _vm._v(" "), (_vm.boxConfig.trigger_button.kind === 'basic') ? _c('span', [_c('background-color-config'), _vm._v(" "), _c('text-color-config'), _vm._v(" "), _c('align-config'), _vm._v(" "), _c('font-size-config'), _vm._v(" "), _c('border-radius-config'), _vm._v(" "), _c('width-config'), _vm._v(" "), _c('height-config')], 1) : _vm._e()], 1)], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 850 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('i', {
	    class: {
	      'fa kp-panel-alternative': _vm.step.kind === 'multiple-choice',
	      'fa kp-panel-yes-no': _vm.step.kind === 'yes-no',
	      'fa kp-panel-register': _vm.step.kind === 'email',
	      'fa icon-kp-link': _vm.step.kind === 'redirect',
	      'fa kp-panel-text': _vm.step.kind === 'text'
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 851 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "kbx-text-editor"
	  }), _vm._v(" "), _c('toolbar')], 1)
	},staticRenderFns: []}

/***/ },
/* 852 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pager_buttons"
	  }, [_c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.page > 1),
	      expression: "page > 1"
	    }],
	    staticClass: "kp-button kp-button__min btn-blue",
	    on: {
	      "click": function($event) {
	        return _vm.reportPreviousPage()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.list.is_last_page),
	      expression: "!list.is_last_page"
	    }],
	    staticClass: "kp-button kp-button__min btn-blue pull-right",
	    on: {
	      "click": function($event) {
	        return _vm.reportNextPage()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])
	},staticRenderFns: []}

/***/ },
/* 853 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('option-general', {
	    attrs: {
	      "value": "interval_until_action",
	      "label": _vm.$t('edit.sidebar.interval_until_action')
	    }
	  }, [_c('div', {
	    staticClass: "box-input-group"
	  }, [_c('input', {
	    staticClass: "box-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": _vm.boxConfig.advanced.exibition_frequency_interval_value
	    },
	    on: {
	      "change": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'advanced',
	          key: 'exibition_frequency_interval_value',
	          value: $event.target.value
	        });
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box-input-group-label"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.days')))])])])
	},staticRenderFns: []}

/***/ },
/* 854 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.modalVisible === 'export-table') ? _c('layout-general', {
	    on: {
	      "close": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.export')) + " " + _vm._s(_vm.$t('modal.export_table.answer_table')))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('modal.export_table.insert')) + ":")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        return _vm.reportExport(_vm.email)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.actions.export')) + " " + _vm._s(_vm.$t('general.labels.table')) + "\n    ")])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 855 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('option-immediately'), _vm._v(" "), _c('option-time'), _vm._v(" "), _c('option-scroll'), _vm._v(" "), _c('option-exit')], 1)
	},staticRenderFns: []}

/***/ },
/* 856 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    class: 'ql-' + _vm.type,
	    attrs: {
	      "type": "button"
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 857 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "klickbox-auth-loader"
	  }, [_c('div', {
	    staticClass: "klickart-loader-container"
	  }, [_c('div', {
	    staticClass: "klickart-loader"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "klickbox-auth-label"
	  }, [_vm._v("Aguarde...")])])])
	}]}

/***/ },
/* 858 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v(_vm._s(_vm.parsedDate))])
	},staticRenderFns: []}

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box",
	    on: {
	      "click": function($event) {
	        _vm.boxUpdateConfig({
	          item: 'advanced',
	          key: 'view_mode',
	          value: 'click'
	        });
	        _vm.sidebarChangePanel('themes')
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('div', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.on_click')))]), _vm._v(" "), _c('span', {
	    staticClass: "box-text"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.on_click_some_button')))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-image"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(560),
	      "alt": ""
	    }
	  })])
	}]}

/***/ },
/* 860 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('li', {
	    style: (_vm.getLiStyle()),
	    attrs: {
	      "klickbox-edit-item": "progress-bullet-default",
	      "klickbox-edit-item-dad": "progress",
	      "klickbox-edit-label": _vm.$t('edit.canvas.default_item')
	    }
	  }, [_c('span', {
	    staticClass: "kbx-subtitle",
	    style: (_vm.getSpanStyle()),
	    domProps: {
	      "innerHTML": _vm._s(_vm.getSVG())
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "kbx-number",
	    style: (_vm.getNumberStyle())
	  }, [_vm._v("3")])])])
	},staticRenderFns: []}

/***/ },
/* 861 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.step.kind !== 'thanks' && _vm.step.kind !== 'welcome') ? _c('button', {
	    staticClass: "klickbox-step-button",
	    on: {
	      "click": function($event) {
	        _vm.stepSetActive(_vm.step);
	        _vm.modalOpen('duplicate-step')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-copy"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "step-subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.duplicate')))])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 862 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sidebarCurrentPanel === 'viewmode'),
	      expression: "sidebarCurrentPanel === 'viewmode'"
	    }],
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.themes')))]), _vm._v(" "), _c('div', {
	    staticClass: "submenu-content sub-color"
	  }, [_c('type-header'), _vm._v(" "), _c('viewmode-automatic'), _vm._v(" "), _c('viewmode-click')], 1)])])
	},staticRenderFns: []}

/***/ },
/* 863 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('footer', {
	    staticClass: "kbx-form-footer"
	  }, [_c('a', {
	    staticClass: "kbx-btn",
	    style: (_vm.stepStyle('welcome-button-positive')),
	    attrs: {
	      "klickbox-edit-item": "welcome-button-positive",
	      "klickbox-edit-label": _vm.$t('edit.canvas.positive_button')
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.stepPreview.options[0].label) + "\n    ")]), _vm._v(" "), (_vm.stepPreview.welcome_option === 'yes-no') ? _c('a', {
	    staticClass: "kbx-btn",
	    style: (_vm.stepStyle('welcome-button-negative')),
	    attrs: {
	      "klickbox-edit-item": "welcome-button-negative",
	      "klickbox-edit-label": _vm.$t('edit.canvas.negative_button')
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.stepPreview.options[1].label) + "\n    ")]) : _vm._e()])])
	},staticRenderFns: []}

/***/ },
/* 864 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.step.kind === 'multiple-choice' || _vm.step.kind === 'yes-no' || _vm.step.kind === 'welcome') ? _c('button', {
	    staticClass: "klickbox-step-button",
	    on: {
	      "click": function($event) {
	        _vm.stepSetActive(_vm.step);
	        _vm.sidebarChangePanel('jump')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-jump-o"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.jumpCount(_vm.step.jumps)),
	      expression: "jumpCount(step.jumps)"
	    }],
	    staticClass: "badge"
	  }, [_vm._v(_vm._s(_vm.jumpCount(_vm.step.jumps)))]), _vm._v(" "), _c('span', {
	    staticClass: "step-subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.destinations')))])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 865 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "box-preview-toolbar-button",
	    class: _vm.activeButton(_vm.device),
	    on: {
	      "click": function($event) {
	        return _vm.updateDevice(_vm.device);
	      }
	    }
	  }, [_c('i', {
	    class: 'kp-panel-' + _vm.icons[_vm.device]
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.device))])])
	},staticRenderFns: []}

/***/ },
/* 866 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', {
	    staticClass: "kbx-title",
	    style: (_vm.stepStyle('welcome-title')),
	    attrs: {
	      "klickbox-edit-item": "welcome-title",
	      "klickbox-edit-label": _vm.$t('edit.canvas.welcome_title')
	    }
	  }, [_c('text-editor', {
	    attrs: {
	      "content": _vm.stepPreview.title,
	      "change": _vm.onChange,
	      "toolbar": true,
	      "placeholder": _vm.$t('edit.canvas.welcome_title')
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 867 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "item",
	    attrs: {
	      "title": "Exportar"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.modalOpen('code');
	        _vm.codeSetupBox(_vm.boxActive)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-import"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "txt"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.export')))])])])
	},staticRenderFns: []}

/***/ },
/* 868 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "col-xs-4",
	    class: {
	      active: _vm.boxConfig.trigger_button.kind === 'external'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'trigger_button',
	          key: 'kind',
	          value: 'external'
	        })
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "kp-tab-label"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.button'))), _c('br'), _vm._v(_vm._s(_vm.$t('general.labels.external')))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "kp-btn-action-lg-mid",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  })])
	}]}

/***/ },
/* 869 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "klickbox-list clearfix"
	  }, [_c('div', {
	    staticClass: "container no-padding"
	  }, [_c('list-header'), _vm._v(" "), (_vm.boxes.length > 0) ? _c('ul', {
	    staticClass: "kp-list-item"
	  }, _vm._l((_vm.boxes), function(box, index) {
	    return _c('item', {
	      attrs: {
	        "box": box,
	        "index": index
	      }
	    })
	  }), 1) : _c('empty')], 1)])
	},staticRenderFns: []}

/***/ },
/* 870 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "kp-btn-action-sm kp-btn__danger",
	    on: {
	      "click": function($event) {
	        return _vm.jumpRemove({
	          id: _vm.jumpId,
	          index: _vm.index
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })])
	},staticRenderFns: []}

/***/ },
/* 871 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-preview-toolbar-container"
	  }, [_c('span', {
	    staticClass: "box-preview-toolbar-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.visualizing')) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "box-preview-toolbar"
	  }, [_c('device-button', {
	    attrs: {
	      "device": "desktop"
	    }
	  }), _vm._v(" "), _c('device-button', {
	    attrs: {
	      "device": "tablet"
	    }
	  }), _vm._v(" "), _c('device-button', {
	    attrs: {
	      "device": "smartphone"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 872 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sidebarCurrentPanel === 'exibitionmode'),
	      expression: "sidebarCurrentPanel === 'exibitionmode'"
	    }],
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.labels.configurations')) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "submenu-content sub-color"
	  }, [_c('advanced-config-header'), _vm._v(" "), _c('advanced-config-options'), _vm._v(" "), _c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sidebarChangePanel('exibitionfrequency');
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.next')))])], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 873 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-no-page"
	  }, [_c('div', {
	    staticClass: "no-page-content"
	  }, [_c('div', {
	    staticClass: "empty_state_logo"
	  }, [_c('svg', {
	    staticClass: "empty_state_svg",
	    attrs: {
	      "width": "28",
	      "height": "28",
	      "viewBox": "0 0 28 28",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M28 25V3C28 1.375 26.625 0 25 0H3C1.3125 0 0 1.375 0 3V25C0 26.6875 1.3125 28 3 28H25C26.625 28 28 26.6875 28 25ZM3 26C2.4375 26 2 25.5625 2 25V3C2 2.5 2.4375 2 3 2H25C25.5 2 26 2.5 26 3V25C26 25.5625 25.5 26 25 26H3ZM16 8.5V7.5C16 7.25 15.75 7 15.5 7H6.5C6.1875 7 6 7.25 6 7.5V8.5C6 8.8125 6.1875 9 6.5 9H15.5C15.75 9 16 8.8125 16 8.5ZM22 14.5V13.5C22 13.25 21.75 13 21.5 13H6.5C6.1875 13 6 13.25 6 13.5V14.5C6 14.8125 6.1875 15 6.5 15H21.5C21.75 15 22 14.8125 22 14.5ZM12 20.5V19.5C12 19.25 11.75 19 11.5 19H6.5C6.1875 19 6 19.25 6 19.5V20.5C6 20.8125 6.1875 21 6.5 21H11.5C11.75 21 12 20.8125 12 20.5Z",
	      "fill": "#464B52"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "empty_state_text-content"
	  }, [_c('div', {
	    staticClass: "empty_state_title"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('empty.title')))])]), _vm._v(" "), _c('div', {
	    staticClass: "empty_state_subtitle"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('empty.subtitle')))])])]), _vm._v(" "), (_vm.topBarConfig.user.ucode === true) ? _c('a', {
	    staticClass: "empty_state_link",
	    attrs: {
	      "href": _vm.$t('empty.urlExtensions')
	    }
	  }, [_vm._v(_vm._s(_vm.$t('empty.link'))), _c('span', {
	    staticClass: "icon-kp-external"
	  })]) : _c('a', {
	    staticClass: "empty_state_link",
	    attrs: {
	      "href": _vm.$t('empty.url')
	    }
	  }, [_vm._v(_vm._s(_vm.$t('empty.link'))), _c('span', {
	    staticClass: "icon-kp-external"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "empty-btn"
	  }, [_c('a', {
	    staticClass: "empty_state_button",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.boxAdd()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('empty.button')))])])])])
	},staticRenderFns: []}

/***/ },
/* 874 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.sidebarCurrentPanel === 'jump') ? _c('section', {
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab shadow-tab"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_c('a', {
	    staticClass: "klickart-element-back-button",
	    attrs: {
	      "href": "javascript:;",
	      "title": _vm.$t('general.actions.back')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sidebarChangePanel('steps');
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-left"
	  })]), _vm._v("\n      " + _vm._s(_vm.$t('general.labels.destinations')) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "submenu-content sub-color"
	  }, [_c('ul', {
	    staticClass: "submenu-no-padding scroll-person",
	    attrs: {
	      "id": "klickbox-step-list"
	    }
	  }, [_c('li', {
	    staticClass: "kp-list-group-item"
	  }, [_c('div', {
	    staticClass: "kp-row"
	  }, [_c('span', [_c('step-icon', {
	    attrs: {
	      "step": _vm.stepActive
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.stepActive.sanitized_title) + "\n            ")], 1)])]), _vm._v(" "), _vm._l((_vm.jumpList), function(jump, index) {
	    return _c('li', {
	      staticClass: "submenu-padding"
	    }, [_c('add-first-button'), _vm._v(" "), (jump.options_ids) ? _c('div', [_c('jump-header', {
	      attrs: {
	        "index": index,
	        "jump-id": jump.id
	      }
	    }), _vm._v(" "), (_vm.stepActive.multiple_answers) ? _c('multiple-answer-select', {
	      attrs: {
	        "jump": jump
	      }
	    }) : _c('single-answer-select', {
	      attrs: {
	        "jump": jump
	      }
	    }), _vm._v(" "), _c('destiny-select', {
	      attrs: {
	        "selected": jump.destination_step_id,
	        "jump": jump
	      }
	    })], 1) : _c('exception-select', {
	      attrs: {
	        "selected": jump.destination_step_id,
	        "jump": jump
	      }
	    })], 1)
	  })], 2)])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 875 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('range', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.height'),
	      "min": "50",
	      "max": "150",
	      "step": "1",
	      "value": _vm.value(),
	      "change": _vm.onChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 876 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.step.kind === 'email') ? _c('div', {
	    staticClass: "klickbox-edit-code clearfix"
	  }, [_c('div', {
	    staticClass: "klickbox-edit-col"
	  }, [_c('div', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.mail_service')))]), _vm._v(" "), _c('textarea', {
	    staticClass: "klickbox-code-input klickbox-code__area",
	    attrs: {
	      "id": "kp-import-form-input",
	      "placeholder": _vm.$t('edit.canvas.mail_service_text_area')
	    },
	    domProps: {
	      "value": _vm.orginalForm
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateFormHtml({
	          html: $event.target.value,
	          id: _vm.step.id,
	          customizedForm: _vm.customizedForm
	        })
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "klickbox-edit-col"
	  }, [_c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.custom_html_form')))]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-check kp-modular-check-without-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.step.customized_form
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateCustomizedForm({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }), _c('span')])]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.redirect_by_mail_service')))]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-check kp-modular-check-without-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.step.redirect_email_service
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateRedirectEmailService({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }), _c('span')])]), _vm._v(" "), _c('exception-select', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.redirect),
	      expression: "!redirect"
	    }],
	    attrs: {
	      "selected": _vm.jump[0].destination_step_id,
	      "jump": _vm.jump[0]
	    }
	  })], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 877 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table_content"
	  }, [_c('pagination-buttons'), _vm._v(" "), _c('table', {
	    staticClass: "table_bordered"
	  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('report.individual.answered_in')) + ":")]), _vm._v(" "), _vm._l((_vm.list.steps), function(step) {
	    return _c('th', [_vm._v(_vm._s(step.sanitized_title))])
	  })], 2), _vm._v(" "), _vm._l((_vm.list.submissions), function(submission) {
	    return _c('tr', [_c('td', [_c('locale-date', {
	      attrs: {
	        "date": submission.created_at
	      }
	    })], 1), _vm._v(" "), _vm._l((_vm.list.steps), function(step) {
	      return _c('td', [_c('span', {
	        domProps: {
	          "innerHTML": _vm._s(_vm.parseResponses(_vm.groupedAnswers(submission.answers, step.id)))
	        }
	      })])
	    })], 2)
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "search-list-container"
	  }, [_c('div', {
	    staticClass: "klickart-loader-container",
	    class: {
	      'is-visible': _vm.isLoading
	    },
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "klickart-loader"
	  })])])], 1)
	},staticRenderFns: []}

/***/ },
/* 878 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box__selected"
	  }, [_c('div', [_c('div', {
	    staticClass: "box-title box-title__theme"
	  }, [_vm._v("\n      " + _vm._s(_vm.getElementLabel()) + "\n    ")]), _vm._v(" "), _c('a', {
	    staticClass: "box-back",
	    on: {
	      "click": function($event) {
	        return _vm.sidebarChangePanel('style')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-left"
	  }), _vm._v(" " + _vm._s(_vm.$t('general.actions.back')) + "\n    ")])])])
	},staticRenderFns: []}

/***/ },
/* 879 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._l((_vm.step.options), function(option, index) {
	    return (_vm.step.welcome_option === 'yes-no') ? _c('div', [(index === 0) ? _c('div', {
	      staticClass: "klickbox-edit-title"
	    }, [_vm._v(_vm._s(_vm.$t('edit.canvas.positive_button_text')))]) : _c('div', {
	      staticClass: "klickbox-edit-title"
	    }, [_vm._v(_vm._s(_vm.$t('edit.canvas.negative_button_text')))]), _vm._v(" "), _c('input', {
	      staticClass: "btn",
	      staticStyle: {
	        "padding-top": "25px",
	        "margin-top": "-20px"
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": option.label
	      },
	      on: {
	        "change": function($event) {
	          return _vm.optionUpdateText({
	            event: $event,
	            id: option.id
	          })
	        }
	      }
	    })]) : _vm._e()
	  }), _vm._v(" "), (_vm.step.welcome_option === 'start') ? _c('div', [_c('div', {
	    staticClass: "klickbox-edit-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.start_button_text')))]), _vm._v(" "), _c('input', {
	    staticClass: "btn",
	    staticStyle: {
	      "padding-top": "25px",
	      "margin-top": "-20px"
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.step.options[0].label
	    },
	    on: {
	      "change": function($event) {
	        return _vm.optionUpdateText({
	          event: $event,
	          id: _vm.step.options[0].id
	        })
	      }
	    }
	  })]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ },
/* 880 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "kp-btn-action-sm kp-btn__success",
	    on: {
	      "click": function($event) {
	        return _vm.jumpAdd({
	          options_ids: []
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])
	},staticRenderFns: []}

/***/ },
/* 881 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-check kp-modular-check-without-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.step.description_visibility
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepChangeDescriptionVisibity({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }), _c('span')])
	},staticRenderFns: []}

/***/ },
/* 882 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content_pages",
	    attrs: {
	      "id": "report-metrics"
	    }
	  }, [_c('div', {
	    staticClass: "table_info clearfix"
	  }, [_c('div', {
	    staticClass: "table_info-col"
	  }, [_c('div', {
	    staticClass: "table_info-title"
	  }, [_vm._v(_vm._s(_vm.$t('report.metrics.total_visits')))]), _vm._v(" "), _c('div', {
	    staticClass: "table_info-number"
	  }, [_vm._v(_vm._s(_vm.metrics.box_hits))])]), _vm._v(" "), _c('div', {
	    staticClass: "table_info-col"
	  }, [_c('div', {
	    staticClass: "table_info-title"
	  }, [_vm._v(_vm._s(_vm.$t('report.metrics.quizzes_completed')))]), _vm._v(" "), _c('div', {
	    staticClass: "table_info-number"
	  }, [_vm._v(_vm._s(_vm.metrics.completed_submissions_count))])]), _vm._v(" "), _c('div', {
	    staticClass: "table_info-col"
	  }, [_c('div', {
	    staticClass: "table_info-title"
	  }, [_vm._v(_vm._s(_vm.$t('report.metrics.completion_rate')))]), _vm._v(" "), _c('div', {
	    staticClass: "table_info-number"
	  }, [_vm._v(_vm._s(_vm.metrics.conclusion_rate))])]), _vm._v(" "), _c('div', {
	    staticClass: "table_info-col"
	  }, [_c('div', {
	    staticClass: "table_info-title"
	  }, [_vm._v(_vm._s(_vm.$t('report.metrics.average_time_to_complete')))]), _vm._v(" "), _c('div', {
	    staticClass: "table_info-number"
	  }, [_vm._v(_vm._s(_vm.metrics.conclusion_average_time))])])]), _vm._v(" "), _c('ul', {
	    staticClass: "table_collumns"
	  }, [_c('Device', {
	    attrs: {
	      "metric": _vm.devicesMetrics('desktop'),
	      "banner": "kp-panel-pc",
	      "title": _vm.$t('report.metrics.desktop')
	    }
	  }), _vm._v(" "), _c('Device', {
	    attrs: {
	      "metric": _vm.devicesMetrics('tablet'),
	      "banner": "kp-panel-tablet",
	      "title": _vm.$t('report.metrics.tablet')
	    }
	  }), _vm._v(" "), _c('Device', {
	    attrs: {
	      "metric": _vm.devicesMetrics('mobile'),
	      "banner": "kp-panel-mobile",
	      "title": _vm.$t('report.metrics.mobile')
	    }
	  }), _vm._v(" "), _c('Device', {
	    attrs: {
	      "metric": _vm.devicesMetrics('others'),
	      "banner": "kp-panel-others",
	      "title": _vm.$t('report.metrics.others')
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 883 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-folder-table-title"
	  }, [_c('div', {
	    staticClass: "kp-folder-name"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.box_name')))])]), _vm._v(" "), _c('div', {
	    staticClass: "kp-folder-testab"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('index.list_header.modality')))])]), _vm._v(" "), _c('div', {
	    staticClass: "kp-folder-updatedate"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('index.list_header.last_modification')))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-desc"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "kp-folder-status"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.status')))])]), _vm._v(" "), _c('div', {
	    staticClass: "kp-folder-actions"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.actions')))])])
	},staticRenderFns: []}

/***/ },
/* 884 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "klickbox-edit-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.button_text')))]), _vm._v(" "), (!_vm.step.redirect_automatic) ? _c('input', {
	    staticClass: "btn",
	    staticStyle: {
	      "padding-top": "25px",
	      "margin-top": "-20px"
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.step.redirect_button_text
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateRedirectButtonText({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 885 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "btn btn__green",
	    on: {
	      "click": function($event) {
	        return _vm.jumpAddOptionId({
	          jump: _vm.jump
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" " + _vm._s(_vm.$t('edit.sidebar.add_answer')))])
	},staticRenderFns: []}

/***/ },
/* 886 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('color-picker', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.text_color'),
	      "id": "triggerButtonTextColor",
	      "value": _vm.boxConfig.trigger_button.style.color,
	      "change": _vm.onColorChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 887 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._l((_vm.step.options), function(option, index) {
	    return _c('div', {
	      staticClass: "klickbox-step-options"
	    }, [_c('label', [_c('input', {
	      attrs: {
	        "disabled": "",
	        "type": [_vm.step.multiple_answers ? 'checkbox' : 'radio'],
	        "name": _vm.step.id
	      },
	      domProps: {
	        "value": option.label
	      }
	    }), _vm._v(" "), _c('input', {
	      staticClass: "klickbox-step-input-edit",
	      class: {
	        'klickbox-step-input-other': option.other
	      },
	      attrs: {
	        "type": "text",
	        "placeholder": _vm.$t('edit.canvas.multiple_choice_placeholder')
	      },
	      domProps: {
	        "value": option.label
	      },
	      on: {
	        "change": function($event) {
	          return _vm.optionUpdateText({
	            event: $event,
	            id: option.id
	          })
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "klickbox-step-bar"
	    })]), _vm._v(" "), (!option.other && _vm.step.kind !== 'yes-no') ? _c('div', {
	      staticClass: "klickbox-step-remove-option",
	      on: {
	        "click": function($event) {
	          return _vm.optionRemove({
	            id: option.id,
	            index: index
	          })
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times"
	    })]) : _vm._e()])
	  }), _vm._v(" "), (_vm.step.kind === 'multiple-choice') ? _c('div', {
	    staticClass: "klickbox-step-options"
	  }, [_c('label', {
	    staticClass: "klickbox-step-add-option",
	    on: {
	      "click": function($event) {
	        return _vm.optionAdd({
	          other: false
	        })
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": [_vm.step.multiple_answers ? 'checkbox' : 'radio'],
	      "disabled": ""
	    }
	  }), _vm._v("\n      " + _vm._s(_vm.$t('edit.canvas.add_option')) + "\n      ")])]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ },
/* 888 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "kp-select-open",
	    attrs: {
	      "to": {
	        name: 'boxReportsMetrics',
	        params: {
	          locale: _vm.i18n.locale,
	          boxId: _vm.box.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bar-chart"
	  }), _vm._v(_vm._s(_vm.$t('general.actions.report')) + "\n")])
	},staticRenderFns: []}

/***/ },
/* 889 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-row"
	  }, [_c('span', [_c('i', {
	    staticClass: "kp-panel-jump"
	  }), _vm._v(_vm._s(_vm.$t('general.labels.jump')))]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('add-button'), _vm._v(" "), _c('remove-button', {
	    attrs: {
	      "index": _vm.index,
	      "jump-id": _vm.jumpId
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 890 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "kbx-progress",
	    style: (_vm.getStyle()),
	    attrs: {
	      "klickbox-edit-item": "progress-bar-default",
	      "klickbox-edit-item-dad": "progress",
	      "klickbox-edit-label": _vm.$t('edit.canvas.default_item')
	    }
	  }, [_c('item-done'), _vm._v(" "), _c('item-active')], 1)])
	},staticRenderFns: []}

/***/ },
/* 891 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "klickbox-edit-item": "option",
	      "klickbox-edit-label": _vm.$t('edit.canvas.answer_options')
	    },
	    on: {
	      "mouseenter": function($event) {
	        return _vm.canvasEnableHighlight({
	          event: $event
	        })
	      }
	    }
	  }, _vm._l((_vm.stepPreview.options), function(option) {
	    return _c('div', {
	      staticClass: "kbx-form"
	    }, [_c('label', {
	      class: [_vm.stepPreview.multiple_answers ? 'kbx-checkbox' : 'kbx-radio'],
	      style: (_vm.stepStyle('option'))
	    }, [_c('input', {
	      attrs: {
	        "type": [_vm.stepPreview.multiple_answers ? 'checkbox' : 'radio'],
	        "name": "example"
	      }
	    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.label))])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ },
/* 892 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    staticClass: "kbx-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.placeholderText
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 893 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('color-picker', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.background_color'),
	      "id": "triggerButtonBgColor",
	      "value": _vm.boxConfig.trigger_button.style.backgroundColor,
	      "change": _vm.onColorChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 894 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn__copy",
	    attrs: {
	      "data-clipboard-text": _vm.text
	    }
	  }, [_c('span', {
	    staticClass: "txt"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))]), _vm._v(" "), _c('span', {
	    staticClass: "txt-active"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.copied')) + "!")])])
	},staticRenderFns: []}

/***/ },
/* 895 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('general-item', {
	    attrs: {
	      "format": "slider"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.in_a_slider')))]), _vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "description"
	    },
	    slot: "description"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.one_screen_apper_right')))])])
	},staticRenderFns: []}

/***/ },
/* 896 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('general-item', {
	    attrs: {
	      "format": "popup"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.in_a_popup')))]), _vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "description"
	    },
	    slot: "description"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.one_box_apper_in_the_middle')))])])
	},staticRenderFns: []}

/***/ },
/* 897 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('general-item', {
	    attrs: {
	      "format": "minislide"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.in_mini_slider')))]), _vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "description"
	    },
	    slot: "description"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.one_small_window_apper')))])])
	},staticRenderFns: []}

/***/ },
/* 898 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-label-aling"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.alignment')))]), _vm._v(" "), _c('select', {
	    staticClass: "klickart-select"
	  }, [_c('option', {
	    attrs: {
	      "value": "none"
	    },
	    domProps: {
	      "selected": _vm.value() === 'none'
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.center')))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "left"
	    },
	    domProps: {
	      "selected": _vm.value() === 'left'
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.left')))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "right"
	    },
	    domProps: {
	      "selected": _vm.value() === 'right'
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.right')))])])])
	},staticRenderFns: []}

/***/ },
/* 899 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "kp-select-open mobile-hide",
	    attrs: {
	      "to": {
	        name: 'boxEdit',
	        params: {
	          locale: _vm.i18n.locale,
	          boxId: _vm.box.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-kp-edit"
	  }), _vm._v(_vm._s(_vm.$t('general.actions.edit')) + "\n")])
	},staticRenderFns: []}

/***/ },
/* 900 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.when_might_show')))]), _vm._v(" "), _c('div', {
	    staticClass: "box-description"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_when_box_should_apper')))])])
	},staticRenderFns: []}

/***/ },
/* 901 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "kp-select-open",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.boxSetActive(_vm.box);
	        _vm.modalOpen('delete-box')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-kp-delete"
	  }), _vm._v(_vm._s(_vm.$t('general.actions.delete')) + "\n")])
	},staticRenderFns: []}

/***/ },
/* 902 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.boxConfig.trigger_button.kind === 'external') ? _c('div', {
	    staticClass: "klick-modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('i', {
	    staticClass: "fa fa-info-circle",
	    staticStyle: {
	      "font-size": "30px",
	      "color": "#6B8A99"
	    }
	  }), _vm._v(" "), _c('h4', {
	    staticStyle: {
	      "color": "#6B8A99",
	      "font-weight": "bold",
	      "margin-top": "16px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.external_button')))])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.labels.step')) + " 1:")]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.click_button')) + " "), _c('b', [_vm._v(_vm._s(_vm.$t('general.actions.export')) + " "), _c('i', {
	    staticClass: "kp-panel-import"
	  })]), _vm._v(".")])]), _vm._v(" "), _c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.labels.step')) + " 2:")]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.copy_the')) + " "), _c('b', [_vm._v(_vm._s(_vm.$t('edit.canvas.box_code')))]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.past_in_your_page')) + ".")])]), _vm._v(" "), _c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.labels.step')) + " 3:")]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.copy_the')) + " "), _c('b', [_vm._v(_vm._s(_vm.$t('edit.canvas.call_button_code')))]), _vm._v(" " + _vm._s(_vm.$t('edit.canvas.add_to_link_or_button')) + ".")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  })])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 903 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('basic-button'), _vm._v(" "), _c('naked-button'), _vm._v(" "), _c('external-button')], 1)
	},staticRenderFns: []}

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.exibition_mode')))]), _vm._v(" "), _c('div', {
	    staticClass: "box-description"
	  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.how_box_should_display')))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-image"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(562),
	      "alt": ""
	    }
	  })])
	}]}

/***/ },
/* 905 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "kbx-form-footer"
	  }, [_c('a', {
	    staticClass: "kbx-btn",
	    staticStyle: {
	      "min-width": "100px"
	    },
	    style: (_vm.stepStyle('button')),
	    attrs: {
	      "klickbox-edit-item": "button",
	      "klickbox-edit-label": _vm.$t('edit.canvas.redirect_button')
	    }
	  }, [_vm._v(_vm._s(_vm.stepPreview.redirect_button_text))])])
	},staticRenderFns: []}

/***/ },
/* 906 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "kbx-form-footer"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showButton()),
	      expression: "showButton()"
	    }],
	    staticClass: "kbx-btn",
	    staticStyle: {
	      "min-width": "100px",
	      "overflow": "visible"
	    },
	    style: (_vm.stepStyle('button')),
	    attrs: {
	      "klickbox-edit-item": "button",
	      "klickbox-edit-label": "Botão Próximo",
	      "klickbox-edit-label": _vm.$t('edit.canvas.next_button'),
	      "klickbox-internal-style": "kbx-btn-submit-form"
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.stepPreview.next_button_text || _vm.$t('general.labels.next')) + "\n  ")])])
	},staticRenderFns: []}

/***/ },
/* 907 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.step.kind === 'text') ? _c('div', {
	    staticClass: "klickbox-edit-code"
	  }, [_c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label label__checkbox"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.required_response')))]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.step.required
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateTextRequired({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label label__checkbox"
	  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.multiline_response')))]), _vm._v(" "), _c('div', {
	    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.step.text_size === 'long'
	    },
	    on: {
	      "change": function($event) {
	        return _vm.stepUpdateTextSize({
	          event: $event,
	          id: _vm.step.id
	        })
	      }
	    }
	  }), _vm._v(" "), _c('span')])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 908 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box box__selected"
	  }, [_c('div', [_c('div', {
	    staticClass: "box-title box-title__theme"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('edit.sidebar.call_button_style')) + "\n    ")]), _vm._v(" "), _c('a', {
	    staticClass: "box-back",
	    on: {
	      "click": function($event) {
	        _vm.sidebarChangePanel('style');
	        _vm.canvasChangeView('preview')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-left"
	  }), _vm._v(" " + _vm._s(_vm.$t('general.actions.back')) + "\n    ")])])])
	},staticRenderFns: []}

/***/ },
/* 909 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('range', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.width'),
	      "min": "100",
	      "max": "500",
	      "step": "1",
	      "value": _vm.value(),
	      "change": _vm.onChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 910 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box box__selected"
	  }, [_c('a', {
	    staticClass: "box-back has-icon--left",
	    on: {
	      "click": function($event) {
	        return _vm.sidebarChangePanel('types')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-left"
	  }), _vm._v(" " + _vm._s(_vm.$t('edit.sidebar.format')) + "\n    ")])])])
	},staticRenderFns: []}

/***/ },
/* 911 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('option-general', {
	    attrs: {
	      "value": "scroll",
	      "label": _vm.$t('edit.sidebar.on_scroll')
	    }
	  }, [_c('div', [_c('select', {
	    staticClass: "klickart-select",
	    on: {
	      "change": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'advanced',
	          key: 'exibition_mode_scroll_value',
	          value: $event.target.value
	        });
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "25"
	    },
	    domProps: {
	      "selected": _vm.boxConfig.advanced.exibition_mode_scroll_value === '25'
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('edit.sidebar.until_page_top')) + "\n      ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "50"
	    },
	    domProps: {
	      "selected": _vm.boxConfig.advanced.exibition_mode_scroll_value === '50'
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('edit.sidebar.until_page_middle')) + "\n      ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "75"
	    },
	    domProps: {
	      "selected": _vm.boxConfig.advanced.exibition_mode_scroll_value === '75'
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('edit.sidebar.until_page_bottom')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ },
/* 912 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.modalVisible === 'delete-step') ? _c('layout-general', {
	    on: {
	      "close": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')) + " " + _vm._s(_vm.$t('general.labels.step')))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('modal.delete_step.are_you_sure')))])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.stepRemove()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "txt"
	  }, [_vm._v(_vm._s(_vm.$t('modal.delete_step.yes')))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "txt"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 913 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sidebarCurrentPanel === 'modifiers'),
	      expression: "sidebarCurrentPanel === 'modifiers'"
	    }],
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_vm._v("\n        Configurações\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "submenu-content sub-color"
	  }, [_c('header-config'), _vm._v(" "), _vm._l((_vm.subItems), function(subItem) {
	    return _c('div', {
	      staticClass: "kp-list-group-item clearfix"
	    }, [_c('label', {
	      staticClass: "kp-row box-title box-title__button",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.sidebarSetElement(subItem)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(subItem.getAttribute('klickbox-edit-label')) + "\n            "), _vm._m(0, true)]), _vm._v(" "), _c('span')])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "submenu-padding"
	  }, _vm._l((_vm.modifiers), function(modifier) {
	    return _c('div', [_c('editor', {
	      attrs: {
	        "modifier": modifier,
	        "general": _vm.stepPreview.isGeneral,
	        "item": _vm.item
	      }
	    })], 1)
	  }), 0)], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-right"
	  }, [_c('span', {
	    staticClass: "btn is-circular has-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  })])])
	}]}

/***/ },
/* 914 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "klick-modal"
	    }
	  }, [_c('div', {
	    staticClass: "klick-modal-mask"
	  }, [_c('div', {
	    staticClass: "klick-modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })]), _vm._v(" "), _vm._t("header")], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer")], 2)])])])])])
	},staticRenderFns: []}

/***/ },
/* 915 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.modalVisible === 'delete-box') ? _c('layout-general', {
	    on: {
	      "close": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')) + " Box")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('modal.delete_box.are_you_sure')))])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.boxesDelete()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "txt"
	  }, [_vm._v(_vm._s(_vm.$t('modal.delete_box.yes')))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "txt"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 916 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sidebarCurrentPanel === 'steps'),
	      expression: "sidebarCurrentPanel === 'steps'"
	    }],
	    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
	  }, [_c('div', {
	    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
	  }, [_c('header', {
	    staticClass: "kp-modular-title"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.labels.steps')) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "padding-bottom submenu-content"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.stepHasOnlyThanks),
	      expression: "stepHasOnlyThanks"
	    }],
	    staticClass: "kp-first-component"
	  }, [_c('div', {
	    staticClass: "kp-first-text"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('general.actions.click')) + " " + _vm._s(_vm.$t('general.labels.in').toUpperCase()) + "\n            "), _vm._m(0), _vm._v("\n            " + _vm._s(_vm.$t('general.labels.to').toUpperCase()) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('general.actions.add')) + " " + _vm._s(_vm.$t('general.labels.your')) + " " + _vm._s(_vm.$t('general.labels.first')) + " " + _vm._s(_vm.$t('general.labels.step')) + "\n          ")])]), _vm._v(" "), _c('list'), _vm._v(" "), _c('button-add')], 1)])]), _vm._v(" "), _c('jump')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "btn_circle btn_circle__text"
	  }, [_c('i', {
	    staticClass: "kp-panel-plus"
	  })])
	}]}

/***/ },
/* 917 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kp-modular-row clearfix"
	  }, [_c('label', {
	    staticClass: "kp-modular-label"
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
	    staticClass: "box-color"
	  }, [_c('input', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "id": _vm.id,
	      "type": "text"
	    },
	    domProps: {
	      "value": this.value
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onChange($event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "view-color"
	  })])])
	},staticRenderFns: []}

/***/ },
/* 918 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('range', {
	    attrs: {
	      "label": _vm.$t('edit.sidebar.font_size'),
	      "min": "0",
	      "max": "10",
	      "step": "0.1",
	      "value": _vm.value(),
	      "change": _vm.onChange,
	      "move": _vm.onMove
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 919 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('search'), _vm._v(" "), _c('list'), _vm._v(" "), _c('modal-code'), _vm._v(" "), _c('modal-delete-box')], 1)
	},staticRenderFns: []}

/***/ },
/* 920 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "kbx-trigger-content"
	  }, [_c('link', {
	    attrs: {
	      "rel": "stylesheet",
	      "href": _vm.themeCdnUri + '/popup.css'
	    }
	  }), _vm._v(" "), (_vm.boxConfig.trigger_button.kind === 'basic') ? _c('input', {
	    staticClass: "kbx-trigger-btn kbx-trigger-button",
	    style: (_vm.boxConfig.trigger_button.style),
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.boxConfig.trigger_button.text
	    },
	    on: {
	      "change": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'trigger_button',
	          key: 'text',
	          value: $event.target.value
	        })
	      }
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 921 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "kbx-progress-bar",
	    staticStyle: {
	      "width": "50%"
	    },
	    style: (_vm.getStyle()),
	    attrs: {
	      "klickbox-edit-item": "progress-bar-done",
	      "klickbox-edit-item-dad": "progress",
	      "klickbox-edit-label": _vm.$t('edit.canvas.past_item')
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 922 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.modalVisible === 'report-export-in-progress') ? _c('layout-general', {
	    on: {
	      "close": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.exporting')) + "...")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', [_c('h4', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.your')) + "\n      "), _c('span', {
	    staticClass: "important-info"
	  }, [_vm._v(_vm._s(_vm.$t('modal.export_table_in_progress.processing_request')))]), _vm._v("\n       " + _vm._s(_vm.$t('modal.export_table_in_progress.send_email')) + "\n      "), _c('span', {
	    staticClass: "important-info"
	  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(". " + _vm._s(_vm.$t('modal.export_table_in_progress.some_hours')))])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        return _vm.modalClose()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.close')))])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 923 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.canvasCurrentView === 'fluxogram'),
	      expression: "canvasCurrentView === 'fluxogram'"
	    }]
	  }, [_vm._m(0), _vm._v(" "), _c('a', {
	    staticClass: "button_close",
	    on: {
	      "click": function($event) {
	        return _vm.canvasChangeView('steps')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  }), _vm._v(" " + _vm._s(_vm.$t('general.actions.close')))]), _vm._v(" "), _c('div', {
	    staticClass: "flow_button flow_button__zoom"
	  }, [_c('a', {
	    staticClass: "flow_button__zoom-btn",
	    on: {
	      "click": function($event) {
	        return _vm.fluxogramZoomIn()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search-plus"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "flow_button__zoom-btn",
	    on: {
	      "click": function($event) {
	        return _vm.fluxogramZoomOut()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search-minus"
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "klickbox-fluxogram-holder"
	  }, [_c('div', {
	    staticClass: "klickbox-fluxogram-container"
	  })])
	}]}

/***/ },
/* 924 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    class: {
	      active: _vm.sidebarActiveButton === 'advancedconfig',
	      disabled: _vm.boxConfig.advanced.view_mode === 'click'
	    },
	    attrs: {
	      "title": "Config."
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleClick()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-kp-config"
	  })])
	},staticRenderFns: []}

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "kp-logo",
	    attrs: {
	      "title": _vm.$t('general.labels.homepage')
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'index',
	        params: {
	          locale: _vm.i18n.locale
	        }
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(558),
	      "alt": _vm.$t('general.labels.hotmart_logo')
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ },
/* 926 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "kp-btn-action-sm kp-btn__danger",
	    on: {
	      "click": function($event) {
	        return _vm.jumpRemoveOptionId({
	          jump: _vm.jump,
	          index: _vm.index
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })])
	},staticRenderFns: []}

/***/ },
/* 927 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.stepPreview.description_visibility) ? _c('h2', {
	    staticClass: "kbx-description",
	    style: (_vm.stepStyle('welcome-description')),
	    attrs: {
	      "klickbox-edit-item": "welcome-description",
	      "klickbox-edit-label": _vm.$t('edit.canvas.welcome_description'),
	      "klickbox-edit-label": "Descrição de Boas Vindas"
	    }
	  }, [_c('text-editor', {
	    attrs: {
	      "content": _vm.stepPreview.description_text,
	      "change": _vm.onChange,
	      "toolbar": true,
	      "placeholder": _vm.$t('edit.canvas.welcome_description')
	    }
	  })], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 928 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.formHtml) ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.formHtml)
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 929 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('option-general', {
	    attrs: {
	      "value": "times_until_action",
	      "label": _vm.$t('edit.sidebar.times_until_action')
	    }
	  }, [_c('div', {
	    staticClass: "box-input-group"
	  }, [_c('input', {
	    staticClass: "box-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": _vm.boxConfig.advanced.exibition_frequency_times_value
	    },
	    on: {
	      "change": function($event) {
	        return _vm.boxUpdateConfig({
	          item: 'advanced',
	          key: 'exibition_frequency_times_value',
	          value: $event.target.value
	        });
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box-input-group-label"
	  }, [_vm._v(_vm._s(_vm.$t('general.labels.times')))])])])
	},staticRenderFns: []}

/***/ },
/* 930 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "option",
	    attrs: {
	      "href": "javascript:;",
	      "title": "Exportar"
	    },
	    on: {
	      "click": function($event) {
	        _vm.modalOpen('code');
	        _vm.codeSetupBox(_vm.box)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "kp-panel-import"
	  }), _vm._v(" " + _vm._s(_vm.$t('general.actions.export')) + " Box\n")])
	},staticRenderFns: []}

/***/ },
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./component.svg": 563,
		"./fullscreen.svg": 564,
		"./minislide.svg": 565,
		"./popup.svg": 566,
		"./slider.svg": 567
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 935;


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.bf877564f8fed95b566f.js
 **/